
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("8iNtg", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4wH3g = parcelRequire("4wH3g");


var $jbxiN = parcelRequire("jbxiN");


var $eRJEr = parcelRequire("eRJEr");


var $cXtTj = parcelRequire("cXtTj");


var $4o0zT = parcelRequire("4o0zT");


var $2pQiO = parcelRequire("2pQiO");


var $iDrrr = parcelRequire("iDrrr");


var $anBbz = parcelRequire("anBbz");


var $mW7G5 = parcelRequire("mW7G5");


var $fjeDY = parcelRequire("fjeDY");


var $gRoSG = parcelRequire("gRoSG");


var $krYZG = parcelRequire("krYZG");








var $irnO2 = parcelRequire("irnO2");


var $kDDrf = parcelRequire("kDDrf");


var $bjY3F = parcelRequire("bjY3F");


var $kCECX = parcelRequire("kCECX");


var $bjg0G = parcelRequire("bjg0G");




const $b4d126e73ed52524$export$4b29030e1d9baeba = (node, previousMauiId, localId)=>{
    return node.type.name === 'extension' && node.attrs.extensionKey === 'native-embed:maui' && node.attrs.parameters?.macroParams?.url?.value.endsWith(previousMauiId) && (localId ? node.attrs?.localId === localId : true);
};
const $b4d126e73ed52524$export$47dfdc23943fef4 = (attrs, previousMauiId, newMauiId)=>{
    /**
   * Some older browsers like chrome 97 doesn't support structuredClone.
   * So using JSON.parse(JSON.stringify()) as a fallback.
   */ const newAttrs = typeof window !== 'undefined' && typeof window.structuredClone === 'function' ? structuredClone(attrs) : JSON.parse(JSON.stringify(attrs));
    newAttrs.parameters.macroParams.url.value = newAttrs.parameters.macroParams.url.value.replace(previousMauiId, newMauiId);
    return newAttrs;
};
const $b4d126e73ed52524$export$ff177b3b8713a3ae = ({ previousMauiId: previousMauiId, newMauiId: newMauiId, localId: localId, suppressScrollIntoView: suppressScrollIntoView })=>({ tr: tr })=>{
        // Check current selection, if the node is already selected we can skip expensive document traversal
        if ((0, $bjg0G.isNodeSelection)(tr.selection) && $b4d126e73ed52524$export$4b29030e1d9baeba(tr.selection.node, previousMauiId, localId)) {
            const node = tr.selection.node;
            const pos = tr.selection.$anchor.pos;
            tr.setNodeMarkup(pos, undefined, $b4d126e73ed52524$export$47dfdc23943fef4(node.attrs, previousMauiId, newMauiId));
            if ((0, $iDrrr.fg)('platform_remix_fix_node_replacement_selection')) tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, pos));
            if (suppressScrollIntoView) tr.setMeta('scrollIntoView', false);
            return tr;
        }
        // Find the first node that matches the previous MAUI App ID
        let nodeResult;
        tr.doc.descendants((node, pos)=>{
            if (nodeResult) return false;
            if ($b4d126e73ed52524$export$4b29030e1d9baeba(node, previousMauiId, localId)) nodeResult = {
                node: node,
                pos: pos
            };
            return !nodeResult;
        });
        if (nodeResult) {
            const { node: node, pos: pos } = nodeResult;
            tr.setNodeMarkup(pos, undefined, $b4d126e73ed52524$export$47dfdc23943fef4(node.attrs, previousMauiId, newMauiId));
            if ((0, $iDrrr.fg)('platform_remix_fix_node_replacement_selection')) tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, pos));
            if (suppressScrollIntoView) tr.setMeta('scrollIntoView', false);
            return tr;
        }
        return null;
    };



var $bpOXf = parcelRequire("bpOXf");

function $9ea85748e8d18b6b$export$4f422ec95246a715({ api: api, config: config }) {
    return async ({ previousMauiId: previousMauiId, newMauiId: newMauiId, localId: localId, requireInsertionAcknowledgement: requireInsertionAcknowledgement })=>{
        let idToInsert = newMauiId;
        if (!(0, $cXtTj.default).getExperimentValue('remix_maui_duplicate_stability_improvement', 'value', false)) {
            // TODO: lift these deps out of `config.diagramPaste` to top-level `PluginConfiguration` once both flows share a config surface.
            const duplicateConfig = config?.diagramPaste;
            const duplicateMauiApp = duplicateConfig?.duplicateMauiApp;
            const containerContentId = duplicateConfig?.getCurrentPageId?.();
            const containerContentType = duplicateConfig?.getCurrentContentType?.();
            if (duplicateMauiApp && containerContentId) {
                const experienceTracker = (0, $bjY3F.ExperienceTrackerHandler).getInstance().experienceTracker;
                const experienceAttributes = {
                    appId: newMauiId,
                    currentPageId: containerContentId,
                    source: 'mauiInlineEdit'
                };
                experienceTracker.start({
                    name: (0, $irnO2.ExperienceName).REMIX_DUPLICATE_APP,
                    id: (0, $irnO2.ExperienceName).REMIX_DUPLICATE_APP,
                    attributes: {
                        ...experienceAttributes,
                        remixCreateId: (0, $kDDrf.getActiveRemixCreateId)()
                    }
                });
                try {
                    const { id: id, attempts: attempts, statusCode: statusCode } = await duplicateMauiApp(newMauiId, containerContentId, containerContentType);
                    idToInsert = id;
                    const wasNoOp = id === newMauiId;
                    $9ea85748e8d18b6b$var$fireAnalytics(api, {
                        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                        actionSubject: 'mauiAppDuplicate',
                        action: 'succeeded',
                        actionSubjectId: 'mauiInlineEdit',
                        attributes: {
                            originalId: newMauiId,
                            newId: id,
                            attempts: attempts,
                            statusCode: statusCode,
                            wasNoOp: wasNoOp
                        }
                    });
                    experienceTracker.succeed({
                        name: (0, $irnO2.ExperienceName).REMIX_DUPLICATE_APP,
                        attributes: {
                            ...experienceAttributes,
                            newAppId: id,
                            attempts: attempts,
                            statusCode: statusCode,
                            wasNoOp: wasNoOp
                        }
                    });
                } catch (error) {
                    const statusCode = error?.statusCode;
                    const errorCode = error?.code;
                    const attempts = error?.attempts;
                    const isPermissionError = statusCode === 403;
                    $9ea85748e8d18b6b$var$fireAnalytics(api, {
                        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                        actionSubject: 'mauiAppDuplicate',
                        action: 'failed',
                        actionSubjectId: 'mauiInlineEdit',
                        attributes: {
                            originalId: newMauiId,
                            errorMessage: error?.message,
                            isPermissionError: isPermissionError,
                            statusCode: statusCode,
                            errorCode: errorCode,
                            attempts: attempts
                        }
                    });
                    const duplicateError = error instanceof Error ? error : new Error('Failed to duplicate MAUI app');
                    experienceTracker.fail({
                        name: (0, $irnO2.ExperienceName).REMIX_DUPLICATE_APP,
                        error: duplicateError,
                        attributes: {
                            ...experienceAttributes,
                            statusCode: statusCode,
                            errorCode: errorCode,
                            isPermissionError: isPermissionError,
                            attempts: attempts,
                            remixCreateId: (0, $kDDrf.getActiveRemixCreateId)()
                        }
                    });
                    experienceTracker.fail({
                        name: (0, $irnO2.ExperienceName).REMIX_INSERT,
                        error: duplicateError,
                        attributes: {
                            ...experienceAttributes,
                            failedDueTo: (0, $irnO2.ExperienceName).REMIX_DUPLICATE_APP,
                            statusCode: statusCode,
                            errorCode: errorCode,
                            isPermissionError: isPermissionError,
                            attempts: attempts,
                            remixCreateId: (0, $kDDrf.getActiveRemixCreateId)()
                        }
                    });
                }
            }
        }
        const aiDecorationState = api?.aiExperience?.sharedState.currentState()?.aiDecorationExperiencePluginState;
        const isMatchingInlineEditTarget = Boolean(previousMauiId) && Boolean(localId) && (Boolean(aiDecorationState?.isInlineEditReady) && aiDecorationState?.inlineEditReadyTargetId === localId || aiDecorationState?.inlineRovoStreamingTargetId === localId);
        const shouldManageInlineEditScroll = isMatchingInlineEditTarget && (0, $4o0zT.isExperimentEnabled)('cc_maui_polish_changes_batch_6');
        const isTargetInView = shouldManageInlineEditScroll ? api?.aiExperience?.actions.isInlineEditTargetInView?.(localId) : undefined;
        const suppressScrollIntoView = shouldManageInlineEditScroll && isTargetInView !== true;
        const didReplace = api?.core?.actions.execute(({ tr: tr })=>{
            const result = (0, $b4d126e73ed52524$export$ff177b3b8713a3ae)({
                previousMauiId: previousMauiId,
                newMauiId: idToInsert,
                localId: localId,
                ...suppressScrollIntoView ? {
                    suppressScrollIntoView: suppressScrollIntoView
                } : {}
            })({
                tr: tr
            });
            if (result && localId) tr.setMeta((0, $bpOXf.malleableUiPluginKey), {
                addAiEditReplacementLocalId: localId
            });
            return result;
        });
        if (!didReplace && requireInsertionAcknowledgement) return undefined;
        return {
            insertedMauiId: idToInsert
        };
    };
}
function $9ea85748e8d18b6b$var$fireAnalytics(api, payload) {
    api?.analytics?.actions.fireAnalyticsEvent(payload);
}






var $5J9kV = parcelRequire("5J9kV");


var $3kyUj = parcelRequire("3kyUj");

function $157df83f4da5e36c$export$68002784dcd3d97({ config: config }) {
    return async (args)=>{
        if (args.targetSpace && // eslint-disable-next-line @atlaskit/platform/use-recommended-utils -- dynamic config killswitch, not a standard feature gate
        (0, $cXtTj.default).getExperimentValue('maui-native-embed-finalize-diagram-anywhere', 'value', false)) return {
            status: 'not-finalized'
        };
        const diagramPaste = config?.diagramPaste;
        if (!diagramPaste) return {
            status: 'not-finalized'
        };
        const { originalUrl: originalUrl, conversationContext: conversationContext, mode: mode, targetSpace: targetSpace } = args;
        // Use the view that owns this embed URL.
        const view = (0, $3kyUj.getMauiDiagramPasteView)(originalUrl);
        if (!view) return {
            status: 'not-finalized'
        };
        let contentId = args.contentId;
        if (!contentId) {
            const parsed = (0, $5J9kV.parseMauiDiagramLink)(originalUrl);
            contentId = parsed?.contentId;
        }
        if (!contentId) return {
            status: 'not-finalized'
        };
        const workflowArgs = {
            contentId: contentId,
            originalUrl: originalUrl,
            conversationContext: conversationContext,
            mode: mode,
            targetSpace: targetSpace
        };
        await (0, $3kyUj.executeMauiEmbedFinalize)(view, diagramPaste, workflowArgs);
        const status = (0, $3kyUj.mauiDiagramPastePluginKey).getState(view.state)?.embedFinalizeStates[contentId]?.status;
        return status === (0, $3kyUj.MauiEmbedFinalizeStatus).FINALIZED || status === (0, $3kyUj.MauiEmbedFinalizeStatus).NOT_NEEDED ? {
            status: 'finalized',
            contentId: contentId
        } : {
            status: 'not-finalized',
            contentId: contentId
        };
    };
}



var $kpCD8 = parcelRequire("kpCD8");





var $dOW9b = parcelRequire("dOW9b");


var $iCjKh = parcelRequire("iCjKh");

const $93f21268088062df$var$isUndoTransaction = (transaction)=>Object.values(transaction.meta ?? {}).some((value)=>typeof value === 'object' && value !== null && 'redo' in value && value.redo === false && 'historyState' in value);
const $93f21268088062df$var$nodeMatchesStackEntry = (node, { fieldId: fieldId, url: url })=>{
    if (fieldId && node.attrs?.id === fieldId) return true;
    if (!url) return false;
    const nodeUrl = node.attrs?.parameters?.macroParams?.url?.value;
    if (typeof nodeUrl !== 'string') return false;
    const entryMauiId = (0, $dOW9b.getMauiIdFromUrl)(url);
    return nodeUrl === url || entryMauiId !== undefined && (0, $dOW9b.getMauiIdFromUrl)(nodeUrl) === entryMauiId;
};
const $93f21268088062df$var$getActiveStackIndex = (doc, stack)=>{
    for(let index = stack.length - 1; index >= 0; index--){
        let found = $93f21268088062df$var$nodeMatchesStackEntry(doc, stack[index]);
        if (!found) doc.descendants((node)=>{
            if ($93f21268088062df$var$nodeMatchesStackEntry(node, stack[index])) {
                found = true;
                return false;
            }
            return true;
        });
        if (found) return index;
    }
    return -1;
};
const $93f21268088062df$var$getUndoneRemixEntry = ({ historyMap: historyMap, newDoc: newDoc, oldDoc: oldDoc })=>{
    for (const historyEntry of Object.values(historyMap)){
        const oldIndex = $93f21268088062df$var$getActiveStackIndex(oldDoc, historyEntry.stack);
        if (oldIndex !== -1 && oldIndex !== $93f21268088062df$var$getActiveStackIndex(newDoc, historyEntry.stack)) return historyEntry.stack[oldIndex];
    }
};
function $93f21268088062df$var$getMatchingStackIndex(stack, { fieldId: fieldId, url: url }) {
    if (!fieldId && !url) return -1;
    for(let index = stack.length - 1; index >= 0; index--){
        const stackEntry = stack[index];
        if (url && stackEntry.url === url || fieldId && stackEntry.fieldId === fieldId) return index;
    }
    return -1;
}
/**
 * Find the history entry whose stack contains a step matching the given id
 * (image fieldId or MAUI app id extracted from the stack entry's URL).
 * Returns the conversation key, the entry, and the matched stack index so the
 * caller can trim redo entries above it.
 */ function $93f21268088062df$var$findHistoryEntryByStackId(historyMap, id) {
    for (const [key, entry] of Object.entries(historyMap).reverse())for(let stackIndex = entry.stack.length - 1; stackIndex >= 0; stackIndex--){
        const stackEntry = entry.stack[stackIndex];
        if (stackEntry.fieldId === id || (0, $dOW9b.getMauiIdFromUrl)(stackEntry.url) === id) return {
            key: key,
            entry: entry,
            stackIndex: stackIndex
        };
    }
    return undefined;
}
function $93f21268088062df$var$reducer(state, meta) {
    switch(meta?.type){
        // for image, the fieldId will be updated after the image is uploaded via updateRemixImageHistoryFieldId
        case 'addHistoryEntry':
            {
                const { admissionBaselineInvocationId: admissionBaselineInvocationId, conversationId: conversationId, dynamicUiSource: dynamicUiSource, dynamicUiSubtype: dynamicUiSubtype, dynamicUiType: dynamicUiType, finalMessage: finalMessage, url: url, fieldId: fieldId } = meta.payload;
                const finalMessageId = (0, $dOW9b.getFinalMessageId)(finalMessage);
                const historyEntry = {
                    conversationId: conversationId,
                    dynamicUiSource: dynamicUiSource,
                    latestFinalMessage: finalMessage,
                    latestFinalMessageId: finalMessageId,
                    stack: [
                        {
                            ...admissionBaselineInvocationId !== undefined && {
                                admissionBaselineInvocationId: admissionBaselineInvocationId
                            },
                            dynamicUiType: dynamicUiType,
                            dynamicUiSubtype: dynamicUiSubtype,
                            finalMessage: finalMessage,
                            finalMessageId: finalMessageId,
                            url: url,
                            fieldId: fieldId
                        }
                    ]
                };
                return {
                    historyMap: {
                        ...state.historyMap,
                        [conversationId]: historyEntry
                    }
                };
            }
        case 'updateRemixImageHistoryFieldId':
            {
                const { conversationId: conversationId, fieldId: fieldId } = meta.payload;
                const historyEntry = state.historyMap[conversationId];
                if (!historyEntry) return state;
                const currentStackIndex = historyEntry.stack.length - 1;
                if (currentStackIndex < 0) return state;
                const updatedHistoryEntry = {
                    ...historyEntry,
                    stack: historyEntry.stack.map((stackEntry, index)=>index === currentStackIndex ? {
                            ...stackEntry,
                            fieldId: fieldId
                        } : stackEntry)
                };
                return {
                    historyMap: {
                        ...state.historyMap,
                        [conversationId]: updatedHistoryEntry
                    }
                };
            }
        case 'addHistoryStackEntry':
            {
                const { admissionBaselineInvocationId: admissionBaselineInvocationId, conversationId: conversationId, dynamicUiType: dynamicUiType, dynamicUiSubtype: dynamicUiSubtype, finalMessage: finalMessage, url: url, fieldId: fieldId, previousUrl: previousUrl, previousFieldId: previousFieldId } = meta.payload;
                const finalMessageId = (0, $dOW9b.getFinalMessageId)(finalMessage);
                const historyEntry = state.historyMap[conversationId];
                if (!historyEntry) return state;
                const currentStackIndex = $93f21268088062df$var$getMatchingStackIndex(historyEntry.stack, {
                    url: previousUrl,
                    fieldId: previousFieldId
                });
                const stackEntriesToKeep = currentStackIndex === -1 ? historyEntry.stack : historyEntry.stack.slice(0, currentStackIndex + 1);
                const updatedHistoryEntry = {
                    ...historyEntry,
                    latestFinalMessage: finalMessage,
                    latestFinalMessageId: finalMessageId,
                    stack: [
                        ...stackEntriesToKeep,
                        {
                            ...admissionBaselineInvocationId !== undefined && {
                                admissionBaselineInvocationId: admissionBaselineInvocationId
                            },
                            dynamicUiType: dynamicUiType,
                            dynamicUiSubtype: dynamicUiSubtype,
                            finalMessage: finalMessage,
                            finalMessageId: finalMessageId,
                            url: url,
                            fieldId: fieldId
                        }
                    ]
                };
                return {
                    historyMap: {
                        ...state.historyMap,
                        [conversationId]: updatedHistoryEntry
                    }
                };
            }
        // Append a stack entry for a backend-initiated update (bridge stream).
        // No conversationId / finalMessage in payload — inherit both from the
        // existing entry, located by stack-id search. The payload is a
        // discriminated union: MAUI variant carries previousMauiId + new URL;
        // image variant carries previousFieldId + new fieldId.
        case 'addBackendHistoryStackEntry':
            {
                const { payload: payload } = meta;
                const isMauiPayload = (0, $iCjKh.isAddBackendMauiRemixHistoryStackEntryPayload)(payload);
                const lookupId = isMauiPayload ? payload.previousMauiId : payload.previousFieldId;
                const found = $93f21268088062df$var$findHistoryEntryByStackId(state.historyMap, lookupId);
                if (!found) return state;
                const { key: key, entry: entry, stackIndex: stackIndex } = found;
                const matchedStackEntry = entry.stack[stackIndex];
                const inheritedFinalMessage = entry.latestFinalMessage ?? matchedStackEntry.finalMessage;
                const inheritedFinalMessageId = entry.latestFinalMessageId ?? (0, $dOW9b.getFinalMessageId)(entry.latestFinalMessage) ?? matchedStackEntry.finalMessageId ?? (0, $dOW9b.getFinalMessageId)(matchedStackEntry.finalMessage);
                // Prefer the payload's `dynamicUiSubtype` when the processor passes one —
                // a backend edit that changed the type (e.g. line-chart → bar-chart, or a
                // new tree map) — so the style picker reflects the new type. Otherwise
                // inherit the matched entry's subtype (e.g. the backend omitted it).
                const newStackEntry = isMauiPayload ? {
                    dynamicUiType: payload.dynamicUiType ?? matchedStackEntry.dynamicUiType,
                    dynamicUiSubtype: payload.dynamicUiSubtype ?? matchedStackEntry.dynamicUiSubtype,
                    finalMessage: inheritedFinalMessage,
                    finalMessageId: inheritedFinalMessageId,
                    url: payload.url,
                    fieldId: undefined
                } : {
                    dynamicUiType: matchedStackEntry.dynamicUiType,
                    dynamicUiSubtype: matchedStackEntry.dynamicUiSubtype,
                    finalMessage: inheritedFinalMessage,
                    finalMessageId: inheritedFinalMessageId,
                    url: undefined,
                    fieldId: payload.fieldId
                };
                const updatedHistoryEntry = {
                    ...entry,
                    stack: [
                        ...entry.stack.slice(0, stackIndex + 1),
                        newStackEntry
                    ]
                };
                return {
                    historyMap: {
                        ...state.historyMap,
                        [key]: updatedHistoryEntry
                    }
                };
            }
        case 'goBackInHistory':
        case 'goForwardInHistory':
            return state;
        default:
            return state;
    }
}
const $93f21268088062df$export$2e13bdf171bca4ae = new (0, $kCECX.PluginKey)('remixHistoryPlugin');
function $93f21268088062df$export$275a1873be81202e({ api: api, dispatch: dispatch }) {
    return new (0, $kpCD8.SafePlugin)({
        key: $93f21268088062df$export$2e13bdf171bca4ae,
        state: {
            init () {
                return {
                    historyMap: {}
                };
            },
            apply (tr, pluginState, oldState, newState) {
                let newPluginState = pluginState;
                const meta = tr.getMeta($93f21268088062df$export$2e13bdf171bca4ae);
                if (meta) newPluginState = $93f21268088062df$var$reducer(newPluginState, meta);
                if ($93f21268088062df$var$isUndoTransaction(tr) && oldState?.doc && newState?.doc) {
                    const undoneEntry = $93f21268088062df$var$getUndoneRemixEntry({
                        historyMap: pluginState.historyMap,
                        newDoc: newState.doc,
                        oldDoc: oldState.doc
                    });
                    if (undoneEntry) api?.analytics?.actions.fireAnalyticsEvent({
                        eventType: 'ui',
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'remixUndo',
                        attributes: {
                            remixType: undoneEntry.dynamicUiType,
                            remixSubtype: undoneEntry.dynamicUiSubtype
                        }
                    });
                }
                if (newPluginState !== pluginState) dispatch($93f21268088062df$export$2e13bdf171bca4ae, newPluginState);
                return newPluginState;
            }
        }
    });
}


function $f4ca8840d77ba1f3$export$b509b1134d7bb5c1(options) {
    return ({ tr: tr })=>{
        tr.setMeta((0, $93f21268088062df$export$2e13bdf171bca4ae), {
            type: 'addBackendHistoryStackEntry',
            payload: options
        });
        return tr;
    };
}









var $8nvEM = parcelRequire("8nvEM");


var $8HW7o = parcelRequire("8HW7o");




/**
 * Editor-`api`-keyed slots for callbacks that cross a boundary React context cannot.
 *
 * The thinking widget renders through `nodeViewPortalProviderAPI`, so it is not a descendant of the
 * plugin's `contentComponent()`. The UX closures live in `RemixContentComponentInner`, inside
 * `@atlassian/malleable-ui-components`, which cannot import from this package. Both reach across via
 * `api`, the way `onRegisterAbortRequest` already bridges `registerAbortRequest` in `./remix-state`.
 *
 * Machine ownership and completion presentation belong to the retained lifecycle session; UX
 * handles belong to a content component that unmounts on terminal cleanup.
 */ /**
 * One value per editor instance, with cleanup that cannot outlive its own registration.
 *
 * The map holds a wrapper object so cleanup is guarded on *entry* identity. Guarding on the value
 * would not be enough: re-registering the same function object — a stable `useCallback` across a
 * remount — would make the stale cleanup indistinguishable from the current one, and unmounting the
 * old consumer would delete the new consumer's registration.
 *
 * `WeakMap`-keyed, so two editors on one page cannot see each other and nothing is retained once an
 * editor is collected.
 */ const $dc44c0de1ed07c1a$var$createApiKeyedCallbackSlot = ()=>{
    const entries = new WeakMap();
    return {
        get: (api)=>api ? entries.get(api)?.value : undefined,
        register: (api, value)=>{
            // No-op cleanup for an absent api keeps callers from branching, as `registerAbortRequest` does.
            if (!api) return ()=>{};
            const entry = {
                value: value
            };
            entries.set(api, entry);
            return ()=>{
                if (entries.get(api) === entry) entries.delete(api);
            };
        }
    };
};
const $dc44c0de1ed07c1a$var$uxHandlesSlot = $dc44c0de1ed07c1a$var$createApiKeyedCallbackSlot();
const $dc44c0de1ed07c1a$var$lifecycleSessions = new WeakMap();
const $dc44c0de1ed07c1a$var$presentationListeners = new WeakMap();
const $dc44c0de1ed07c1a$var$mutationCancellationSinks = new WeakMap();
const $dc44c0de1ed07c1a$var$EMPTY_PRESENTATION = Object.freeze({
    animationFinished: false,
    authority: undefined,
    phase: undefined,
    remixId: undefined,
    token: undefined
});
const $dc44c0de1ed07c1a$var$notifyPresentation = (api)=>{
    $dc44c0de1ed07c1a$var$presentationListeners.get(api)?.forEach((listener)=>{
        try {
            listener();
        } catch  {
        // A presentation subscriber cannot prevent lifecycle authority from latching or releasing.
        }
    });
};
const $dc44c0de1ed07c1a$export$d8fb321eb73ac931 = (api)=>{
    const captured = $dc44c0de1ed07c1a$export$66f5178019bac961(api);
    return captured ? ()=>{
        captured();
    } : undefined;
};
const $dc44c0de1ed07c1a$export$66f5178019bac961 = (api)=>{
    const session = api ? $dc44c0de1ed07c1a$var$lifecycleSessions.get(api) : undefined;
    return session?.authority === 'active' ? session.animationFinishedSink : undefined;
};
const $dc44c0de1ed07c1a$export$3a7772ffa9a9fcc0 = (api)=>{
    if (!api) return undefined;
    const capturedApi = api;
    const captured = $dc44c0de1ed07c1a$var$lifecycleSessions.get(capturedApi);
    if (!captured) return undefined;
    return (cleanup)=>{
        if ($dc44c0de1ed07c1a$var$lifecycleSessions.get(capturedApi) !== captured) return false;
        try {
            cleanup();
        } finally{
            if (captured.authority === 'terminal-latched') $dc44c0de1ed07c1a$var$releaseEditorRemixLifecycleAuthority(capturedApi, captured.token);
        }
        return true;
    };
};
const $dc44c0de1ed07c1a$export$7d31a25b751a9034 = (api, handles)=>$dc44c0de1ed07c1a$var$uxHandlesSlot.register(api, handles);
const $dc44c0de1ed07c1a$export$e4c5d0e97ec647cf = (api, sink)=>{
    const session = api ? $dc44c0de1ed07c1a$var$lifecycleSessions.get(api) : undefined;
    if (!api || !session || session.authority !== 'active') return ()=>{};
    const entry = {
        session: session,
        sink: sink
    };
    $dc44c0de1ed07c1a$var$mutationCancellationSinks.set(api, entry);
    return ()=>{
        if ($dc44c0de1ed07c1a$var$mutationCancellationSinks.get(api) === entry) $dc44c0de1ed07c1a$var$mutationCancellationSinks.delete(api);
    };
};
const $dc44c0de1ed07c1a$export$5ff3ad1bbf1465a9 = (api)=>{
    if (!api) return undefined;
    const entry = $dc44c0de1ed07c1a$var$mutationCancellationSinks.get(api);
    if (!entry || $dc44c0de1ed07c1a$var$lifecycleSessions.get(api) !== entry.session || entry.session.authority !== 'active' || !entry.session.mutationCancellationEnabled) return undefined;
    return ()=>{
        if ($dc44c0de1ed07c1a$var$lifecycleSessions.get(api) !== entry.session || entry.session.authority !== 'active') return false;
        entry.session.mutationInvalidationPending = true;
        const cancelled = entry.sink();
        // A refused cancellation must not leak presentation state.
        if (!cancelled && $dc44c0de1ed07c1a$var$lifecycleSessions.get(api) === entry.session) entry.session.mutationInvalidationPending = false;
        return cancelled;
    };
};
const $dc44c0de1ed07c1a$export$8c3960abef4008ee = (api)=>{
    const session = api ? $dc44c0de1ed07c1a$var$lifecycleSessions.get(api) : undefined;
    if (!api || !session || session.authority !== 'active') return false;
    session.mutationCancellationEnabled = false;
    return true;
};
const $dc44c0de1ed07c1a$export$c2ad78149c7e98ec = (api, remixId)=>{
    const session = api ? $dc44c0de1ed07c1a$var$lifecycleSessions.get(api) : undefined;
    if (!session || session.remixId !== remixId || !session.mutationInvalidationPending) return false;
    session.mutationInvalidationPending = false;
    return true;
};
const $dc44c0de1ed07c1a$export$a174cbea3e7863fe = (api)=>$dc44c0de1ed07c1a$var$uxHandlesSlot.get(api);
const $dc44c0de1ed07c1a$export$10406465ad92edb2 = (api, options)=>{
    if (!api) return ()=>{};
    const { remixId: remixId, token: token } = options;
    const session = {
        animationFinished: false,
        animationFinishedSink: ()=>{
            // The closure captures the session identity at registration time. A portal callback retained
            // by A cannot complete a replacement B, even if B is now the registry's current session.
            const currentSession = api ? $dc44c0de1ed07c1a$var$lifecycleSessions.get(api) : undefined;
            if (!api || currentSession !== session || currentSession?.token !== token || currentSession.authority !== 'active') return false;
            $dc44c0de1ed07c1a$export$9b7a6c697ac7e013(api, token);
            return true;
        },
        remixId: remixId,
        token: token,
        authority: 'active',
        mutationCancellationEnabled: true,
        mutationInvalidationPending: false,
        presentation: {
            animationFinished: false,
            authority: 'active',
            phase: undefined,
            remixId: remixId,
            token: token
        }
    };
    $dc44c0de1ed07c1a$var$lifecycleSessions.set(api, session);
    $dc44c0de1ed07c1a$var$notifyPresentation(api);
    const cleanup = Object.assign(()=>{
        if ($dc44c0de1ed07c1a$var$lifecycleSessions.get(api) !== session || session.authority === 'terminal-latched') return;
        $dc44c0de1ed07c1a$var$lifecycleSessions.delete(api);
        $dc44c0de1ed07c1a$var$notifyPresentation(api);
    }, {
        latchTerminalAuthority: ()=>{
            if ($dc44c0de1ed07c1a$var$lifecycleSessions.get(api) !== session) return;
            session.authority = 'terminal-latched';
            session.presentation = {
                ...session.presentation,
                authority: 'terminal-latched'
            };
            $dc44c0de1ed07c1a$var$notifyPresentation(api);
        },
        settleTerminalAuthority: ()=>$dc44c0de1ed07c1a$var$releaseEditorRemixLifecycleAuthority(api, token)
    });
    return cleanup;
};
const $dc44c0de1ed07c1a$export$4050079e84e0fec6 = (api)=>Boolean(api && $dc44c0de1ed07c1a$var$lifecycleSessions.get(api)?.authority === 'active');
const $dc44c0de1ed07c1a$export$f2d1c70f96537b99 = (api)=>Boolean(api && $dc44c0de1ed07c1a$var$lifecycleSessions.get(api)?.token);
/** Releases only the matching terminal authority lease; stale cleanup cannot affect a replacement. */ function $dc44c0de1ed07c1a$var$releaseEditorRemixLifecycleAuthority(api, token) {
    if (!api || token === undefined) return false;
    const session = $dc44c0de1ed07c1a$var$lifecycleSessions.get(api);
    if (session?.token !== token || session.authority !== 'terminal-latched') return false;
    $dc44c0de1ed07c1a$var$lifecycleSessions.delete(api);
    $dc44c0de1ed07c1a$var$notifyPresentation(api);
    return true;
}
const $dc44c0de1ed07c1a$export$58aeb614b6d856f7 = (api)=>{
    const session = api ? $dc44c0de1ed07c1a$var$lifecycleSessions.get(api) : undefined;
    return session?.presentation ?? $dc44c0de1ed07c1a$var$EMPTY_PRESENTATION;
};
const $dc44c0de1ed07c1a$export$ca9605d624b3c2db = (api, listener)=>{
    if (!api) return ()=>{};
    const listeners = $dc44c0de1ed07c1a$var$presentationListeners.get(api) ?? new Set();
    $dc44c0de1ed07c1a$var$presentationListeners.set(api, listeners);
    listeners.add(listener);
    return ()=>listeners.delete(listener);
};
const $dc44c0de1ed07c1a$export$1ae55ee74816df71 = (api, token, phase)=>{
    const session = api ? $dc44c0de1ed07c1a$var$lifecycleSessions.get(api) : undefined;
    if (!api || !session || token === undefined || session.token !== token) return;
    if (session.presentation.phase === phase) return;
    session.presentation = {
        ...session.presentation,
        phase: phase
    };
    $dc44c0de1ed07c1a$var$notifyPresentation(api);
};
const $dc44c0de1ed07c1a$export$9b7a6c697ac7e013 = (api, token)=>{
    const session = api ? $dc44c0de1ed07c1a$var$lifecycleSessions.get(api) : undefined;
    if (!api || !session || session.token !== token || session.authority !== 'active' || session.animationFinished) return;
    session.animationFinished = true;
    session.presentation = {
        ...session.presentation,
        animationFinished: true
    };
    $dc44c0de1ed07c1a$var$notifyPresentation(api);
};






var $kSwu1 = parcelRequire("kSwu1");


var $1hQ0e = parcelRequire("1hQ0e");











var $b6QLO = parcelRequire("b6QLO");





const $06443500a2493931$export$5569fef6b45e570f = ({ reopenModal: reopenModal } = {})=>({ tr: tr })=>{
        const thinkingMeta = {
            presentation: {
                kind: 'stop',
                preserveSavedSelection: !!reopenModal
            },
            lifecycle: {
                kind: 'legacy-stop'
            }
        };
        tr.setMeta((0, $5ea92dab24394af7$export$38c8fc373d691b1d), thinkingMeta);
        if (reopenModal) tr.setMeta((0, $bpOXf.malleableUiPluginKey), {
            isRemixModalOpen: true
        });
        return tr;
    };










/**
 * WeakMap registry keyed by the editor api object (unique per editor instance).
 * Stores the stopRemixing function so cancelRemixThinking can call it to abort
 * the in-flight AI request and trigger paired aiInteraction analytics via AbortError,
 * without needing stopRemixing to be passed through the component tree.
 */ const $b96b9e650a905796$var$abortRequestRegistry = new WeakMap();
function $b96b9e650a905796$export$f9cb53c9d12f6f55(api, abortFn) {
    if (!api) return ()=>{};
    $b96b9e650a905796$var$abortRequestRegistry.set(api, abortFn);
    return ()=>{
        $b96b9e650a905796$var$abortRequestRegistry.delete(api);
    };
}
function $b96b9e650a905796$export$e125c3b8c9ddf1a1(api) {
    if (!api) return undefined;
    return $b96b9e650a905796$var$abortRequestRegistry.get(api);
}
function $b96b9e650a905796$export$e02ace41eac2e13a({ api: api, reopenModal: reopenModal }) {
    // end the inline-Rovo streaming
    api?.aiExperience?.actions?.endInlineRovoStreaming?.();
    api?.aiExperience?.actions.toggleAiEntryPoints?.(false);
    if ((0, $anBbz.expValEqualsNoExposure)('cc_page_experiences_editor_image_generation', 'isEnabled', true)) {
        // If a pre-supplied userPrompt was cancelled (e.g. image generation flow),
        // call the onCancel callback instead of reopening the remix modal.
        const remixModalMetadata = api?.malleableUi?.sharedState.currentState()?.remixModalMetadata;
        const userPrompt = remixModalMetadata?.userPrompt;
        const onCancel = remixModalMetadata?.onCancel;
        if (onCancel && userPrompt) {
            api?.core.actions.execute((0, $06443500a2493931$export$5569fef6b45e570f)({
                reopenModal: false
            }));
            onCancel();
            return;
        }
    }
    const isUpdate = api?.malleableUi?.sharedState.currentState()?.isUpdate ?? false;
    api?.core.actions.execute((0, $06443500a2493931$export$5569fef6b45e570f)({
        reopenModal: reopenModal ?? ((0, $iDrrr.fg)('platform_editor_ai_remix_close_modal_on_stop') ? false : !isUpdate)
    }));
}
function $b96b9e650a905796$export$ae8cbff5055b0856({ api: api, capturedAnimationFinishedSink: capturedAnimationFinishedSink }) {
    if (capturedAnimationFinishedSink) {
        // The sink is the whole guard: it accepts only while this flow still holds its session, so a
        // late callback retained by flow A cannot release entry points that replacement B disabled.
        // This relies on the insertion settle running *after* completion (see `hasInsertionSucceeded`
        // in `useOnComplete`); settle first and the session is already gone, the sink declines, and
        // nothing ever re-enables the entry points.
        if (capturedAnimationFinishedSink()) api?.aiExperience?.actions.toggleAiEntryPoints?.(false);
        return;
    }
    api?.aiExperience?.actions.toggleAiEntryPoints?.(false);
    api?.core.actions.execute((0, $06443500a2493931$export$5569fef6b45e570f)());
}


const $29d6db7c0a9c3ffe$export$4ea4004ba136efe5 = 'remix-thinking-widget';
const $29d6db7c0a9c3ffe$var$THINKING_WIDGET_PLACEHOLDER_KEY = 'remix-thinking-widget-placeholder';
function $29d6db7c0a9c3ffe$export$ca6d884735f53b24({ api: api, container: container, contentType: contentType, getIntl: getIntl, isComplete: isComplete, isWaitingForInput: isWaitingForInput = false, remixAttemptId: remixAttemptId, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI }) {
    const intl = getIntl();
    const remixModalMetadata = api?.malleableUi?.sharedState.currentState()?.remixModalMetadata;
    const userPrompt = remixModalMetadata?.userPrompt;
    const capturedCompletionSink = (0, $dc44c0de1ed07c1a$export$4050079e84e0fec6)(api) ? (0, $dc44c0de1ed07c1a$export$66f5178019bac961)(api) : undefined;
    const capturedTerminalCleanupSink = (0, $dc44c0de1ed07c1a$export$3a7772ffa9a9fcc0)(api);
    const onStopThinking = ()=>{
        // Settle the attempt rendered by this presentation, not the current active attempt.
        if (remixAttemptId) api?.malleableUi?.actions.reportInlineRovoEdit?.(remixAttemptId, 'generation-aborted');
        const cleanup = ()=>{
            const shouldCloseModal = !userPrompt;
            if ((0, $iDrrr.fg)('platform_editor_ai_remix_toolbar')) {
                // Abort before cancelling so send-message-action.ts fires the paired
                // aiInteraction initiated + dismissed events via AbortError.
                (0, $b96b9e650a905796$export$e125c3b8c9ddf1a1)(api)?.();
                (0, $b96b9e650a905796$export$e02ace41eac2e13a)({
                    api: api,
                    reopenModal: shouldCloseModal ? false : undefined
                });
            } else {
                api?.aiExperience?.actions.toggleAiEntryPoints?.(false);
                if ((0, $anBbz.expValEqualsNoExposure)('cc_page_experiences_editor_image_generation', 'isEnabled', true)) {
                    const onCancel = remixModalMetadata?.onCancel;
                    if (onCancel && userPrompt) {
                        // Abort the AI request so send-message-action.ts fires the paired
                        // aiInteraction initiated + dismissed events automatically via AbortError.
                        (0, $b96b9e650a905796$export$e125c3b8c9ddf1a1)(api)?.();
                        api?.core.actions.execute((0, $06443500a2493931$export$5569fef6b45e570f)({
                            reopenModal: false
                        }));
                        onCancel();
                        return;
                    }
                }
                const isUpdate = api?.malleableUi?.sharedState.currentState()?.isUpdate ?? false;
                api?.core.actions.execute((0, $06443500a2493931$export$5569fef6b45e570f)({
                    reopenModal: shouldCloseModal ? false : (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') ? !isUpdate : true
                }));
            }
        };
        if (capturedTerminalCleanupSink) capturedTerminalCleanupSink(cleanup);
        else cleanup();
    };
    const onComplete = ()=>{
        if (capturedCompletionSink) {
            if (capturedCompletionSink()) api?.aiExperience?.actions.toggleAiEntryPoints?.(false);
            return;
        }
        if ((0, $iDrrr.fg)('platform_editor_ai_remix_toolbar')) (0, $b96b9e650a905796$export$ae8cbff5055b0856)({
            api: api
        });
        else {
            api?.aiExperience?.actions.toggleAiEntryPoints?.(false);
            api?.core.actions.execute((0, $06443500a2493931$export$5569fef6b45e570f)());
        }
    };
    nodeViewPortalProviderAPI.render(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
            defaultLocale: intl.defaultLocale || 'en-US',
            locale: intl.locale || 'en-US',
            messages: intl.messages,
            formats: intl.formats,
            onError: intl.onError
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6QLO.RemixThinkingBar), {
            isWaitingForInput: isWaitingForInput,
            remixAttemptId: remixAttemptId,
            loadingBarType: "big-bar",
            // when userPrompt is not set, it means it is a remix entrance
            // otherwise it is a non-remix entrance
            isRemixEntrance: (0, $anBbz.expValEqualsNoExposure)('cc_page_experiences_editor_image_generation', 'isEnabled', true) ? !userPrompt : true,
            contentType: contentType,
            isComplete: isComplete,
            isRelative: true,
            onCompleteAnimationFinished: onComplete,
            onStop: onStopThinking,
            showProgressBar: true
        })), container, $29d6db7c0a9c3ffe$export$4ea4004ba136efe5, undefined, true);
}
function $29d6db7c0a9c3ffe$var$createRemixThinkingWidget({ api: api, contentType: contentType, getIntl: getIntl, isComplete: isComplete, isWaitingForInput: isWaitingForInput, isPlaceholder: isPlaceholder, remixAttemptId: remixAttemptId, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI }) {
    const document = (0, $1hQ0e.getDocument)();
    if (!document) throw new Error('Document is required to render the remix thinking widget.');
    const container = document.createElement('div');
    container.className = isPlaceholder ? `${$29d6db7c0a9c3ffe$export$4ea4004ba136efe5} ${$29d6db7c0a9c3ffe$var$THINKING_WIDGET_PLACEHOLDER_KEY}` : $29d6db7c0a9c3ffe$export$4ea4004ba136efe5;
    container.dataset.testid = isPlaceholder ? $29d6db7c0a9c3ffe$var$THINKING_WIDGET_PLACEHOLDER_KEY : $29d6db7c0a9c3ffe$export$4ea4004ba136efe5;
    if (!isPlaceholder) $29d6db7c0a9c3ffe$export$ca6d884735f53b24({
        api: api,
        container: container,
        contentType: contentType,
        getIntl: getIntl,
        isComplete: isComplete,
        isWaitingForInput: isWaitingForInput,
        remixAttemptId: remixAttemptId,
        nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
    });
    return container;
}
function $29d6db7c0a9c3ffe$export$2f3df55a342cf539(view) {
    return view.dom.querySelector(`.${$29d6db7c0a9c3ffe$export$4ea4004ba136efe5}`);
}
function $29d6db7c0a9c3ffe$var$getPositionAfterDepthOneParent({ doc: doc, to: to }) {
    const $to = doc.resolve(to);
    return $to.depth >= 1 ? $to.after(1) : to;
}
function $29d6db7c0a9c3ffe$export$cce5a0bc4f5e594d({ api: api, contentType: contentType, doc: doc, getIntl: getIntl, isComplete: isComplete, isWaitingForInput: isWaitingForInput, isPlaceholder: isPlaceholder, remixAttemptId: remixAttemptId, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, to: to }) {
    const decorationKey = isPlaceholder ? $29d6db7c0a9c3ffe$var$THINKING_WIDGET_PLACEHOLDER_KEY : $29d6db7c0a9c3ffe$export$4ea4004ba136efe5;
    const widgetPosition = $29d6db7c0a9c3ffe$var$getPositionAfterDepthOneParent({
        doc: doc,
        to: to
    });
    return (0, $8nvEM.Decoration).widget(widgetPosition, ()=>$29d6db7c0a9c3ffe$var$createRemixThinkingWidget({
            api: api,
            contentType: contentType,
            getIntl: getIntl,
            isComplete: isComplete ?? false,
            isWaitingForInput: isWaitingForInput ?? false,
            isPlaceholder: isPlaceholder,
            remixAttemptId: remixAttemptId,
            nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
        }), {
        key: decorationKey,
        // use a low negative side to ensure the decoration is rendered before all other decorations
        // so other decorations update don't cause this decoration to be re-rendered
        side: -999,
        destroy: ()=>{
            if (!isPlaceholder) nodeViewPortalProviderAPI.remove($29d6db7c0a9c3ffe$export$4ea4004ba136efe5);
        }
    });
}


const $5ea92dab24394af7$var$THINKING_HIGHLIGHT_CLASS = 'remix-thinking-highlight';
const $5ea92dab24394af7$export$38c8fc373d691b1d = new (0, $kCECX.PluginKey)('remixThinkingPlugin');
function $5ea92dab24394af7$var$getInitialState() {
    return {
        isThinking: false,
        isComplete: false,
        isUpdate: false,
        historyEntryForUpdate: undefined,
        dynamicUiSubtypeForUpdate: undefined,
        remixAttemptId: undefined,
        decorationSet: (0, $8nvEM.DecorationSet).empty
    };
}
function $5ea92dab24394af7$var$withoutWaitingForInput(pluginState) {
    if (!('isWaitingForInput' in pluginState)) return pluginState;
    const nextState = {
        ...pluginState
    };
    delete nextState.isWaitingForInput;
    return nextState;
}
/**
 * Whether every field the `reset` presentation kind clears is already cleared. `isThinking` and
 * `isComplete` are excluded: they belong to the lifecycle channel, which `reset` leaves alone.
 */ function $5ea92dab24394af7$var$hasNoPresentationState(pluginState) {
    return pluginState.contentType === undefined && pluginState.remixAttemptId === undefined && pluginState.isUpdate === false && pluginState.historyEntryForUpdate === undefined && pluginState.dynamicUiSubtypeForUpdate === undefined && pluginState.savedSelection === undefined && !pluginState.isWaitingForInput && pluginState.decorationSet.find().length === 0;
}
function $5ea92dab24394af7$export$ac33393cae2df1df({ maps: maps, savedSelection: savedSelection }) {
    let { from: from, to: to } = savedSelection;
    for (const map of maps){
        let touched = false;
        map.forEach((oldStart, oldEnd)=>{
            if (oldStart === oldEnd) {
                // Boundary insertions are outside the tracked content.
                touched || (touched = oldStart > from && oldStart < to);
                return;
            }
            // This also catches equal-size replacement, for which mapped positions alone are ambiguous.
            touched || (touched = oldStart < to && oldEnd > from);
        });
        if (touched) return true;
        // Keep boundary insertions outside the remapped range.
        from = map.map(from, 1);
        to = map.map(to, -1);
    }
    return false;
}
function $5ea92dab24394af7$var$reducePresentationUpdate({ api: api, getIntl: getIntl, isViewMode: isViewMode, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, newState: newState, presentation: presentation, pluginState: pluginState }) {
    switch(presentation.kind){
        case 'reset':
            // Same reference when there is nothing to clear, so a caller that pairs this with a
            // lifecycle write does not churn the plugin state on a no-op.
            if ($5ea92dab24394af7$var$hasNoPresentationState(pluginState)) return pluginState;
            return {
                ...$5ea92dab24394af7$var$getInitialState(),
                isComplete: pluginState.isComplete,
                isThinking: pluginState.isThinking
            };
        case 'start':
            {
                const from = presentation.thinkingSelectionFrom;
                const to = presentation.thinkingSelectionTo;
                let decorations;
                if (presentation.suppressThinkingHighlight) decorations = [];
                else if (presentation.cellSelectionRanges) decorations = presentation.cellSelectionRanges.map((range)=>(0, $8nvEM.Decoration).inline(range.from, range.to, {
                        class: $5ea92dab24394af7$var$THINKING_HIGHLIGHT_CLASS
                    }));
                else if (presentation.isNodeSelection) decorations = [
                    (0, $8nvEM.Decoration).node(from, to, {
                        class: $5ea92dab24394af7$var$THINKING_HIGHLIGHT_CLASS
                    })
                ];
                else decorations = [
                    (0, $8nvEM.Decoration).inline(from, to, {
                        class: $5ea92dab24394af7$var$THINKING_HIGHLIGHT_CLASS
                    })
                ];
                if (!isViewMode && (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading')) decorations.push((0, $29d6db7c0a9c3ffe$export$cce5a0bc4f5e594d)({
                    api: api,
                    contentType: presentation.contentType,
                    doc: newState.doc,
                    getIntl: getIntl,
                    isComplete: false,
                    isWaitingForInput: false,
                    isPlaceholder: (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') ? presentation.isUpdate ?? false : false,
                    remixAttemptId: presentation.remixAttemptId,
                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                    to: to
                }));
                const decorationSet = (0, $8nvEM.DecorationSet).create(newState.doc, decorations);
                const result = {
                    contentType: (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') ? presentation.contentType : undefined,
                    remixAttemptId: presentation.remixAttemptId,
                    isThinking: pluginState.isThinking,
                    isUpdate: (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') ? presentation.isUpdate : undefined,
                    dynamicUiSubtypeForUpdate: (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') ? presentation.dynamicUiSubtypeForUpdate : undefined,
                    historyEntryForUpdate: (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') ? presentation.historyEntryForUpdate : undefined,
                    isComplete: pluginState.isComplete,
                    decorationSet: decorationSet,
                    savedSelection: {
                        from: from,
                        to: to,
                        isNodeSelection: presentation.isNodeSelection ?? false,
                        anchorCellPos: presentation.anchorCellPos,
                        headCellPos: presentation.headCellPos
                    }
                };
                return result;
            }
        case 'clear-decoration':
            {
                if (!(0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') || !pluginState.isThinking) return pluginState;
                const result = {
                    contentType: pluginState.contentType,
                    remixAttemptId: pluginState.remixAttemptId,
                    isThinking: pluginState.isThinking,
                    ...pluginState.isWaitingForInput ? {
                        isWaitingForInput: true
                    } : {},
                    isUpdate: pluginState.isUpdate,
                    isComplete: pluginState.isComplete,
                    historyEntryForUpdate: pluginState.historyEntryForUpdate,
                    dynamicUiSubtypeForUpdate: pluginState.dynamicUiSubtypeForUpdate,
                    decorationSet: (0, $8nvEM.DecorationSet).empty,
                    savedSelection: pluginState.savedSelection
                };
                return result;
            }
        case 'stop':
            {
                const decorations = [];
                if (!isViewMode && pluginState.isComplete && pluginState.savedSelection?.to) decorations.push((0, $29d6db7c0a9c3ffe$export$cce5a0bc4f5e594d)({
                    api: api,
                    // The pre-split stop meta never carried a contentType.
                    contentType: undefined,
                    doc: newState.doc,
                    getIntl: getIntl,
                    isComplete: false,
                    isWaitingForInput: false,
                    isPlaceholder: true,
                    remixAttemptId: pluginState.remixAttemptId,
                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                    to: pluginState.savedSelection.to
                }));
                const result = {
                    contentType: (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') ? pluginState.contentType : undefined,
                    remixAttemptId: pluginState.remixAttemptId,
                    isThinking: pluginState.isThinking,
                    isUpdate: pluginState.isUpdate,
                    dynamicUiSubtypeForUpdate: pluginState.dynamicUiSubtypeForUpdate,
                    historyEntryForUpdate: pluginState.historyEntryForUpdate,
                    isComplete: pluginState.isComplete,
                    decorationSet: (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') ? (0, $8nvEM.DecorationSet).create(newState.doc, decorations) : (0, $8nvEM.DecorationSet).empty,
                    savedSelection: presentation.preserveSavedSelection ? pluginState.savedSelection : undefined
                };
                return result;
            }
    }
}
// Returns `undefined` where the pre-split reducer fell through without a result.
function $5ea92dab24394af7$var$reduceLifecycleUpdate({ lifecycle: lifecycle, pluginState: pluginState }) {
    switch(lifecycle.kind){
        case 'legacy-start':
            {
                const result = {
                    contentType: pluginState.contentType,
                    remixAttemptId: pluginState.remixAttemptId,
                    isThinking: true,
                    isUpdate: pluginState.isUpdate,
                    dynamicUiSubtypeForUpdate: pluginState.dynamicUiSubtypeForUpdate,
                    historyEntryForUpdate: pluginState.historyEntryForUpdate,
                    isComplete: (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') ? false : undefined,
                    decorationSet: pluginState.decorationSet,
                    savedSelection: pluginState.savedSelection
                };
                return result;
            }
        case 'legacy-complete':
            {
                if (!(0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading')) return undefined;
                if (pluginState.isComplete || !pluginState.isThinking) return pluginState;
                const result = {
                    contentType: pluginState.contentType,
                    remixAttemptId: pluginState.remixAttemptId,
                    isThinking: pluginState.isThinking,
                    isUpdate: pluginState.isUpdate,
                    isComplete: true,
                    historyEntryForUpdate: pluginState.historyEntryForUpdate,
                    dynamicUiSubtypeForUpdate: pluginState.dynamicUiSubtypeForUpdate,
                    decorationSet: pluginState.decorationSet,
                    savedSelection: pluginState.savedSelection
                };
                return result;
            }
        case 'legacy-complete-false':
            {
                if (!(0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading')) return undefined;
                if (pluginState.isComplete === false) return pluginState;
                const result = {
                    contentType: undefined,
                    remixAttemptId: undefined,
                    isThinking: false,
                    isComplete: false,
                    isUpdate: false,
                    historyEntryForUpdate: undefined,
                    dynamicUiSubtypeForUpdate: undefined,
                    decorationSet: (0, $8nvEM.DecorationSet).empty,
                    savedSelection: undefined
                };
                return result;
            }
        case 'legacy-stop':
            {
                const result = {
                    contentType: pluginState.contentType,
                    remixAttemptId: pluginState.remixAttemptId,
                    isThinking: false,
                    isUpdate: pluginState.isUpdate,
                    dynamicUiSubtypeForUpdate: pluginState.dynamicUiSubtypeForUpdate,
                    historyEntryForUpdate: pluginState.historyEntryForUpdate,
                    isComplete: (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') ? pluginState.isComplete : undefined,
                    decorationSet: pluginState.decorationSet,
                    savedSelection: pluginState.savedSelection
                };
                return result;
            }
        case 'legacy-clear':
            {
                if (!(0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading')) return undefined;
                if (!pluginState.isThinking) return pluginState;
                const result = {
                    contentType: pluginState.contentType,
                    remixAttemptId: pluginState.remixAttemptId,
                    isThinking: true,
                    isUpdate: pluginState.isUpdate,
                    isComplete: false,
                    historyEntryForUpdate: pluginState.historyEntryForUpdate,
                    dynamicUiSubtypeForUpdate: pluginState.dynamicUiSubtypeForUpdate,
                    decorationSet: pluginState.decorationSet,
                    savedSelection: pluginState.savedSelection
                };
                return result;
            }
        case 'legacy-reset':
            return $5ea92dab24394af7$var$getInitialState();
        case 'dismiss':
            if (!pluginState.isThinking && !pluginState.isComplete) return pluginState;
            // The pair the machine's terminal projection writes, so it agrees when it gets there.
            return $5ea92dab24394af7$var$withoutWaitingForInput({
                ...pluginState,
                isThinking: false,
                isComplete: false
            });
        case 'machine-projection':
            {
                const { isComplete: isComplete, isThinking: isThinking } = lifecycle;
                if (isThinking === pluginState.isThinking && isComplete === pluginState.isComplete) return pluginState;
                const result = {
                    ...pluginState,
                    isThinking: isThinking,
                    isComplete: isComplete
                };
                return isThinking && !isComplete ? result : $5ea92dab24394af7$var$withoutWaitingForInput(result);
            }
    }
}
/**
 * normal flow:
 * - reset when show modal
 * - start: isThinking: true
 * - complete: isThinking: true; isComplete: true (after we have final network response)
 * - stop: isThinking: false; isComplete: true; (after onCompleteAnimationFinished)
 * 	 - we can't reset isComplete when stop thinking because we need it to show the ready toast
 *   - if the ready toast is not shown, currently, we're not resetting isComplete at all
 *   - if this become a bigger issue later, we need to properly reset it
 * - optional: complete-false: isThinking: false; isComplete: false; (after clicking ready toast)
 *
 * update flow:
 * - start: isThinking: true; isUpdate: true;
 * - rest is same as normal flow
 */ function $5ea92dab24394af7$var$reducePluginState({ api: api, getIntl: getIntl, isViewMode: isViewMode, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, newState: newState, meta: meta, pluginState: pluginState }) {
    if (!meta.presentation && !meta.lifecycle && meta.isWaitingForInput === undefined) return undefined;
    let result = pluginState;
    if (meta.presentation) result = $5ea92dab24394af7$var$reducePresentationUpdate({
        api: api,
        getIntl: getIntl,
        isViewMode: isViewMode,
        nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
        newState: newState,
        presentation: meta.presentation,
        pluginState: result
    });
    if (meta.lifecycle) {
        const isLegacyLifecycle = meta.lifecycle.kind.startsWith('legacy-');
        if (isLegacyLifecycle && (0, $dc44c0de1ed07c1a$export$f2d1c70f96537b99)(api)) return meta.presentation ? result : undefined;
        const lifecycleResult = $5ea92dab24394af7$var$reduceLifecycleUpdate({
            lifecycle: meta.lifecycle,
            pluginState: result
        });
        if (lifecycleResult) result = lifecycleResult;
    }
    if (meta.isWaitingForInput !== undefined) {
        const isWaitingForInput = result.isThinking && !result.isComplete ? meta.isWaitingForInput : false;
        if (isWaitingForInput && !result.isWaitingForInput) result = {
            ...result,
            isWaitingForInput: true
        };
        else if (!isWaitingForInput && result.isWaitingForInput) result = $5ea92dab24394af7$var$withoutWaitingForInput(result);
    }
    return result === pluginState ? undefined : result;
}
function $5ea92dab24394af7$export$1c17a47e3daa5065({ api: api, config: config, dispatch: dispatch, getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI }) {
    return new (0, $kpCD8.SafePlugin)({
        key: $5ea92dab24394af7$export$38c8fc373d691b1d,
        state: {
            init () {
                return $5ea92dab24394af7$var$getInitialState();
            },
            apply (tr, pluginState, _oldState, newState) {
                const isViewMode = api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
                const meta = tr.getMeta($5ea92dab24394af7$export$38c8fc373d691b1d);
                if (meta) {
                    const result = $5ea92dab24394af7$var$reducePluginState({
                        api: api,
                        getIntl: getIntl,
                        isViewMode: isViewMode,
                        nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                        newState: newState,
                        meta: meta,
                        pluginState: pluginState
                    });
                    if (result) {
                        dispatch($5ea92dab24394af7$export$38c8fc373d691b1d, result);
                        return result;
                    }
                }
                if (pluginState.isThinking && tr.docChanged && pluginState.savedSelection && $5ea92dab24394af7$export$ac33393cae2df1df({
                    maps: tr.mapping.maps,
                    savedSelection: pluginState.savedSelection
                })) {
                    // Capture the session before leaving Plugin.apply.
                    const cancel = (0, $dc44c0de1ed07c1a$export$5ff3ad1bbf1465a9)(api);
                    if (cancel) queueMicrotask(()=>{
                        cancel();
                    });
                }
                if (pluginState.isThinking) {
                    // Remap savedSelection even when visual decorations are suppressed.
                    let mappedDecorationSet = pluginState.decorationSet;
                    if (pluginState.decorationSet !== (0, $8nvEM.DecorationSet).empty) {
                        mappedDecorationSet = pluginState.decorationSet.map(tr.mapping, newState.doc);
                        // re-create the thinking widget decoration if the widget is not in the mapped decoration set while thinking
                        // it can be removed when updating the remix, which will replace the node and delete the decoration
                        if (!isViewMode && (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar')) {
                            const thinkingWidgetDecoration = mappedDecorationSet.find(undefined, undefined, (spec)=>{
                                return spec?.key === (0, $29d6db7c0a9c3ffe$export$4ea4004ba136efe5);
                            });
                            if (!thinkingWidgetDecoration.length && pluginState.savedSelection?.to) mappedDecorationSet = mappedDecorationSet.add(newState.doc, [
                                (0, $29d6db7c0a9c3ffe$export$cce5a0bc4f5e594d)({
                                    api: api,
                                    contentType: pluginState.contentType,
                                    doc: newState.doc,
                                    getIntl: getIntl,
                                    isComplete: false,
                                    isWaitingForInput: pluginState.isWaitingForInput,
                                    isPlaceholder: (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') ? pluginState.isUpdate ?? false : false,
                                    remixAttemptId: pluginState.remixAttemptId,
                                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                                    to: tr.mapping.map(pluginState.savedSelection.to)
                                })
                            ]);
                        }
                    }
                    const mappedSavedSelection = tr.docChanged && pluginState.savedSelection ? {
                        ...pluginState.savedSelection,
                        from: tr.mapping.map(pluginState.savedSelection.from),
                        to: tr.mapping.map(pluginState.savedSelection.to),
                        anchorCellPos: pluginState.savedSelection.anchorCellPos !== undefined ? tr.mapping.map(pluginState.savedSelection.anchorCellPos) : undefined,
                        headCellPos: pluginState.savedSelection.headCellPos !== undefined ? tr.mapping.map(pluginState.savedSelection.headCellPos) : undefined
                    } : pluginState.savedSelection;
                    if (mappedDecorationSet !== pluginState.decorationSet || mappedSavedSelection !== pluginState.savedSelection) {
                        const result = {
                            ...pluginState,
                            decorationSet: mappedDecorationSet,
                            savedSelection: mappedSavedSelection
                        };
                        dispatch($5ea92dab24394af7$export$38c8fc373d691b1d, result);
                        return result;
                    }
                }
                return pluginState;
            }
        },
        view () {
            return {
                update (view, previousState) {
                    const previousPluginState = $5ea92dab24394af7$export$38c8fc373d691b1d.getState(previousState);
                    const currentPluginState = $5ea92dab24394af7$export$38c8fc373d691b1d.getState(view.state);
                    const isViewMode = api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
                    // Scroll thinking bar into view when thinking starts (for large blocks like tables)
                    if (!isViewMode && currentPluginState?.isThinking && !previousPluginState?.isThinking && (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading')) requestAnimationFrame(()=>{
                        const container = (0, $29d6db7c0a9c3ffe$export$2f3df55a342cf539)(view);
                        container?.scrollIntoView({
                            behavior: 'smooth',
                            block: 'nearest'
                        });
                    });
                    const shouldRerenderThinkingPortal = !isViewMode && currentPluginState?.isThinking && (!previousPluginState?.isComplete && currentPluginState.isComplete || previousPluginState?.isWaitingForInput !== currentPluginState.isWaitingForInput) && ((0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') ? !currentPluginState.isUpdate : true) && (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading');
                    if (shouldRerenderThinkingPortal) {
                        const container = (0, $29d6db7c0a9c3ffe$export$2f3df55a342cf539)(view);
                        if (!container) return;
                        (0, $29d6db7c0a9c3ffe$export$ca6d884735f53b24)({
                            api: api,
                            container: container,
                            contentType: currentPluginState.contentType,
                            getIntl: getIntl,
                            isComplete: currentPluginState.isComplete ?? false,
                            isWaitingForInput: currentPluginState.isWaitingForInput,
                            remixAttemptId: currentPluginState.remixAttemptId,
                            nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                        });
                    }
                }
            };
        },
        appendTransaction (_transactions, oldState, newState) {
            const oldPluginState = $5ea92dab24394af7$export$38c8fc373d691b1d.getState(oldState);
            const newPluginState = $5ea92dab24394af7$export$38c8fc373d691b1d.getState(newState);
            // only restore selection if the plugin state is not complete
            // which means the remix is cancelled
            // we don't want to restore selection if the remix is complete
            // which will trigger floating toolbar
            if (oldPluginState?.isThinking && !newPluginState?.isThinking && newPluginState?.savedSelection && !(newPluginState?.isComplete && (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading'))) {
                const { savedSelection: savedSelection } = newPluginState;
                const tr = newState.tr;
                if (savedSelection.anchorCellPos !== undefined && savedSelection.headCellPos !== undefined) tr.setSelection((0, $8HW7o.CellSelection).create(tr.doc, savedSelection.anchorCellPos, savedSelection.headCellPos));
                else if (savedSelection.isNodeSelection) tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, savedSelection.from));
                else tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, savedSelection.from, savedSelection.to));
                return tr;
            }
            return null;
        },
        props: {
            decorations (state) {
                return $5ea92dab24394af7$export$38c8fc373d691b1d.getState(state)?.decorationSet ?? (0, $8nvEM.DecorationSet).empty;
            }
        }
    });
}


const $592515a66bfc26f7$export$65f89d2d4741e4b7 = ()=>({ tr: tr })=>{
        tr.setMeta((0, $5ea92dab24394af7$export$38c8fc373d691b1d), {
            presentation: {
                kind: 'clear-decoration'
            },
            lifecycle: {
                kind: 'legacy-clear'
            }
        });
        return tr;
    };





const $d02a52a2c9adaa11$export$8818f9db6e7370f7 = (api)=>()=>({ tr: tr })=>{
            // Clear the block selection so stale ak-editor-selected-node decorations
            // are removed when the modal is dismissed.
            api?.selection?.commands?.clearBlockSelection()({
                tr: tr
            });
            tr.setMeta((0, $bpOXf.malleableUiPluginKey), {
                isRemixModalOpen: false,
                remixModalMetadata: undefined,
                remixSource: undefined
            });
            return tr;
        };



var $j8XGH = parcelRequire("j8XGH");











var $hdBxM = parcelRequire("hdBxM");


var $k1Pvg = parcelRequire("k1Pvg");

















const $07a368e9003b6a4b$export$be13f069b08235f1 = (selection)=>{
    if ((0, $2pQiO.UNSAFE_expValNoExposure)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'control') !== 'variant2') return;
    const remixPreset = selection.empty ? 'page' : 'selection';
    (0, $hdBxM.publish)((0, $k1Pvg.Topics).ROVO_REMIX, {
        type: 'update-rovo-remix-preset',
        source: 'editor-selection',
        openChat: false,
        data: {
            remixConsumer: 'editor',
            remixPreset: remixPreset
        }
    });
};











const $6687d9fc6cf5746d$var$HEADING_NODE_TYPE = 'heading';
const $6687d9fc6cf5746d$export$e8f38c0ba1044114 = (doc, headingPos)=>{
    let currentPos = 0;
    for(let index = 0; index < doc.childCount; index++){
        const child = doc.child(index);
        if (currentPos !== headingPos) {
            currentPos += child.nodeSize;
            continue;
        }
        if (child.type.name !== $6687d9fc6cf5746d$var$HEADING_NODE_TYPE) return null;
        let endPos = headingPos + child.nodeSize;
        let endIndex = index + 1;
        for(let sectionIndex = index + 1; sectionIndex < doc.childCount; sectionIndex++){
            const sectionNode = doc.child(sectionIndex);
            if (sectionNode.type.name === $6687d9fc6cf5746d$var$HEADING_NODE_TYPE) break;
            endPos += sectionNode.nodeSize;
            endIndex = sectionIndex + 1;
        }
        return {
            startPos: headingPos,
            endPos: endPos,
            startIndex: index,
            endIndex: endIndex
        };
    }
    return null;
};


const $1cd013bee2f15b85$export$f7560b42cf0c7e6b = 'blockNudge';
const $1cd013bee2f15b85$export$601d1e5a3bab7ca2 = ({ nodePos: nodePos, source: source, tr: tr })=>{
    if (source !== $1cd013bee2f15b85$export$f7560b42cf0c7e6b) return false;
    const headingSection = (0, $6687d9fc6cf5746d$export$e8f38c0ba1044114)(tr.doc, nodePos);
    if (!headingSection) return false;
    const headingSectionSelection = (0, $kCECX.TextSelection).create(tr.doc, headingSection.startPos, headingSection.endPos);
    tr.setSelection(headingSectionSelection);
    return true;
};
const $1cd013bee2f15b85$export$5dcb9dab860f04dd = (api)=>({ nodePos: nodePos, nodeType: nodeType, source: source, from: from, to: to } = {})=>({ tr: tr })=>{
            if (from !== undefined && to !== undefined) {
                tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, from, to));
                api?.selection?.commands?.setBlockSelection(tr.selection)({
                    tr: tr
                });
                return tr;
            }
            if (nodePos === undefined || !nodeType) return tr;
            if ((0, $iDrrr.fg)('cc-maui-phase-3')) {
                const didApplyHeadingSelection = $1cd013bee2f15b85$export$601d1e5a3bab7ca2({
                    nodePos: nodePos,
                    source: source,
                    tr: tr
                });
                if (!didApplyHeadingSelection) (0, $j8XGH.selectNodeAtPos)(tr, nodePos, nodeType);
            } else if ((0, $iDrrr.fg)('platform_editor_maui_jira_updates')) (0, $j8XGH.selectNodeAtPos)(tr, nodePos, nodeType);
            else api?.blockControls?.commands.expandAndUpdateSelection({
                startPos: nodePos,
                nodeType: nodeType,
                selection: tr.selection,
                isShiftPressed: false
            })({
                tr: tr
            });
            // If a multi-block TextSelection was set, signal to the selection plugin
            // so that ak-editor-selected-node decorations are applied to all selected nodes.
            if (tr.selection instanceof (0, $kCECX.TextSelection)) api?.selection?.commands?.setBlockSelection(tr.selection)({
                tr: tr
            });
            return tr;
        };


const $a41417a475703a7a$export$f437f2a5f6852f29 = 'pasteMenu';
const $a41417a475703a7a$export$e01f52b7ef73f07b = (api)=>({ nodePos: nodePos, nodeType: nodeType, metadata: metadata, source: source } = {})=>({ tr: tr })=>{
            // If the remix modal is being opened from the paste menu, set the selection to the pasted content range
            if (source === $a41417a475703a7a$export$f437f2a5f6852f29 && api && 'pasteOptionsToolbarPlugin' in api && api.pasteOptionsToolbarPlugin && [
                'hasSpellingAndGrammar',
                'hasAltAiActions'
            ].includes((0, $mW7G5.expValNoExposure)('platform_editor_paste_actions_menu_v2', 'variant', 'control'))) {
                const pasteState = api.pasteOptionsToolbarPlugin.sharedState.currentState();
                if (!pasteState) // Exit early if we can't get the paste state, which means we won't be able to set the selection to the pasted content.
                return null;
                const { pasteStartPos: pasteStartPos, pasteEndPos: pasteEndPos } = pasteState;
                if (pasteStartPos === undefined || pasteEndPos === undefined) // Exit early if the paste state doesn't have valid start or end positions.
                return null;
                const pasteSelection = (0, $kCECX.TextSelection).create(tr.doc, pasteStartPos, pasteEndPos);
                tr.setSelection(pasteSelection);
                api?.selection?.commands?.setBlockSelection(pasteSelection)({
                    tr: tr
                });
            } else if (nodePos !== undefined && nodeType) {
                if ((0, $2pQiO.UNSAFE_expValNoExposure)('platform_editor_ai_content_suggested_edits', 'isEnabled', false)) // Node-selection logic extracted into `makeSelectRemixAnchor` so it can be reused to
                // anchor a remix without opening the modal (e.g. Suggested Remix).
                (0, $1cd013bee2f15b85$export$5dcb9dab860f04dd)(api)({
                    nodePos: nodePos,
                    nodeType: nodeType,
                    source: source
                })({
                    tr: tr
                });
                else {
                    // TODO(platform_editor_ai_content_suggested_edits cleanup): delete this legacy inline
                    // branch — the `makeSelectRemixAnchor` call above is the replacement.
                    if ((0, $iDrrr.fg)('cc-maui-phase-3')) {
                        const didApplyHeadingSelection = (0, $1cd013bee2f15b85$export$601d1e5a3bab7ca2)({
                            nodePos: nodePos,
                            source: source,
                            tr: tr
                        });
                        if (!didApplyHeadingSelection) (0, $j8XGH.selectNodeAtPos)(tr, nodePos, nodeType);
                    } else if ((0, $iDrrr.fg)('platform_editor_maui_jira_updates')) (0, $j8XGH.selectNodeAtPos)(tr, nodePos, nodeType);
                    else api?.blockControls?.commands.expandAndUpdateSelection({
                        startPos: nodePos,
                        nodeType: nodeType,
                        selection: tr.selection,
                        isShiftPressed: false
                    })({
                        tr: tr
                    });
                    // If a multi-block TextSelection was set, signal to the selection plugin
                    // so that ak-editor-selected-node decorations are applied to all selected nodes.
                    if (tr.selection instanceof (0, $kCECX.TextSelection)) api?.selection?.commands?.setBlockSelection(tr.selection)({
                        tr: tr
                    });
                }
            }
            if (!metadata?.userPrompt && (0, $2pQiO.UNSAFE_expValNoExposure)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'control') === 'variant2') {
                const remixPreset = tr.selection.empty ? 'page' : 'selection';
                const payload = {
                    type: 'open-rovo-remix-sidebar',
                    source: source ?? 'remix',
                    consumeOnce: true,
                    openChat: true,
                    openChatMode: 'sidebar',
                    autoFocusInput: false,
                    data: {
                        remixConsumer: 'editor',
                        remixPreset: remixPreset
                    }
                };
                // The same message is deliberately sent on two topics, because two different parts of
                // the product are listening and each one only listens on one of them:
                //
                // - The 'ai-mate' topic is what opens the Rovo sidebar in the first place. It is also
                //   where the RemixContent component in this package listens, so that it can remember
                //   which blocks of the page the user had selected. It needs that later, when the
                //   finished content comes back from Rovo and has to be inserted in the right place.
                // - The 'rovo-remix-launch' topic is what tells the Rovo sidebar to show the list of
                //   Remix options rather than an ordinary chat conversation.
                //
                // Sending on only one of the two topics breaks the other half of the feature. Sending
                // on both is safe: the publish and subscribe system gives every call to publish its own
                // delivery identifier, so a listener that asked to handle a message only once still
                // receives its own copy instead of discarding the second send as a repeat.
                (0, $hdBxM.publish)((0, $k1Pvg.Topics).AI_MATE, payload);
                (0, $hdBxM.publish)((0, $k1Pvg.Topics).ROVO_REMIX_LAUNCH, payload);
                // Send the whole-page-or-selection choice again, on its own topic. The list of Remix
                // options only starts listening once the sidebar has finished rendering, which happens
                // after the two messages above have already been delivered, so without this it would
                // never find out whether the user is remixing the whole page or only their selection.
                (0, $07a368e9003b6a4b$export$be13f069b08235f1)(tr.selection);
                return tr;
            }
            tr.setMeta((0, $bpOXf.malleableUiPluginKey), {
                isRemixModalOpen: true,
                remixModalMetadata: metadata,
                remixSource: source
            });
            if ((0, $iDrrr.fg)('platform_editor_ai_remix_toolbar')) tr.setMeta((0, $5ea92dab24394af7$export$38c8fc373d691b1d), {
                presentation: {
                    kind: 'reset'
                },
                lifecycle: {
                    kind: 'legacy-reset'
                }
            });
            return tr;
        };















// The native-embeds auto-converter wraps a MAUI whiteboard URL
// (`...?isRemixDiagram=true`) into an extension node keyed by the
// `maui-whiteboard` experience id, not the generic `whiteboard` experience.
// See native-embeds-editor-extension `createManifest` autoConvert.
const $51bd462f1be2ad42$var$NATIVE_WHITEBOARD_EXTENSION_KEY = 'native-embed:maui-whiteboard';
const $51bd462f1be2ad42$var$getString = (value)=>typeof value === 'string' ? value : undefined;
// The native-embeds plugin can persist a whiteboard extension in one of two
// shapes depending on how it was created/transformed:
// - Nested macro shape: `attrs.parameters.macroParams.url.value`
// - Flat shape:         `attrs.parameters.url`
const $51bd462f1be2ad42$var$getNativeWhiteboardUrl = (attrs)=>$51bd462f1be2ad42$var$getString(attrs.parameters?.macroParams?.url?.value) ?? $51bd462f1be2ad42$var$getString(attrs.parameters?.url);
const $51bd462f1be2ad42$var$getWhiteboardContentId = (url)=>{
    if (!url) return undefined;
    const match = /\/whiteboard\/([^/?#]+)/.exec(url);
    const encodedContentId = match?.[1];
    if (!encodedContentId) return undefined;
    try {
        return decodeURIComponent(encodedContentId);
    } catch  {
        return encodedContentId;
    }
};
const $51bd462f1be2ad42$var$getWhiteboardEmbedNodeInfo = (node)=>{
    if (node.type.name === 'embedCard') return {
        kind: 'embedCard',
        localId: $51bd462f1be2ad42$var$getString(node.attrs.localId),
        url: $51bd462f1be2ad42$var$getString(node.attrs.url)
    };
    if (node.type.name === 'extension' && node.attrs.extensionKey === $51bd462f1be2ad42$var$NATIVE_WHITEBOARD_EXTENSION_KEY) return {
        kind: 'nativeWhiteboard',
        localId: $51bd462f1be2ad42$var$getString(node.attrs.localId),
        url: $51bd462f1be2ad42$var$getNativeWhiteboardUrl(node.attrs)
    };
    return undefined;
};
const $51bd462f1be2ad42$var$isMatchingWhiteboardContent = (url, contentId)=>$51bd462f1be2ad42$var$getWhiteboardContentId(url) === contentId;
const $51bd462f1be2ad42$var$isMatchingLocalId = (actualLocalId, expectedLocalId)=>expectedLocalId ? actualLocalId === expectedLocalId : true;
const $51bd462f1be2ad42$export$fc1c1f126d7fc18e = (node, contentId, localId)=>{
    const info = $51bd462f1be2ad42$var$getWhiteboardEmbedNodeInfo(node);
    if (!info || !$51bd462f1be2ad42$var$isMatchingWhiteboardContent(info.url, contentId)) return false;
    // Finalize can run during the timing window before or after native-embeds
    // converts Rovo's early embedCard into a maui-whiteboard extension. The
    // embedCard has localId; the converted extension does not, so match it by
    // exact contentId.
    if (info.kind === 'nativeWhiteboard') return true;
    return $51bd462f1be2ad42$var$isMatchingLocalId(info.localId, localId);
};
const $51bd462f1be2ad42$export$c3cec2ff440d20b7 = (doc, contentId)=>{
    let found;
    doc.descendants((node, pos)=>{
        if (found !== undefined) return false;
        if ($51bd462f1be2ad42$export$fc1c1f126d7fc18e(node, contentId)) {
            found = pos;
            return false;
        }
        return true;
    });
    return found;
};
// Only updates the shapes that actually exist on the node, to avoid inventing
// missing nested objects on a flat node (mirrors `getNativeWhiteboardUrl`).
const $51bd462f1be2ad42$var$updateNativeWhiteboardUrlAttrs = (attrs, finalizedUrl)=>({
        ...attrs,
        parameters: {
            ...attrs.parameters,
            ...typeof attrs.parameters?.url === 'string' ? {
                url: finalizedUrl
            } : {},
            ...attrs.parameters?.macroParams ? {
                macroParams: {
                    ...attrs.parameters.macroParams,
                    url: {
                        ...attrs.parameters.macroParams.url,
                        value: finalizedUrl
                    }
                }
            } : {},
            ...attrs.parameters?.macroMetadata ? {
                macroMetadata: {
                    ...attrs.parameters.macroMetadata,
                    url: finalizedUrl
                }
            } : {}
        }
    });
const $51bd462f1be2ad42$export$f23238abf7f83f7e = (node, finalizedUrl)=>{
    const info = $51bd462f1be2ad42$var$getWhiteboardEmbedNodeInfo(node);
    if (info?.kind === 'nativeWhiteboard') return $51bd462f1be2ad42$var$updateNativeWhiteboardUrlAttrs(node.attrs, finalizedUrl);
    return {
        ...node.attrs,
        url: finalizedUrl
    };
};
const $51bd462f1be2ad42$var$updateWhiteboardNodeUrl = (tr, node, pos, contentId, finalizedUrl)=>{
    tr.setNodeMarkup(pos, undefined, $51bd462f1be2ad42$export$f23238abf7f83f7e(node, finalizedUrl));
    // Tell the maui-diagram paste plugin that this content has been finalized so
    // the `MauiNativeEmbedBanner` stops surfacing the "needs finalize" warning
    // even if the BE move hasn't propagated by the time the probe fires.
    tr.setMeta((0, $3kyUj.mauiDiagramPastePluginKey), {
        type: (0, $3kyUj.ActionType).EMBED_FINALIZE_STATUS_CHANGED,
        contentId: contentId,
        status: (0, $3kyUj.MauiEmbedFinalizeStatus).FINALIZED
    });
    if ((0, $iDrrr.fg)('platform_remix_fix_node_replacement_selection')) tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, pos));
    // Finalize's setNodeMarkup would otherwise trigger the editor's scroll-into-view plugin. Suppress
    // it so the ready-signal owns the scroll-vs-"View"-bar decision instead of a forced page scroll.
    tr.setMeta('scrollIntoView', false);
    return tr;
};
const $51bd462f1be2ad42$var$findWhiteboardNode = (doc, contentId, localId)=>{
    let nodeResult;
    doc.descendants((node, pos)=>{
        if (nodeResult) return false;
        if ($51bd462f1be2ad42$export$fc1c1f126d7fc18e(node, contentId, localId)) nodeResult = {
            node: node,
            pos: pos
        };
        return !nodeResult;
    });
    return nodeResult;
};
const $51bd462f1be2ad42$export$1aa62896db449f52 = ({ contentId: contentId, finalizedUrl: finalizedUrl, localId: localId })=>({ tr: tr })=>{
        // Fast path: if the target is already selected, avoid walking the whole document.
        if ((0, $bjg0G.isNodeSelection)(tr.selection) && $51bd462f1be2ad42$export$fc1c1f126d7fc18e(tr.selection.node, contentId, localId)) return $51bd462f1be2ad42$var$updateWhiteboardNodeUrl(tr, tr.selection.node, tr.selection.$anchor.pos, contentId, finalizedUrl);
        const nodeResult = $51bd462f1be2ad42$var$findWhiteboardNode(tr.doc, contentId, localId);
        if (nodeResult) return $51bd462f1be2ad42$var$updateWhiteboardNodeUrl(tr, nodeResult.node, nodeResult.pos, contentId, finalizedUrl);
        return null;
    };





const $39483ef3a0dde328$export$d2cccfcd66c92b90 = ({ contentId: contentId, status: status })=>({ tr: tr })=>{
        if (!contentId) return null;
        tr.setMeta((0, $3kyUj.mauiDiagramPastePluginKey), {
            type: (0, $3kyUj.ActionType).EMBED_FINALIZE_STATUS_CHANGED,
            contentId: contentId,
            status: status
        });
        return tr;
    };





const $8ef7f637f4ca3dda$export$f36198854f9520d1 = ({ mediaId: mediaId })=>({ tr: tr })=>{
        tr.setMeta((0, $bpOXf.malleableUiPluginKey), {
            remixImageMediaId: mediaId
        });
        return tr;
    };



var $2ROjz = parcelRequire("2ROjz");

var $3rWk6 = parcelRequire("3rWk6");


// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- uuid is used as a fallback for environments where crypto.randomUUID is unavailable

var $03RpJ = parcelRequire("03RpJ");


var $4EksL = parcelRequire("4EksL");

var $eaLat = parcelRequire("eaLat");




















const $3ed7f22374c9e3fb$var$randomId = ()=>{
    if (globalThis?.crypto?.randomUUID) return globalThis.crypto.randomUUID();
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- uuid is used as a fallback for environments where crypto.randomUUID is unavailable
    return (0, $03RpJ.default)();
};
const $3ed7f22374c9e3fb$export$b0011c604093029 = (api)=>({ contentType: contentType, dynamicUiSubtypeForUpdate: dynamicUiSubtypeForUpdate, isUpdate: isUpdate, historyEntryForUpdate: historyEntryForUpdate, remixAttemptId: remixAttemptId, remixModalMetadata: remixModalMetadata, suppressThinkingHighlight: suppressThinkingHighlight } = {})=>({ tr: tr })=>{
            const selection = tr.selection;
            const isNodeSelection = selection instanceof (0, $kCECX.NodeSelection);
            const isCellSelection = selection instanceof (0, $8HW7o.CellSelection);
            const presentation = {
                kind: 'start',
                contentType: contentType,
                remixAttemptId: remixAttemptId ?? $3ed7f22374c9e3fb$var$randomId(),
                isUpdate: isUpdate,
                historyEntryForUpdate: historyEntryForUpdate,
                dynamicUiSubtypeForUpdate: dynamicUiSubtypeForUpdate,
                thinkingSelectionFrom: selection.from,
                thinkingSelectionTo: isNodeSelection ? selection.from + selection.node.nodeSize : selection.to,
                isNodeSelection: isNodeSelection,
                suppressThinkingHighlight: suppressThinkingHighlight
            };
            if (isCellSelection) {
                presentation.cellSelectionRanges = selection.ranges.map((range)=>({
                        from: range.$from.pos,
                        to: range.$to.pos
                    }));
                presentation.anchorCellPos = selection.$anchorCell.pos;
                presentation.headCellPos = selection.$headCell.pos;
            }
            const thinkingMeta = {
                presentation: presentation,
                lifecycle: {
                    kind: 'legacy-start'
                }
            };
            // Clear block selection decorations before applying the thinking state.
            api?.selection?.commands?.clearBlockSelection()({
                tr: tr
            });
            tr.setMeta((0, $5ea92dab24394af7$export$38c8fc373d691b1d), thinkingMeta);
            /**
   * Added this check so that when a userPrompt is pre-supplied in metadata (e.g. from the AI Image Generation flow),
   * we can pass in necessary metadata to the malleable-ui plugin.
   * like the userPrompt
   */ const isRovoChatRemix = remixModalMetadata?.remixSource === 'rovoChat' && remixModalMetadata.preselectedType !== undefined && (0, $2pQiO.UNSAFE_expValNoExposure)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'control') === 'variant2';
            if (remixModalMetadata && (isRovoChatRemix || remixModalMetadata.userPrompt && (remixModalMetadata.remixSource === 'suggestedRemix' && (0, $2pQiO.UNSAFE_expValNoExposure)('platform_editor_ai_content_suggested_edits', 'isEnabled', false) || (0, $anBbz.expValEqualsNoExposure)('cc_page_experiences_editor_image_generation', 'isEnabled', true)))) tr.setMeta((0, $bpOXf.malleableUiPluginKey), {
                isRemixModalOpen: false,
                remixModalMetadata: remixModalMetadata,
                remixSource: remixModalMetadata.remixSource,
                remixUpdateScrollTargetUrl: undefined
            });
            else tr.setMeta((0, $bpOXf.malleableUiPluginKey), {
                isRemixModalOpen: false,
                remixUpdateScrollTargetUrl: undefined
            });
            // Move the active selection away from the selected node so the user can
            // continue editing while the remix is processing.
            const endPos = isNodeSelection ? selection.from + selection.node.nodeSize : selection.to;
            if (isNodeSelection && (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar')) {
                const $endPos = tr.doc.resolve(endPos);
                tr.setSelection((0, $4EksL.GapCursorSelection).valid($endPos) ? new (0, $4EksL.GapCursorSelection)($endPos, (0, $eaLat.Side).RIGHT) : (0, $kCECX.TextSelection).create(tr.doc, endPos));
            } else tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, endPos));
            return tr;
        };
function $3ed7f22374c9e3fb$export$fdf82e9851b59bf0({ api: api, options: options }) {
    api?.aiExperience?.actions.toggleAiEntryPoints?.(true);
    api?.core.actions.execute(api?.malleableUi.commands.startRemixThinking(options));
}


/** Finds nodes matching `localIds` in doc order; `from`/`to` are each block's content span. */ const $5708e7965bf3427a$var$findMatchedAnchors = (doc, localIds)=>{
    const wanted = new Set(localIds);
    const matches = [];
    if (wanted.size === 0) return matches;
    doc.descendants((node, pos)=>{
        const id = node.attrs?.localId;
        if (typeof id === 'string' && wanted.has(id)) {
            matches.push({
                nodePos: pos,
                nodeType: node.type.name,
                from: pos + 1,
                to: pos + node.nodeSize - 1
            });
            return false;
        }
        return true;
    });
    return matches;
};
const $5708e7965bf3427a$export$e34b9fef80996931 = (api)=>({ localIds: localIds, remixModalMetadata: remixModalMetadata })=>({ tr: tr })=>{
            const matches = $5708e7965bf3427a$var$findMatchedAnchors(tr.doc, localIds ?? []);
            if (matches.length === 1) (0, $1cd013bee2f15b85$export$5dcb9dab860f04dd)(api)({
                nodePos: matches[0].nodePos,
                nodeType: matches[0].nodeType,
                source: remixModalMetadata.remixSource
            })({
                tr: tr
            });
            else if (matches.length > 1) (0, $1cd013bee2f15b85$export$5dcb9dab860f04dd)(api)({
                from: Math.min(...matches.map((m)=>m.from)),
                to: Math.max(...matches.map((m)=>m.to)),
                source: remixModalMetadata.remixSource
            })({
                tr: tr
            });
            const selection = tr.selection;
            const capturedSelectionContext = {
                selectionFragment: (0, $2ROjz.getFragmentsFromSelection)(selection),
                localIds: (0, $3rWk6.getLocalIdsFromSelection)(selection),
                selectionMarkdown: null,
                startIndex: selection.$from.parentOffset,
                endIndex: selection.$to.parentOffset
            };
            (0, $3ed7f22374c9e3fb$export$b0011c604093029)(api)({
                remixModalMetadata: {
                    ...remixModalMetadata,
                    capturedSelectionContext: capturedSelectionContext
                }
            })({
                tr: tr
            });
            return tr;
        };







const $756f290e221243c1$export$a5258d8cd6540560 = ()=>({ tr: tr })=>{
        tr.setMeta((0, $bpOXf.malleableUiPluginKey), {
            showSubtypeAdjustedFlag: true
        });
        return tr;
    };
const $756f290e221243c1$export$cc7138497964f45a = ()=>({ tr: tr })=>{
        tr.setMeta((0, $bpOXf.malleableUiPluginKey), {
            showSubtypeAdjustedFlag: false
        });
        return tr;
    };





function $7725f70f68e88b96$export$b3219bd5df32333({ id: id }) {
    return ({ tr: tr })=>{
        tr.setMeta((0, $bpOXf.malleableUiPluginKey), {
            addInFlightVariantUpdateId: id
        });
        return tr;
    };
}
function $7725f70f68e88b96$export$242a1c29a4a1fdc3({ id: id }) {
    return ({ tr: tr })=>{
        tr.setMeta((0, $bpOXf.malleableUiPluginKey), {
            removeInFlightVariantUpdateId: id
        });
        return tr;
    };
}



function $51d6f7d12f1d2e45$export$de0bdc3bedba2bdf(options) {
    return ({ tr: tr })=>{
        tr.setMeta((0, $93f21268088062df$export$2e13bdf171bca4ae), {
            type: 'updateRemixImageHistoryFieldId',
            payload: {
                conversationId: options.conversationId,
                fieldId: options.fieldId
            }
        });
        return tr;
    };
}














/**
 * Remix block control: positioned at the right edge of the block.
 * Uses anchor(anchorName end) or getRightPositionForRootElement (same coordinate system
 * as left controls). The widget span has no position:relative so position:absolute
 * uses the same containing block as the node.
 */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $lOiVq = parcelRequire("lOiVq");


var $cbY7C = parcelRequire("cbY7C");





var $1sCHt = parcelRequire("1sCHt");


var $3k5Tv = parcelRequire("3k5Tv");


var $k8PFz = parcelRequire("k8PFz");


var $fKt2m = parcelRequire("fKt2m");

var $jWiWP = parcelRequire("jWiWP");

var $69FTU = parcelRequire("69FTU");

var $bdkuW = parcelRequire("bdkuW");

var $hTjcC = parcelRequire("hTjcC");

var $lhJQI = parcelRequire("lhJQI");


var $1pCE4 = parcelRequire("1pCE4");


var $cha5E = parcelRequire("cha5E");








var $ieeJu = parcelRequire("ieeJu");





var $lpNn5 = parcelRequire("lpNn5");








var $iBsvI = parcelRequire("iBsvI");





var $8GyO5 = parcelRequire("8GyO5");











const $3397a9320ab7f32b$export$95a12c22f1d400bc = new (0, $kCECX.PluginKey)('remixHoverHighlightPlugin');
const $3397a9320ab7f32b$export$cb3fa8e98acae648 = 'remix-hover-highlight';
const $3397a9320ab7f32b$var$getHeadingSectionDecorations = ({ doc: doc, headingPos: headingPos, className: className })=>{
    const headingSection = (0, $6687d9fc6cf5746d$export$e8f38c0ba1044114)(doc, headingPos);
    if (!headingSection) return [];
    const decorations = [];
    let currentPos = headingSection.startPos;
    for(let index = headingSection.startIndex; index < headingSection.endIndex; index++){
        const child = doc.child(index);
        decorations.push((0, $8nvEM.Decoration).node(currentPos, currentPos + child.nodeSize, {
            class: className
        }));
        currentPos += child.nodeSize;
    }
    return decorations;
};
function $3397a9320ab7f32b$export$1c5a63402318eb67() {
    return new (0, $kpCD8.SafePlugin)({
        key: $3397a9320ab7f32b$export$95a12c22f1d400bc,
        state: {
            init () {
                return {
                    highlightedPos: null,
                    decorationSet: (0, $8nvEM.DecorationSet).empty
                };
            },
            apply (tr, pluginState, _oldState, newState) {
                const meta = tr.getMeta($3397a9320ab7f32b$export$95a12c22f1d400bc);
                if (meta !== undefined) {
                    if (meta.highlightPos === null) // Clear highlight
                    return {
                        highlightedPos: null,
                        decorationSet: (0, $8nvEM.DecorationSet).empty
                    };
                    const pos = meta.highlightPos;
                    const node = newState.doc.nodeAt(pos);
                    if (!node) return pluginState;
                    const decorationClassNames = meta.rootNodeType === 'table' ? [
                        'ak-editor-selected-node'
                    ] : [
                        $3397a9320ab7f32b$export$cb3fa8e98acae648
                    ];
                    const className = decorationClassNames.join(' ');
                    const headingSectionDecorations = $3397a9320ab7f32b$var$getHeadingSectionDecorations({
                        doc: newState.doc,
                        headingPos: pos,
                        className: className
                    });
                    const decorations = headingSectionDecorations.length > 0 ? headingSectionDecorations : [
                        (0, $8nvEM.Decoration).node(pos, pos + node.nodeSize, {
                            class: className
                        })
                    ];
                    const decorationSet = (0, $8nvEM.DecorationSet).create(newState.doc, decorations);
                    return {
                        highlightedPos: pos,
                        decorationSet: decorationSet
                    };
                }
                // Map decorations on doc changes
                if (pluginState.highlightedPos !== null && pluginState.decorationSet !== (0, $8nvEM.DecorationSet).empty) {
                    const mappedDecorationSet = pluginState.decorationSet.map(tr.mapping, newState.doc);
                    if (mappedDecorationSet !== pluginState.decorationSet) {
                        const mappedPos = tr.mapping.map(pluginState.highlightedPos);
                        return {
                            ...pluginState,
                            highlightedPos: mappedPos,
                            decorationSet: mappedDecorationSet
                        };
                    }
                }
                return pluginState;
            }
        },
        props: {
            decorations (state) {
                return $3397a9320ab7f32b$export$95a12c22f1d400bc.getState(state)?.decorationSet ?? (0, $8nvEM.DecorationSet).empty;
            }
        }
    });
}



var $lhZdS = parcelRequire("lhZdS");

/**
 * Remix button visibility for Malleable Content. Canonical deny list and show rules.
 * Use with block-controls activeNode (or a full PM node) and these filters in both edit and view.
 */ 









var $1qYXT = parcelRequire("1qYXT");

/**
 * Confluence-side read of `REMIX_EXPANDS_EXPERIMENT`, which unlocks Remix for expands.
 *
 * Exposure fires here because this is only reached for an expand node — i.e. at the point where
 * an expand Remix entry point is about to be shown or withheld.
 */ const $444f275c146ea05d$var$areRemixExpandsEnabled = ()=>(0, $4o0zT.isExperimentEnabled)((0, $1qYXT.REMIX_EXPANDS_EXPERIMENT));
const $444f275c146ea05d$export$d3f1ba79de0d4efe = [
    'mediaSingle',
    'media'
];
const $444f275c146ea05d$export$ebd59c3751cfcc95 = (node)=>{
    if (!node) return false;
    // Aya's principle:
    // Empty anything should not have the Remix button shown
    // Once there is text or something in the element, we can show it
    // NOTE: Currently, we are ignoring "something" because Remix can't handle only emoji, status, etc.
    return node.textContent.trim().length === 0;
};
const $444f275c146ea05d$export$dad9e20bd9ca4fef = 'editor-floating-toolbar__remix-button';
const $444f275c146ea05d$export$287305cbde0809e = 'editor-floating-toolbar__remove-background-button';
const $444f275c146ea05d$export$20c713d08b4969ef = [
    0,
    8
];
const $444f275c146ea05d$export$e1c7ad9e4a3badb9 = 'malleable-ui-remix-floating-toolbar-anchor';
const $444f275c146ea05d$export$2c2cd6cb969bd93a = ()=>(0, $2pQiO.UNSAFE_expValNoExposure)((0, $1qYXT.REMIX_MENU_EXPERIMENT), (0, $1qYXT.REMIX_MENU_COHORT_PARAM), (0, $1qYXT.REMIX_MENU_CONTROL_COHORT)) === (0, $1qYXT.REMIX_MENU_INLINE_DROPDOWN_COHORT);
/**
 * MBE extension keys that are allowed to use Remix in Confluence.
 * The allow list is owned by the product layer so product-specific
 * decisions stay out of platform code.
 *
 * Already gated by the existing `cc-maui` experiment (controls Remix
 * visibility) and `confluence_native_tabs_experiment` (controls
 * whether native tabs nodes exist in the editor).
 */ const $444f275c146ea05d$var$REMIX_MBE_ALLOW_LIST = [
    'native-tabs'
];
/**
 * Extension keys that are allowed to use Remix in Confluence, no empty check.
 * The allow list is owned by the product layer so product-specific
 * decisions stay out of platform code.
 *
 * Emptiness checks don't make sense for extensions like native embeds because
 * they don't have text content.
 */ const $444f275c146ea05d$var$REMIX_NO_EMPTY_CHECK_EXTENSION_ALLOW_LIST = new Set([
    'native-embed:page'
]);
/**
 * Check if the extension key is allowed to use Remix, gated by feature flags.
 */ const $444f275c146ea05d$var$isAllowedExtensionForRemixNoEmptyCheck = (extensionKey)=>$444f275c146ea05d$var$REMIX_NO_EMPTY_CHECK_EXTENSION_ALLOW_LIST.has(extensionKey) && (0, $iDrrr.fg)('maui_remixable_page_native_embeds');
const $444f275c146ea05d$export$ff7e5ebac3487125 = (context)=>{
    const nodeType = context.node?.type?.name ?? context.nodeType;
    if (nodeType === undefined) return false;
    // Allow specific MBE variants (e.g. native tabs) even though the generic
    // multiBodiedExtension type is in the deny list.
    if (nodeType === 'multiBodiedExtension' && context.node) {
        const extensionKey = context.node.attrs?.extensionKey;
        if ((0, $1qYXT.isAllowedMBEExtensionForRemix)(extensionKey, $444f275c146ea05d$var$REMIX_MBE_ALLOW_LIST)) return true;
        return false;
    }
    const extensionKey = context.node?.attrs?.extensionKey ?? context.extensionKey ?? '';
    if (nodeType === 'extension' && $444f275c146ea05d$var$isAllowedExtensionForRemixNoEmptyCheck(extensionKey)) return true;
    // Expands are deny-listed by default and only become remixable under
    // `REMIX_EXPANDS_EXPERIMENT`; every other deny-listed type is unaffected. The thunk is only
    // invoked for expand nodes, so selecting a paragraph or a table never fires an exposure.
    if ((0, $1qYXT.isRemixRestrictedNodeTypeWithExpands)(nodeType, $444f275c146ea05d$var$areRemixExpandsEnabled)) return false;
    return !$444f275c146ea05d$export$ebd59c3751cfcc95(context.node);
};








const $185ff2366808da00$export$5626baa73ed0afeb = (formatMessage, reason)=>{
    // Hosts always pass a reason with their own `isDisabled`, so no reason means the AI entry points
    // are disabled because an AI flow (e.g. a Rovo Remix stream) is running on the page.
    if (reason === undefined && (0, $iDrrr.fg)('remix_state_rearchitecture_enabled')) return formatMessage((0, $lhZdS.messages).remixInProgressTooltip);
    switch(reason){
        case 'version-history':
            return formatMessage((0, $lhZdS.messages).remixDisabledTooltipVersionHistory);
        case 'archived':
        default:
            return formatMessage((0, $lhZdS.messages).remixDisabledTooltipArchived);
    }
};


const $d1c28dddb88abfdb$export$44c2dcb159008a4b = (state)=>Boolean(state?.aiDecorationExperiencePluginState?.isRunning || state?.isStreaming || state?.isShowingAcceptRejectScreen);


parcelRequire("cozmU");

const $1e53a3d0eb9e77e8$export$6c1a73717c6bf793 = ({ children: children })=>children([]);


function $1147f98e36d88087$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1147f98e36d88087$var$REMIX_BUTTON_HEIGHT = 24;
const $1147f98e36d88087$var$REMIX_BUTTON_WIDTH = 24;
const $1147f98e36d88087$var$REMIX_BUTTON_DIMENSIONS = {
    width: $1147f98e36d88087$var$REMIX_BUTTON_WIDTH,
    height: $1147f98e36d88087$var$REMIX_BUTTON_HEIGHT
};
const $1147f98e36d88087$var$REMIX_BUTTON_RIGHT_OFFSET = 55;
// Column layout (layoutSection) has breakout resize handles extending to the right; push Remix button further so it doesn't overlap
const $1147f98e36d88087$var$REMIX_BUTTON_RIGHT_OFFSET_LAYOUT_SECTION = 91;
const $1147f98e36d88087$var$INNER_CONTAINER_SELECTORS = {
    embedCard: '.rich-media-item',
    table: '.resizer-item',
    mediaSingle: '.resizer-item',
    extension: '.extension-container[data-layout]',
    bodiedExtension: '.extension-container[data-layout]',
    blockCard: '.datasourceView-content-inner-wrap'
};
const $1147f98e36d88087$var$getInnerContainerAndEdgeCase = (dom, rootNodeType)=>{
    const selector = $1147f98e36d88087$var$INNER_CONTAINER_SELECTORS[rootNodeType];
    const innerContainer = selector ? dom.querySelector(selector) : null;
    // Edge case: nodes with nested inner containers (resizer, extension, embedCard, blockCard)
    // require offset-based positioning including dom.offsetLeft because anchor-based positioning
    // doesn't correctly account for the nested layout. Occurs when the inner container exists and
    // the block is not aligned to the right edge of the editor content area.
    const isEdgeCase = selector !== undefined && innerContainer !== null;
    return {
        innerContainer: innerContainer,
        isEdgeCase: isEdgeCase
    };
};
const $1147f98e36d88087$var$containerBaseStyles = {
    name: "1sgo8pu",
    styles: "position:absolute;z-index:100;display:flex;align-items:flex-start;justify-content:center"
};
const $1147f98e36d88087$var$stickyButtonContainerStyles = {
    name: "cdscbk",
    styles: "top:8px;position:sticky;display:block;z-index:100;button{border-radius:var(--ds-radius-full, 9999px);}"
};
const $1147f98e36d88087$var$stickyButtonContainerStylesStickyHeader = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-remix-button-container]:has(~ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $k8PFz.tableControlsSpacing)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-remix-button-container]):has(~ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $k8PFz.tableControlsSpacing)
    }
});
const $1147f98e36d88087$var$stickyButtonContainerStylesImprovedStickyHeader = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-remix-button-container]:has(~ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $k8PFz.tableControlsSpacing)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-remix-button-container]:has(~ [data-prosemirror-mark-name="fragment"] >[data-prosemirror-node-name="table"] tr.pm-table-row-native-sticky.pm-table-row-native-sticky-active) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: `${(0, $hTjcC.STICKY_CONTROLS_TOP_MARGIN_FOR_STICKY_HEADER)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-remix-button-container]:has(~ [data-prosemirror-node-name="table"] tr.pm-table-row-native-sticky.pm-table-row-native-sticky-active) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: `${(0, $hTjcC.STICKY_CONTROLS_TOP_MARGIN_FOR_STICKY_HEADER)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-remix-button-container]:has(~ [data-prosemirror-mark-name="fragment"] >[data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $k8PFz.tableControlsSpacing)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-remix-button-container]):has(~ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $k8PFz.tableControlsSpacing)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-remix-button-container]):has(~ [data-prosemirror-mark-name="fragment"] >[data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $k8PFz.tableControlsSpacing)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-remix-button-container]):has(~ [data-prosemirror-node-name="table"] tr.pm-table-row-native-sticky.pm-table-row-native-sticky-active) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: `${(0, $hTjcC.STICKY_CONTROLS_TOP_MARGIN_FOR_STICKY_HEADER)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-remix-button-container]):has(~ [data-prosemirror-mark-name="fragment"] >[data-prosemirror-node-name="table"] tr.pm-table-row-native-sticky.pm-table-row-native-sticky-active) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: `${(0, $hTjcC.STICKY_CONTROLS_TOP_MARGIN_FOR_STICKY_HEADER)}px`
    }
});
const $1147f98e36d88087$export$e420cb1e340b26d1 = ({ view: view, api: api, getPos: getPos, anchorName: anchorName, isDisabled: isDisabled, isRovoLLMEnabled: isRovoLLMEnabled, livePage: livePage, remixDisabledReason: remixDisabledReason, rootAnchorName: rootAnchorName, rootNodeType: rootNodeType, rootPos: rootPos, remixHiddenOptionsResolver: RemixHiddenOptionsResolver = (0, $1e53a3d0eb9e77e8$export$6c1a73717c6bf793) })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { macroInteractionUpdates: macroInteractionUpdates, editorViewMode: editorViewMode, activeNode: activeNode, rightSideControlsEnabled: rightSideControlsEnabled, hoverSide: hoverSide, contentId: contentId, isOwnRemixing: isOwnRemixing, isAnyRemixing: isAnyRemixing, aiEditInProgress: aiEditInProgress, areAiEntryPointsDisabled: areAiEntryPointsDisabled } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'featureFlags',
        'editorViewMode',
        'blockControls',
        'contextIdentifier',
        'malleableUi',
        'aiExperience'
    ], (states)=>({
            macroInteractionUpdates: states.featureFlagsState?.macroInteractionUpdates,
            editorViewMode: states.editorViewModeState?.mode,
            activeNode: states.blockControlsState?.activeNode,
            rightSideControlsEnabled: states.blockControlsState?.rightSideControlsEnabled ?? false,
            hoverSide: states.blockControlsState?.hoverSide,
            contentId: states.contextIdentifierState?.contextIdentifierProvider?.objectId,
            isOwnRemixing: states.malleableUiState?.isRemixModalOpen || false || states.malleableUiState?.isThinking || false,
            // Only the editor treatment projects this, from the shared Remix registry.
            isAnyRemixing: states.malleableUiState?.isAnyRemixing ?? false,
            areAiEntryPointsDisabled: states.aiExperienceState?.areAiEntryPointsDisabled ?? false,
            aiEditInProgress: (0, $d1c28dddb88abfdb$export$44c2dcb159008a4b)(states.aiExperienceState)
        }));
    // A Remix from another surface (e.g. the Object Sidebar, including one still generating in
    // Rovo Chat after its handoff) is also in progress, and the machine would refuse a new start.
    const isRemixing = isOwnRemixing || isAnyRemixing;
    const isInlineDropdownVariant = (0, $444f275c146ea05d$export$2c2cd6cb969bd93a)();
    const isViewMode = editorViewMode === 'view';
    // pageMode for analytics: 'editor' = full page editor, 'liveEdit' = live page edit, 'liveView' = live page view (livePage set by Confluence).
    const pageMode = editorViewMode === 'edit' && !livePage ? 'editor' : editorViewMode === 'edit' && livePage ? 'liveEdit' : editorViewMode === 'view' && livePage ? 'liveView' : undefined;
    const isRemixAvailable = isRovoLLMEnabled && (0, $anBbz.expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true);
    // Use block-controls shared state (activeNode) + reusable filter instead of DOM checks for restricted nodes.
    // When activeNode is null (e.g. on initial render), default to showing the button — the anchor/position
    // logic handles visibility. Only block when we have an explicit restricted node type.
    const activeNodeType = activeNode?.rootNodeType ?? activeNode?.nodeType;
    const activeNodeExtensionKey = activeNode && activeNodeType === 'extension' ? view.state.doc.nodeAt(activeNode?.rootPos ?? activeNode.pos)?.attrs?.extensionKey : undefined;
    const showRemixButton = activeNodeType === undefined || (0, $444f275c146ea05d$export$ff7e5ebac3487125)({
        nodeType: activeNodeType,
        extensionKey: activeNodeExtensionKey
    });
    const hasRemixOrEditInProgress = (isRemixing || aiEditInProgress) && (0, $4o0zT.isExperimentEnabled)('cc_maui_polish_changes_batch_6');
    // Fire the experiments associated with this Remix control when it becomes visible.
    const hasFiredExposureRef = (0, $cozmU.useRef)(false);
    const isActiveBlock = activeNode?.rootPos === rootPos && activeNode?.rootAnchorName === (rootAnchorName ?? anchorName);
    const isRightSideVisible = rightSideControlsEnabled && (hoverSide === 'right' || isViewMode);
    (0, $cozmU.useEffect)(()=>{
        if (hasFiredExposureRef.current || !isActiveBlock || !isRightSideVisible || !isRemixAvailable || !showRemixButton || hasRemixOrEditInProgress || areAiEntryPointsDisabled) return;
        (0, $iDrrr.fg)('confluence_remix_button_right_side_block_fg');
        (0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true);
        (0, $ieeJu.expValEquals)('cc_maui_remix_button_hover_corridor', 'isEnabled', true);
        hasFiredExposureRef.current = true;
    }, [
        areAiEntryPointsDisabled,
        hasRemixOrEditInProgress,
        isActiveBlock,
        isRemixAvailable,
        isRightSideVisible,
        showRemixButton
    ]);
    const [positionStyles, setPositionStyles] = (0, $cozmU.useState)({
        display: 'none'
    });
    // Shared offset-based positioning for view mode and edit-mode fallback.
    // Horizontal (left) uses getRightPositionForRootElement; vertical uses getTopPosition.
    const rightOffset = rootNodeType === 'layoutSection' ? $1147f98e36d88087$var$REMIX_BUTTON_RIGHT_OFFSET_LAYOUT_SECTION : $1147f98e36d88087$var$REMIX_BUTTON_RIGHT_OFFSET;
    const getOffsetBasedPosition = (0, $cozmU.useCallback)((dom, safeAnchorName)=>{
        const { innerContainer: innerContainer, isEdgeCase: isEdgeCase } = $1147f98e36d88087$var$getInnerContainerAndEdgeCase(dom, rootNodeType);
        const isExtension = rootNodeType === 'extension' || rootNodeType === 'bodiedExtension';
        const isMacroInteractionUpdates = macroInteractionUpdates && isExtension;
        const isSticky = (0, $jWiWP.shouldBeSticky)(rootNodeType);
        const rightEdgeLeft = (0, $69FTU.getRightPositionForRootElement)(dom, rootNodeType, $1147f98e36d88087$var$REMIX_BUTTON_DIMENSIONS, innerContainer ?? undefined, isMacroInteractionUpdates);
        const height = (0, $jWiWP.getControlHeightCSSValue)((0, $jWiWP.getNodeHeight)(dom, safeAnchorName) || 0, isSticky, true, `${$1147f98e36d88087$var$REMIX_BUTTON_DIMENSIONS.height}`);
        return {
            left: isEdgeCase ? `calc(${dom.offsetLeft}px + (${rightEdgeLeft}) + ${rightOffset}px)` : `calc(${rightEdgeLeft} + ${rightOffset}px)`,
            top: (0, $jWiWP.getTopPosition)(dom, rootNodeType),
            ...height,
            bottom: 'unset'
        };
    }, [
        rootNodeType,
        macroInteractionUpdates,
        rightOffset
    ]);
    // Edit mode: anchor-based when supported, otherwise offset-based (same as view mode).
    const calculatePosition = (0, $cozmU.useCallback)(()=>{
        const safeAnchorName = (0, $bdkuW.refreshAnchorName)({
            getPos: getPos,
            view: view,
            anchorName: rootAnchorName ?? anchorName
        });
        let dom = view.dom.querySelector(`[${(0, $fKt2m.getAnchorAttrName)()}="${safeAnchorName}"]`);
        // Fallback: table nodes use data-node-anchor (set by table-anchor-names plugin) rather than
        // data-drag-handler-anchor-name. When getAnchorAttrName() returns the drag-handler attribute
        // (experiment disabled), the primary query above finds nothing. Try data-node-anchor as a
        // fallback so tables work regardless of the platform_editor_native_anchor_with_dnd experiment.
        if (!dom) dom = view.dom.querySelector(`[data-node-anchor="${safeAnchorName}"]`);
        if (!dom) return {
            display: 'none'
        };
        // For layoutSection, the anchor attribute is on the outer ReactNodeView wrapper div which
        // may have a larger offsetWidth than the actual layout section content area.
        // Use the inner [data-layout-section] element for accurate width-based positioning.
        // Keep a reference to the outer wrapper: getTopPosition needs it because the inner
        // [data-layout-section] element's offsetTop is ~0 relative to the wrapper.
        const outerDom = dom;
        if (rootNodeType === 'layoutSection') dom = dom.querySelector('[data-layout-section]') ?? dom;
        const isSticky = (0, $jWiWP.shouldBeSticky)(rootNodeType);
        // View mode always uses offset-based (anchor positioning can differ in view mode).
        if (isViewMode) {
            // layoutSection: the inner element's right edge gives the correct width, but its
            // offsetTop is ~0 (relative to the wrapper). Mirror the table branch — use a single
            // getBoundingClientRect() diff for the right edge and getTopPosition(outerDom) for top.
            if (rootNodeType === 'layoutSection') {
                const gap = (0, $hTjcC.rootElementGap)(rootNodeType);
                const layoutRight = outerDom.offsetLeft + (dom.getBoundingClientRect().right - outerDom.getBoundingClientRect().left) - gap - $1147f98e36d88087$var$REMIX_BUTTON_DIMENSIONS.width;
                const height = (0, $jWiWP.getControlHeightCSSValue)((0, $jWiWP.getNodeHeight)(outerDom, safeAnchorName) || 0, isSticky, true, `${$1147f98e36d88087$var$REMIX_BUTTON_DIMENSIONS.height}`);
                return {
                    left: `calc(${layoutRight}px + ${rightOffset}px)`,
                    top: (0, $jWiWP.getTopPosition)(outerDom, rootNodeType),
                    ...height,
                    bottom: 'unset'
                };
            }
            // In view mode, tables have no .resizer-item so isEdgeCase=false and getOffsetBasedPosition
            // uses dom.offsetWidth (editor width) instead of the actual table width. For wide/max tables
            // this places the button at the editor margin, not the table's right edge.
            // Use the first <tr> as the inner reference (same role as .resizer-item in edit mode):
            // tr.offsetLeft + tr.offsetWidth gives the actual table right edge relative to dom.
            const tableRow = rootNodeType === 'table' || rootNodeType === '' ? dom.querySelector('thead tr, tr') : null;
            if (tableRow) {
                const effectiveNodeType = rootNodeType || 'table';
                const gap = (0, $hTjcC.rootElementGap)(effectiveNodeType);
                // Get the tr's right edge relative to dom's left edge using BoundingClientRect
                // (avoids offset-parent chain issues between tr and the nodeview wrapper).
                const trRight = tableRow.getBoundingClientRect().right - dom.getBoundingClientRect().left;
                const rightEdgeLeft = dom.offsetLeft + trRight - gap - $1147f98e36d88087$var$REMIX_BUTTON_DIMENSIONS.width;
                const isSticky = (0, $jWiWP.shouldBeSticky)(effectiveNodeType);
                const height = (0, $jWiWP.getControlHeightCSSValue)((0, $jWiWP.getNodeHeight)(dom, safeAnchorName) || 0, isSticky, true, `${$1147f98e36d88087$var$REMIX_BUTTON_DIMENSIONS.height}`);
                return {
                    left: `calc(${rightEdgeLeft}px + ${rightOffset}px)`,
                    top: (0, $jWiWP.getTopPosition)(dom, effectiveNodeType),
                    ...height,
                    bottom: 'unset'
                };
            }
            return getOffsetBasedPosition(dom, safeAnchorName);
        }
        const { isEdgeCase: isEdgeCase } = $1147f98e36d88087$var$getInnerContainerAndEdgeCase(dom, rootNodeType);
        // Check anchor first (no reflow). Only use offset-based when fallback needed.
        const supportsAnchorRight = CSS.supports('left', `anchor(${safeAnchorName} end)`) && CSS.supports('top', `anchor(${safeAnchorName} start)`);
        if (supportsAnchorRight && !isEdgeCase) return {
            left: `calc(anchor(${safeAnchorName} end) - ${$1147f98e36d88087$var$REMIX_BUTTON_DIMENSIONS.width}px - ${(0, $hTjcC.rootElementGap)(rootNodeType)}px + ${rightOffset}px)`,
            top: `calc(anchor(${safeAnchorName} start) + ${(0, $hTjcC.topPositionAdjustment)(rootNodeType)}px)`,
            ...(0, $jWiWP.getControlBottomCSSValue)(safeAnchorName, isSticky, true)
        };
        return getOffsetBasedPosition(dom, safeAnchorName);
    }, [
        view,
        getPos,
        anchorName,
        rootAnchorName,
        rootNodeType,
        isViewMode,
        getOffsetBasedPosition,
        rightOffset
    ]);
    // Recompute button position on mount and when the block's right edge can shift after mount:
    // - extension/embedCard layout changes (expand/collapse) via transitionend
    // - the editor content area resizing, e.g. the Rovo chat panel opening/closing (MAUI-923).
    //   Tables (and other pixel-positioned edge-case nodes) derive an absolute `left` from the
    //   block's right edge, and never use the self-reflowing CSS anchor() path, so without a
    //   resize listener the button keeps a stale position and can end up inside a wide table.
    //   Observe the same scroll-parent editor-plugin-block-controls observes for its own controls.
    (0, $cozmU.useEffect)(()=>{
        let cleanUpTransitionListener;
        if (rootNodeType === 'extension' || rootNodeType === 'embedCard') {
            const anchorDom = view.dom.querySelector(`[${(0, $fKt2m.getAnchorAttrName)()}="${rootAnchorName ?? anchorName}"]`);
            if (anchorDom) cleanUpTransitionListener = (0, $cbY7C.bind)(anchorDom, {
                type: 'transitionend',
                listener: ()=>setPositionStyles(calculatePosition())
            });
        }
        const id = requestAnimationFrame(()=>setPositionStyles(calculatePosition()));
        let resizeObserver;
        let resizeRafId;
        if (typeof ResizeObserver !== 'undefined' && (0, $iDrrr.fg)('confluence_remix_button_right_side_block_fg')) {
            const scrollParent = view.dom.closest('.fabric-editor-popup-scroll-parent') ?? view.dom;
            resizeObserver = new ResizeObserver(()=>{
                if (resizeRafId !== undefined) cancelAnimationFrame(resizeRafId);
                resizeRafId = requestAnimationFrame(()=>setPositionStyles(calculatePosition()));
            });
            resizeObserver.observe(scrollParent);
        }
        return ()=>{
            cancelAnimationFrame(id);
            cleanUpTransitionListener?.();
            if (resizeRafId !== undefined) cancelAnimationFrame(resizeRafId);
            resizeObserver?.disconnect();
        };
    }, [
        calculatePosition,
        view.dom,
        rootAnchorName,
        rootNodeType,
        anchorName,
        isViewMode
    ]);
    const [isDropdownOpen, setIsDropdownOpen] = (0, $cozmU.useState)(false);
    const nodePosRef = (0, $cozmU.useRef)(undefined);
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    const clearHoverHighlight = (0, $cozmU.useCallback)(()=>{
        if ((0, $iDrrr.fg)('cc-maui-phase-3')) api?.core.actions.execute(({ tr: tr })=>tr.setMeta((0, $3397a9320ab7f32b$export$95a12c22f1d400bc), {
                highlightPos: null
            }));
    }, [
        api
    ]);
    const openRemix = (0, $cozmU.useCallback)((preselection)=>{
        const featureArea = (0, $iBsvI.getRemixFeatureArea)({});
        experienceTracker.start({
            name: (0, $irnO2.ExperienceName).REMIX_START,
            id: (0, $irnO2.ExperienceName).REMIX_START,
            attributes: {
                entryPoint: 'editor',
                remixSource: 'blockNudge',
                product: 'confluence',
                ...featureArea !== undefined && {
                    featureArea: featureArea
                }
            }
        });
        (0, $kDDrf.startRemixCreateExperience)({
            experienceTracker: experienceTracker,
            attributes: {
                entryPoint: 'editor',
                remixSource: 'blockNudge',
                product: 'confluence'
            }
        });
        // Clear the hover highlight decoration before opening the modal to prevent flashing
        clearHoverHighlight();
        api?.core.actions.execute(api?.malleableUi.commands.openRemixModal({
            nodePos: nodePosRef.current,
            nodeType: rootNodeType,
            metadata: {
                interactionSource: 'remixModalFromNudge',
                ...preselection && {
                    preselectedType: preselection.type,
                    preselectedSubType: preselection.subType,
                    ...preselection.userPrompt && {
                        preselectedUserPrompt: preselection.userPrompt
                    }
                }
            },
            source: 'blockNudge'
        }));
    }, [
        api,
        clearHoverHighlight,
        experienceTracker,
        rootNodeType
    ]);
    const handleClick = (0, $cozmU.useCallback)(()=>{
        if (isDisabled) return;
        nodePosRef.current = getPos();
        (0, $cha5E.expVal)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'control');
        (0, $cha5E.expVal)('cc-ce-maui-remix-menu-multivariant-aa', 'variant', 'control');
        if (isInlineDropdownVariant) {
            clearHoverHighlight();
            setIsDropdownOpen(true);
            return;
        }
        openRemix();
    }, [
        clearHoverHighlight,
        getPos,
        isDisabled,
        isInlineDropdownVariant,
        openRemix
    ]);
    const closeDropdown = (0, $cozmU.useCallback)(()=>setIsDropdownOpen(false), []);
    const handleOptionSelect = (0, $cozmU.useCallback)((selection)=>{
        closeDropdown();
        openRemix(selection);
    }, [
        closeDropdown,
        openRemix
    ]);
    // Re-affirm activeNode when entering the remix button to prevent disappearing when moving
    // from block toward the button. Skip if already active to avoid flickering from re-dispatch.
    const handleMouseEnter = (0, $cozmU.useCallback)(()=>{
        const anchor = rootAnchorName ?? anchorName;
        if (activeNode?.rootAnchorName === anchor && activeNode?.rootPos === rootPos) return;
        api?.core?.actions.execute(api?.blockControls?.commands.showDragHandleAt(rootPos, anchor, rootNodeType, undefined, rootPos, anchor, rootNodeType));
    }, [
        api,
        rootPos,
        anchorName,
        rootAnchorName,
        rootNodeType,
        activeNode?.rootAnchorName,
        activeNode?.rootPos
    ]);
    // Show hover highlight decoration on the content block when hovering the Remix button
    const handleRemixButtonMouseEnter = (0, $cozmU.useCallback)(()=>{
        if (!(0, $iDrrr.fg)('cc-maui-phase-3')) return;
        const tr = view.state.tr;
        tr.setMeta((0, $3397a9320ab7f32b$export$95a12c22f1d400bc), {
            highlightPos: rootPos,
            rootNodeType: rootNodeType
        });
        view.dispatch(tr);
    }, [
        view,
        rootPos,
        rootNodeType
    ]);
    const handleRemixButtonMouseLeave = (0, $cozmU.useCallback)(()=>{
        if (!(0, $iDrrr.fg)('cc-maui-phase-3')) return;
        const tr = view.state.tr;
        tr.setMeta((0, $3397a9320ab7f32b$export$95a12c22f1d400bc), {
            highlightPos: null
        });
        view.dispatch(tr);
    }, [
        view
    ]);
    if (!isRemixAvailable || !showRemixButton || areAiEntryPointsDisabled || hasRemixOrEditInProgress) return null;
    const tooltipContent = isRemixing ? formatMessage((0, $lhZdS.messages).remixInProgressTooltip) : isDisabled ? (0, $185ff2366808da00$export$5626baa73ed0afeb)(formatMessage, remixDisabledReason) : (0, $iDrrr.fg)('cc_maui_updated_remix_tooltip_text') ? formatMessage((0, $lhZdS.messages).remixBlockTooltipUpdated) : formatMessage((0, $lhZdS.messages).remixBlockTooltip);
    const renderIconButton = (triggerProps)=>/*#__PURE__*/ (0, $lOiVq.jsx)((0, $lpNn5.default), {
            content: tooltipContent,
            position: "top"
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $1sCHt.default), {
            ...triggerProps,
            spacing: "compact",
            appearance: "subtle",
            shape: "circle",
            label: formatMessage((0, $lhZdS.messages).remixBlockLabel),
            icon: ()=>/*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1pCE4))), {
                    label: "",
                    size: "small"
                }),
            isDisabled: isDisabled || isRemixing,
            isSelected: isInlineDropdownVariant ? isDropdownOpen : undefined,
            analyticsContext: {
                actionSubjectId: 'remix',
                source: 'remixModalFromNudge',
                attributes: {
                    ...pageMode !== undefined && {
                        pageMode: pageMode
                    },
                    nodeType: rootNodeType,
                    ...contentId !== undefined && contentId !== '' && {
                        contentId: contentId
                    }
                }
            },
            testId: "visible-block-ctrl-remix-button",
            onMouseEnter: handleRemixButtonMouseEnter,
            onMouseLeave: handleRemixButtonMouseLeave,
            onBlur: handleRemixButtonMouseLeave,
            onMouseDown: (e)=>e.preventDefault(),
            onClick: handleClick
        }));
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lhJQI.VisibilityContainer), {
        api: api,
        controlSide: "right",
        // Moving into the portaled menu counts as a mouse-out, but the popup is anchored to this
        // trigger so it must stay visible while open.
        forceVisibleOnMouseOut: isDropdownOpen
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $1147f98e36d88087$var$containerBaseStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Dynamic positioning (left, top, height) calculated at runtime
        style: positionStyles,
        "data-testid": "block-ctrl-remix-button",
        onMouseEnter: handleMouseEnter,
        onFocus: handleMouseEnter
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        css: [
            $1147f98e36d88087$var$stickyButtonContainerStyles,
            (0, $iDrrr.fg)('confluence_remix_button_right_side_block_fg') ? $1147f98e36d88087$var$stickyButtonContainerStylesImprovedStickyHeader : $1147f98e36d88087$var$stickyButtonContainerStylesStickyHeader
        ]
    }, isInlineDropdownVariant ? /*#__PURE__*/ (0, $lOiVq.jsx)(RemixHiddenOptionsResolver, {
        enabled: true,
        contentId: contentId
    }, (hiddenOptions)=>/*#__PURE__*/ (0, $lOiVq.jsx)((0, $8GyO5.RemixContainer), {
            hiddenOptions: hiddenOptions,
            presentation: "popup",
            trigger: renderIconButton,
            popupPlacement: "bottom-end",
            popupOffset: [
                0,
                4
            ],
            isPopupOpen: isDropdownOpen,
            isThinking: false,
            // Block-controls removes this widget decoration when the editor blurs, which would
            // unmount the menu before an option press is handled.
            shouldPreserveEditorFocus: true,
            onClose: closeDropdown,
            onOptionSelect: handleOptionSelect
        })) : renderIconButton())));
};



const $2986bbc07141fc36$var$TYPE_REMIX_BUTTON = 'REMIX_BUTTON';
const $2986bbc07141fc36$export$901fb543799e0108 = (decorations, from, to)=>{
    return decorations.find(from, to, (spec)=>spec.type === $2986bbc07141fc36$var$TYPE_REMIX_BUTTON);
};
const $2986bbc07141fc36$export$d411c8f539cb0edd = ({ api: api, isDisabled: isDisabled, isRovoLLMEnabled: isRovoLLMEnabled, livePage: livePage, remixDisabledReason: remixDisabledReason, rootPos: rootPos, anchorName: anchorName, nodeType: nodeType, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, rootAnchorName: rootAnchorName, rootNodeType: rootNodeType, remixHiddenOptionsResolver: remixHiddenOptionsResolver })=>{
    // Edit mode re-adds node decorations on routine churn, which remounts the React tree and discards
    // the open inline dropdown. `WidgetType.eq` short-circuits on `spec.key`, so keying by block
    // identity reuses the widget DOM when nothing meaningful changed.
    const shouldReuseWidget = (0, $444f275c146ea05d$export$2c2cd6cb969bd93a)();
    const key = shouldReuseWidget ? `${$2986bbc07141fc36$var$TYPE_REMIX_BUTTON}:${rootAnchorName ?? anchorName}:${rootNodeType ?? nodeType}:${rootPos}` : crypto.randomUUID();
    const widgetSpec = {
        side: -4,
        type: $2986bbc07141fc36$var$TYPE_REMIX_BUTTON,
        ...shouldReuseWidget && {
            key: key
        },
        destroy: (_)=>{
            nodeViewPortalProviderAPI.remove(key);
        }
    };
    return (0, $8nvEM.Decoration).widget(rootPos, (view, getPos)=>{
        const doc = (0, $1hQ0e.getDocument)();
        if (!doc) throw new Error('Document not available');
        const element = doc.createElement('span');
        if ((0, $iDrrr.fg)('confluence_remix_button_right_side_block_fg')) // display:contents makes the span a "phantom" box - zero layout impact,
        // so it never pushes text down when inserted inline around media/embed wraps.
        // The inner position:absolute div in RemixButtonDecoration still renders correctly.
        element.style.display = 'contents';
        else element.style.display = 'block';
        element.contentEditable = 'false';
        if ((0, $iDrrr.fg)('confluence_remix_button_right_side_block_fg')) {
            // Generic right-edge control attribute for block-controls hover area (Remix-specific: data-blocks-remix-button-*)
            element.setAttribute('data-blocks-right-edge-button-container', 'true');
            element.setAttribute('data-blocks-right-edge-button-anchor', rootAnchorName ?? anchorName);
            element.setAttribute('data-blocks-remix-button-container', 'true');
            element.setAttribute('data-blocks-remix-button-anchor', rootAnchorName ?? anchorName);
        }
        element.setAttribute('data-testid', 'block-ctrl-remix-button-container');
        nodeViewPortalProviderAPI.render(()=>(0, $cozmU.createElement)((0, $1147f98e36d88087$export$e420cb1e340b26d1), {
                api: api,
                getPos: getPos,
                view: view,
                anchorName: anchorName,
                rootAnchorName: rootAnchorName,
                rootNodeType: rootNodeType ?? nodeType,
                rootPos: rootPos,
                livePage: livePage,
                isDisabled: isDisabled,
                isRovoLLMEnabled: isRovoLLMEnabled,
                remixDisabledReason: remixDisabledReason,
                remixHiddenOptionsResolver: remixHiddenOptionsResolver
            }), element, key, undefined, true);
        return element;
    }, widgetSpec);
};





function $0714cd2e74fa9587$export$c2f4e91d1c0a0502(onEditorViewInit, onEditorViewDestroy, onEditorViewUpdate) {
    return new (0, $kpCD8.SafePlugin)({
        view (editorView) {
            onEditorViewInit(editorView);
            return {
                update (view, previousState) {
                    if (!view.state.selection.eq(previousState.selection)) onEditorViewUpdate?.(view);
                },
                destroy () {
                    onEditorViewDestroy?.();
                }
            };
        }
    });
}












function $2bef14e94508caba$export$c976fd9e927eb20d({ state: state, url: url, fieldId: fieldId }) {
    const remixHistoryState = (0, $93f21268088062df$export$2e13bdf171bca4ae).getState(state);
    const historyMap = remixHistoryState?.historyMap;
    if (!historyMap) return;
    // The lookup URL is the live URL on the node. The stack entry URL is what
    // was synthesized when the entry was pushed. They may share a MAUI app id
    // but disagree on origin (e.g. BE-driven updates that re-use the node's
    // pre-update origin vs. user-driven inserts that use window.location.origin),
    // so compare by extracted app id rather than full-string equality.
    const targetAppId = (0, $dOW9b.getMauiIdFromUrl)(url);
    for (const historyEntry of Object.values(historyMap).reverse()){
        const currentStackEntry = [
            ...historyEntry.stack
        ].reverse().find((stackEntry)=>fieldId && stackEntry.fieldId === fieldId || url && stackEntry.url === url || targetAppId && (0, $dOW9b.getMauiIdFromUrl)(stackEntry.url) === targetAppId);
        if (!currentStackEntry) continue;
        const historyEntryForUpdate = {
            ...currentStackEntry.admissionBaselineInvocationId !== undefined && {
                admissionBaselineInvocationId: currentStackEntry.admissionBaselineInvocationId
            },
            conversationId: historyEntry.conversationId,
            dynamicUiSource: historyEntry.dynamicUiSource,
            latestFinalMessage: historyEntry.latestFinalMessage,
            latestFinalMessageId: historyEntry.latestFinalMessageId,
            dynamicUiType: currentStackEntry.dynamicUiType,
            dynamicUiSubtype: currentStackEntry.dynamicUiSubtype,
            finalMessage: currentStackEntry.finalMessage,
            finalMessageId: currentStackEntry.finalMessageId,
            fieldId: currentStackEntry.fieldId,
            url: currentStackEntry.url
        };
        return historyEntryForUpdate;
    }
}


















var $93WrI = parcelRequire("93WrI");





var $8i6M6 = parcelRequire("8i6M6");

var $cCXFd = parcelRequire("cCXFd");





var $dVKvM = parcelRequire("dVKvM");





var $aDSIl = parcelRequire("aDSIl");





































const $b924ab10b3fb73fd$var$hasRemixInProgressState = (state)=>Boolean(state?.isRemixModalOpen || state?.isThinking);
const $b924ab10b3fb73fd$var$RemixBlockMenuItem = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(43);
    const { api: api, remixHiddenOptionsResolver: t1 } = t0;
    const RemixHiddenOptionsResolver = t1 === undefined ? (0, $1e53a3d0eb9e77e8$export$6c1a73717c6bf793) : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    const [isDropdownOpen, setIsDropdownOpen] = (0, $cozmU.useState)(false);
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $444f275c146ea05d$export$2c2cd6cb969bd93a)();
        $[0] = t2;
    } else t2 = $[0];
    const isInlineDropdownVariant = t2;
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = [
            "aiExperience",
            "contextIdentifier",
            "malleableUi"
        ];
        $[1] = t3;
    } else t3 = $[1];
    const { aiEditInProgress: aiEditInProgress, contentId: contentId, isRemixUpdate: isRemixUpdate, remixInProgress: remixInProgress } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, t3, $b924ab10b3fb73fd$var$_temp);
    let t4;
    if ($[2] !== aiEditInProgress || $[3] !== remixInProgress) {
        t4 = (aiEditInProgress || remixInProgress) && (0, $4o0zT.isExperimentEnabled)("cc_maui_polish_changes_batch_5");
        $[2] = aiEditInProgress;
        $[3] = remixInProgress;
        $[4] = t4;
    } else t4 = $[4];
    const isDisabled = t4;
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = [];
        $[5] = t5;
    } else t5 = $[5];
    (0, $cozmU.useEffect)($b924ab10b3fb73fd$var$_temp2, t5);
    let t6;
    if ($[6] !== api.analytics?.actions) {
        t6 = ()=>{
            api?.analytics?.actions.fireAnalyticsEvent({
                action: (0, $krYZG.ACTION).CLICKED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).AI_REMIX_BUTTON,
                eventType: (0, $krYZG.EVENT_TYPE).UI,
                attributes: {
                    entryPoint: "editor",
                    triggeredFrom: "blockMenu"
                }
            });
        };
        $[6] = api.analytics?.actions;
        $[7] = t6;
    } else t6 = $[7];
    const fireClickAnalytics = t6;
    let t7;
    if ($[8] !== api.blockControls?.commands || $[9] !== api.core || $[10] !== api.malleableUi?.commands || $[11] !== api.selection?.commands || $[12] !== experienceTracker) {
        t7 = (preselection)=>{
            api?.core?.actions.execute((t8)=>{
                const { tr: tr } = t8;
                api?.blockControls?.commands?.stopPreservingSelection()({
                    tr: tr
                });
                api?.blockControls?.commands?.toggleBlockMenu({
                    closeMenu: true
                })({
                    tr: tr
                });
                api?.selection?.commands?.clearBlockSelection()({
                    tr: tr
                });
                return tr;
            });
            const openRemixModal = api.malleableUi?.commands.openRemixModal({
                metadata: {
                    interactionSource: "remixModalFromBlockMenu",
                    ...preselection && {
                        preselectedType: preselection.type,
                        preselectedSubType: preselection.subType,
                        ...preselection.userPrompt && {
                            preselectedUserPrompt: preselection.userPrompt
                        }
                    }
                },
                source: "remixModalFromBlockMenu"
            });
            if (openRemixModal) {
                const featureArea = (0, $iBsvI.getRemixFeatureArea)({});
                experienceTracker.start({
                    name: (0, $irnO2.ExperienceName).REMIX_START,
                    id: (0, $irnO2.ExperienceName).REMIX_START,
                    attributes: {
                        entryPoint: "editor",
                        remixSource: "blockMenu",
                        ...featureArea !== undefined && {
                            featureArea: featureArea
                        }
                    }
                });
                (0, $kDDrf.startRemixCreateExperience)({
                    experienceTracker: experienceTracker,
                    attributes: {
                        entryPoint: "editor",
                        remixSource: "blockMenu"
                    }
                });
                api.core.actions.execute(openRemixModal);
            }
        };
        $[8] = api.blockControls?.commands;
        $[9] = api.core;
        $[10] = api.malleableUi?.commands;
        $[11] = api.selection?.commands;
        $[12] = experienceTracker;
        $[13] = t7;
    } else t7 = $[13];
    const openRemix = t7;
    let t8;
    if ($[14] !== fireClickAnalytics || $[15] !== isDisabled || $[16] !== openRemix) {
        t8 = ()=>{
            if (isDisabled) return;
            fireClickAnalytics();
            (0, $cha5E.expVal)("cc-ce-maui-remix-menu-multivariant", "cohort", "control");
            (0, $cha5E.expVal)("cc-ce-maui-remix-menu-multivariant-aa", "variant", "control");
            if (isInlineDropdownVariant) {
                setIsDropdownOpen($b924ab10b3fb73fd$var$_temp3);
                return;
            }
            openRemix();
        };
        $[14] = fireClickAnalytics;
        $[15] = isDisabled;
        $[16] = openRemix;
        $[17] = t8;
    } else t8 = $[17];
    const handleClick = t8;
    let t9;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = ()=>setIsDropdownOpen(false);
        $[18] = t9;
    } else t9 = $[18];
    const closeDropdown = t9;
    let t10;
    if ($[19] !== openRemix) {
        t10 = (selection)=>{
            closeDropdown();
            openRemix(selection);
        };
        $[19] = openRemix;
        $[20] = t10;
    } else t10 = $[20];
    const handleOptionSelect = t10;
    let t11;
    if ($[21] !== aiEditInProgress || $[22] !== formatMessage || $[23] !== isDisabled || $[24] !== isRemixUpdate || $[25] !== remixInProgress) {
        t11 = isDisabled ? aiEditInProgress && (!remixInProgress || isRemixUpdate) ? formatMessage((0, $lhZdS.messages).editInProgressTooltip) : formatMessage((0, $lhZdS.messages).remixInProgressTooltip) : undefined;
        $[21] = aiEditInProgress;
        $[22] = formatMessage;
        $[23] = isDisabled;
        $[24] = isRemixUpdate;
        $[25] = remixInProgress;
        $[26] = t11;
    } else t11 = $[26];
    const disabledTooltip = t11;
    let t12;
    if ($[27] !== disabledTooltip || $[28] !== formatMessage || $[29] !== handleClick || $[30] !== isDisabled || $[31] !== isDropdownOpen) {
        t12 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
                triggerRef: triggerProps?.ref,
                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1pCE4))), {
                    label: "",
                    size: "small"
                }),
                elemAfter: isInlineDropdownVariant ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                    label: "",
                    size: "small"
                }) : undefined,
                hasNestedDropdownMenu: isInlineDropdownVariant,
                onClick: handleClick,
                isSelected: isInlineDropdownVariant ? isDropdownOpen : undefined,
                isDisabled: isDisabled,
                title: disabledTooltip
            }, formatMessage((0, $93WrI.aiConfigItemMessages).remixTitle));
        $[27] = disabledTooltip;
        $[28] = formatMessage;
        $[29] = handleClick;
        $[30] = isDisabled;
        $[31] = isDropdownOpen;
        $[32] = t12;
    } else t12 = $[32];
    const renderMenuItem = t12;
    if (!isInlineDropdownVariant) {
        let t13;
        if ($[33] !== renderMenuItem) {
            t13 = renderMenuItem();
            $[33] = renderMenuItem;
            $[34] = t13;
        } else t13 = $[34];
        return t13;
    }
    let t13;
    if ($[35] !== handleOptionSelect || $[36] !== isDropdownOpen || $[37] !== renderMenuItem) {
        t13 = (hiddenOptions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8GyO5.RemixContainer), {
                hiddenOptions: hiddenOptions,
                presentation: "popup",
                trigger: renderMenuItem,
                popupPlacement: "right-start",
                popupOffset: [
                    0,
                    8
                ],
                isPopupOpen: isDropdownOpen,
                isThinking: false,
                onClose: closeDropdown,
                onOptionSelect: handleOptionSelect
            });
        $[35] = handleOptionSelect;
        $[36] = isDropdownOpen;
        $[37] = renderMenuItem;
        $[38] = t13;
    } else t13 = $[38];
    let t14;
    if ($[39] !== RemixHiddenOptionsResolver || $[40] !== contentId || $[41] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(RemixHiddenOptionsResolver, {
            enabled: true,
            contentId: contentId
        }, t13);
        $[39] = RemixHiddenOptionsResolver;
        $[40] = contentId;
        $[41] = t13;
        $[42] = t14;
    } else t14 = $[42];
    return t14;
} : ({ api: api, remixHiddenOptionsResolver: RemixHiddenOptionsResolver = (0, $1e53a3d0eb9e77e8$export$6c1a73717c6bf793) })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    const [isDropdownOpen, setIsDropdownOpen] = (0, $cozmU.useState)(false);
    const isInlineDropdownVariant = (0, $444f275c146ea05d$export$2c2cd6cb969bd93a)();
    const { aiEditInProgress: aiEditInProgress, contentId: contentId, isRemixUpdate: isRemixUpdate, remixInProgress: remixInProgress } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'aiExperience',
        'contextIdentifier',
        'malleableUi'
    ], (states)=>({
            aiEditInProgress: (0, $d1c28dddb88abfdb$export$44c2dcb159008a4b)(states.aiExperienceState),
            contentId: states.contextIdentifierState?.contextIdentifierProvider?.objectId,
            isRemixUpdate: states.malleableUiState?.isUpdate ?? false,
            remixInProgress: $b924ab10b3fb73fd$var$hasRemixInProgressState(states.malleableUiState)
        }));
    const isDisabled = (aiEditInProgress || remixInProgress) && (0, $4o0zT.isExperimentEnabled)('cc_maui_polish_changes_batch_5');
    // Fire experiment exposure on mount — registration uses expValEqualsNoExposure
    // to avoid over-counting on every editor load. The exposure is recorded here
    // when the Remix button is actually visible to the user.
    (0, $cozmU.useEffect)(()=>{
        (0, $ieeJu.expValEquals)('platform_editor_remix_in_block_menu', 'isEnabled', true);
    }, []);
    const fireClickAnalytics = (0, $cozmU.useCallback)(()=>{
        api?.analytics?.actions.fireAnalyticsEvent({
            action: (0, $krYZG.ACTION).CLICKED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).AI_REMIX_BUTTON,
            eventType: (0, $krYZG.EVENT_TYPE).UI,
            attributes: {
                entryPoint: 'editor',
                triggeredFrom: 'blockMenu'
            }
        });
    }, [
        api
    ]);
    const openRemix = (0, $cozmU.useCallback)((preselection)=>{
        // Close block menu and clear selection highlight
        api?.core?.actions.execute(({ tr: tr })=>{
            api?.blockControls?.commands?.stopPreservingSelection()({
                tr: tr
            });
            api?.blockControls?.commands?.toggleBlockMenu({
                closeMenu: true
            })({
                tr: tr
            });
            api?.selection?.commands?.clearBlockSelection()({
                tr: tr
            });
            return tr;
        });
        // Start experience tracking and open remix modal.
        // malleableUi is guaranteed to exist here — this component is always
        // registered by malleableUiPlugin itself.
        const openRemixModal = api.malleableUi?.commands.openRemixModal({
            metadata: {
                interactionSource: 'remixModalFromBlockMenu',
                ...preselection && {
                    preselectedType: preselection.type,
                    preselectedSubType: preselection.subType,
                    ...preselection.userPrompt && {
                        preselectedUserPrompt: preselection.userPrompt
                    }
                }
            },
            source: 'remixModalFromBlockMenu'
        });
        if (openRemixModal) {
            const featureArea = (0, $iBsvI.getRemixFeatureArea)({});
            experienceTracker.start({
                name: (0, $irnO2.ExperienceName).REMIX_START,
                id: (0, $irnO2.ExperienceName).REMIX_START,
                attributes: {
                    entryPoint: 'editor',
                    remixSource: 'blockMenu',
                    ...featureArea !== undefined && {
                        featureArea: featureArea
                    }
                }
            });
            (0, $kDDrf.startRemixCreateExperience)({
                experienceTracker: experienceTracker,
                attributes: {
                    entryPoint: 'editor',
                    remixSource: 'blockMenu'
                }
            });
            api.core.actions.execute(openRemixModal);
        }
    }, [
        api,
        experienceTracker
    ]);
    const handleClick = (0, $cozmU.useCallback)(()=>{
        if (isDisabled) return;
        fireClickAnalytics();
        (0, $cha5E.expVal)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'control');
        (0, $cha5E.expVal)('cc-ce-maui-remix-menu-multivariant-aa', 'variant', 'control');
        if (isInlineDropdownVariant) {
            // Keep the block menu open while the live Remix trigger owns its nested dropdown.
            // The block menu is closed by `openRemix` once an option is committed.
            setIsDropdownOpen((isOpen)=>!isOpen);
            return;
        }
        openRemix();
    }, [
        fireClickAnalytics,
        isDisabled,
        isInlineDropdownVariant,
        openRemix
    ]);
    const closeDropdown = (0, $cozmU.useCallback)(()=>setIsDropdownOpen(false), []);
    const handleOptionSelect = (0, $cozmU.useCallback)((selection)=>{
        closeDropdown();
        openRemix(selection);
    }, [
        closeDropdown,
        openRemix
    ]);
    const disabledTooltip = isDisabled ? aiEditInProgress && (!remixInProgress || isRemixUpdate) ? formatMessage((0, $lhZdS.messages).editInProgressTooltip) : formatMessage((0, $lhZdS.messages).remixInProgressTooltip) : undefined;
    const renderMenuItem = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
            triggerRef: triggerProps?.ref,
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1pCE4))), {
                label: "",
                size: "small"
            }),
            elemAfter: isInlineDropdownVariant ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                label: "",
                size: "small"
            }) : undefined,
            hasNestedDropdownMenu: isInlineDropdownVariant,
            onClick: handleClick,
            isSelected: isInlineDropdownVariant ? isDropdownOpen : undefined,
            isDisabled: isDisabled,
            title: disabledTooltip
        }, formatMessage((0, $93WrI.aiConfigItemMessages).remixTitle));
    if (!isInlineDropdownVariant) return renderMenuItem();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(RemixHiddenOptionsResolver, {
        enabled: true,
        contentId: contentId
    }, (hiddenOptions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8GyO5.RemixContainer), {
            hiddenOptions: hiddenOptions,
            presentation: "popup",
            trigger: renderMenuItem,
            popupPlacement: "right-start",
            // Match the default 8px distance used by the Change format nested dropdown.
            popupOffset: [
                0,
                8
            ],
            isPopupOpen: isDropdownOpen,
            isThinking: false,
            onClose: closeDropdown,
            onOptionSelect: handleOptionSelect
        }));
};
/**
 * Creates block menu registration components for the Remix action.
 *
 * Registered by editor-plugin-malleable-ui (which owns the openRemixModal command)
 * when the platform_editor_remix_in_block_menu experiment is enabled.
 * The AI plugin hides its polish/improve-formatting action when this experiment is on,
 * so the Remix item effectively replaces it.
 */ const $b924ab10b3fb73fd$var$createRemixBlockMenuItemComponent = (api, remixHiddenOptionsResolver)=>{
    const RemixBlockMenuItemWrapper = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
        const $ = (0, $bDgLe.c)(1);
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b924ab10b3fb73fd$var$RemixBlockMenuItem, {
                api: api,
                remixHiddenOptionsResolver: remixHiddenOptionsResolver
            });
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    } : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b924ab10b3fb73fd$var$RemixBlockMenuItem, {
            api: api,
            remixHiddenOptionsResolver: remixHiddenOptionsResolver
        });
    RemixBlockMenuItemWrapper.displayName = 'RemixBlockMenuItemWrapper';
    return RemixBlockMenuItemWrapper;
};
const $b924ab10b3fb73fd$var$getCachedTextLength = (api, editorView, cache)=>{
    const { state: state } = editorView;
    if (cache.state === state) return cache.textLength;
    const textLength = api?.blockControls?.actions.getTextInfo(editorView)?.textLength ?? null;
    cache.state = state;
    cache.textLength = textLength;
    return textLength;
};
const $b924ab10b3fb73fd$export$96499eef52eb1886 = ({ api: api, getEditorView: getEditorView, remixHiddenOptionsResolver: remixHiddenOptionsResolver })=>{
    const textLengthCache = {
        state: null,
        textLength: null
    };
    return [
        {
            type: 'block-menu-item',
            key: `ai-${(0, $8i6M6.AI_REMIX_MENU_ITEM).key}`,
            parent: {
                type: 'block-menu-section',
                key: (0, $8i6M6.AI_MENU_SECTION).key,
                rank: (0, $cCXFd.AI_MENU_SECTION_RANK)[(0, $8i6M6.AI_MENU_SECTION).key]
            },
            component: $b924ab10b3fb73fd$var$createRemixBlockMenuItemComponent(api, remixHiddenOptionsResolver),
            isHidden: ()=>{
                if (!(0, $anBbz.expValEqualsNoExposure)('platform_editor_ai_blockmenu_integration', 'isEnabled', true)) return true;
                const editorView = getEditorView();
                const menuTriggerByNode = api?.blockControls?.sharedState?.currentState()?.menuTriggerByNode;
                const triggerPos = menuTriggerByNode?.rootPos ?? menuTriggerByNode?.pos;
                const triggeredNode = editorView && triggerPos !== undefined ? editorView.state.doc.nodeAt(triggerPos) : undefined;
                if (triggeredNode?.type.name === 'extension' && (0, $444f275c146ea05d$export$ff7e5ebac3487125)({
                    node: triggeredNode
                }) && (0, $iDrrr.fg)('maui_remixable_page_native_embeds')) return false;
                const textLength = editorView ? $b924ab10b3fb73fd$var$getCachedTextLength(api, editorView, textLengthCache) : null;
                // When context is unavailable, default to visible (matches AI plugin behaviour)
                if (textLength === null) return false;
                return textLength < (0, $8i6M6.AI_BLOCK_MENU_LARGE_TEXT_THRESHOLD);
            }
        }
    ];
};
function $b924ab10b3fb73fd$var$_temp(states) {
    return {
        aiEditInProgress: (0, $d1c28dddb88abfdb$export$44c2dcb159008a4b)(states.aiExperienceState),
        contentId: states.contextIdentifierState?.contextIdentifierProvider?.objectId,
        isRemixUpdate: states.malleableUiState?.isUpdate ?? false,
        remixInProgress: $b924ab10b3fb73fd$var$hasRemixInProgressState(states.malleableUiState)
    };
}
function $b924ab10b3fb73fd$var$_temp2() {
    (0, $ieeJu.expValEquals)("platform_editor_remix_in_block_menu", "isEnabled", true);
}
function $b924ab10b3fb73fd$var$_temp3(isOpen) {
    return !isOpen;
}











const $d41f3058f4db498d$var$entries = new WeakMap();
const $d41f3058f4db498d$var$entryFor = (api)=>{
    if (!api) return undefined;
    const existing = $d41f3058f4db498d$var$entries.get(api);
    if (existing) return existing;
    const entry = {};
    $d41f3058f4db498d$var$entries.set(api, entry);
    return entry;
};
const $d41f3058f4db498d$var$observe = (entry, observation)=>{
    try {
        entry?.adapter?.observeLifecycle?.(observation);
    } catch  {
    // Ownership observations must never affect editor behavior.
    }
};
const $d41f3058f4db498d$export$a890533e09d530df = (api, adapter)=>{
    const entry = $d41f3058f4db498d$var$entryFor(api);
    if (!entry) return ()=>{};
    entry.adapter = adapter;
    return ()=>{
        if (entry.adapter === adapter) {
            entry.adapter = undefined;
            entry.active?.lifecycle.end('aborted');
            entry.active = undefined;
        }
    };
};
const $d41f3058f4db498d$export$12ede4f917884c4 = (api, owner)=>{
    const entry = $d41f3058f4db498d$var$entryFor(api);
    if (!entry) return ()=>{};
    entry.owner = owner;
    return ()=>{
        if (entry.owner === owner) {
            entry.owner = undefined;
            entry.active?.lifecycle.end('aborted');
            entry.active = undefined;
        }
    };
};
const $d41f3058f4db498d$export$b9869b87d1be6011 = (api, targetId)=>{
    const entry = $d41f3058f4db498d$var$entryFor(api);
    if (!entry?.adapter || !entry.owner) return {
        status: 'unavailable'
    };
    if (!targetId) return {
        status: 'legacy'
    };
    if (entry.active) return {
        status: 'rejected'
    };
    const lifecycleRetention = (()=>{
        try {
            return (0, $fjeDY.admitAndRetainEditorRemixLifecycle)({
                adapter: entry.adapter,
                owner: entry.owner,
                request: {
                    kind: 'update',
                    conversationId: targetId,
                    targetNodeId: targetId,
                    updateSentinel: targetId,
                    observation: {
                        producer: 'inline-rovo-edit',
                        artifactType: 'unknown',
                        sentinelSource: 'none'
                    }
                }
            });
        } catch  {
            return undefined;
        }
    })();
    if (!lifecycleRetention) return {
        status: 'unavailable'
    };
    if (lifecycleRetention.status === 'active-flow-rejected') return {
        status: 'rejected'
    };
    if (lifecycleRetention.status !== 'retained') return lifecycleRetention.status === 'infrastructure-failure' ? {
        status: 'unavailable'
    } : {
        status: 'legacy'
    };
    const attemptId = lifecycleRetention.lifecycle.remixId;
    entry.active = {
        claimed: false,
        lifecycle: lifecycleRetention.lifecycle,
        presentationStarted: false,
        targetId: targetId,
        artifactType: 'unknown'
    };
    return {
        status: 'admitted',
        attemptId: attemptId
    };
};
const $d41f3058f4db498d$export$516511b718918dc3 = (api, attemptId)=>{
    const active = $d41f3058f4db498d$var$entryFor(api)?.active;
    if (!active || active.lifecycle.remixId !== attemptId || active.presentationStarted) return false;
    active.presentationStarted = true;
    return true;
};
const $d41f3058f4db498d$export$804d6981ddbce4fe = (api, targetId)=>{
    const entry = $d41f3058f4db498d$var$entryFor(api);
    const active = entry?.active;
    if (!active) {
        $d41f3058f4db498d$var$observe(entry, {
            actionSubjectId: 'bridgeClaim',
            producer: 'inline-rovo-edit',
            artifactType: 'unknown',
            outcome: 'no-retained-attempt',
            reason: 'no-active-attempt'
        });
        return undefined;
    }
    if (!targetId) {
        $d41f3058f4db498d$var$observe(entry, {
            actionSubjectId: 'bridgeClaim',
            producer: 'inline-rovo-edit',
            artifactType: active.artifactType,
            outcome: 'missing-target',
            reason: 'target-missing'
        });
        return undefined;
    }
    if (active.targetId !== targetId) {
        $d41f3058f4db498d$var$observe(entry, {
            actionSubjectId: 'bridgeClaim',
            producer: 'inline-rovo-edit',
            artifactType: active.artifactType,
            outcome: 'mismatched-target',
            reason: 'target-mismatch'
        });
        return undefined;
    }
    if (active.claimed) {
        $d41f3058f4db498d$var$observe(entry, {
            actionSubjectId: 'bridgeClaim',
            producer: 'inline-rovo-edit',
            artifactType: active.artifactType,
            outcome: 'no-retained-attempt',
            reason: 'already-claimed'
        });
        return undefined;
    }
    active.claimed = true;
    $d41f3058f4db498d$var$observe(entry, {
        actionSubjectId: 'bridgeClaim',
        producer: 'inline-rovo-edit',
        artifactType: active.artifactType,
        outcome: 'matched',
        reason: 'target-match'
    });
    return active.lifecycle.remixId;
};
const $d41f3058f4db498d$export$ffcbf537033846f5 = (api, observation)=>{
    const entry = $d41f3058f4db498d$var$entryFor(api);
    // A concurrent rejected/unavailable submission is not the retained attempt and must not
    // relabel the active flow's later bridge/settlement observations.
    if (entry?.active && observation.outcome === 'admitted') entry.active.artifactType = observation.artifactType;
    const reason = observation.target === 'present' ? observation.admissionHook === 'available' ? 'target-present-admission-available' : 'target-present-admission-unavailable' : observation.admissionHook === 'available' ? 'target-missing-admission-available' : 'target-missing-admission-unavailable';
    // A rejection never replaces `entry.active`, so it is still the attempt that blocked this one.
    // With no active inline attempt, the owner refused because a create or variant flow is live.
    const blockingAttempt = observation.outcome !== 'rejected' ? undefined : !entry?.active ? 'other-flow' : entry.active.claimed ? 'inline-claimed' : entry.active.presentationStarted ? 'inline-unclaimed-handed-off' : 'inline-unclaimed';
    $d41f3058f4db498d$var$observe(entry, {
        actionSubjectId: 'producerAttempt',
        producer: 'inline-rovo-edit',
        artifactType: observation.artifactType,
        outcome: observation.outcome,
        reason: reason,
        ...blockingAttempt ? {
            blockingAttempt: blockingAttempt
        } : {}
    });
};
const $d41f3058f4db498d$export$14ce80a40ed788cd = (api, attemptId)=>{
    const entry = $d41f3058f4db498d$var$entryFor(api);
    const active = entry?.active;
    if (!active || active.lifecycle.remixId !== attemptId || active.claimed) return false;
    return $d41f3058f4db498d$export$5b4e6541783f126c(api, attemptId, 'handoff');
};
const $d41f3058f4db498d$export$5b4e6541783f126c = (api, attemptId, result)=>{
    const entry = $d41f3058f4db498d$var$entryFor(api);
    const active = entry?.active;
    if (!active || active.lifecycle.remixId !== attemptId) return false;
    const transition = (event)=>active.lifecycle.transition(event);
    if (result === 'result-ready') return transition({
        type: 'RESULT_READY'
    });
    if (result === 'direct-insertion-started') return transition({
        type: 'DIRECT_INSERTION_STARTED'
    });
    if (result === 'handoff') {
        if (!active.lifecycle.end('handed-off')) return false;
    } else if (result === 'inserted') {
        if (!transition({
            type: 'INSERTED'
        })) return false;
    } else if (result === 'insertion-failed') {
        if (!transition({
            type: 'INSERTION_FAILED'
        })) return false;
    } else if (result === 'generation-error') {
        if (!transition({
            type: 'GENERATION_ERROR'
        })) return false;
    } else if (!transition({
        type: 'GENERATION_ABORTED'
    })) return false;
    entry.active = undefined;
    return true;
};



const $b2e4188f0e483040$export$fdca5082072fada0 = ({ api: api, LifecycleAdapterHost: LifecycleAdapterHost })=>{
    const lifecycleOwner = (0, $fjeDY.useEditorRemixLifecycleOwner)();
    const retain = lifecycleOwner?.retain;
    const forgetMachineAuthority = lifecycleOwner?.forgetMachineAuthority;
    // Register only stable owner actions so activity changes cannot tear down an admitted attempt.
    const lifecycleOwnerForRegistration = (0, $cozmU.useMemo)(()=>{
        if (!retain || !forgetMachineAuthority) return undefined;
        return {
            active: undefined,
            forgetMachineAuthority: forgetMachineAuthority,
            retain: retain
        };
    }, [
        forgetMachineAuthority,
        retain
    ]);
    const onRegisterEditorRemixMachineLifecycleOwnership = (0, $cozmU.useCallback)((session)=>(0, $dc44c0de1ed07c1a$export$10406465ad92edb2)(api, session), [
        api
    ]);
    const onRegisterEditorInlineRovoEditLifecycleAdapter = (0, $cozmU.useCallback)((adapter)=>(0, $d41f3058f4db498d$export$a890533e09d530df)(api, adapter), [
        api
    ]);
    const onStartInlineRovoEditHandoffPresentation = (0, $cozmU.useCallback)((attemptId)=>{
        if (!api?.core.actions.execute || !api.malleableUi?.commands.startRemixThinking) return false;
        if (!(0, $d41f3058f4db498d$export$516511b718918dc3)(api, attemptId)) return false;
        api.core.actions.execute(api.malleableUi.commands.startRemixThinking({
            isUpdate: true,
            remixAttemptId: attemptId
        }));
        return true;
    }, [
        api
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!lifecycleOwnerForRegistration) return;
        return (0, $d41f3058f4db498d$export$12ede4f917884c4)(api, lifecycleOwnerForRegistration);
    }, [
        api,
        lifecycleOwnerForRegistration
    ]);
    (0, $cozmU.useEffect)(()=>{
        return api?.aiExperience?.actions.registerInlineRovoEditAdmission?.((targetId)=>{
            try {
                return api.malleableUi?.actions.beginInlineRovoEdit?.(targetId) ?? {
                    status: 'unavailable'
                };
            } catch  {
                // The bridge is optional; unavailable lifecycle infrastructure preserves legacy submission.
                return {
                    status: 'unavailable'
                };
            }
        });
    }, [
        api
    ]);
    (0, $cozmU.useEffect)(()=>{
        return api?.aiExperience?.actions.registerInlineRovoEditProducerAttemptReporting?.((observation)=>(0, $d41f3058f4db498d$export$ffcbf537033846f5)(api, observation));
    }, [
        api
    ]);
    (0, $cozmU.useEffect)(()=>{
        return api?.aiExperience?.actions.registerInlineRovoEditHandoffPresentation?.(onStartInlineRovoEditHandoffPresentation);
    }, [
        api,
        onStartInlineRovoEditHandoffPresentation
    ]);
    (0, $cozmU.useEffect)(()=>{
        return api?.aiExperience?.actions.registerInlineRovoEditReporting?.((attemptId_0, outcome)=>api.malleableUi?.actions.reportInlineRovoEdit?.(attemptId_0, outcome) ?? false);
    }, [
        api
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(LifecycleAdapterHost, {
        isEditorRemixStateRearchitectureTreatment: true,
        onRegisterEditorRemixMachineLifecycleOwnership: onRegisterEditorRemixMachineLifecycleOwnership,
        onRegisterEditorInlineRovoEditLifecycleAdapter: onRegisterEditorInlineRovoEditLifecycleAdapter
    });
};












var $9DHhW = parcelRequire("9DHhW");

const $7e9f8d762d979b80$var$toLifecycleObservation = (observation)=>({
        actionSubjectId: 'producerAttempt',
        producer: 'inline-rovo-edit',
        artifactType: observation.artifactType,
        outcome: observation.outcome,
        reason: observation.target === 'present' ? observation.admissionHook === 'available' ? 'target-present-admission-available' : 'target-present-admission-unavailable' : observation.admissionHook === 'available' ? 'target-missing-admission-available' : 'target-missing-admission-unavailable'
    });
const $7e9f8d762d979b80$export$9fd1c9027ae2084e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { api: api } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    if ($[0] !== createAnalyticsEvent) {
        t1 = (observation)=>{
            const lifecycleObservation = $7e9f8d762d979b80$var$toLifecycleObservation(observation);
            try {
                createAnalyticsEvent({
                    type: "sendOperationalEvent",
                    data: {
                        action: "observed",
                        actionSubject: "editorRemixLifecycleOwnership",
                        actionSubjectId: lifecycleObservation.actionSubjectId,
                        source: "editorRemix",
                        tags: [
                            "remix",
                            "stateRearchitecture"
                        ],
                        attributes: {
                            migrationPhase: "ownership-soak",
                            producer: lifecycleObservation.producer,
                            artifactType: lifecycleObservation.artifactType,
                            outcome: lifecycleObservation.outcome,
                            reason: lifecycleObservation.reason
                        }
                    }
                }).fire();
            } catch  {}
        };
        $[0] = createAnalyticsEvent;
        $[1] = t1;
    } else t1 = $[1];
    const report = t1;
    let t2;
    if ($[2] !== api?.aiExperience?.actions || $[3] !== report) {
        t2 = ()=>api?.aiExperience?.actions.registerInlineRovoEditProducerAttemptReporting?.(report);
        $[2] = api?.aiExperience?.actions;
        $[3] = report;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== api || $[6] !== report) {
        t3 = [
            api,
            report
        ];
        $[5] = api;
        $[6] = report;
        $[7] = t3;
    } else t3 = $[7];
    (0, $cozmU.useEffect)(t2, t3);
    return null;
} : ({ api: api })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const report = (0, $cozmU.useCallback)((observation)=>{
        const lifecycleObservation = $7e9f8d762d979b80$var$toLifecycleObservation(observation);
        try {
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'observed',
                    actionSubject: 'editorRemixLifecycleOwnership',
                    actionSubjectId: lifecycleObservation.actionSubjectId,
                    source: 'editorRemix',
                    tags: [
                        'remix',
                        'stateRearchitecture'
                    ],
                    attributes: {
                        migrationPhase: 'ownership-soak',
                        producer: lifecycleObservation.producer,
                        artifactType: lifecycleObservation.artifactType,
                        outcome: lifecycleObservation.outcome,
                        reason: lifecycleObservation.reason
                    }
                }
            }).fire();
        } catch  {
        // Observability must never affect submission behavior.
        }
    }, [
        createAnalyticsEvent
    ]);
    (0, $cozmU.useEffect)(()=>api?.aiExperience?.actions.registerInlineRovoEditProducerAttemptReporting?.(report), [
        api,
        report
    ]);
    return null;
};















var $FKQbh = parcelRequire("FKQbh");


var $lqtHz = parcelRequire("lqtHz");


var $iZMIZ = parcelRequire("iZMIZ");


var $24dy7 = parcelRequire("24dy7");


var $fodiz = parcelRequire("fodiz");




const $8990df313a4c5595$export$2a1e596305c92bc7 = ()=>({ tr: tr })=>{
        tr.setMeta((0, $3kyUj.mauiDiagramPastePluginKey), {
            type: (0, $3kyUj.ActionType).DISMISS_FLAG
        });
        return tr;
    };





const $cf98493589757f0e$var$getIcon = (type)=>{
    switch(type){
        case (0, $3kyUj.MauiDiagramPasteFlagType).SUCCESS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iZMIZ))), {
                label: "",
                color: "var(--ds-icon-success, #6A9A23)"
            });
        case (0, $3kyUj.MauiDiagramPasteFlagType).INFO:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
                label: "",
                color: "var(--ds-icon-information, #357DE8)"
            });
        case (0, $3kyUj.MauiDiagramPasteFlagType).ERROR:
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                label: "",
                color: "var(--ds-icon-danger, #C9372C)"
            });
    }
};
const $cf98493589757f0e$var$getProductFlagType = (type)=>{
    switch(type){
        case (0, $3kyUj.MauiDiagramPasteFlagType).SUCCESS:
            return 'success';
        case (0, $3kyUj.MauiDiagramPasteFlagType).INFO:
            return 'info';
        case (0, $3kyUj.MauiDiagramPasteFlagType).ERROR:
        default:
            return 'error';
    }
};
const $cf98493589757f0e$export$bdca710d02013452 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { api: api, productFlags: productFlags } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            "malleableUi"
        ];
        $[0] = t1;
    } else t1 = $[0];
    const activeFlag = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, t1, $cf98493589757f0e$var$_temp);
    const previousProductFlagIdRef = (0, $cozmU.useRef)();
    let t2;
    if ($[1] !== api?.core.actions) {
        t2 = ()=>{
            api?.core.actions.execute((0, $8990df313a4c5595$export$2a1e596305c92bc7)());
        };
        $[1] = api?.core.actions;
        $[2] = t2;
    } else t2 = $[2];
    const onDismissed = t2;
    let t3;
    let t4;
    if ($[3] !== activeFlag || $[4] !== onDismissed || $[5] !== productFlags) {
        t3 = ()=>{
            if (!productFlags) return;
            const previousProductFlagId = previousProductFlagIdRef.current;
            if (!activeFlag) {
                if (previousProductFlagId) {
                    productFlags.hideFlag(previousProductFlagId);
                    previousProductFlagIdRef.current = undefined;
                }
                return;
            }
            if (previousProductFlagId && previousProductFlagId !== activeFlag.id) productFlags.hideFlag(previousProductFlagId);
            previousProductFlagIdRef.current = activeFlag.id;
            productFlags.showFlag({
                description: activeFlag.description ?? "",
                icon: $cf98493589757f0e$var$getIcon(activeFlag.type),
                id: activeFlag.id,
                onDismissed: onDismissed,
                title: activeFlag.title ?? "",
                type: $cf98493589757f0e$var$getProductFlagType(activeFlag.type)
            });
        };
        t4 = [
            activeFlag,
            onDismissed,
            productFlags
        ];
        $[3] = activeFlag;
        $[4] = onDismissed;
        $[5] = productFlags;
        $[6] = t3;
        $[7] = t4;
    } else {
        t3 = $[6];
        t4 = $[7];
    }
    (0, $cozmU.useEffect)(t3, t4);
    if (!activeFlag || productFlags) return null;
    const title = activeFlag.title ?? "";
    const description = activeFlag.description ?? "";
    let t5;
    if ($[8] !== activeFlag.type) {
        t5 = $cf98493589757f0e$var$getIcon(activeFlag.type);
        $[8] = activeFlag.type;
        $[9] = t5;
    } else t5 = $[9];
    const icon = t5;
    let t6;
    if ($[10] !== activeFlag.id || $[11] !== description || $[12] !== icon || $[13] !== onDismissed || $[14] !== title) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lqtHz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $FKQbh.default), {
            onDismissed: onDismissed,
            title: title,
            description: description,
            id: activeFlag.id,
            testId: activeFlag.id,
            icon: icon
        }));
        $[10] = activeFlag.id;
        $[11] = description;
        $[12] = icon;
        $[13] = onDismissed;
        $[14] = title;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
} : ({ api: api, productFlags: productFlags })=>{
    const activeFlag = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states)=>states.malleableUiState?.diagramPaste?.activeFlag ?? null);
    const previousProductFlagIdRef = (0, $cozmU.useRef)();
    const onDismissed = (0, $cozmU.useCallback)(()=>{
        api?.core.actions.execute((0, $8990df313a4c5595$export$2a1e596305c92bc7)());
    }, [
        api
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!productFlags) return;
        const previousProductFlagId = previousProductFlagIdRef.current;
        if (!activeFlag) {
            if (previousProductFlagId) {
                productFlags.hideFlag(previousProductFlagId);
                previousProductFlagIdRef.current = undefined;
            }
            return;
        }
        if (previousProductFlagId && previousProductFlagId !== activeFlag.id) productFlags.hideFlag(previousProductFlagId);
        previousProductFlagIdRef.current = activeFlag.id;
        productFlags.showFlag({
            description: activeFlag.description ?? '',
            icon: $cf98493589757f0e$var$getIcon(activeFlag.type),
            id: activeFlag.id,
            onDismissed: onDismissed,
            title: activeFlag.title ?? '',
            type: $cf98493589757f0e$var$getProductFlagType(activeFlag.type)
        });
    }, [
        activeFlag,
        onDismissed,
        productFlags
    ]);
    if (!activeFlag || productFlags) return null;
    const title = activeFlag.title ?? '';
    const description = activeFlag.description ?? '';
    const icon = $cf98493589757f0e$var$getIcon(activeFlag.type);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lqtHz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $FKQbh.default), {
        onDismissed: onDismissed,
        title: title,
        description: description,
        id: activeFlag.id,
        testId: activeFlag.id,
        icon: icon
    }));
};
function $cf98493589757f0e$var$_temp(states) {
    return states.malleableUiState?.diagramPaste?.activeFlag ?? null;
}


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 





const $828d24cf3c31b50c$var$remixHoverHighlightBackground = "var(--ds-background-accent-blue-subtler, #CFE1FD)";
const $828d24cf3c31b50c$var$remixHoverHighlightBorder = "var(--ds-background-accent-blue-subtler, #CFE1FD)";
const $828d24cf3c31b50c$var$persistedHighlightStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- ProseMirror decoration class
    '.akEditor div.ProseMirror .remix-thinking-highlight': {
        backgroundColor: "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
        textDecoration: 'underline',
        textDecorationStyle: 'dotted',
        textDecorationThickness: "var(--ds-space-025, 2px)",
        textDecorationColor: "var(--ds-border-accent-purple, #AF59E1)",
        textDecorationSkipInk: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Default remix hover highlight for non-table nodes
    '.akEditor div.ProseMirror .remix-hover-highlight': {
        background: $828d24cf3c31b50c$var$remixHoverHighlightBackground,
        boxShadow: `0 0 0 2px ${$828d24cf3c31b50c$var$remixHoverHighlightBorder}`
    }
});
const $828d24cf3c31b50c$export$3bccfb6f759a17 = ()=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lOiVq.Global), {
        styles: $828d24cf3c31b50c$var$persistedHighlightStyles
    }));
};


/* RemixContent.tsx generated by @compiled/babel-plugin v3.0.2 */ 












var $2sp5n = parcelRequire("2sp5n");





var $2iHw5 = parcelRequire("2iHw5");











var $iMnC5 = parcelRequire("iMnC5");























var $7jUr8 = parcelRequire("7jUr8");



/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $ad7Ou = parcelRequire("ad7Ou");





var $w6R6I = parcelRequire("w6R6I");


var $1jz5K = parcelRequire("1jz5K");





var $l3wuH = parcelRequire("l3wuH");








var $8RXjp = parcelRequire("8RXjp");

const $cdf71ed8a5ea431a$var$styles = {
    container: "_2mHwu82ADO _0bjKvDyzSk _1mT5xdy1CL _0Bm75G5zaO _3OE6xY715P _1VJPcajssS _3iDTPbQ4SZ _0hPCNLDIqT _4ouGXIwBC3 _4kiQYApJKa _2Zuz6Q5zaO _1Znuxb2ADO _0KLXrulfZc _2OUyjtGk8v _42Yu6BbFo4",
    absolute: "_1mT5xdWVPG",
    readyMessage: "_2sNsIgmnOE _2O5Vij7dHp _3YEZNOdnbC _1bHrqEIZbP _2Zuz6Q2ADO _1UtDYzZpcK _1kk5Tkf7mX"
};
const $cdf71ed8a5ea431a$var$AUTO_DISMISS_DELAY_MS = 10000;
const $cdf71ed8a5ea431a$var$SHORT_AUTO_DISMISS_DELAY_MS = 1000;
function $cdf71ed8a5ea431a$export$c758b087b04ee4fe({ isUpdate: isUpdate = false, onView: onView, onClose: onClose, showActions: showActions = true } = {}) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const wrapperRef = (0, $cozmU.useRef)(null);
    const [isAbsolute, setIsAbsolute] = (0, $cozmU.useState)(false);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!wrapperRef.current) return;
         // no scrollParent, such as Jira description editor
        // if in the future, they do have scrollParent, then we need to check if offsetParent is in scrollParent
        const scrollParent = (0, $1jz5K.findOverflowScrollParent)(wrapperRef.current);
        if (!scrollParent) {
            // wrapperRef.current.offsetParent is null when it's fixed
            // so we have to check the parentElement's offsetParent
            const offsetParent = wrapperRef.current.parentElement?.offsetParent;
            if (offsetParent) {
                const offsetParentRect = offsetParent.getBoundingClientRect();
                if (offsetParentRect.bottom < window.innerHeight) setIsAbsolute(true);
            }
        }
    }, []);
    (0, $cozmU.useEffect)(()=>{
        const timeoutId = window.setTimeout(()=>{
            onClose?.({
                auto: true
            });
        }, showActions ? $cdf71ed8a5ea431a$var$AUTO_DISMISS_DELAY_MS : $cdf71ed8a5ea431a$var$SHORT_AUTO_DISMISS_DELAY_MS);
        return ()=>window.clearTimeout(timeoutId);
    }, [
        onClose,
        showActions
    ]);
    const readyMessage = isUpdate ? (0, $8RXjp.remixReadyMessages).updateReady : (0, $iDrrr.fg)('cc_maui_updated_remix_tooltip_text') ? (0, $8RXjp.remixReadyMessages).remixReadyUpdated : (0, $8RXjp.remixReadyMessages).remixReady;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: wrapperRef,
        xcss: (0, $w6R6I.cx)($cdf71ed8a5ea431a$var$styles.container, isAbsolute && $cdf71ed8a5ea431a$var$styles.absolute)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iZMIZ))), {
        label: "",
        color: "var(--ds-icon-success, #6A9A23)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cdf71ed8a5ea431a$var$styles.readyMessage
    }, formatMessage(readyMessage)), showActions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: onView
    }, formatMessage((0, $8RXjp.remixReadyMessages).viewButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        spacing: "compact",
        appearance: "subtle",
        label: formatMessage((0, $8RXjp.remixReadyMessages).closeButton),
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                label: ""
            }),
        onClick: ()=>onClose?.()
    })));
}






var $3sXr4 = parcelRequire("3sXr4");


var $ft2zO = parcelRequire("ft2zO");


function $c3515eab9d989c2d$export$81acf0fbb9db54fa(options) {
    return ({ tr: tr })=>{
        tr.setMeta((0, $93f21268088062df$export$2e13bdf171bca4ae), {
            payload: options,
            type: 'addHistoryEntry'
        });
        return tr;
    };
}






function $005eb73a7f6b40e4$export$9f60bd9ee414a7c0(options) {
    return ({ tr: tr })=>{
        tr.setMeta((0, $93f21268088062df$export$2e13bdf171bca4ae), {
            type: 'addHistoryStackEntry',
            payload: options
        });
        tr.setMeta((0, $bpOXf.malleableUiPluginKey), {
            remixUpdateScrollTargetUrl: options.url
        });
        return tr;
    };
}




const $36058288d319cae1$export$788d053d96dbd6b6 = ({ tr: tr })=>{
    tr.setMeta((0, $5ea92dab24394af7$export$38c8fc373d691b1d), {
        lifecycle: {
            kind: 'dismiss'
        }
    });
    return tr;
};








const $94cf8481f86e3649$export$e119ad44c40da033 = ({ contentId: contentId, originalUrl: originalUrl, flag: flag })=>({ tr: tr })=>{
        if (// eslint-disable-next-line @atlaskit/platform/use-recommended-utils -- dynamic config killswitch, not a standard feature gate
        (0, $cXtTj.default).getExperimentValue('maui-native-embed-finalize-diagram-anywhere', 'value', false)) return null;
        if (!contentId || !originalUrl) return null;
        tr.setMeta((0, $3kyUj.mauiDiagramPastePluginKey), {
            type: (0, $3kyUj.ActionType).EMBED_FINALIZE_STATUS_CHANGED,
            contentId: contentId,
            originalUrl: originalUrl,
            status: (0, $3kyUj.MauiEmbedFinalizeStatus).NEEDS_SPACE_SELECTION,
            flag: flag
        });
        return tr;
    };



var $90zNn = parcelRequire("90zNn");


const $8ac54cfa8c1aac76$export$831107003cfefb8 = (isComplete)=>({ tr: tr })=>{
        tr.setMeta((0, $5ea92dab24394af7$export$38c8fc373d691b1d), {
            lifecycle: {
                kind: isComplete ? 'legacy-complete' : 'legacy-complete-false'
            }
        });
        return tr;
    };
const $8ac54cfa8c1aac76$export$a9d5e9b88fbfa587 = ({ tr: tr })=>{
    tr.setMeta((0, $5ea92dab24394af7$export$38c8fc373d691b1d), {
        presentation: {
            kind: 'reset'
        }
    });
    return tr;
};



const $5641e9520598103d$export$92f20a5f93e2b790 = (isWaitingForInput)=>({ tr: tr })=>{
        tr.setMeta((0, $5ea92dab24394af7$export$38c8fc373d691b1d), {
            isWaitingForInput: isWaitingForInput
        });
        return tr;
    };





const $0a73920d50ae3ac4$export$9c8ccf478e05e6c0 = (showLocationPicker)=>({ tr: tr })=>{
        tr.setMeta((0, $bpOXf.malleableUiPluginKey), {
            showLocationPicker: showLocationPicker
        });
        return tr;
    };









var $loghT = parcelRequire("loghT");


















/**
 * Position of the `mediaSingle` wrapping the media node with this id (media is its first child, so
 * the wrapper sits one position earlier), or the media node's own position when it isn't wrapped.
 */ const $8d75a090c1bd5f30$var$findMediaNodePosByMediaId = (doc, mediaId)=>{
    let mediaPos;
    doc.descendants((node, pos, parent)=>{
        if (mediaPos !== undefined) return false;
        if (node.type.name === 'media' && node.attrs.id === mediaId) {
            mediaPos = parent?.type.name === 'mediaSingle' ? pos - 1 : pos;
            return false;
        }
        return true;
    });
    return mediaPos;
};
const $8d75a090c1bd5f30$export$d286e3535d15a9f0 = (editorView, mediaId)=>{
    const mediaPos = $8d75a090c1bd5f30$var$findMediaNodePosByMediaId(editorView.state.doc, mediaId);
    const mediaDom = mediaPos !== undefined ? editorView.nodeDOM(mediaPos) : null;
    return mediaDom instanceof HTMLElement ? mediaDom : mediaDom?.parentElement ?? null;
};


const $d1bf1147fd18e4d3$var$getViewportPlacement = ({ element: element, root: root, requireSubstantiallyVisible: requireSubstantiallyVisible = false })=>{
    try {
        const elementRect = element.getBoundingClientRect();
        const rootRect = root.getBoundingClientRect();
        const isInViewport = elementRect.bottom > rootRect.top && elementRect.right > rootRect.left && elementRect.top < rootRect.bottom && elementRect.left < rootRect.right;
        if (isInViewport && requireSubstantiallyVisible) {
            // Clamp the scroll root to the window: the `document.body` fallback root reports the whole
            // document height rather than the visible area.
            const viewportTop = Math.max(rootRect.top, 0);
            const viewportBottom = Math.min(rootRect.bottom, window.innerHeight);
            const visibleHeight = Math.min(elementRect.bottom, viewportBottom) - Math.max(elementRect.top, viewportTop);
            const requiredVisibleHeight = Math.min(elementRect.height, viewportBottom - viewportTop) / 2;
            return visibleHeight >= requiredVisibleHeight ? 'in-view' : 'bottom';
        }
        if (isInViewport) return 'in-view';
        // The floating bar always sits at the bottom of the viewport when the inline
        // widget is scrolled out of view, regardless of scroll direction.
        return 'bottom';
    } catch  {
        // On measurement failure, behave as if the widget is in view so we never
        // show a stuck floating bar we cannot position.
        return 'in-view';
    }
};
const $d1bf1147fd18e4d3$export$c58dfb1653294667 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { editorView: editorView, isActive: isActive, diagramContentId: diagramContentId, imageMediaId: imageMediaId, onDiagramBoardReady: onDiagramBoardReady, onDiagramBoardTimeout: onDiagramBoardTimeout } = t0;
    const [placement, setPlacement] = (0, $cozmU.useState)("in-view");
    const boardElementRef = (0, $cozmU.useRef)(null);
    const imageElementRef = (0, $cozmU.useRef)(null);
    let t1;
    let t2;
    if ($[0] !== diagramContentId || $[1] !== editorView || $[2] !== imageMediaId || $[3] !== isActive || $[4] !== onDiagramBoardReady || $[5] !== onDiagramBoardTimeout) {
        t1 = ()=>{
            if (!isActive || !editorView) {
                boardElementRef.current = null;
                imageElementRef.current = null;
                setPlacement("in-view");
                return;
            }
            const isDiagram = diagramContentId !== undefined;
            const isImage = imageMediaId !== undefined;
            const anchorElement = ()=>(0, $29d6db7c0a9c3ffe$export$2f3df55a342cf539)(editorView);
            const resolveTrackedElement = ()=>{
                if (isImage) {
                    if (imageElementRef.current?.isConnected) return {
                        element: imageElementRef.current,
                        isImageNode: true
                    };
                    const image = (0, $8d75a090c1bd5f30$export$d286e3535d15a9f0)(editorView, imageMediaId);
                    if (image) {
                        imageElementRef.current = image;
                        return {
                            element: image,
                            isImageNode: true
                        };
                    }
                    const anchor = anchorElement();
                    return anchor ? {
                        element: anchor,
                        isImageNode: false
                    } : null;
                }
                if (isDiagram) {
                    if (boardElementRef.current?.isConnected) return {
                        element: boardElementRef.current,
                        isImageNode: false
                    };
                    const pos = (0, $51bd462f1be2ad42$export$c3cec2ff440d20b7)(editorView.state.doc, diagramContentId);
                    if (pos !== undefined) {
                        const dom = editorView.nodeDOM(pos);
                        const boardElement = dom instanceof HTMLElement ? dom : dom?.parentElement instanceof HTMLElement ? dom.parentElement : null;
                        boardElementRef.current = boardElement;
                        return boardElement ? {
                            element: boardElement,
                            isImageNode: false
                        } : null;
                    }
                    return null;
                }
                const anchor_0 = anchorElement();
                return anchor_0 ? {
                    element: anchor_0,
                    isImageNode: false
                } : null;
            };
            const runMeasure = (root)=>{
                const tracked = resolveTrackedElement();
                if (!tracked) {
                    setPlacement("in-view");
                    return;
                }
                setPlacement($d1bf1147fd18e4d3$var$getViewportPlacement({
                    element: tracked.element,
                    root: root,
                    requireSubstantiallyVisible: tracked.isImageNode
                }));
            };
            if (isDiagram) {
                const root_0 = (0, $1jz5K.findOverflowScrollParent)(editorView.dom) || document.body;
                const measure = ()=>runMeasure(root_0);
                let frameId;
                let unbindScroll = $d1bf1147fd18e4d3$var$_temp;
                let unbindResize = $d1bf1147fd18e4d3$var$_temp2;
                const startTracking = ()=>{
                    measure();
                    onDiagramBoardReady?.();
                    const scrollTarget = root_0 === document.body ? window : root_0;
                    unbindScroll = (0, $cbY7C.bind)(scrollTarget, {
                        type: "scroll",
                        listener: measure,
                        options: {
                            passive: true,
                            capture: true
                        }
                    });
                    unbindResize = (0, $cbY7C.bind)(window, {
                        type: "resize",
                        listener: measure,
                        options: {
                            passive: true
                        }
                    });
                };
                let frames = 0;
                const pollForBoard = ()=>{
                    if (resolveTrackedElement()) {
                        startTracking();
                        return;
                    }
                    frames = frames + 1;
                    frames;
                    if (frames >= 300) {
                        onDiagramBoardTimeout?.();
                        return;
                    }
                    frameId = requestAnimationFrame(pollForBoard);
                };
                if (resolveTrackedElement()) startTracking();
                else frameId = requestAnimationFrame(pollForBoard);
                return ()=>{
                    if (frameId !== undefined) cancelAnimationFrame(frameId);
                    unbindScroll();
                    unbindResize();
                    boardElementRef.current = null;
                    imageElementRef.current = null;
                };
            }
            if (!resolveTrackedElement()) {
                setPlacement("in-view");
                return;
            }
            const root_1 = (0, $1jz5K.findOverflowScrollParent)(editorView.dom) || document.body;
            const measure_0 = ()=>runMeasure(root_1);
            measure_0();
            const scrollTarget_0 = root_1 === document.body ? window : root_1;
            const unbindScroll_0 = (0, $cbY7C.bind)(scrollTarget_0, {
                type: "scroll",
                listener: measure_0,
                options: {
                    passive: true,
                    capture: true
                }
            });
            const unbindResize_0 = (0, $cbY7C.bind)(window, {
                type: "resize",
                listener: measure_0,
                options: {
                    passive: true
                }
            });
            return ()=>{
                unbindScroll_0();
                unbindResize_0();
                boardElementRef.current = null;
                imageElementRef.current = null;
            };
        };
        t2 = [
            editorView,
            isActive,
            diagramContentId,
            imageMediaId,
            onDiagramBoardReady,
            onDiagramBoardTimeout
        ];
        $[0] = diagramContentId;
        $[1] = editorView;
        $[2] = imageMediaId;
        $[3] = isActive;
        $[4] = onDiagramBoardReady;
        $[5] = onDiagramBoardTimeout;
        $[6] = t1;
        $[7] = t2;
    } else {
        t1 = $[6];
        t2 = $[7];
    }
    (0, $cozmU.useLayoutEffect)(t1, t2);
    return placement;
} : ({ editorView: editorView, isActive: isActive, diagramContentId: diagramContentId, imageMediaId: imageMediaId, onDiagramBoardReady: onDiagramBoardReady, onDiagramBoardTimeout: onDiagramBoardTimeout })=>{
    const [placement, setPlacement] = (0, $cozmU.useState)('in-view');
    // Caches the resolved diagram DOM node so we don't walk the doc on every
    // scroll/resize; re-resolved only once the cached node leaves the document.
    const boardElementRef = (0, $cozmU.useRef)(null);
    // Same for the inserted image: resolving it walks the doc, so cache it rather than traversing on
    // every scroll/resize.
    const imageElementRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!isActive || !editorView) {
            boardElementRef.current = null;
            imageElementRef.current = null;
            setPlacement('in-view');
            return;
        }
        const isDiagram = diagramContentId !== undefined;
        const isImage = imageMediaId !== undefined;
        const anchorElement = ()=>(0, $29d6db7c0a9c3ffe$export$2f3df55a342cf539)(editorView);
        // For diagrams, track the whiteboard node itself (its position drives the scroll-vs-"View"
        // decision); for images, the inserted media node; other remixes track the thinking widget.
        // `isImageNode` says whether we ended up on the image itself rather than falling back to the
        // anchor, so `runMeasure` doesn't have to re-query the DOM to work that out.
        const resolveTrackedElement = ()=>{
            if (isImage) {
                if (imageElementRef.current?.isConnected) return {
                    element: imageElementRef.current,
                    isImageNode: true
                };
                const image = (0, $8d75a090c1bd5f30$export$d286e3535d15a9f0)(editorView, imageMediaId);
                if (image) {
                    imageElementRef.current = image;
                    return {
                        element: image,
                        isImageNode: true
                    };
                }
                // Fall back to the anchor if the media node has gone (e.g. the user deleted it). Not
                // cached: the upload may still be in flight, and the anchor is a cheap querySelector.
                const anchor = anchorElement();
                return anchor ? {
                    element: anchor,
                    isImageNode: false
                } : null;
            }
            if (isDiagram) {
                if (boardElementRef.current?.isConnected) return {
                    element: boardElementRef.current,
                    isImageNode: false
                };
                const pos = (0, $51bd462f1be2ad42$export$c3cec2ff440d20b7)(editorView.state.doc, diagramContentId);
                if (pos !== undefined) {
                    const dom = editorView.nodeDOM(pos);
                    const boardElement = dom instanceof HTMLElement ? dom : dom?.parentElement instanceof HTMLElement ? dom.parentElement : null;
                    boardElementRef.current = boardElement;
                    return boardElement ? {
                        element: boardElement,
                        isImageNode: false
                    } : null;
                }
                // The board mounts asynchronously, so it may not be in the document yet — the caller
                // keeps polling until it appears.
                return null;
            }
            const anchor_0 = anchorElement();
            return anchor_0 ? {
                element: anchor_0,
                isImageNode: false
            } : null;
        };
        // Re-resolves the tracked element each call (it can mount/unmount/be replaced mid-remix) and
        // updates placement against the scroll root.
        const runMeasure = (root)=>{
            const tracked = resolveTrackedElement();
            if (!tracked) {
                setPlacement('in-view');
                return;
            }
            setPlacement($d1bf1147fd18e4d3$var$getViewportPlacement({
                element: tracked.element,
                root: root,
                // Only the image path tracks a full-size result element; the zero-height anchor and
                // the diagram board keep the plain intersection rule.
                requireSubstantiallyVisible: tracked.isImageNode
            }));
        };
        // Nothing to measure when the effect first runs (board mounts async, widget already cleared),
        // so poll until the board mounts, then track it with the usual scroll/resize listeners.
        if (isDiagram) {
            const root_0 = (0, $1jz5K.findOverflowScrollParent)(editorView.dom) || document.body;
            const measure = ()=>runMeasure(root_0);
            let frameId;
            let unbindScroll = ()=>{};
            let unbindResize = ()=>{};
            const startTracking = ()=>{
                measure();
                // The board is now in the document and its placement measured — signal the earliest
                // point a scroll can safely target it.
                onDiagramBoardReady?.();
                const scrollTarget = root_0 === document.body ? window : root_0;
                unbindScroll = (0, $cbY7C.bind)(scrollTarget, {
                    type: 'scroll',
                    listener: measure,
                    options: {
                        passive: true,
                        capture: true
                    }
                });
                unbindResize = (0, $cbY7C.bind)(window, {
                    type: 'resize',
                    listener: measure,
                    options: {
                        passive: true
                    }
                });
            };
            // ~300 frames ≈ 5s at 60fps — a ceiling for the async insert to land; past it assume a failed
            // insert and stop rather than poll forever. (rAF pauses in background tabs, so no hidden spin.)
            const MAX_POLL_FRAMES = 300;
            let frames = 0;
            const pollForBoard = ()=>{
                if (resolveTrackedElement()) {
                    startTracking();
                    return;
                }
                frames += 1;
                if (frames >= MAX_POLL_FRAMES) {
                    onDiagramBoardTimeout?.();
                    return;
                }
                frameId = requestAnimationFrame(pollForBoard);
            };
            if (resolveTrackedElement()) startTracking();
            else frameId = requestAnimationFrame(pollForBoard);
            return ()=>{
                if (frameId !== undefined) cancelAnimationFrame(frameId);
                unbindScroll();
                unbindResize();
                boardElementRef.current = null;
                imageElementRef.current = null;
            };
        }
        // Non-diagram: bail out (without querying the scroll parent) when the widget isn't present yet.
        if (!resolveTrackedElement()) {
            setPlacement('in-view');
            return;
        }
        const root_1 = (0, $1jz5K.findOverflowScrollParent)(editorView.dom) || document.body;
        const measure_0 = ()=>runMeasure(root_1);
        measure_0();
        // Re-measure on scroll (both the overflow scroll parent and the window, to
        // cover page-level scrolling) and on resize.
        const scrollTarget_0 = root_1 === document.body ? window : root_1;
        const unbindScroll_0 = (0, $cbY7C.bind)(scrollTarget_0, {
            type: 'scroll',
            listener: measure_0,
            options: {
                passive: true,
                capture: true
            }
        });
        const unbindResize_0 = (0, $cbY7C.bind)(window, {
            type: 'resize',
            listener: measure_0,
            options: {
                passive: true
            }
        });
        return ()=>{
            unbindScroll_0();
            unbindResize_0();
            boardElementRef.current = null;
            imageElementRef.current = null;
        };
    }, [
        editorView,
        isActive,
        diagramContentId,
        imageMediaId,
        onDiagramBoardReady,
        onDiagramBoardTimeout
    ]);
    return placement;
};
const $d1bf1147fd18e4d3$export$7523f6d059999b11 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { editorView: editorView, isComplete: isComplete } = t0;
    let t1;
    if ($[0] !== editorView || $[1] !== isComplete) {
        t1 = {
            editorView: editorView,
            isActive: isComplete
        };
        $[0] = editorView;
        $[1] = isComplete;
        $[2] = t1;
    } else t1 = $[2];
    const placement = $d1bf1147fd18e4d3$export$c58dfb1653294667(t1);
    return placement === "in-view";
} : ({ editorView: editorView, isComplete: isComplete })=>{
    const placement = $d1bf1147fd18e4d3$export$c58dfb1653294667({
        editorView: editorView,
        isActive: isComplete
    });
    return placement === 'in-view';
};
function $d1bf1147fd18e4d3$var$_temp() {}
function $d1bf1147fd18e4d3$var$_temp2() {}


















const $ce233e243bc5fa07$export$2e3ceb21b2f61793 = (remixDiagramContentId)=>({ tr: tr })=>{
        tr.setMeta((0, $bpOXf.malleableUiPluginKey), {
            remixDiagramContentId: remixDiagramContentId
        });
        return tr;
    };


const $e4ad0a68bee3bd68$export$34656d0347a5137b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { api: api, isThinking: isThinking } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            "malleableUi"
        ];
        $[0] = t1;
    } else t1 = $[0];
    const remixDiagramContentId = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, t1, $e4ad0a68bee3bd68$var$_temp);
    const prevIsThinkingRef = (0, $cozmU.useRef)(false);
    let t2;
    if ($[1] !== api?.core || $[2] !== isThinking || $[3] !== remixDiagramContentId) {
        t2 = ()=>{
            const justStartedThinking = isThinking && !prevIsThinkingRef.current;
            prevIsThinkingRef.current = isThinking;
            if (justStartedThinking && remixDiagramContentId !== undefined) api?.core.actions.execute((0, $ce233e243bc5fa07$export$2e3ceb21b2f61793)(undefined));
        };
        $[1] = api?.core;
        $[2] = isThinking;
        $[3] = remixDiagramContentId;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== api || $[6] !== isThinking || $[7] !== remixDiagramContentId) {
        t3 = [
            isThinking,
            remixDiagramContentId,
            api
        ];
        $[5] = api;
        $[6] = isThinking;
        $[7] = remixDiagramContentId;
        $[8] = t3;
    } else t3 = $[8];
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[9] !== api?.core) {
        t4 = (contentId)=>{
            api?.core.actions.execute((0, $ce233e243bc5fa07$export$2e3ceb21b2f61793)(contentId));
        };
        $[9] = api?.core;
        $[10] = t4;
    } else t4 = $[10];
    const recordDiagramContentId = t4;
    let t5;
    if ($[11] !== remixDiagramContentId) {
        t5 = (editorView)=>{
            if (remixDiagramContentId === undefined) return null;
            const boardPos = (0, $51bd462f1be2ad42$export$c3cec2ff440d20b7)(editorView.state.doc, remixDiagramContentId);
            const boardDom = boardPos !== undefined ? editorView.nodeDOM(boardPos) : null;
            return boardDom instanceof HTMLElement ? boardDom : boardDom?.parentElement ?? null;
        };
        $[11] = remixDiagramContentId;
        $[12] = t5;
    } else t5 = $[12];
    const resolveDiagramScrollTarget = t5;
    let t6;
    if ($[13] !== recordDiagramContentId || $[14] !== remixDiagramContentId || $[15] !== resolveDiagramScrollTarget) {
        t6 = {
            recordDiagramContentId: recordDiagramContentId,
            remixDiagramContentId: remixDiagramContentId,
            resolveDiagramScrollTarget: resolveDiagramScrollTarget
        };
        $[13] = recordDiagramContentId;
        $[14] = remixDiagramContentId;
        $[15] = resolveDiagramScrollTarget;
        $[16] = t6;
    } else t6 = $[16];
    return t6;
} : ({ api: api, isThinking: isThinking })=>{
    // contentId of the diagram produced by the in-flight remix (set at streaming-start).
    // Presence marks this remix as a diagram and lets the ready-signal UI target the board node.
    const remixDiagramContentId = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states)=>states.malleableUiState?.remixDiagramContentId);
    // Clear a diagram contentId left over from a previous remix when a new one starts (rising edge
    // of isThinking), so a later non-diagram remix never targets a stale board.
    const prevIsThinkingRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        const justStartedThinking = isThinking && !prevIsThinkingRef.current;
        prevIsThinkingRef.current = isThinking;
        if (justStartedThinking && remixDiagramContentId !== undefined) api?.core.actions.execute((0, $ce233e243bc5fa07$export$2e3ceb21b2f61793)(undefined));
    }, [
        isThinking,
        remixDiagramContentId,
        api
    ]);
    // Record the streaming diagram's contentId (called from the 'suppressed' finalize-status branch
    // as the board starts streaming in).
    const recordDiagramContentId = (0, $cozmU.useCallback)((contentId)=>{
        api?.core.actions.execute((0, $ce233e243bc5fa07$export$2e3ceb21b2f61793)(contentId));
    }, [
        api
    ]);
    // The whiteboard's DOM element (by contentId) so the scroll can target the board. Null for
    // non-diagram remixes or before the board mounts — callers fall back to the anchor resolution.
    const resolveDiagramScrollTarget = (0, $cozmU.useCallback)((editorView)=>{
        if (remixDiagramContentId === undefined) return null;
        const boardPos = (0, $51bd462f1be2ad42$export$c3cec2ff440d20b7)(editorView.state.doc, remixDiagramContentId);
        const boardDom = boardPos !== undefined ? editorView.nodeDOM(boardPos) : null;
        return boardDom instanceof HTMLElement ? boardDom : boardDom?.parentElement ?? null;
    }, [
        remixDiagramContentId
    ]);
    return {
        recordDiagramContentId: recordDiagramContentId,
        remixDiagramContentId: remixDiagramContentId,
        resolveDiagramScrollTarget: resolveDiagramScrollTarget
    };
};
function $e4ad0a68bee3bd68$var$_temp(states) {
    return states.malleableUiState?.remixDiagramContentId;
}
















const $0e92e32cfa4af727$export$62164441b7fc0faa = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { api: api, isThinking: isThinking } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            "malleableUi"
        ];
        $[0] = t1;
    } else t1 = $[0];
    const recordedImageMediaId = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, t1, $0e92e32cfa4af727$var$_temp);
    const remixImageMediaId = recordedImageMediaId;
    const prevIsThinkingRef = (0, $cozmU.useRef)(false);
    let t2;
    if ($[1] !== api?.core || $[2] !== isThinking || $[3] !== remixImageMediaId) {
        t2 = ()=>{
            const justStartedThinking = isThinking && !prevIsThinkingRef.current;
            prevIsThinkingRef.current = isThinking;
            if (justStartedThinking && remixImageMediaId !== undefined) api?.core.actions.execute((0, $8ef7f637f4ca3dda$export$f36198854f9520d1)({
                mediaId: undefined
            }));
        };
        $[1] = api?.core;
        $[2] = isThinking;
        $[3] = remixImageMediaId;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== api || $[6] !== isThinking || $[7] !== remixImageMediaId) {
        t3 = [
            isThinking,
            remixImageMediaId,
            api
        ];
        $[5] = api;
        $[6] = isThinking;
        $[7] = remixImageMediaId;
        $[8] = t3;
    } else t3 = $[8];
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[9] !== remixImageMediaId) {
        t4 = (editorView)=>{
            if (remixImageMediaId === undefined) return null;
            return (0, $8d75a090c1bd5f30$export$d286e3535d15a9f0)(editorView, remixImageMediaId);
        };
        $[9] = remixImageMediaId;
        $[10] = t4;
    } else t4 = $[10];
    const resolveImageScrollTarget = t4;
    let t5;
    if ($[11] !== remixImageMediaId || $[12] !== resolveImageScrollTarget) {
        t5 = {
            remixImageMediaId: remixImageMediaId,
            resolveImageScrollTarget: resolveImageScrollTarget
        };
        $[11] = remixImageMediaId;
        $[12] = resolveImageScrollTarget;
        $[13] = t5;
    } else t5 = $[13];
    return t5;
} : ({ api: api, isThinking: isThinking })=>{
    // Media id of the image this remix inserted (set by the rovo bridge once the upload lands).
    const recordedImageMediaId = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states)=>states.malleableUiState?.remixImageMediaId);
    const remixImageMediaId = recordedImageMediaId;
    // Clear an image id left over from a previous remix when a new one starts (rising edge of
    // isThinking), so a later non-image remix never targets a stale image.
    const prevIsThinkingRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        const justStartedThinking = isThinking && !prevIsThinkingRef.current;
        prevIsThinkingRef.current = isThinking;
        if (justStartedThinking && remixImageMediaId !== undefined) api?.core.actions.execute((0, $8ef7f637f4ca3dda$export$f36198854f9520d1)({
            mediaId: undefined
        }));
    }, [
        isThinking,
        remixImageMediaId,
        api
    ]);
    // The inserted image's DOM element. Null for non-image remixes or before the upload lands —
    // callers fall back to the anchor resolution.
    const resolveImageScrollTarget = (0, $cozmU.useCallback)((editorView)=>{
        if (remixImageMediaId === undefined) return null;
        return (0, $8d75a090c1bd5f30$export$d286e3535d15a9f0)(editorView, remixImageMediaId);
    }, [
        remixImageMediaId
    ]);
    return {
        remixImageMediaId: remixImageMediaId,
        resolveImageScrollTarget: resolveImageScrollTarget
    };
};
function $0e92e32cfa4af727$var$_temp(states) {
    return states.malleableUiState?.remixImageMediaId;
}







const $da0e6f79e5c28019$var$isEmptyParagraphNode = (node)=>{
    return node.type === 'paragraph' && (node.content?.length ?? 0) === 0;
};
const $da0e6f79e5c28019$var$isNativeEmbedNode = (node)=>{
    const { attrs: attrs } = node;
    return node.type === 'extension' && typeof attrs === 'object' && attrs !== null && 'extensionKey' in attrs && typeof attrs.extensionKey === 'string' && attrs.extensionKey.startsWith((0, $2sp5n.NATIVE_EMBED_EXTENSION_KEY)) && 'localId' in attrs && typeof attrs.localId === 'string' && attrs.localId.length > 0;
};
const $da0e6f79e5c28019$var$getNativeEmbedUrl = (node)=>{
    const url = node.attrs.parameters?.macroParams?.url?.value;
    return typeof url === 'string' ? url : undefined;
};
const $da0e6f79e5c28019$var$getTerminalUrlSegment = (url)=>{
    try {
        const pathname = new URL(url).pathname;
        return pathname.split('/').filter(Boolean).pop();
    } catch  {
        return url.split('/').filter(Boolean).pop();
    }
};
const $da0e6f79e5c28019$export$5afa7589883bc579 = ({ nodeUrl: nodeUrl, targetUrl: targetUrl })=>{
    if (nodeUrl === targetUrl) return true;
    const nodeId = $da0e6f79e5c28019$var$getTerminalUrlSegment(nodeUrl);
    const targetId = $da0e6f79e5c28019$var$getTerminalUrlSegment(targetUrl);
    return Boolean(nodeId && targetId && nodeId === targetId);
};
const $da0e6f79e5c28019$var$resolveNativeEmbedScrollTargetByUrl = ({ doc: doc, targetUrl: targetUrl, editorView: editorView })=>{
    if (!targetUrl) return null;
    let targetPos;
    doc.descendants((node, pos)=>{
        if (targetPos !== undefined) return false;
        const nodeUrl = $da0e6f79e5c28019$var$getNativeEmbedUrl(node);
        if (node.type.name === 'extension' && typeof node.attrs.extensionKey === 'string' && node.attrs.extensionKey.startsWith((0, $2sp5n.NATIVE_EMBED_EXTENSION_KEY)) && nodeUrl && $da0e6f79e5c28019$export$5afa7589883bc579({
            nodeUrl: nodeUrl,
            targetUrl: targetUrl
        })) {
            targetPos = pos;
            return false;
        }
        return true;
    });
    const targetDom = targetPos !== undefined ? editorView.nodeDOM(targetPos) : null;
    return targetDom instanceof HTMLElement ? targetDom : targetDom?.parentElement ?? null;
};
const $da0e6f79e5c28019$var$isNativeContentContextFragment = (context)=>{
    return context?.type === 'nativeContentContext' && 'contentResult' in context;
};
const $da0e6f79e5c28019$var$isEmbeddedPageContent = (content)=>{
    return typeof content === 'object' && content !== null && 'embeddedPageBody' in content && typeof content.embeddedPageBody === 'string';
}; // JSON.parse succeeds on non-document payloads (`123`, `null`, `[]`), so the shape must be checked.
const $da0e6f79e5c28019$var$isAdfDocument = (value)=>{
    return typeof value === 'object' && value !== null && !Array.isArray(value) && value.type === 'doc';
};
const $da0e6f79e5c28019$var$getRemixTypeProps = (selectedContext)=>{
    const blockProps = {
        remixType: 'block'
    };
    if (!(0, $iDrrr.fg)('maui_remixable_page_native_embeds')) return blockProps;
     // The AI selection context can include empty paragraph nodes adjacent to the
    // user-selected object. Ignore those placeholders so selecting a single native
    // embed plus surrounding empty paragraphs still enables object remix, while
    // any other selected content continues to fall back to block remix.
    const nodes = selectedContext.selectionFragment?.filter((node)=>!$da0e6f79e5c28019$var$isEmptyParagraphNode(node));
    if (nodes?.length !== 1) return blockProps;
    const [node] = nodes;
    if (!node || !$da0e6f79e5c28019$var$isNativeEmbedNode(node)) return blockProps;
    const { localId: localId } = node.attrs;
    const context = selectedContext.additionalNodeContext?.[localId];
    if (!$da0e6f79e5c28019$var$isNativeContentContextFragment(context)) return blockProps;
     // A rejection here (or a rejected `contentResult`) is the read failure; the consumer handles it as a non-success.
    const adfDocument = context.contentResult.then((content)=>{
        if (content === undefined) throw new Error('Native embed content is unavailable');
        if (!$da0e6f79e5c28019$var$isEmbeddedPageContent(content) || content.embeddedPageBody === '') throw new Error('Native embed content is missing an embedded page body');
        let parsedBody;
        try {
            parsedBody = JSON.parse(content.embeddedPageBody);
        } catch  {
            throw new Error('Native embed content is malformed');
        }
        if (!$da0e6f79e5c28019$var$isAdfDocument(parsedBody)) throw new Error('Native embed content is not a valid ADF document');
        return parsedBody;
    }); // The consumer only awaits this on option-select, so a read that fails earlier has no awaiter yet.
    // The inert handler prevents an unhandled rejection; the consumer's await still gets the rejection.
    adfDocument.catch(()=>undefined);
    return {
        remixType: 'object',
        adfDocument: adfDocument
    };
};
const $da0e6f79e5c28019$var$styles = {
    floatingBarBottom: "_1mT5xdy1CL _0Bm75G5zaO _3OE6xY715P _1VJPcajssS _39xV02E6Kk _4ouGXIHakr _42Yu6BbFo4"
}; // How long the floating "ready" bar stays visible while the remix is out of
// view before auto-dismissing (per the Remix Figma spec).
const $da0e6f79e5c28019$var$READY_BAR_AUTO_DISMISS_MS = 10000; // Operational event fired when diagram board tracking gives up (custom event — not part of the
const $da0e6f79e5c28019$var$EMPTY_EDITOR_REMIX_LIFECYCLE_PRESENTATION = {
    animationFinished: false,
    authority: undefined,
    phase: undefined,
    remixId: undefined,
    token: undefined
};
const $da0e6f79e5c28019$export$9b636cd211668abd = ({ api: api, hiddenOptions: hiddenOptions, isEditorRemixStateRearchitectureTreatment: isEditorRemixStateRearchitectureTreatment, remixContentComponent: Component })=>{
    const [, refreshMachinePresentation] = (0, $cozmU.useState)(0);
    const machinePresentation = isEditorRemixStateRearchitectureTreatment ? (0, $dc44c0de1ed07c1a$export$58aeb614b6d856f7)(api) : $da0e6f79e5c28019$var$EMPTY_EDITOR_REMIX_LIFECYCLE_PRESENTATION;
    const capturedAnimationFinishedSink = isEditorRemixStateRearchitectureTreatment ? (0, $dc44c0de1ed07c1a$export$66f5178019bac961)(api) : undefined;
    const capturedTerminalCleanupSink = isEditorRemixStateRearchitectureTreatment ? (0, $dc44c0de1ed07c1a$export$3a7772ffa9a9fcc0)(api) : undefined;
    const [dismissedReadySession, setDismissedReadySession] = (0, $cozmU.useState)(undefined);
    const previousImageMediaIdRef = (0, $cozmU.useRef)(undefined);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!isEditorRemixStateRearchitectureTreatment) return;
        return (0, $dc44c0de1ed07c1a$export$ca9605d624b3c2db)(api, ()=>refreshMachinePresentation((value)=>value + 1));
    }, [
        api,
        isEditorRemixStateRearchitectureTreatment,
        machinePresentation.remixId
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (dismissedReadySession !== undefined && dismissedReadySession !== machinePresentation.remixId) setDismissedReadySession(undefined);
    }, [
        dismissedReadySession,
        machinePresentation.remixId
    ]);
    const { editorView: editorView } = (0, $cozmU.useContext)((0, $2iHw5.default));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const pendingRovoRemixTargetRef = (0, $cozmU.useRef)(undefined);
    const isCurrentReadyPresentationDismissed = dismissedReadySession !== undefined && dismissedReadySession === machinePresentation.remixId; /**
                                                                                                                                             * True while a lifecycle-machine session still owns this flow.
                                                                                                                                             *
                                                                                                                                             * An early streaming whiteboard moves the machine into `inserting` before generation finishes,
                                                                                                                                             * and the projection reports that as `!isThinking && isComplete`. That is not a ready result, so
                                                                                                                                             * every ready-presentation path below has to use this ownership boundary rather than trusting
                                                                                                                                             * those two booleans on their own. The session is registered for the life of the flow.
                                                                                                                                             */ 
    const hasLiveMachineFlow = machinePresentation.authority === 'active'; /**
                                                                          * True only while the machine is inserting, which for a diagram starts when the early streaming
                                                                          * whiteboard lands and generation is still running.
                                                                          *
                                                                          * `hasLiveMachineFlow` cannot stand in for this. It is also true after the flow genuinely
                                                                          * completes, and suppressing the ready presentation for that whole window would take away the
                                                                          * treatment ready bar and its auto-dismiss.
                                                                          */ 
    const isMachineInserting = machinePresentation.phase === 'inserting';
    const captureRovoRemixTarget = (preset)=>{
        pendingRovoRemixTargetRef.current = {
            preset: preset
        };
    };
    (0, $hdBxM.useSubscribe)({
        topic: (0, $k1Pvg.Topics).AI_MATE
    }, (payload)=>{
        if (payload.type === 'open-rovo-remix-sidebar' && payload.data.remixConsumer === 'editor') {
            captureRovoRemixTarget(payload.data.remixPreset);
            return;
        }
        if (payload.type === 'editor-context-payload' && payload.source === 'editor' && payload.data && pendingRovoRemixTargetRef.current && editorView) {
            const preset_0 = editorView.state.selection.empty ? 'page' : 'selection';
            if (pendingRovoRemixTargetRef.current.preset === preset_0) {
                captureRovoRemixTarget(preset_0);
                return;
            }
            (0, $07a368e9003b6a4b$export$be13f069b08235f1)(editorView.state.selection);
        }
    });
    (0, $hdBxM.useSubscribe)({
        topic: (0, $k1Pvg.Topics).ROVO_REMIX
    }, (payload_0)=>{
        if (payload_0.type === 'update-rovo-remix-preset' && payload_0.data.remixConsumer === 'editor') captureRovoRemixTarget(payload_0.data.remixPreset);
    });
    (0, $hdBxM.useSubscribe)({
        topic: (0, $k1Pvg.Topics).ROVO_REMIX,
        consumeOnceKey: 'editor-rovo-remix-submit'
    }, (payload_1)=>{
        if (payload_1.type !== 'submit-rovo-remix' || payload_1.data.remixConsumer !== 'editor' || (0, $2pQiO.UNSAFE_expValNoExposure)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'control') !== 'variant2') return;
        const target = pendingRovoRemixTargetRef.current;
        pendingRovoRemixTargetRef.current = undefined;
        if (payload_1.data.remixPreset !== 'selection') return;
        if (target?.preset !== 'selection' || !editorView || editorView.state.selection.empty || !api) {
            (0, $hdBxM.publish)((0, $k1Pvg.Topics).ROVO_REMIX, {
                type: 'rovo-remix-handoff-failed',
                source: 'editor-rovo-remix'
            });
            return;
        }
        api.core.actions.execute(api.malleableUi.commands.startRemix({
            remixModalMetadata: {
                remixSource: 'rovoChat',
                preselectedType: payload_1.data.remixOption,
                preselectedSubType: payload_1.data.remixSubType,
                preselectedUserPrompt: payload_1.data.userPrompt,
                preselectedConversationId: payload_1.data.conversationId
            }
        }));
    });
    const scheduleRemixRetentionCheck = (0, $7jUr8.useRemixRetentionTracker)();
    const isViewMode = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'editorViewMode'
    ], (states)=>states.editorViewModeState?.mode === 'view');
    const isModalOpen = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states_0)=>states_0.malleableUiState?.isRemixModalOpen || false);
    const isThinking = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states_1)=>states_1.malleableUiState?.isThinking || false);
    const isWaitingForInput = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states_2)=>states_2.malleableUiState?.isWaitingForInput || false);
    const isComplete = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states_3)=>states_3.malleableUiState?.isComplete || false);
    const remixModalMetadata = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states_4)=>states_4.malleableUiState?.remixModalMetadata);
    const remixSource = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states_5)=>states_5.malleableUiState?.remixSource);
    const remixAttemptId = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states_6)=>states_6.malleableUiState?.remixAttemptId);
    const showLocationPicker = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states_7)=>states_7.malleableUiState?.showLocationPicker || false);
    const isUpdate = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states_8)=>states_8.malleableUiState?.isUpdate || false);
    const historyEntryForUpdate = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states_9)=>states_9.malleableUiState?.historyEntryForUpdate);
    const dynamicUiSubtypeForUpdate = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states_10)=>states_10.malleableUiState?.dynamicUiSubtypeForUpdate);
    const savedSelection = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states_11)=>states_11.malleableUiState?.savedSelection);
    const remixUpdateScrollTargetUrl = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states_12)=>states_12.malleableUiState?.remixUpdateScrollTargetUrl); // Diagram-specific ready-signal logic (board tracking + scroll targeting) lives in its own hook.
    // When this isn't a diagram remix the returned values are inert.
    const { remixDiagramContentId: remixDiagramContentId, recordDiagramContentId: recordDiagramContentId, resolveDiagramScrollTarget: resolveDiagramScrollTarget } = (0, $e4ad0a68bee3bd68$export$34656d0347a5137b)({
        api: api,
        isThinking: isThinking
    }); // Image-specific ready-signal logic (media-node scroll target). Inert for non-image remixes.
    const { remixImageMediaId: remixImageMediaId, resolveImageScrollTarget: resolveImageScrollTarget } = (0, $0e92e32cfa4af727$export$62164441b7fc0faa)({
        api: api,
        isThinking: isThinking
    }); // Start Remix experience for floating toolbar entry point (can't use hooks in toolbar config).
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    const isSuggestedRemix = remixSource === 'suggestedRemix' && (0, $2pQiO.UNSAFE_expValNoExposure)('platform_editor_ai_content_suggested_edits', 'isEnabled', false);
    const prevIsModalOpen = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!prevIsModalOpen.current && isModalOpen && remixSource === 'floatingToolbar') {
            const featureArea = (0, $iBsvI.getRemixFeatureArea)({});
            experienceTracker.start({
                name: (0, $irnO2.ExperienceName).REMIX_START,
                id: (0, $irnO2.ExperienceName).REMIX_START,
                attributes: {
                    entryPoint: 'editor',
                    remixSource: 'floatingToolbar',
                    product: 'confluence',
                    ...featureArea !== undefined && {
                        featureArea: featureArea
                    }
                }
            });
            if (!isUpdate) (0, $kDDrf.startRemixCreateExperience)({
                experienceTracker: experienceTracker,
                attributes: {
                    entryPoint: 'editor',
                    remixSource: 'floatingToolbar',
                    product: 'confluence'
                }
            });
        }
        prevIsModalOpen.current = isModalOpen;
    }, [
        isModalOpen,
        isUpdate,
        remixSource,
        experienceTracker
    ]);
    const previousSuggestedRemixAttemptId = (0, $cozmU.useRef)(undefined);
    (0, $cozmU.useEffect)(()=>{
        if (isSuggestedRemix && remixAttemptId !== undefined && previousSuggestedRemixAttemptId.current !== remixAttemptId) {
            previousSuggestedRemixAttemptId.current = remixAttemptId;
            const attributes = {
                entryPoint: 'editor',
                remixAttemptId: remixAttemptId,
                remixSource: 'suggestedRemix',
                product: 'confluence'
            };
            experienceTracker.start({
                name: (0, $irnO2.ExperienceName).REMIX_START,
                id: (0, $irnO2.ExperienceName).REMIX_START,
                attributes: attributes
            });
            if (!isUpdate) (0, $kDDrf.startRemixCreateExperience)({
                experienceTracker: experienceTracker,
                attributes: attributes,
                includeOpenMenuExperience: false
            });
        }
    }, [
        experienceTracker,
        isSuggestedRemix,
        isUpdate,
        remixAttemptId
    ]); // Prefer `startRemix`'s snapshot for Suggested Remix (experiment-gated) — the caret has already
    // moved off the anchor by the time this renders.
    const isRovoChatRemix = remixSource === 'rovoChat' && (0, $2pQiO.UNSAFE_expValNoExposure)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'control') === 'variant2';
    const capturedSelectionContext = isSuggestedRemix || isRovoChatRemix ? remixModalMetadata?.capturedSelectionContext : undefined;
    const selectedContext = capturedSelectionContext ?? api?.aiExperience?.actions.getAISelectionContext();
    const remixTypeProps = (0, $cozmU.useMemo)(()=>selectedContext ? $da0e6f79e5c28019$var$getRemixTypeProps(selectedContext) : undefined, [
        selectedContext
    ]);
    const handleModalClose = (0, $cozmU.useCallback)(()=>{
        api?.core.actions.execute(api?.malleableUi.commands.closeRemixModal());
    }, [
        api
    ]);
    const onStartThinking = (0, $cozmU.useCallback)((options)=>{
        if ((0, $iDrrr.fg)('platform_editor_ai_remix_toolbar')) (0, $3ed7f22374c9e3fb$export$fdf82e9851b59bf0)({
            api: api,
            options: options
        });
        else {
            api?.aiExperience?.actions.toggleAiEntryPoints?.(true);
            api?.core.actions.execute(api?.malleableUi.commands.startRemixThinking(options));
        }
    }, [
        api
    ]);
    const onStopThinking = (0, $cozmU.useCallback)((options_0)=>{
        // Settle the rendered attempt unless the request is being preserved for handoff.
        if (!options_0?.preserveRequest && remixAttemptId) api?.malleableUi?.actions.reportInlineRovoEdit?.(remixAttemptId, 'generation-aborted');
        const cleanup = ()=>{
            if ((0, $iDrrr.fg)('platform_editor_ai_remix_toolbar')) {
                // Abort before cancelling so send-message-action.ts fires the paired
                // aiInteraction initiated + dismissed events via AbortError.
                // `preserveRequest` keeps the in-flight request alive (the preview it streams into is
                // opening) while still dismissing the thinking UI.
                if (!options_0?.preserveRequest) (0, $b96b9e650a905796$export$e125c3b8c9ddf1a1)(api)?.();
                (0, $b96b9e650a905796$export$e02ace41eac2e13a)({
                    api: api,
                    reopenModal: options_0?.reopenModal
                });
            } else {
                api?.aiExperience?.actions.toggleAiEntryPoints?.(false);
                api?.core.actions.execute(api?.malleableUi.commands.stopRemixThinking(options_0));
            }
        }; // Treatment callbacks capture their session before any UX mutation. A delayed callback from
        // A must not abort, toggle, or dispatch cleanup against replacement B. Legacy callbacks have
        // no captured sink and retain their existing behavior.
        if (capturedTerminalCleanupSink) capturedTerminalCleanupSink(cleanup);
        else cleanup();
    }, [
        api,
        capturedTerminalCleanupSink,
        remixAttemptId
    ]);
    const onDismissThinkingUi = (0, $cozmU.useCallback)((options_1)=>{
        if ((0, $iDrrr.fg)('platform_editor_ai_remix_toolbar')) (0, $b96b9e650a905796$export$e02ace41eac2e13a)({
            api: api,
            reopenModal: options_1?.reopenModal
        });
        else {
            api?.aiExperience?.actions.toggleAiEntryPoints?.(false);
            api?.core.actions.execute(api?.malleableUi.commands.stopRemixThinking(options_1));
        } // The dismissal above clears `isThinking` through a `legacy-stop` write, which the reducer
        // drops while write authority is held. Same predicate as that fence, so control is untouched.
        if (options_1?.endsFlow && (0, $dc44c0de1ed07c1a$export$f2d1c70f96537b99)(api)) api?.core.actions.execute((0, $36058288d319cae1$export$788d053d96dbd6b6));
    }, [
        api
    ]);
    const onRegisterAbortRequest = (0, $cozmU.useCallback)((abortFn)=>(0, $b96b9e650a905796$export$f9cb53c9d12f6f55)(api, abortFn), [
        api
    ]);
    const onRegisterEditorRemixMachineLifecycleOwnership = (0, $cozmU.useCallback)((session)=>(0, $dc44c0de1ed07c1a$export$10406465ad92edb2)(api, session), [
        api
    ]); /**
                                                                                                                                                                                           * Deliberately not gated, matching `onRegisterAbortRequest` above: this is the same kind of
                                                                                                                                                                                           * api-keyed bridge, and publishing into a registry slot is inert on its own.
                                                                                                                                                                                           *
                                                                                                                                                                                           * The only reader is `EditorRemixEffectHost`, and `malleableUiPlugin` mounts that behind the
                                                                                                                                                                                           * master gate and an exposure-free cohort read — so in control, master-gate-off and adapter-absent
                                                                                                                                                                                           * Jira the slot is written and never read. `malleableUiPlugin-remixEffectHost.test.tsx` asserts
                                                                                                                                                                                           * the host is absent for those cohorts, which is what makes that structural rather than a
                                                                                                                                                                                           * convention.
                                                                                                                                                                                           *
                                                                                                                                                                                           * Gating here would mean evaluating the same experiment a second time on a render path, or
                                                                                                                                                                                           * threading the plugin's decision down purely to guard a `WeakMap` write.
                                                                                                                                                                                           */ 
    const onRegisterEditorRemixUxHandles = (0, $cozmU.useCallback)((handles)=>(0, $dc44c0de1ed07c1a$export$7d31a25b751a9034)(api, handles), [
        api
    ]);
    const onRegisterEditorRemixMutationCancellationSink = (0, $cozmU.useCallback)((sink)=>(0, $dc44c0de1ed07c1a$export$e4c5d0e97ec647cf)(api, sink), [
        api
    ]);
    const onBeforeEditorRemixResultInsertion = (0, $cozmU.useCallback)(()=>(0, $dc44c0de1ed07c1a$export$8c3960abef4008ee)(api), [
        api
    ]);
    const remixRecoveryCoordinator = (0, $loghT.useEditorRemixRecoveryCoordinator)();
    const clearThinkingDecoration = (0, $cozmU.useCallback)(()=>{
        api?.core.actions.execute((0, $592515a66bfc26f7$export$65f89d2d4741e4b7)());
    }, [
        api
    ]);
    const replaceWhiteboardEmbed = (0, $cozmU.useCallback)((options_2)=>{
        return api?.core.actions.execute(api?.malleableUi.commands.replaceWhiteboardEmbed(options_2)) === true;
    }, [
        api
    ]); // Maps the MAUI-side string status to the editor's finalize-status enum.
    const setMauiEmbedFinalizeStatus = (0, $cozmU.useCallback)((options_3)=>{
        api?.core.actions.execute(api?.malleableUi.commands.setMauiEmbedFinalizeStatus({
            contentId: options_3.contentId,
            status: options_3.status === 'suppressed' ? (0, $4o0zT.isExperimentEnabled)('cc_maui_polish_changes_batch_5') ? (0, $3kyUj.MauiEmbedFinalizeStatus).STREAMING : (0, $3kyUj.MauiEmbedFinalizeStatus).CHECKING : (0, $3kyUj.MauiEmbedFinalizeStatus).NEEDS_FINALIZE
        })); // The 'suppressed' status is set as the diagram starts streaming in — record its
        // contentId so the ready-signal UI can target the board node.
        if (options_3.status === 'suppressed') recordDiagramContentId(options_3.contentId);
    }, [
        api,
        recordDiagramContentId
    ]);
    const setThinkingComplete = (0, $cozmU.useCallback)((isComplete_0)=>{
        // this is to clear the inline-Rovo streaming target when the remix is complete
        if (isComplete_0) api?.aiExperience?.actions?.endInlineRovoStreaming?.();
        if (isEditorRemixStateRearchitectureTreatment && (0, $dc44c0de1ed07c1a$export$4050079e84e0fec6)(api)) {
            if (!isComplete_0) {
                setDismissedReadySession(machinePresentation.remixId); // Lifecycle stays machine-owned. Clear only the editor presentation so the completed
                // inline portal is removed without a legacy lifecycle write being discarded.
                api?.core.actions.execute((0, $8ac54cfa8c1aac76$export$a9d5e9b88fbfa587));
            }
        } else api?.core.actions.execute((0, $8ac54cfa8c1aac76$export$831107003cfefb8)(isComplete_0));
         // View mode owns the floating thinking bar; let that bar finish its completion
        // animation and open the preview before stopping thinking.
        if (isComplete_0 && !isViewMode) (0, $b96b9e650a905796$export$ae8cbff5055b0856)({
            api: api,
            capturedAnimationFinishedSink: capturedAnimationFinishedSink
        });
    }, [
        api,
        capturedAnimationFinishedSink,
        isEditorRemixStateRearchitectureTreatment,
        isViewMode,
        machinePresentation.remixId
    ]);
    const setThinkingWaitingForInput = (0, $cozmU.useCallback)((waiting)=>{
        api?.core.actions.execute((0, $5641e9520598103d$export$92f20a5f93e2b790)(waiting));
    }, [
        api
    ]);
    const _onRemixThinkingCompleteAnimationFinished = (0, $cozmU.useCallback)(()=>{
        (0, $b96b9e650a905796$export$ae8cbff5055b0856)({
            api: api,
            capturedAnimationFinishedSink: capturedAnimationFinishedSink
        });
    }, [
        api,
        capturedAnimationFinishedSink
    ]);
    const setShowLocationPicker = (0, $cozmU.useCallback)((showLocationPicker_0)=>{
        api?.core.actions.execute((0, $0a73920d50ae3ac4$export$9c8ccf478e05e6c0)(showLocationPicker_0));
    }, [
        api
    ]); // When automatic finalization of a remixed whiteboard fails, open the shared
    // native-embed space picker (the same UI used by the paste / in-embed banner
    // flow) instead of the platform's remix-only picker. We dispatch two separate
    // transactions: first register the embed as NEEDS_SPACE_SELECTION (carrying
    // the "Choose where to save whiteboard" flag), then open the picker. Returns
    // `true` so the platform skips its own fallback flag + picker.
    const onFinalizeFailed = (0, $cozmU.useCallback)(({ contentId: contentId, originalUrl: originalUrl })=>{
        if (!api) return false;
        api.core.actions.execute((0, $94cf8481f86e3649$export$e119ad44c40da033)({
            contentId: contentId,
            originalUrl: originalUrl,
            flag: {
                id: `maui-embed-finalize-space-picker-${contentId}`,
                type: (0, $3kyUj.MauiDiagramPasteFlagType).INFO,
                title: formatMessage((0, $lhZdS.messages).flagFinalizeSpacePickerTitle),
                description: formatMessage((0, $lhZdS.messages).flagFinalizeSpacePickerDescription)
            }
        }));
        api.core.actions.execute((0, $90zNn.openMauiEmbedSpacePickerCommand)({
            contentId: contentId,
            originalUrl: originalUrl
        }));
        remixRecoveryCoordinator?.defer(contentId);
        return true;
    }, [
        api,
        formatMessage,
        remixRecoveryCoordinator
    ]);
    const addHistoryEntry = (0, $cozmU.useCallback)((options_4)=>{
        api?.core.actions.execute((0, $c3515eab9d989c2d$export$81acf0fbb9db54fa)(options_4));
    }, [
        api
    ]);
    const addHistoryStackEntry = (0, $cozmU.useCallback)((options_5)=>{
        api?.core.actions.execute((0, $005eb73a7f6b40e4$export$9f60bd9ee414a7c0)(options_5));
    }, [
        api
    ]); // Bridges the plugin's `trackVariantUpdateComplete` command into the
    // remix flow; `useOnComplete` fires it once the FE insertion settles.
    const onVariantUpdateComplete = (0, $cozmU.useCallback)((id)=>{
        if (!api?.malleableUi?.commands.trackVariantUpdateComplete) return;
        api.core.actions.execute(api.malleableUi.commands.trackVariantUpdateComplete({
            id: id
        }));
    }, [
        api
    ]); // Shows the "Output adjusted" flag via editor-level plugin state, which
    // survives this component unmounting on completion.
    const onSubtypeMismatch = (0, $cozmU.useCallback)(()=>{
        if (!api?.malleableUi?.commands.showSubtypeAdjustedFlag) return;
        api.core.actions.execute(api.malleableUi.commands.showSubtypeAdjustedFlag());
    }, [
        api
    ]); // The whiteboard is inserted asynchronously, so it isn't in the document when the remix reports
    // "ready". Latch its mount so the scroll waits for it (else it lands on the pre-remix selection).
    const [isDiagramBoardReady, setIsDiagramBoardReady] = (0, $cozmU.useState)(false);
    const handleDiagramBoardReady = (0, $cozmU.useCallback)(()=>{
        setIsDiagramBoardReady(true);
    }, []); // Reset the latch when a new remix begins so a prior remix's board can't trigger this one's scroll.
    (0, $cozmU.useEffect)(()=>{
        if (isThinking) setIsDiagramBoardReady(false);
    }, [
        isThinking
    ]); // Report when diagram board tracking gives up (the board never mounted) so we can measure how
    // often the ready-signal silently falls back to the shared behaviour. Fires at most once per remix.
    const handleDiagramBoardTimeout = (0, $cozmU.useCallback)(()=>{
        api?.analytics?.actions.fireAnalyticsEvent({
            action: 'timedOut',
            actionSubject: 'mauiDiagram',
            actionSubjectId: 'readySignalBoardTracking',
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                contentId: remixDiagramContentId
            }
        });
    }, [
        api,
        remixDiagramContentId
    ]); // Track where the inline thinking widget sits relative to the viewport so we
    // can float a bar at the matching edge (top/bottom) whenever it scrolls out
    // of view — during both the thinking phase and the completed "ready" phase.
    // Gated so we don't resolve DOM or bind scroll/resize listeners when the
    // in-editor loading feature is off.
    const floatingBarPlacement = (0, $d1bf1147fd18e4d3$export$c58dfb1653294667)({
        editorView: editorView,
        // `isComplete` alone would start the viewport work during the whiteboard's `inserting` gap,
        // where the result is not actually ready yet.
        isActive: (isThinking || isComplete && !isMachineInserting) && (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading'),
        diagramContentId: remixDiagramContentId,
        // Once an image remix's upload lands, the in-view decision is about the media node rather
        // than the zero-height thinking anchor that sits just above it.
        imageMediaId: remixImageMediaId,
        onDiagramBoardReady: handleDiagramBoardReady,
        onDiagramBoardTimeout: handleDiagramBoardTimeout
    });
    const isRemixReady = !isViewMode && isComplete && !isThinking && !isModalOpen && // An inserting flow is still generating even when the projection says complete, so it must not
    // present as ready. This also keeps the ready bar's auto-dismiss from firing mid-flow and
    // resetting presentation state the flow still needs.
    !isMachineInserting && !isCurrentReadyPresentationDismissed && (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading');
    (0, $cozmU.useEffect)(()=>{
        if (remixImageMediaId !== undefined && previousImageMediaIdRef.current !== remixImageMediaId) setDismissedReadySession(undefined);
        previousImageMediaIdRef.current = remixImageMediaId;
    }, [
        remixImageMediaId
    ]);
    const handleReadyToastView = (0, $cozmU.useCallback)(()=>{
        if (editorView) {
            // For diagrams, scroll to the whiteboard node itself; null for other remixes or before
            // the board mounts, so we fall back to the anchor resolution below.
            const boardTarget = resolveDiagramScrollTarget(editorView);
            const updateTarget = isUpdate ? $da0e6f79e5c28019$var$resolveNativeEmbedScrollTargetByUrl({
                doc: editorView.state.doc,
                editorView: editorView,
                targetUrl: remixUpdateScrollTargetUrl
            }) : null; // Images are uploaded and inserted after the remix reports ready, so target the media node
            // once it has landed — by then the thinking anchor no longer marks the result.
            const imageTarget = boardTarget ? null : resolveImageScrollTarget(editorView);
            const container = (0, $29d6db7c0a9c3ffe$export$2f3df55a342cf539)(editorView);
            const target_0 = boardTarget || updateTarget || imageTarget || savedSelection?.from !== undefined && editorView.nodeDOM(savedSelection.from) || container || (()=>{
                try {
                    if (!savedSelection?.to) return null;
                    const resolved = editorView.state.doc.resolve(savedSelection.to);
                    const anchorPos = resolved.depth >= 1 ? resolved.after(1) : savedSelection.to;
                    const domAtPos = editorView.domAtPos(anchorPos);
                    return domAtPos.node instanceof HTMLElement ? domAtPos.node : domAtPos.node.parentElement;
                } catch  {
                    return null;
                }
            })();
            if (target_0 instanceof HTMLElement) {
                // Leave breathing room above the board (below the sticky toolbar). scrollIntoView reads the
                // margin synchronously, so set it for this scroll then clear it — no lingering node mutation.
                const needsScrollMargin = target_0 === boardTarget || target_0 === imageTarget;
                if (needsScrollMargin) target_0.style.scrollMarginTop = "var(--ds-space-300, 24px)";
                target_0.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
                if (needsScrollMargin) target_0.style.scrollMarginTop = '';
            }
        } // setThinkingComplete(false); do the job, but a reset could be more meaningful
        setThinkingComplete(false);
    }, [
        editorView,
        savedSelection?.from,
        savedSelection?.to,
        isUpdate,
        remixUpdateScrollTargetUrl,
        resolveDiagramScrollTarget,
        resolveImageScrollTarget,
        setThinkingComplete
    ]);
    const handleReadyToastClose = (0, $cozmU.useCallback)(()=>{
        // setThinkingComplete(false); do the job, but a reset could be more meaningful
        setThinkingComplete(false);
    }, [
        setThinkingComplete
    ]); // Diagrams must wait for the async board mount before scrolling; other remixes have their result
    // in place already, so they scroll as soon as ready.
    const isDiagramRemix = remixDiagramContentId !== undefined;
    const isScrollTargetReady = isRemixReady && (!isDiagramRemix || isDiagramBoardReady); // Only scroll on the rising edge of readiness — not on later 'in-view' transitions from the user
    // scrolling the result into view, which would hijack their scroll.
    const prevIsScrollTargetReadyRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        const justBecameReady = isScrollTargetReady && !prevIsScrollTargetReadyRef.current;
        prevIsScrollTargetReadyRef.current = isScrollTargetReady;
        if (!justBecameReady || !editorView) return;
         // These updates never scroll, so they never reach `handleReadyToastView`, which is what clears
        // the presentation. Only machine-owned flows need it done here: control clears the decoration
        // through `stopRemixThinking` on the legacy completion branch, which treatment skips.
        if (isUpdate) {
            if ((0, $dc44c0de1ed07c1a$export$4050079e84e0fec6)(api)) setThinkingComplete(false);
            return;
        } // Out of view the ready bar owns dismissal, and clears the presentation with it.
        if (floatingBarPlacement !== 'in-view') return;
        const animationFrameId = requestAnimationFrame(handleReadyToastView);
        return ()=>cancelAnimationFrame(animationFrameId);
    }, [
        api,
        editorView,
        floatingBarPlacement,
        handleReadyToastView,
        isScrollTargetReady,
        isUpdate,
        setThinkingComplete
    ]); // handle escape key to stop remix thinking
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading')) return;
        if (!isThinking || !editorView) return;
         // focus editor first
        if (!editorView.hasFocus()) editorView.focus();
        return (0, $cbY7C.bind)(editorView.dom, {
            type: 'keydown',
            listener: (e)=>{
                if (e.key === 'Escape') {
                    e.stopPropagation();
                    if ((0, $iDrrr.fg)('platform_editor_ai_remix_toolbar')) {
                        // Abort before cancelling so send-message-action.ts fires the paired
                        // aiInteraction initiated + dismissed events via AbortError.
                        (0, $b96b9e650a905796$export$e125c3b8c9ddf1a1)(api)?.();
                        (0, $b96b9e650a905796$export$e02ace41eac2e13a)({
                            api: api,
                            reopenModal: false
                        });
                    } else {
                        if ((0, $anBbz.expValEqualsNoExposure)('cc_page_experiences_editor_image_generation', 'isEnabled', true)) {
                            // If a pre-supplied userPrompt was cancelled (e.g. image generation flow),
                            // call the onCancel callback instead of reopening the remix modal.
                            const currentMetadata = api?.malleableUi?.sharedState.currentState()?.remixModalMetadata;
                            const cancelledPrompt = currentMetadata?.userPrompt;
                            const onCancel = currentMetadata?.onCancel;
                            if (cancelledPrompt && onCancel) {
                                onStopThinking({
                                    reopenModal: false
                                });
                                onCancel();
                                return;
                            }
                        }
                        onStopThinking({
                            reopenModal: false
                        });
                    }
                }
            }
        });
    }, [
        isThinking,
        onStopThinking,
        editorView,
        api?.malleableUi.sharedState,
        api
    ]); // When the remix modal overlay is open (isModalOpen),
    // set the editor user intent to 'overlayOpen' so the floating toolbar is suppressed
    // (it would otherwise appear above the overlay in Jira).
    // We intentionally do NOT suppress during the thinking-only state
    // — the user may still interact with the editor while the AI is thinking.
    // Reset to 'default' when the modal closes or the component unmounts.
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!(0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading')) return;
        if (!isModalOpen) {
            if (api?.userIntent?.sharedState.currentState()?.currentUserIntent === 'overlayOpen') api?.core?.actions.execute(api?.userIntent?.commands.setCurrentUserIntent('default'));
            return;
        }
        api?.core?.actions.execute(api?.userIntent?.commands.setCurrentUserIntent('overlayOpen'));
        return ()=>{
            api?.core?.actions.execute(api?.userIntent?.commands.setCurrentUserIntent('default'));
        };
    }, [
        isModalOpen,
        api
    ]); // Auto-dismiss the floating "ready" bar after a fixed delay when the remix is
    // complete but out of view (per the Figma spec). Resetting thinking-complete
    // removes the bar; if the user scrolls back to their remix (placement becomes
    // 'in-view') the bar is hidden anyway and the timer is cleared.
    const isFloatingReadyBarVisible = !isViewMode && isComplete && !isThinking && !isModalOpen && // Same boundary as `isRemixReady`: no ready bar, and so no auto-dismiss, while inserting.
    !isMachineInserting && !isCurrentReadyPresentationDismissed && floatingBarPlacement !== 'in-view' && (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading'); // `remixImageMediaId` is a dep so the window restarts when an image remix's upload finally
    // lands: for images the bar appears before the media node exists, and dismissing it while the
    // result is still arriving would leave the user with no way back to it.
    (0, $cozmU.useEffect)(()=>{
        if (!isFloatingReadyBarVisible) return;
        const scheduledTreatmentSession = isEditorRemixStateRearchitectureTreatment && (0, $dc44c0de1ed07c1a$export$4050079e84e0fec6)(api) ? machinePresentation.remixId : undefined;
        const timeoutId = setTimeout(()=>{
            if (scheduledTreatmentSession !== undefined) {
                if ((0, $dc44c0de1ed07c1a$export$58aeb614b6d856f7)(api).remixId === scheduledTreatmentSession) // Marks the ready session dismissed and clears the presentation, which this path used
                // to skip: the decoration then survived an auto-dismiss that never scrolled.
                setThinkingComplete(false);
                return;
            }
            setThinkingComplete(false);
        }, $da0e6f79e5c28019$var$READY_BAR_AUTO_DISMISS_MS);
        return ()=>{
            clearTimeout(timeoutId);
        };
    }, [
        api,
        isFloatingReadyBarVisible,
        isEditorRemixStateRearchitectureTreatment,
        machinePresentation.remixId,
        remixImageMediaId,
        setThinkingComplete
    ]);
    if (!api || !Component || !selectedContext || !remixTypeProps) return null;
     // when the remix isComplete and
    // - the modal is not open because isComplete may not be reset to false when the modal is open
    // - not thinking because we need to show the thinking bar when isThinking and isComplete
    //   - after onCompleteAnimationFinished, isThinking will be false and only isComplete will be true
    // we need to show the ready toast
    if (isRemixReady) {
        // Surface the shared Rovo "ready" state as a floating bar at the edge of the
        // viewport (closing the inline thinking bar). Only show it when the inline
        // widget is scrolled out of view so it can take the user back to their remix.
        if (floatingBarPlacement === 'in-view') return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $da0e6f79e5c28019$var$styles.floatingBarBottom
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3sXr4.RovoThinkingBarWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ft2zO.RovoThinkingReady), {
            onView: handleReadyToastView,
            onClose: handleReadyToastClose,
            readyText: formatMessage(isUpdate ? (0, $8RXjp.remixReadyMessages).updateReady : (0, $iDrrr.fg)('cc_maui_updated_remix_tooltip_text') ? (0, $8RXjp.remixReadyMessages).remixReadyUpdated : (0, $8RXjp.remixReadyMessages).remixReady)
        })));
    } // When the flag is ON, only show when isModalOpen, isThinking, or showLocationPicker — this
    // is the correct gating behaviour for the new loading path.
    // When the flag is OFF (legacy path), always show — EXCEPT when a pre-supplied userPrompt
    // is present (image-gen flow) and the flow is done (neither isModalOpen nor isThinking),
    // to prevent the option-picker from flashing on cancellation.
    const hasPreSuppliedPrompt = !!remixModalMetadata?.userPrompt;
    const canShow = isModalOpen || isThinking || // `Component` owns the subtree that finalizes the insertion. The machine reports
    // `!isThinking` from the moment the early streaming whiteboard lands, so without this the
    // owner unmounts mid-flow and the final message never arrives to finalize it.
    hasLiveMachineFlow || showLocationPicker || !(0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') && !hasPreSuppliedPrompt; // While the remix is generating, surface a floating thinking bar at the edge
    // of the viewport whenever the inline thinking widget is scrolled out of view,
    // so the user stays aware the process is ongoing. It sticks to the bottom when
    // the widget is above the viewport, or the top when it is below. Rendered
    // alongside the modal/option-picker Component (not instead of it) so any
    // underlying streaming/staging state is never unmounted.
    //
    // During an update (edit of an existing remix), the RemixContainer inside
    // `Component` already renders its own fixed thinking bar (its `hideThinkingBar`
    // guard is `isThinking && !isUpdate`, so it is only hidden for fresh inserts).
    // Rendering this floating bar as well would produce two overlapping, slightly
    // offset bars, so it is gated off for updates to keep a single loading bar.
    const showFloatingThinkingBar = !isViewMode && isThinking && !isUpdate && !isModalOpen && floatingBarPlacement !== 'in-view' && (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading');
    const floatingThinkingBar = showFloatingThinkingBar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $da0e6f79e5c28019$var$styles.floatingBarBottom
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6QLO.RemixThinkingBar), {
        isWaitingForInput: isWaitingForInput,
        remixAttemptId: remixAttemptId,
        loadingBarType: "mini-bar",
        isRelative: true,
        onStop: ()=>onStopThinking({
                reopenModal: false
            })
    })) : null;
    if (!canShow || Component === undefined) return floatingThinkingBar;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, floatingThinkingBar, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
        ...remixTypeProps,
        remixAttemptId: remixAttemptId,
        isViewMode: (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') ? isViewMode : undefined,
        isModalOpen: isModalOpen,
        hasLiveMachineFlow: hasLiveMachineFlow,
        isThinking: isThinking,
        isUpdate: (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') ? isUpdate : undefined,
        historyEntryForUpdate: (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') ? historyEntryForUpdate : undefined,
        dynamicUiSubtypeForUpdate: (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') ? dynamicUiSubtypeForUpdate : undefined,
        isComplete: (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') ? isComplete : undefined,
        scheduleRemixRetentionCheck: scheduleRemixRetentionCheck,
        handleModalClose: handleModalClose,
        remixSource: remixSource,
        isEditorRemixStateRearchitectureTreatment: isEditorRemixStateRearchitectureTreatment,
        selectedContext: selectedContext,
        editorApi: api,
        clearThinkingDecoration: (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') ? clearThinkingDecoration : undefined,
        replaceWhiteboardEmbed: (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') ? replaceWhiteboardEmbed : undefined,
        setMauiEmbedFinalizeStatus: (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') ? setMauiEmbedFinalizeStatus : undefined,
        setThinkingComplete: (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') ? setThinkingComplete : undefined,
        setThinkingWaitingForInput: setThinkingWaitingForInput,
        onStartThinking: onStartThinking,
        onDismissThinkingUi: onDismissThinkingUi,
        onStopThinking: onStopThinking,
        onRegisterAbortRequest: onRegisterAbortRequest,
        onRegisterEditorRemixMachineLifecycleOwnership: onRegisterEditorRemixMachineLifecycleOwnership,
        onRegisterEditorRemixUxHandles: onRegisterEditorRemixUxHandles,
        onRegisterEditorRemixMutationCancellationSink: onRegisterEditorRemixMutationCancellationSink,
        onBeforeEditorRemixResultInsertion: onBeforeEditorRemixResultInsertion,
        onRemixThinkingCompleteAnimationFinished: (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') ? _onRemixThinkingCompleteAnimationFinished : undefined,
        showLocationPicker: (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') ? showLocationPicker : false,
        setShowLocationPicker: (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') ? setShowLocationPicker : ()=>{},
        onFinalizeFailed: (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') ? onFinalizeFailed : undefined,
        addHistoryEntry: (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') ? addHistoryEntry : ()=>{},
        addHistoryStackEntry: (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') ? addHistoryStackEntry : ()=>{},
        onVariantUpdateComplete: (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') ? onVariantUpdateComplete : undefined,
        onSubtypeMismatch: (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') ? onSubtypeMismatch : undefined,
        remixModalMetadata: remixModalMetadata,
        hiddenOptions: hiddenOptions
    }));
};


/**
 * Remix right surface block control, registered via the UI Control Registry API as a replacement
 * for `RemixButtonDecoration`. Positioning is fully owned by the block-controls right-surface host
 * (`BlockControlsRightSurfaces` / `getSurfacePlacement`) — this component only renders content.
 */ 























































const $b3a2adec84b86170$export$9097235bf2b51422 = ({ api: api, isDisabled: isDisabled, isRovoLLMEnabled: isRovoLLMEnabled, livePage: livePage, remixDisabledReason: remixDisabledReason, surfaceContext: surfaceContext, remixHiddenOptionsResolver: RemixHiddenOptionsResolver = (0, $1e53a3d0eb9e77e8$export$6c1a73717c6bf793) })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const context = surfaceContext?.get((0, $jbxiN.BLOCK_CONTROL_UI_CONTEXT));
    const rootNodeType = context?.rootNode.type.name ?? context?.targetNode.type.name ?? '';
    const rootPos = context?.rootNode.pos ?? context?.targetNode.pos;
    const { editorViewMode: editorViewMode, contentId: contentId, isOwnRemixing: isOwnRemixing, isAnyRemixing: isAnyRemixing, aiEditInProgress: aiEditInProgress, areAiEntryPointsDisabled: areAiEntryPointsDisabled } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'editorViewMode',
        'contextIdentifier',
        'malleableUi',
        'aiExperience'
    ], (states)=>({
            editorViewMode: states.editorViewModeState?.mode,
            contentId: states.contextIdentifierState?.contextIdentifierProvider?.objectId,
            isOwnRemixing: Boolean(states.malleableUiState?.isRemixModalOpen || states.malleableUiState?.isThinking),
            // Only the editor treatment projects this, from the shared Remix registry.
            isAnyRemixing: states.malleableUiState?.isAnyRemixing ?? false,
            areAiEntryPointsDisabled: states.aiExperienceState?.areAiEntryPointsDisabled ?? false,
            aiEditInProgress: (0, $d1c28dddb88abfdb$export$44c2dcb159008a4b)(states.aiExperienceState)
        }));
    // A Remix from another surface (e.g. the Object Sidebar, including one still generating in
    // Rovo Chat after its handoff) is also in progress, and the machine would refuse a new start.
    const isRemixing = isOwnRemixing || isAnyRemixing;
    const isInlineDropdownVariant = (0, $444f275c146ea05d$export$2c2cd6cb969bd93a)();
    // pageMode for analytics: 'editor' = full page editor, 'liveEdit' = live page edit, 'liveView' = live page view (livePage set by Confluence).
    const pageMode = editorViewMode === 'edit' && !livePage ? 'editor' : editorViewMode === 'edit' && livePage ? 'liveEdit' : editorViewMode === 'view' && livePage ? 'liveView' : undefined;
    const isRemixAvailable = isRovoLLMEnabled && (0, $anBbz.expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true);
    const hasRemixOrEditInProgress = (isRemixing || aiEditInProgress) && (0, $4o0zT.isExperimentEnabled)('cc_maui_polish_changes_batch_6');
    const [isDropdownOpen, setIsDropdownOpen] = (0, $cozmU.useState)(false);
    const nodePosRef = (0, $cozmU.useRef)(rootPos);
    nodePosRef.current = rootPos;
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    const clearHoverHighlight = (0, $cozmU.useCallback)(()=>{
        if ((0, $iDrrr.fg)('cc-maui-phase-3')) api?.core.actions.execute(({ tr: tr })=>tr.setMeta((0, $3397a9320ab7f32b$export$95a12c22f1d400bc), {
                highlightPos: null
            }));
    }, [
        api
    ]);
    const openRemix = (0, $cozmU.useCallback)((preselection)=>{
        const featureArea = (0, $iBsvI.getRemixFeatureArea)({});
        experienceTracker.start({
            name: (0, $irnO2.ExperienceName).REMIX_START,
            id: (0, $irnO2.ExperienceName).REMIX_START,
            attributes: {
                entryPoint: 'editor',
                remixSource: 'blockNudge',
                product: 'confluence',
                ...featureArea !== undefined && {
                    featureArea: featureArea
                }
            }
        });
        (0, $kDDrf.startRemixCreateExperience)({
            experienceTracker: experienceTracker,
            attributes: {
                entryPoint: 'editor',
                remixSource: 'blockNudge',
                product: 'confluence'
            }
        });
        // Clear the hover highlight decoration before opening the modal to prevent flashing
        clearHoverHighlight();
        api?.core.actions.execute(api?.malleableUi.commands.openRemixModal({
            nodePos: nodePosRef.current,
            nodeType: rootNodeType,
            metadata: {
                interactionSource: 'remixModalFromNudge',
                ...preselection && {
                    preselectedType: preselection.type,
                    preselectedSubType: preselection.subType,
                    ...preselection.userPrompt && {
                        preselectedUserPrompt: preselection.userPrompt
                    }
                }
            },
            source: 'blockNudge'
        }));
    }, [
        api,
        clearHoverHighlight,
        experienceTracker,
        rootNodeType
    ]);
    const handleClick = (0, $cozmU.useCallback)(()=>{
        if (isDisabled) return;
        (0, $cha5E.expVal)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'control');
        (0, $cha5E.expVal)('cc-ce-maui-remix-menu-multivariant-aa', 'variant', 'control');
        if (isInlineDropdownVariant) {
            clearHoverHighlight();
            setIsDropdownOpen(true);
            return;
        }
        openRemix();
    }, [
        clearHoverHighlight,
        isDisabled,
        isInlineDropdownVariant,
        openRemix
    ]);
    const closeDropdown = (0, $cozmU.useCallback)(()=>setIsDropdownOpen(false), []);
    const handleOptionSelect = (0, $cozmU.useCallback)((selection)=>{
        closeDropdown();
        openRemix(selection);
    }, [
        closeDropdown,
        openRemix
    ]);
    const handleRemixButtonMouseEnter = (0, $cozmU.useCallback)(()=>{
        if (!(0, $iDrrr.fg)('cc-maui-phase-3') || rootPos === undefined) return;
        api?.core.actions.execute(({ tr: tr_0 })=>tr_0.setMeta((0, $3397a9320ab7f32b$export$95a12c22f1d400bc), {
                highlightPos: rootPos,
                rootNodeType: rootNodeType
            }));
    }, [
        api,
        rootNodeType,
        rootPos
    ]);
    const handleRemixButtonMouseLeave = (0, $cozmU.useCallback)(()=>{
        if (!(0, $iDrrr.fg)('cc-maui-phase-3')) return;
        api?.core.actions.execute(({ tr: tr_1 })=>tr_1.setMeta((0, $3397a9320ab7f32b$export$95a12c22f1d400bc), {
                highlightPos: null
            }));
    }, [
        api
    ]);
    if (!isRemixAvailable || areAiEntryPointsDisabled || hasRemixOrEditInProgress) return null;
    const tooltipContent = isRemixing ? formatMessage((0, $lhZdS.messages).remixInProgressTooltip) : isDisabled ? (0, $185ff2366808da00$export$5626baa73ed0afeb)(formatMessage, remixDisabledReason) : (0, $iDrrr.fg)('cc_maui_updated_remix_tooltip_text') ? formatMessage((0, $lhZdS.messages).remixBlockTooltipUpdated) : formatMessage((0, $lhZdS.messages).remixBlockTooltip);
    const renderIconButton = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: tooltipContent,
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            ...triggerProps,
            spacing: "compact",
            appearance: "subtle",
            shape: "circle",
            label: formatMessage((0, $lhZdS.messages).remixBlockLabel),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1pCE4))), {
                    label: "",
                    size: "small"
                }),
            isDisabled: isDisabled || isRemixing,
            isSelected: isInlineDropdownVariant ? isDropdownOpen : undefined,
            analyticsContext: {
                actionSubjectId: 'remix',
                source: 'remixModalFromNudge',
                attributes: {
                    ...pageMode !== undefined && {
                        pageMode: pageMode
                    },
                    nodeType: rootNodeType,
                    ...contentId !== undefined && contentId !== '' && {
                        contentId: contentId
                    }
                }
            },
            testId: "visible-block-ctrl-remix-button",
            onMouseEnter: handleRemixButtonMouseEnter,
            onMouseLeave: handleRemixButtonMouseLeave,
            onBlur: handleRemixButtonMouseLeave,
            onMouseDown: (e)=>e.preventDefault(),
            onClick: handleClick
        }));
    return isInlineDropdownVariant ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(RemixHiddenOptionsResolver, {
        enabled: true,
        contentId: contentId
    }, (hiddenOptions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8GyO5.RemixContainer), {
            hiddenOptions: hiddenOptions,
            presentation: "popup",
            trigger: renderIconButton,
            popupPlacement: "bottom-end",
            popupOffset: [
                0,
                4
            ],
            isPopupOpen: isDropdownOpen,
            isThinking: false,
            // Block-controls removes this widget decoration when the editor blurs, which would
            // unmount the menu before an option press is handled.
            shouldPreserveEditorFocus: true,
            onClose: closeDropdown,
            onOptionSelect: handleOptionSelect
        })) : renderIconButton();
};


















var $a2foB = parcelRequire("a2foB");











const $7d0e604702ca44aa$var$FLAG_ID = 'maui-remix-subtype-adjusted';
const $7d0e604702ca44aa$export$a91404893a3e2794 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { api: api, productFlags: productFlags } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            "malleableUi"
        ];
        $[0] = t1;
    } else t1 = $[0];
    const isShown = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, t1, $7d0e604702ca44aa$var$_temp);
    let t2;
    if ($[1] !== api?.core.actions) {
        t2 = ()=>{
            api?.core.actions.execute((0, $756f290e221243c1$export$cc7138497964f45a)());
        };
        $[1] = api?.core.actions;
        $[2] = t2;
    } else t2 = $[2];
    const onDismissed = t2;
    let t3;
    if ($[3] !== intl) {
        t3 = intl.formatMessage((0, $lhZdS.messages).subtypeAdjustedFlagTitle);
        $[3] = intl;
        $[4] = t3;
    } else t3 = $[4];
    const title = t3;
    let t4;
    if ($[5] !== intl) {
        t4 = intl.formatMessage((0, $lhZdS.messages).subtypeAdjustedFlagDescription);
        $[5] = intl;
        $[6] = t4;
    } else t4 = $[6];
    const description = t4;
    const hasShownFlag = (0, $cozmU.useRef)(false);
    let t5;
    let t6;
    if ($[7] !== description || $[8] !== isShown || $[9] !== onDismissed || $[10] !== productFlags || $[11] !== title) {
        t5 = ()=>{
            if (!productFlags) return;
            if (!isShown) {
                if (hasShownFlag.current) {
                    productFlags.hideFlag($7d0e604702ca44aa$var$FLAG_ID);
                    hasShownFlag.current = false;
                }
                return;
            }
            hasShownFlag.current = true;
            productFlags.showFlag({
                autoDismissSeconds: 8,
                description: description,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
                    label: "",
                    color: "var(--ds-icon-information, #357DE8)"
                }),
                id: $7d0e604702ca44aa$var$FLAG_ID,
                onDismissed: onDismissed,
                title: title,
                type: "info"
            });
        };
        t6 = [
            description,
            isShown,
            onDismissed,
            productFlags,
            title
        ];
        $[7] = description;
        $[8] = isShown;
        $[9] = onDismissed;
        $[10] = productFlags;
        $[11] = title;
        $[12] = t5;
        $[13] = t6;
    } else {
        t5 = $[12];
        t6 = $[13];
    }
    (0, $cozmU.useEffect)(t5, t6);
    if (productFlags) return null;
    if (!isShown) return null;
    let t7;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
            label: "",
            color: "var(--ds-icon-information, #357DE8)"
        });
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== description || $[16] !== onDismissed || $[17] !== title) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lqtHz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a2foB.default), {
            onDismissed: onDismissed,
            title: title,
            description: description,
            id: $7d0e604702ca44aa$var$FLAG_ID,
            testId: $7d0e604702ca44aa$var$FLAG_ID,
            icon: t7
        }));
        $[15] = description;
        $[16] = onDismissed;
        $[17] = title;
        $[18] = t8;
    } else t8 = $[18];
    return t8;
} : ({ api: api, productFlags: productFlags })=>{
    const intl = (0, $kSwu1.useIntl)();
    const isShown = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states)=>states.malleableUiState?.showSubtypeAdjustedFlag ?? false);
    const onDismissed = (0, $cozmU.useCallback)(()=>{
        api?.core.actions.execute((0, $756f290e221243c1$export$cc7138497964f45a)());
    }, [
        api
    ]);
    const title = intl.formatMessage((0, $lhZdS.messages).subtypeAdjustedFlagTitle);
    const description = intl.formatMessage((0, $lhZdS.messages).subtypeAdjustedFlagDescription);
    // Track whether we have ever raised the flag through the product sink, so we
    // only call hideFlag after a real show. Without this guard, hideFlag(FLAG_ID)
    // would fire on initial mount whenever productFlags is provided and isShown is
    // false, spuriously asking the host to hide a flag that was never shown.
    const hasShownFlag = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!productFlags) return;
        if (!isShown) {
            if (hasShownFlag.current) {
                productFlags.hideFlag($7d0e604702ca44aa$var$FLAG_ID);
                hasShownFlag.current = false;
            }
            return;
        }
        hasShownFlag.current = true;
        productFlags.showFlag({
            autoDismissSeconds: 8,
            description: description,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
                label: "",
                color: "var(--ds-icon-information, #357DE8)"
            }),
            id: $7d0e604702ca44aa$var$FLAG_ID,
            onDismissed: onDismissed,
            title: title,
            type: 'info'
        });
    }, [
        description,
        isShown,
        onDismissed,
        productFlags,
        title
    ]);
    if (productFlags) return null;
    if (!isShown) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lqtHz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a2foB.default), {
        onDismissed: onDismissed,
        title: title,
        description: description,
        id: $7d0e604702ca44aa$var$FLAG_ID,
        testId: $7d0e604702ca44aa$var$FLAG_ID,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
            label: "",
            color: "var(--ds-icon-information, #357DE8)"
        })
    }));
};
function $7d0e604702ca44aa$var$_temp(states) {
    return states.malleableUiState?.showSubtypeAdjustedFlag ?? false;
}








/**
 * The editor's command-effect boundary: machine commands in, editor UX out.
 *
 * Registered by the editor plugin's persistent effect host for the state-machine cohort. The
 * Confluence lifecycle adapter starts admitted flows with `useCommandBus`, so commands reach this
 * hook through the process-default in-memory dispatcher.
 *
 * What this owns is the *policy* — which flow a command belongs to, whether its effect has already
 * run, and when the latched terminal read session may be dismissed. The product effects themselves
 * are injected, because they are editor UX (experience settlement, preview close, sidebar) that this
 * product-neutral package must not know about.
 *
 * ## Command order is not the order you would guess
 *
 * `@atlassian/state-machine` fires transition listeners *before* a state's `onEnter` effects. The
 * lifecycle observer in `editorRemixLifecycleOwner` runs on the transition and releases machine
 * ownership, which tears the flow down and announces `RemixFlowEnded`; the commands for the state
 * just entered are dispatched afterwards. So a terminal phase arrives as:
 *
 *     RemixFlowEnded('error')   →  RemixErrored  →  RemixGenerationEnded('error')
 *     RemixFlowEnded('aborted') →  RemixAborted  →  RemixGenerationEnded('aborted')
 *
 * `RemixFlowEnded` is therefore NOT last for a terminal outcome, and two rules follow:
 *
 *  1. The claim set is reset on session replacement only, never on `RemixFlowEnded` — clearing it
 *     there would wipe the claims immediately *before* the terminal UX commands arrive, so a
 *     repeated `RemixErrored` would run error cleanup twice.
 *  2. `RemixFlowEnded('error' | 'aborted')` must retain the session. The paired `RemixErrored` /
 *     `RemixAborted` cleanup dismisses it, and only once that cleanup has run.
 *
 * Dismissal is still ordering-safe: the observer writes the latched phase into the provider's ref
 * synchronously before releasing, and `dismissTerminal` reads that ref rather than rendered state.
 * A cleanup handler that dismisses at the end of the same synchronous turn therefore sees the latch,
 * even though React has not re-rendered the session yet.
 *
 * ## Mount this at the persistent owner level, not inside the Remix content component
 *
 * `RemixContentComponent` renders nothing unless the modal, thinking UI or location picker is up, so
 * terminal cleanup unmounts it — and unmounting drops this hook's subscription along with it, losing
 * the dismissal and every command that follows. It has to be mounted somewhere that outlives a
 * settled flow, inside `EditorRemixLifecycleOwnerProvider` but above that content component.
 *
 * The practical consequence: the editor UX closures that live in `RemixContentComponentInner`
 * (`onStopThinking`, `handleModalClose`, the preview open/close pair, the experience tracker) are
 * not in scope at that level, so the host reaches them through the plugin's api-keyed callback
 * registry, read at invocation time rather than captured at mount.
 *
 * ## A safety/AUP violation is not a command, and must never become one
 *
 * A safety or AUP violation arrives as a *completed* action while the friendly response is still
 * streaming into the conversation, so the editor handles it locally off the AIFC store signal:
 * dismiss the thinking UI, close any preview, open the side chat. There is deliberately no command
 * for it here. Mapping it onto `RemixErrored` would run error cleanup — which aborts the in-flight
 * request — and cut off the friendly response before the user ever sees it.
 *
 * ## `onAborted` is origin-blind, deliberately
 *
 * `CANCELLED` transitions the machine to `aborted`, so the observer's `end('aborted')` pre-empts
 * every producer `end('cancelled')`. In treatment a local cancel, a Rovo-side abort and a preview
 * dismissal all arrive as the same `RemixAborted`. A caller that needs to tell them apart records
 * its own intent before driving the machine and reads it inside `onAborted`, the way the renderer
 * surface does — this hook cannot infer it from the command.
 */ 



var $lEf8v = parcelRequire("lEf8v");




/** End reasons whose read session must survive teardown until terminal UX dismisses it. */ const $d5e099afc0dbe32a$var$isTerminalFlowEndReason = (reason)=>reason === 'error' || reason === 'aborted';
const $d5e099afc0dbe32a$export$b2a1915e04b347a = ({ onReady: onReady, onErrored: onErrored, onAborted: onAborted, onInserted: onInserted, onCancellationSettled: onCancellationSettled, onHandlerError: onHandlerError })=>{
    const { remixId: sessionRemixId, dismissTerminal: dismissTerminal } = (0, $fjeDY.useEditorRemixLifecycle)();
    const claimedRef = (0, $cozmU.useRef)({
        remixId: undefined,
        claims: new Set(),
        isCleared: false
    });
    (0, $lEf8v.useRemixCommands)((command)=>{
        // Session identity alone, never `isAdmitted`: admission is already cleared by the time the
        // terminal commands arrive.
        if (sessionRemixId === undefined || command.remixId !== sessionRemixId) return;
        // The only reset. Clearing on `RemixFlowEnded` would drop the claims just before the terminal
        // commands arrive — see the module comment on ordering.
        if (claimedRef.current.remixId !== command.remixId) claimedRef.current = {
            remixId: command.remixId,
            claims: new Set(),
            isCleared: false
        };
        // Suppress same-turn commands until the cleared session is rendered.
        if (claimedRef.current.isCleared) return;
        const claimOnce = (claim)=>{
            if (claimedRef.current.claims.has(claim)) return false;
            claimedRef.current.claims.add(claim);
            return true;
        };
        /** Whether a terminal command has already settled this session's cleanup UX. */ const hasSettledTerminalCleanup = ()=>claimedRef.current.claims.has('RemixErrored') || claimedRef.current.claims.has('RemixAborted');
        /**
		 * Isolates the injected effect from the dismissal that follows it: an unwrapped throw in
		 * `onErrored` would skip `dismissTerminal()` and strand the latched session forever.
		 */ const runEffect = (effect)=>{
            try {
                effect();
            } catch (error) {
                try {
                    onHandlerError({
                        commandType: command.type,
                        error: error
                    });
                } catch  {
                // Diagnostics must never affect command handling.
                }
            }
        };
        switch(command.type){
            // Effect-free on this surface, so not claimed either.
            case 'RemixStarted':
            case 'RemixGenerationEnded':
                return;
            case 'RemixReady':
                if (claimOnce('RemixReady')) runEffect(()=>onReady(command));
                return;
            case 'RemixErrored':
                if (claimOnce('RemixErrored')) {
                    runEffect(()=>onErrored(command));
                    dismissTerminal();
                }
                return;
            case 'RemixAborted':
                if (claimOnce('RemixAborted')) {
                    runEffect(()=>onAborted(command));
                    dismissTerminal();
                }
                return;
            case 'RemixFlowEnded':
                if (!claimOnce(`RemixFlowEnded:${command.reason}`)) return;
                // Retained, not cleared: the paired terminal command arrives after this one and still
                // owns the cleanup and the dismissal.
                if ($d5e099afc0dbe32a$var$isTerminalFlowEndReason(command.reason)) return;
                if (command.reason === 'inserted') runEffect(()=>onInserted?.(command));
                claimedRef.current.isCleared = true;
                // A rollback releases ownership before sending `CANCELLED`, so the machine reaches
                // `aborted` unobserved and `RemixAborted` lands before this. Abort ownership wins;
                // running cancellation cleanup on top would settle the same experience twice.
                if (command.reason === 'cancelled' && !hasSettledTerminalCleanup()) // Relies on React batching to retain sessionRemixId for this command turn.
                runEffect(()=>onCancellationSettled?.(command));
                return;
        }
    });
};














const $3ea14f9b5e4b7135$export$287b8183f0ccac41 = (api, isAnyRemixing)=>({ tr: tr })=>{
        if (api?.malleableUi?.sharedState?.currentState()?.isAnyRemixing === isAnyRemixing) return null;
        tr.setMeta((0, $bpOXf.malleableUiPluginKey), {
            isAnyRemixing: isAnyRemixing
        });
        return tr;
    };




const $0887781a4e706550$export$f8dbf6fdfa5ec676 = (lifecycle)=>({ tr: tr })=>{
        tr.setMeta((0, $5ea92dab24394af7$export$38c8fc373d691b1d), {
            lifecycle: {
                kind: 'machine-projection',
                ...lifecycle
            }
        });
        return tr;
    };














const $23d615222ee2c9e3$export$d81f524b6935fe5c = ({ animationFinished: animationFinished, phase: phase })=>{
    switch(phase){
        case 'inactive':
        case 'error':
        case 'aborted':
            return {
                isThinking: false,
                isComplete: false
            };
        case 'thinking':
            return {
                isThinking: true,
                isComplete: false
            };
        case 'ready':
            return animationFinished ? {
                isThinking: false,
                isComplete: true
            } : {
                isThinking: true,
                isComplete: true
            };
        case 'previewing':
            return {
                isThinking: false,
                isComplete: true
            };
        case 'inserting':
            return {
                isThinking: false,
                isComplete: true
            };
        default:
            {
                const exhaustive = phase;
                return exhaustive;
            }
    }
};


const $687d619d27fd7060$export$e1c711fd1a28ed63 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { animationFinished: animationFinished, presentationRemixId: presentationRemixId, dispatchProjection: dispatchProjection } = t0;
    const { remixId: remixId, phase: phase, terminalPhase: terminalPhase } = (0, $fjeDY.useEditorRemixLifecycle)();
    const effectivePhase = terminalPhase ?? phase;
    const lastRef = (0, $cozmU.useRef)(undefined);
    let t1;
    let t2;
    if ($[0] !== animationFinished || $[1] !== dispatchProjection || $[2] !== effectivePhase || $[3] !== presentationRemixId || $[4] !== remixId || $[5] !== terminalPhase) {
        t1 = ()=>{
            const last = lastRef.current;
            if (remixId === undefined) {
                if (last?.remixId === undefined) return;
                const projection = (0, $23d615222ee2c9e3$export$d81f524b6935fe5c)({
                    phase: "inactive",
                    animationFinished: false
                });
                dispatchProjection(projection);
                lastRef.current = {
                    remixId: undefined,
                    ...projection
                };
                return;
            }
            const hasLatchedTerminalOutcome = terminalPhase === "error" || terminalPhase === "aborted";
            if (presentationRemixId !== remixId && !hasLatchedTerminalOutcome) return;
            const projection_0 = (0, $23d615222ee2c9e3$export$d81f524b6935fe5c)({
                phase: effectivePhase,
                animationFinished: animationFinished
            });
            if (last?.remixId === remixId && last.isThinking === projection_0.isThinking && last.isComplete === projection_0.isComplete) return;
            dispatchProjection(projection_0);
            lastRef.current = {
                remixId: remixId,
                ...projection_0
            };
        };
        t2 = [
            animationFinished,
            dispatchProjection,
            remixId,
            effectivePhase,
            presentationRemixId,
            terminalPhase
        ];
        $[0] = animationFinished;
        $[1] = dispatchProjection;
        $[2] = effectivePhase;
        $[3] = presentationRemixId;
        $[4] = remixId;
        $[5] = terminalPhase;
        $[6] = t1;
        $[7] = t2;
    } else {
        t1 = $[6];
        t2 = $[7];
    }
    (0, $cozmU.useEffect)(t1, t2);
} : ({ animationFinished: animationFinished, presentationRemixId: presentationRemixId, dispatchProjection: dispatchProjection })=>{
    const { remixId: remixId, phase: phase, terminalPhase: terminalPhase } = (0, $fjeDY.useEditorRemixLifecycle)();
    const effectivePhase = terminalPhase ?? phase;
    const lastRef = (0, $cozmU.useRef)(undefined);
    (0, $cozmU.useEffect)(()=>{
        const last = lastRef.current;
        if (remixId === undefined) {
            // Nothing to release: either the initial mount, or the release write already happened.
            if (last?.remixId === undefined) return;
            const projection = (0, $23d615222ee2c9e3$export$d81f524b6935fe5c)({
                phase: 'inactive',
                animationFinished: false
            });
            dispatchProjection(projection);
            lastRef.current = {
                remixId: undefined,
                ...projection
            };
            return;
        }
        // The React lifecycle context and the synchronous registry can briefly be on adjacent
        // sessions during replacement. Never combine A's live phase with B's presentation. A
        // terminal phase is different: it is latched before ownership release, so its inactive
        // projection remains authoritative after the synchronous registry has cleared its identity.
        const hasLatchedTerminalOutcome = terminalPhase === 'error' || terminalPhase === 'aborted';
        if (presentationRemixId !== remixId && !hasLatchedTerminalOutcome) return;
        const projection_0 = (0, $23d615222ee2c9e3$export$d81f524b6935fe5c)({
            phase: effectivePhase,
            animationFinished: animationFinished
        });
        if (last?.remixId === remixId && last.isThinking === projection_0.isThinking && last.isComplete === projection_0.isComplete) return;
        // Recorded after the dispatch returns so a throwing dispatcher stays retryable.
        dispatchProjection(projection_0);
        lastRef.current = {
            remixId: remixId,
            ...projection_0
        };
    }, [
        animationFinished,
        dispatchProjection,
        remixId,
        effectivePhase,
        presentationRemixId,
        terminalPhase
    ]);
};



const $adce69c763bccff9$export$1ab134daab5fcbca = ({ api: api })=>{
    const { remixId: remixId, phase: phase, terminalPhase: terminalPhase } = (0, $fjeDY.useEditorRemixLifecycle)();
    const isAnyRemixing = (0, $gRoSG.useIsAnyRemixing)();
    const [, refreshPresentation] = (0, $cozmU.useReducer)((count)=>count + 1, 0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useLayoutEffect)(()=>(0, $dc44c0de1ed07c1a$export$ca9605d624b3c2db)(api, refreshPresentation), [
        api,
        remixId
    ]);
    const presentation = (0, $dc44c0de1ed07c1a$export$58aeb614b6d856f7)(api);
    const dispatchProjection = (0, $cozmU.useCallback)((projection)=>{
        api?.core.actions.execute((0, $0887781a4e706550$export$f8dbf6fdfa5ec676)(projection));
    }, [
        api
    ]);
    const resetTerminalPresentation = (0, $cozmU.useCallback)((commandRemixId)=>{
        // A stale terminal command must not reset a replacement presentation.
        if (commandRemixId !== remixId) return;
        api?.core.actions.execute((0, $8ac54cfa8c1aac76$export$a9d5e9b88fbfa587));
    }, [
        api,
        remixId
    ]);
    (0, $687d619d27fd7060$export$e1c711fd1a28ed63)({
        animationFinished: presentation.animationFinished,
        presentationRemixId: presentation.remixId ?? null,
        dispatchProjection: dispatchProjection
    });
    // Publish the phase alongside the projection this host already mirrors. Presentation consumers
    // need to tell `inserting` apart from a genuinely ready result, and the projected booleans are
    // identical for both. Written here because this host has the api, the session token, and the
    // lifecycle context in one place.
    const effectivePhase = terminalPhase ?? phase;
    const presentationToken = presentation.token;
    (0, $cozmU.useLayoutEffect)(()=>{
        if (presentation.remixId !== remixId) // Adjacent sessions during replacement: never label B's presentation with A's phase.
        return;
        (0, $dc44c0de1ed07c1a$export$1ae55ee74816df71)(api, presentationToken, effectivePhase);
    }, [
        api,
        effectivePhase,
        presentationToken,
        presentation.remixId,
        remixId
    ]);
    const commandHandlers = (0, $cozmU.useMemo)(()=>({
            onReady: ()=>{
                // Lifecycle completion is projected by the mirror; this starts presentation only.
                (0, $dc44c0de1ed07c1a$export$a174cbea3e7863fe)(api)?.markReady();
            },
            onErrored: (command)=>{
                const handles = (0, $dc44c0de1ed07c1a$export$a174cbea3e7863fe)(api);
                if (!handles) return;
                handles.settleExperience({
                    kind: 'failed',
                    // Match the legacy fallback when no Rovo store error is available.
                    error: new Error((0, $iCjKh.DEFAULT_REMIX_ERROR_MESSAGE))
                });
                // Stop before closing: stop preserves selection but reopens the modal.
                handles.stopThinking({
                    reopenModal: true
                });
                resetTerminalPresentation(command.remixId);
                handles.closeTerminalPreview();
                handles.closeModal();
                handles.openSidebar();
            },
            onAborted: (command_0)=>{
                const handles_0 = (0, $dc44c0de1ed07c1a$export$a174cbea3e7863fe)(api);
                if (!handles_0) return;
                const presentSourceOrTargetInvalidation = (0, $dc44c0de1ed07c1a$export$c2ad78149c7e98ec)(api, command_0.remixId);
                // `RemixAborted` is origin-blind, so it settles with the reason legacy reports for an
                // abort this surface did not initiate, keeping the two cohorts comparable. Legacy
                // conflates the same cases under that wording, so matching it reproduces legacy
                // exactly, and the content component still overrides it with a recorded local intent.
                if (handles_0.settleExperience({
                    kind: 'aborted',
                    reason: (0, $iCjKh.REMIX_REMOTE_ABORT_REASON),
                    remixId: command_0.remixId
                }) === 'ignored') // A different terminal outcome already owns teardown.
                return;
                if (!presentSourceOrTargetInvalidation) {
                    handles_0.stopThinking({
                        reopenModal: false
                    });
                    resetTerminalPresentation(command_0.remixId);
                    return;
                }
                // Source invalidation must preserve the current Rovo Chat sidebar state.
                handles_0.stopThinking({
                    reopenModal: true
                });
                resetTerminalPresentation(command_0.remixId);
                handles_0.closeTerminalPreview();
                handles_0.closeModal();
            },
            onInserted: (command_1)=>{
                // The machine has accepted INSERTED only after the editor acknowledges the write.
                // Reset the matching decoration explicitly: lifecycle projection intentionally leaves
                // presentation untouched, and a stale command must never clear a replacement session.
                resetTerminalPresentation(command_1.remixId);
            },
            onCancellationSettled: ()=>{
                // Cancellation teardown already handled presentation cleanup.
                (0, $dc44c0de1ed07c1a$export$a174cbea3e7863fe)(api)?.settleCancellation();
            },
            onHandlerError: ({ commandType: commandType, error: error })=>{
                try {
                    createAnalyticsEvent({
                        eventType: 'operational',
                        action: 'failed',
                        actionSubject: 'editorRemixCommandHandler',
                        actionSubjectId: commandType,
                        source: 'editorRemix',
                        attributes: {
                            operation: 'commandEffect',
                            commandType: commandType,
                            // Do not log service-supplied error messages.
                            errorName: error instanceof Error ? error.name : typeof error
                        }
                    }).fire();
                } catch  {
                // Diagnostics must never affect command handling.
                }
            }
        }), [
        api,
        createAnalyticsEvent,
        resetTerminalPresentation
    ]);
    (0, $d5e099afc0dbe32a$export$b2a1915e04b347a)(commandHandlers);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (api?.malleableUi?.sharedState?.currentState()?.isAnyRemixing === isAnyRemixing) return;
        api?.core.actions.execute((0, $3ea14f9b5e4b7135$export$287b8183f0ccac41)(api, isAnyRemixing));
    }, [
        api,
        isAnyRemixing
    ]);
    return null;
};









var $3nacY = parcelRequire("3nacY");






const $d684c767eb9debf9$export$385bdd630aa6668b = 'ai-paste-menu-remix';























const $471b94445789f952$export$7619bedffcb929ce = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { onClick: onClick } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1pCE4))), {
            size: "small",
            label: ""
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== intl) {
        t2 = intl.formatMessage((0, $93WrI.aiConfigItemMessages).remixTitle);
        $[1] = intl;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== onClick || $[4] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
            testId: "ai-paste-menu__remix",
            elemBefore: t1,
            onClick: onClick
        }, t2);
        $[3] = onClick;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ({ onClick: onClick })=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        testId: "ai-paste-menu__remix",
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1pCE4))), {
            size: "small",
            label: ""
        }),
        onClick: onClick
    }, intl.formatMessage((0, $93WrI.aiConfigItemMessages).remixTitle));
};


const $48fd160920f56916$export$e79e54e0ad32496e = ({ api: api })=>{
    const rules = api.pasteOptionsToolbarPlugin?.actions.getPasteMenuRules();
    if (!rules) return [];
    const { allRules: allRules, containsTableRule: containsTableRule, excludedAncestorRule: excludedAncestorRule, hideIfSingleNodeRule: hideIfSingleNodeRule, isSingleLinkRule: isSingleLinkRule, minCharsRule: minCharsRule, notProseRule: notProseRule } = rules;
    const disabled = excludedAncestorRule([
        'codeBlock',
        'heading'
    ]);
    const AI_PASTE_MENU_SECTION_KEY = (0, $3nacY.AI_PASTE_MENU_SECTION).key;
    return [
        {
            type: 'menu-item',
            key: (0, $d684c767eb9debf9$export$385bdd630aa6668b),
            parents: [
                {
                    type: 'menu-section',
                    key: AI_PASTE_MENU_SECTION_KEY,
                    // Rank 6 — shown after Make Longer (rank 5).
                    rank: 6
                }
            ],
            isHidden: allRules(minCharsRule(100), hideIfSingleNodeRule, isSingleLinkRule, disabled, notProseRule, containsTableRule),
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $471b94445789f952$export$7619bedffcb929ce), {
                    onClick: (event)=>{
                        (0, $cha5E.expVal)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'control');
                        (0, $cha5E.expVal)('cc-ce-maui-remix-menu-multivariant-aa', 'variant', 'control');
                        // Captured at click time, before the paste menu closes and the item unmounts.
                        const anchorRect = (0, $444f275c146ea05d$export$2c2cd6cb969bd93a)() ? event.currentTarget.getBoundingClientRect() : undefined;
                        api?.core?.actions.execute((0, $a41417a475703a7a$export$e01f52b7ef73f07b)(api)({
                            metadata: {
                                interactionSource: 'remixModalFromPasteMenu',
                                anchorRect: anchorRect
                            },
                            source: (0, $a41417a475703a7a$export$f437f2a5f6852f29)
                        }));
                    }
                })
        }
    ];
};





















const $9ca8eb041284f342$var$remixFloatingToolbarClickAnalyticsPayload = {
    action: (0, $krYZG.ACTION).CLICKED,
    actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
    actionSubjectId: 'remixModalFromToolbar',
    eventType: (0, $krYZG.EVENT_TYPE).UI,
    source: 'remix'
};
function $9ca8eb041284f342$export$f5e01f6a1e2eeb41({ api: api, options: options }) {
    return ({ node: node, intl: intl })=>{
        if (!api || !node) return undefined;
        if (options?.isRemixHidden) return undefined;
        if (!(0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') || !(0, $iDrrr.fg)('maui_remixable_page_native_embeds')) return undefined;
        // A machine-owned flow is a Remix in progress even though the projection reports
        // `!isThinking` once the early streaming whiteboard lands. Without this the button reads as
        // disabled with no reason and the tooltip helper's default renders the archived copy.
        const isRemixing = api?.malleableUi?.sharedState.currentState()?.isRemixModalOpen || api?.malleableUi?.sharedState.currentState()?.isThinking || (0, $dc44c0de1ed07c1a$export$58aeb614b6d856f7)(api).phase === 'inserting';
        const areAiEntryPointsDisabled = api?.aiExperience?.sharedState.currentState()?.areAiEntryPointsDisabled;
        const disabled = options?.isDisabled || isRemixing || areAiEntryPointsDisabled;
        let tooltipContent = intl.formatMessage((0, $lhZdS.messages).remixToolbarTooltip);
        if (isRemixing) tooltipContent = intl.formatMessage((0, $lhZdS.messages).remixInProgressTooltip);
        else if (options?.remixDisabledReason) tooltipContent = (0, $185ff2366808da00$export$5626baa73ed0afeb)(intl.formatMessage, options?.remixDisabledReason);
        else if ((0, $iDrrr.fg)('cc_maui_updated_remix_tooltip_text')) tooltipContent = intl.formatMessage((0, $lhZdS.messages).remixToolbarTooltipUpdated);
        const onClick = (editorState)=>{
            if (disabled) return false;
            (0, $cha5E.expVal)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'control');
            (0, $cha5E.expVal)('cc-ce-maui-remix-menu-multivariant-aa', 'variant', 'control');
            const $pos = editorState.selection.$from;
            let nodePos;
            for(let depth = $pos.depth; depth > 0; depth--)if ($pos.node(depth) === node) {
                nodePos = $pos.before(depth);
                break;
            }
            api.analytics?.actions.fireAnalyticsEvent($9ca8eb041284f342$var$remixFloatingToolbarClickAnalyticsPayload);
            // Anchor the inline dropdown to the rendered Remix button: the floating toolbar
            // re-evaluates its items between render and click, so a captured `node` reference can be
            // stale, and the popup should anchor to the visible toolbar anyway. Several toolbars can
            // be mounted at once, so pick the first match that is actually visible.
            const anchorRect = (0, $444f275c146ea05d$export$2c2cd6cb969bd93a)() ? Array.from(document.querySelectorAll(`.${(0, $444f275c146ea05d$export$e1c7ad9e4a3badb9)}`)).map((el)=>el.getBoundingClientRect()).find((rect)=>rect.width > 0 && rect.height > 0) : undefined;
            api.core.actions.execute(api.malleableUi.commands.openRemixModal({
                nodePos: nodePos,
                nodeType: node.type.name,
                metadata: {
                    interactionSource: 'remixModalFromFloatingToolbar',
                    anchorRect: anchorRect
                },
                source: 'floatingToolbar'
            }));
            return true;
        };
        return {
            id: 'editor.malleable-ui.remix',
            type: 'button',
            title: intl.formatMessage((0, $lhZdS.messages).remixToolbarLabel),
            tooltipContent: tooltipContent,
            showTitle: true,
            hideTooltipOnClick: false,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($1pCE4))),
            onClick: onClick,
            disabled: disabled,
            testId: 'editor-floating-toolbar__remix-button',
            ...(0, $444f275c146ea05d$export$2c2cd6cb969bd93a)() && {
                className: (0, $444f275c146ea05d$export$e1c7ad9e4a3badb9)
            }
        };
    };
}









var $loej8 = parcelRequire("loej8");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






var $9d7Pd = parcelRequire("9d7Pd");


var $huzJY = parcelRequire("huzJY");


var $6IL1T = parcelRequire("6IL1T");


var $8FgJC = parcelRequire("8FgJC");





var $4n1IT = parcelRequire("4n1IT");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $9z4Bk = parcelRequire("9z4Bk");

const $7829ee1aabc510af$var$MENU_ITEM_HEIGHT = 32;
const $7829ee1aabc510af$var$HEADING_HEIGHT = 32;
const $7829ee1aabc510af$var$MENU_WIDTH = 175;
// ── Preview panel styles ────────────────────────────────────────────────────
const $7829ee1aabc510af$var$PREVIEW_WIDTH = 144;
const $7829ee1aabc510af$var$PREVIEW_HEIGHT = 104;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- internal only
const $7829ee1aabc510af$var$previewContentStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    width: `${$7829ee1aabc510af$var$PREVIEW_WIDTH}px`,
    height: `${$7829ee1aabc510af$var$PREVIEW_HEIGHT}px`,
    boxSizing: 'border-box',
    padding: "var(--ds-space-150, 12px)",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none'
});
function $7829ee1aabc510af$var$TypeSwitcherMenu({ siblingSubTypes: siblingSubTypes, dynamicUiType: dynamicUiType, dynamicUiSubtype: dynamicUiSubtype, groupLabelMessage: groupLabelMessage, onSelect: onSelect, intl: intl, hide: hide }) {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [hoveredSubType, setHoveredSubType] = (0, $cozmU.useState)(null);
    const isAnimatedArtworkEnabled = (0, $4o0zT.isExperimentEnabled)('cc_maui_polish_changes_batch_6');
    const handleMouseEnter = (0, $cozmU.useCallback)((value)=>{
        setHoveredSubType(value);
    }, []);
    const handleMouseLeave = (0, $cozmU.useCallback)(()=>{
        setHoveredSubType(null);
    }, []);
    const handleSelect = (0, $cozmU.useCallback)((subType, isSelected)=>{
        if (isSelected) {
            hide();
            return;
        }
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'remixTypeSwitcherOption',
            attributes: {
                remixType: dynamicUiType,
                remixSubtype: subType
            }
        });
        onSelect({
            subtype: subType
        });
        hide();
    }, [
        dynamicUiType,
        hide,
        onSelect,
        sendAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        "data-testid": "remix-type-switcher-menu-wrapper"
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $6IL1T.default), null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $8FgJC.default), null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $huzJY.default), {
        testId: "remix-type-switcher-group-header"
    }, intl.formatMessage(groupLabelMessage)), siblingSubTypes.map((subType)=>{
        const isSelected = subType.value === dynamicUiSubtype;
        const isHovered = hoveredSubType === subType.value;
        const IconComponent = (0, $9z4Bk.getSubTypeIconComponent)(subType.value, isAnimatedArtworkEnabled);
        const showPreview = isHovered && IconComponent !== null;
        const button = /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            onMouseEnter: ()=>handleMouseEnter(subType.value),
            onMouseLeave: handleMouseLeave,
            onFocus: ()=>handleMouseEnter(subType.value),
            onBlur: handleMouseLeave
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $9d7Pd.default), {
            testId: `remix-type-switcher-item-${subType.value}`,
            isSelected: isSelected,
            onClick: ()=>handleSelect(subType.value, isSelected)
        }, intl.formatMessage(subType.labelMessage)));
        return showPreview ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4n1IT.Popup), {
            key: subType.value,
            isOpen: true,
            placement: "right",
            autoFocus: false,
            shouldDisableFocusLock: true,
            trigger: (triggerProps)=>{
                const { 'aria-expanded': _ariaExpanded, ...restTriggerProps } = triggerProps;
                return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
                    ...restTriggerProps,
                    onMouseEnter: ()=>handleMouseEnter(subType.value),
                    onMouseLeave: handleMouseLeave,
                    onFocus: ()=>handleMouseEnter(subType.value),
                    onBlur: handleMouseLeave
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $9d7Pd.default), {
                    testId: `remix-type-switcher-item-${subType.value}`,
                    isSelected: isSelected,
                    onClick: ()=>handleSelect(subType.value, isSelected)
                }, intl.formatMessage(subType.labelMessage)));
            },
            content: ()=>/*#__PURE__*/ (0, $lOiVq.jsx)("div", {
                    css: $7829ee1aabc510af$var$previewContentStyles,
                    "data-testid": "remix-type-switcher-preview"
                }, /*#__PURE__*/ (0, $lOiVq.jsx)(IconComponent, {
                    alt: intl.formatMessage(subType.labelMessage)
                }))
        }) : /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
            key: subType.value
        }, button);
    }))));
}
function $7829ee1aabc510af$export$a9e8c51842dcf4c7({ dynamicUiType: dynamicUiType, dynamicUiSubtype: dynamicUiSubtype, currentLabel: currentLabel, currentLabelMessage: currentLabelMessage, groupLabelMessage: groupLabelMessage, siblingSubTypes: siblingSubTypes, onSelect: onSelect, intl: intl, disabled: disabled = false }) {
    if (siblingSubTypes.length === 0) return null;
    const height = $7829ee1aabc510af$var$HEADING_HEIGHT + siblingSubTypes.length * $7829ee1aabc510af$var$MENU_ITEM_HEIGHT;
    return {
        id: 'editor.malleable-ui.remix-type-switcher',
        type: 'dropdown',
        title: currentLabelMessage ? intl.formatMessage(currentLabelMessage) : currentLabel,
        options: {
            width: $7829ee1aabc510af$var$MENU_WIDTH,
            height: height,
            render: ({ hide: hide })=>/*#__PURE__*/ (0, $lOiVq.jsx)($7829ee1aabc510af$var$TypeSwitcherMenu, {
                    siblingSubTypes: siblingSubTypes,
                    dynamicUiType: dynamicUiType,
                    dynamicUiSubtype: dynamicUiSubtype,
                    groupLabelMessage: groupLabelMessage,
                    onSelect: onSelect,
                    intl: intl,
                    hide: hide
                })
        },
        showSelected: false,
        disabled: disabled,
        testId: 'editor-floating-toolbar__remix-type-switcher'
    };
}




const $d723c49ce3553147$var$MAUI_REMIX_EXTENSION_KEYS = new Set([
    'native-embed:maui',
    'native-embed:maui-whiteboard'
]);
const $d723c49ce3553147$var$shouldSuppressThinkingHighlight = (extensionKey)=>typeof extensionKey === 'string' && $d723c49ce3553147$var$MAUI_REMIX_EXTENSION_KEYS.has(extensionKey);
function $d723c49ce3553147$export$812e6631895ae78a(node) {
    const localId = node.attrs?.localId;
    return typeof localId === 'string' && localId.length > 0 ? localId : undefined;
}
function $d723c49ce3553147$export$6d88a44c576e4d7a({ node: node, schema: schema, state: state }) {
    const { media: media, mediaSingle: mediaSingle } = schema.nodes;
    const isMaui = node.attrs.extensionKey === 'native-embed:maui';
    const isWhiteboard = node.attrs.extensionKey === 'native-embed:maui-whiteboard';
    if (isMaui || isWhiteboard) {
        const url = node.attrs.parameters?.macroParams?.url?.value;
        return (0, $2bef14e94508caba$export$c976fd9e927eb20d)({
            state: state,
            url: url
        });
    }
    const isMedia = node.type === media || node.type === mediaSingle;
    if (isMedia) {
        const mediaNode = node.type === media ? node : node.firstChild;
        if (mediaNode) {
            const fieldId = mediaNode.attrs.id;
            if (fieldId) return (0, $2bef14e94508caba$export$c976fd9e927eb20d)({
                state: state,
                fieldId: fieldId
            });
        }
    }
}
function $d723c49ce3553147$export$8997b1d407b19449({ node: node, schema: schema, state: state, intl: intl, disabled: disabled, api: api }) {
    if (!(0, $iDrrr.fg)('platform_editor_ai_remix_toolbar')) return undefined;
    const historyEntry = $d723c49ce3553147$export$6d88a44c576e4d7a({
        node: node,
        schema: schema,
        state: state
    });
    if (!historyEntry) return undefined;
    const switcherInfo = (0, $loej8.getRemixSwitcherInfo)(historyEntry.dynamicUiType, historyEntry.dynamicUiSubtype);
    if (!switcherInfo) return undefined;
    const dropdown = (0, $7829ee1aabc510af$export$a9e8c51842dcf4c7)({
        dynamicUiType: historyEntry.dynamicUiType,
        dynamicUiSubtype: historyEntry.dynamicUiSubtype,
        currentLabel: switcherInfo.currentLabel,
        currentLabelMessage: switcherInfo.currentLabelMessage,
        groupLabelMessage: switcherInfo.groupLabelMessage,
        siblingSubTypes: switcherInfo.siblingSubTypes,
        intl: intl,
        disabled: disabled,
        onSelect: ({ subtype: subtype })=>{
            const targetId = $d723c49ce3553147$export$812e6631895ae78a(node);
            const inFlightId = historyEntry.fieldId ?? (0, $dOW9b.getMauiIdFromUrl)(historyEntry.url);
            const suppressThinkingHighlight = $d723c49ce3553147$var$shouldSuppressThinkingHighlight(node.attrs.extensionKey);
            if (targetId) {
                api?.aiExperience?.actions?.stageInlineRovoStreaming?.(targetId);
                api?.aiExperience?.actions?.commitInlineRovoStreaming?.();
            }
            // Mark in-flight so the rovo-bridge update processors skip their
            // BE-pushed insert; `useUpdateRemix`/`useOnComplete` replaces the node
            // instead. id is `fieldId` (image, matches `mediaNode.attrs.id`) or the
            // MAUI app id from the stack-entry URL (matches `data.previousMauiId`).
            if (inFlightId && (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar')) api?.core?.actions.execute(api?.malleableUi?.commands.trackVariantUpdateStart({
                id: inFlightId
            }));
            (0, $3ed7f22374c9e3fb$export$fdf82e9851b59bf0)({
                api: api,
                options: {
                    isUpdate: true,
                    historyEntryForUpdate: historyEntry,
                    dynamicUiSubtypeForUpdate: subtype,
                    suppressThinkingHighlight: suppressThinkingHighlight
                }
            });
        }
    });
    return dropdown ?? undefined;
}
function $d723c49ce3553147$export$fb69ba203a08f43d({ api: api }) {
    return ({ schema: schema, state: state, node: node, intl: intl })=>{
        if (!node) return;
        const disabled = Boolean(api?.malleableUi?.sharedState.currentState()?.isRemixModalOpen || api?.malleableUi?.sharedState.currentState()?.isThinking || api?.aiExperience?.sharedState.currentState()?.areAiEntryPointsDisabled);
        return $d723c49ce3553147$export$8997b1d407b19449({
            node: node,
            schema: schema,
            state: state,
            intl: intl,
            disabled: disabled,
            api: api
        });
    };
}


















var $6t3CY = parcelRequire("6t3CY");

var $lslMH = parcelRequire("lslMH");





var $etoPX = parcelRequire("etoPX");











var $cOvkw = parcelRequire("cOvkw");

















const $f2f7ec9e8a84769b$var$RemoveBackgroundIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $etoPX.RovoIcon), {
            size: "xxsmall"
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $etoPX.RovoIcon), {
        size: "xxsmall"
    });
function $f2f7ec9e8a84769b$export$4acd7d829930a56d(schema) {
    return new Set((0, $1qYXT.REMIX_DENY_LIST_V1).map((name)=>schema.nodes[name]).filter(Boolean));
}
function $f2f7ec9e8a84769b$export$81aefa0141c75da9(schema) {
    return new Set((0, $444f275c146ea05d$export$d3f1ba79de0d4efe).map((name)=>schema.nodes[name]).filter(Boolean));
}
const $f2f7ec9e8a84769b$var$getMediaNodeForAskRovo = (node)=>{
    if (node.type.name === 'media') return node;
    if (node.type.name === 'mediaSingle') return node.firstChild ?? undefined;
    return undefined;
};
const $f2f7ec9e8a84769b$var$isImageMediaNodeForAskRovo = (node)=>{
    const mediaNode = $f2f7ec9e8a84769b$var$getMediaNodeForAskRovo(node);
    if (!mediaNode || mediaNode.type.name !== 'media') return false;
    if (mediaNode.attrs?.type === 'external') return true;
    const fileMimeType = mediaNode.attrs?.__fileMimeType;
    return typeof fileMimeType === 'string' && fileMimeType.includes('image/');
};
const $f2f7ec9e8a84769b$var$getMediaFileId = (node)=>{
    const mediaFileId = $f2f7ec9e8a84769b$var$getMediaNodeForAskRovo(node)?.attrs?.id;
    return typeof mediaFileId === 'string' && mediaFileId.length > 0 ? mediaFileId : undefined;
};
const $f2f7ec9e8a84769b$var$remixFloatingToolbarClickAnalyticsPayload = {
    action: (0, $krYZG.ACTION).CLICKED,
    actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
    actionSubjectId: 'remixModalFromToolbar',
    eventType: (0, $krYZG.EVENT_TYPE).UI,
    source: 'remix'
};
/**
 * Inline-dropdown variant of the floating-toolbar Remix item, rendered as a persistent React
 * component so the anchored picker can hang off a stable trigger. `openRemixModal` is only
 * dispatched once an option is picked — dispatching it just to show the picker moves the
 * ProseMirror selection, which makes the surrounding floating toolbar re-evaluate and detach
 * the popup from its trigger.
 */ const $f2f7ec9e8a84769b$var$RemixFloatingToolbarButton = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RemixFloatingToolbarButton(t0) {
    const $ = (0, $bDgLe.c)(28);
    const { api: api, intl: intl, isDisabled: isDisabled, node: node, remixHiddenOptionsResolver: t1, view: view } = t0;
    const RemixHiddenOptionsResolver = t1 === undefined ? (0, $1e53a3d0eb9e77e8$export$6c1a73717c6bf793) : t1;
    const { formatMessage: formatMessage } = intl;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = [
            "contextIdentifier",
            "malleableUi"
        ];
        $[0] = t2;
    } else t2 = $[0];
    const { contentId: contentId, isRemixing: isRemixing } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, t2, $f2f7ec9e8a84769b$var$_temp);
    const effectiveDisabled = isDisabled || isRemixing;
    const [isDropdownOpen, setIsDropdownOpen] = (0, $cozmU.useState)(false);
    const nodePosRef = (0, $cozmU.useRef)(undefined);
    let t3;
    if ($[1] !== api.analytics?.actions || $[2] !== effectiveDisabled || $[3] !== node || $[4] !== view) {
        t3 = ()=>{
            if (effectiveDisabled || !view) return;
            (0, $cha5E.expVal)("cc-ce-maui-remix-menu-multivariant", "cohort", "control");
            (0, $cha5E.expVal)("cc-ce-maui-remix-menu-multivariant-aa", "variant", "control");
            const $pos = view.state.selection.$from;
            let nodePos;
            for(let depth = $pos.depth; depth > 0; depth--)if ($pos.node(depth) === node) {
                nodePos = $pos.before(depth);
                break;
            }
            nodePosRef.current = nodePos;
            api.analytics?.actions.fireAnalyticsEvent($f2f7ec9e8a84769b$var$remixFloatingToolbarClickAnalyticsPayload);
            setIsDropdownOpen($f2f7ec9e8a84769b$var$_temp2);
        };
        $[1] = api.analytics?.actions;
        $[2] = effectiveDisabled;
        $[3] = node;
        $[4] = view;
        $[5] = t3;
    } else t3 = $[5];
    const handleClick = t3;
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>setIsDropdownOpen(false);
        $[6] = t4;
    } else t4 = $[6];
    const closeDropdown = t4;
    let t5;
    if ($[7] !== api.core.actions || $[8] !== api.malleableUi.commands || $[9] !== node.type.name) {
        t5 = (t6)=>{
            const { type: type, subType: subType, userPrompt: userPrompt } = t6;
            closeDropdown();
            api.core.actions.execute(api.malleableUi.commands.openRemixModal({
                nodePos: nodePosRef.current,
                nodeType: node.type.name,
                metadata: {
                    interactionSource: "remixModalFromFloatingToolbar",
                    preselectedType: type,
                    preselectedSubType: subType,
                    ...userPrompt && {
                        preselectedUserPrompt: userPrompt
                    }
                },
                source: "floatingToolbar"
            }));
        };
        $[7] = api.core.actions;
        $[8] = api.malleableUi.commands;
        $[9] = node.type.name;
        $[10] = t5;
    } else t5 = $[10];
    const handleOptionSelect = t5;
    let t6;
    if ($[11] !== formatMessage || $[12] !== isRemixing) {
        t6 = isRemixing ? formatMessage((0, $lhZdS.messages).remixInProgressTooltip) : formatMessage((0, $lhZdS.messages).remixToolbarTooltip);
        $[11] = formatMessage;
        $[12] = isRemixing;
        $[13] = t6;
    } else t6 = $[13];
    const tooltipContent = t6;
    let t7;
    if ($[14] !== effectiveDisabled || $[15] !== formatMessage || $[16] !== handleClick || $[17] !== isDropdownOpen || $[18] !== tooltipContent) {
        t7 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lslMH.ToolbarTooltip), {
                content: tooltipContent
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6t3CY.ToolbarButton), {
                ...triggerProps,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1pCE4))), {
                    label: "",
                    size: "small"
                }),
                testId: (0, $444f275c146ea05d$export$dad9e20bd9ca4fef),
                onClick: handleClick,
                isSelected: isDropdownOpen,
                isDisabled: effectiveDisabled
            }, formatMessage((0, $lhZdS.messages).remixToolbarLabel)));
        $[14] = effectiveDisabled;
        $[15] = formatMessage;
        $[16] = handleClick;
        $[17] = isDropdownOpen;
        $[18] = tooltipContent;
        $[19] = t7;
    } else t7 = $[19];
    const renderTrigger = t7;
    let t8;
    if ($[20] !== handleOptionSelect || $[21] !== isDropdownOpen || $[22] !== renderTrigger) {
        t8 = (hiddenOptions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8GyO5.RemixContainer), {
                hiddenOptions: hiddenOptions,
                presentation: "popup",
                trigger: renderTrigger,
                popupPlacement: "bottom-start",
                popupOffset: (0, $444f275c146ea05d$export$20c713d08b4969ef),
                isPopupOpen: isDropdownOpen,
                isThinking: false,
                onClose: closeDropdown,
                onOptionSelect: handleOptionSelect
            });
        $[20] = handleOptionSelect;
        $[21] = isDropdownOpen;
        $[22] = renderTrigger;
        $[23] = t8;
    } else t8 = $[23];
    let t9;
    if ($[24] !== RemixHiddenOptionsResolver || $[25] !== contentId || $[26] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(RemixHiddenOptionsResolver, {
            enabled: true,
            contentId: contentId
        }, t8);
        $[24] = RemixHiddenOptionsResolver;
        $[25] = contentId;
        $[26] = t8;
        $[27] = t9;
    } else t9 = $[27];
    return t9;
} : function RemixFloatingToolbarButton({ api: api, intl: intl, isDisabled: isDisabled, node: node, remixHiddenOptionsResolver: RemixHiddenOptionsResolver = (0, $1e53a3d0eb9e77e8$export$6c1a73717c6bf793), view: view }) {
    const { formatMessage: formatMessage } = intl;
    const { contentId: contentId, isRemixing: isRemixing } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'contextIdentifier',
        'malleableUi'
    ], (states)=>({
            contentId: states.contextIdentifierState?.contextIdentifierProvider?.objectId,
            isRemixing: states.malleableUiState?.isRemixModalOpen || false || states.malleableUiState?.isThinking || false
        }));
    const effectiveDisabled = isDisabled || isRemixing;
    const [isDropdownOpen, setIsDropdownOpen] = (0, $cozmU.useState)(false);
    // Captured at click time so the remix targets the node the user clicked on rather than
    // whatever the selection happens to be once they finish picking an option.
    const nodePosRef = (0, $cozmU.useRef)(undefined);
    const handleClick = (0, $cozmU.useCallback)(()=>{
        if (effectiveDisabled || !view) return;
        (0, $cha5E.expVal)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'control');
        (0, $cha5E.expVal)('cc-ce-maui-remix-menu-multivariant-aa', 'variant', 'control');
        const $pos = view.state.selection.$from;
        let nodePos;
        for(let depth = $pos.depth; depth > 0; depth--)if ($pos.node(depth) === node) {
            nodePos = $pos.before(depth);
            break;
        }
        nodePosRef.current = nodePos;
        api.analytics?.actions.fireAnalyticsEvent($f2f7ec9e8a84769b$var$remixFloatingToolbarClickAnalyticsPayload);
        setIsDropdownOpen((open)=>!open);
    }, [
        api,
        effectiveDisabled,
        node,
        view
    ]);
    const closeDropdown = (0, $cozmU.useCallback)(()=>setIsDropdownOpen(false), []);
    const handleOptionSelect = (0, $cozmU.useCallback)(({ type: type, subType: subType, userPrompt: userPrompt })=>{
        closeDropdown();
        api.core.actions.execute(api.malleableUi.commands.openRemixModal({
            nodePos: nodePosRef.current,
            nodeType: node.type.name,
            metadata: {
                interactionSource: 'remixModalFromFloatingToolbar',
                preselectedType: type,
                preselectedSubType: subType,
                ...userPrompt && {
                    preselectedUserPrompt: userPrompt
                }
            },
            source: 'floatingToolbar'
        }));
    }, [
        api,
        closeDropdown,
        node
    ]);
    const tooltipContent = isRemixing ? formatMessage((0, $lhZdS.messages).remixInProgressTooltip) : formatMessage((0, $lhZdS.messages).remixToolbarTooltip);
    const renderTrigger = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lslMH.ToolbarTooltip), {
            content: tooltipContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6t3CY.ToolbarButton), {
            ...triggerProps,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1pCE4))), {
                label: "",
                size: "small"
            }),
            testId: (0, $444f275c146ea05d$export$dad9e20bd9ca4fef),
            onClick: handleClick,
            isSelected: isDropdownOpen,
            isDisabled: effectiveDisabled
        }, formatMessage((0, $lhZdS.messages).remixToolbarLabel)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(RemixHiddenOptionsResolver, {
        enabled: true,
        contentId: contentId
    }, (hiddenOptions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8GyO5.RemixContainer), {
            hiddenOptions: hiddenOptions,
            presentation: "popup",
            trigger: renderTrigger,
            popupPlacement: "bottom-start",
            popupOffset: (0, $444f275c146ea05d$export$20c713d08b4969ef),
            isPopupOpen: isDropdownOpen,
            isThinking: false,
            onClose: closeDropdown,
            onOptionSelect: handleOptionSelect
        }));
};
function $f2f7ec9e8a84769b$var$_temp2(open) {
    return !open;
}
function $f2f7ec9e8a84769b$var$_temp(states) {
    return {
        contentId: states.contextIdentifierState?.contextIdentifierProvider?.objectId,
        isRemixing: states.malleableUiState?.isRemixModalOpen || false || states.malleableUiState?.isThinking || false
    };
}
function $f2f7ec9e8a84769b$export$5b679e92b69e94fb(api, options) {
    if (!api?.toolbar) return ()=>undefined;
    return (state, intl, _providerFactory, activeConfigs)=>{
        if (!activeConfigs?.length) return;
        const unallowedNodes = $f2f7ec9e8a84769b$export$4acd7d829930a56d(state.schema);
        const malleableUiState = (0, $bpOXf.malleableUiPluginKey).getState(state);
        const remixThinkingState = (0, $5ea92dab24394af7$export$38c8fc373d691b1d).getState(state);
        const isRemixing = malleableUiState?.isRemixModalOpen || false || remixThinkingState?.isThinking || false;
        const areAiEntryPointsDisabled = api?.aiExperience?.sharedState.currentState()?.areAiEntryPointsDisabled ?? false;
        activeConfigs.forEach((config)=>{
            const configNodeTypes = [].concat(config.nodeType);
            const isTableConfig = !Array.isArray(config.nodeType) && config.nodeType.name === 'table';
            // When an element is being remixed (modal open or thinking bar showing), hide its
            // element/floating toolbar entirely by emptying its items so the floating toolbar plugin
            // won't show it.
            //
            // Behind `cc-maui-phase-3` this applies to every element type. Previously the toolbar
            // was only hidden for tables, which left the element toolbar visible for other nodes
            // (e.g. panels and column layouts) while the thinking bar was showing. We skip the
            // inline-suggestion toolbar so the in-editor remix loading bar itself is not affected.
            // When the gate is off we retain the legacy table-only behaviour below.
            //
            // `shouldHideToolbarWhileRemixing` is an explicit opt-in from the product (only
            // Confluence sets this to true). This replaces the previous `config.className !==
            // undefined` heuristic, which accidentally affected products (e.g. Jira) that don't
            // set a className on their element toolbar configs.
            if (isRemixing && options?.shouldHideToolbarWhileRemixing && config.className !== (0, $cOvkw.InlineSuggestionToolbar).INLINE_SUGGESTION_FLOATING_TOOLBAR_CLASS && (0, $iDrrr.fg)('cc-maui-phase-3')) {
                config.items = [];
                return;
            }
            // Legacy behaviour (gate off): hide only the table element toolbar while remixing.
            if (isTableConfig && isRemixing && !(0, $iDrrr.fg)('cc-maui-phase-3')) {
                config.items = [];
                return;
            }
            // Check if every config node type is denied or inline. If the config also
            // includes multiBodiedExtension we defer the final decision to the items
            // callback where we can inspect the actual node's extensionKey (so that
            // allowed MBE variants like native tabs still get the Remix button).
            const hasMBENodeType = configNodeTypes.some((nt)=>nt.name === 'multiBodiedExtension');
            // Expands are deny-listed by default and only remixable under REMIX_EXPANDS_EXPERIMENT.
            // Keep their configs alive here (like MBE below) so the items callback can make the
            // gated decision against the real node — the experiment must not be read for every
            // element toolbar evaluation.
            const hasExpandNodeType = configNodeTypes.some((nt)=>(0, $1qYXT.REMIX_EXPAND_NODE_TYPES).includes(nt.name));
            const allDeniedOrInline = configNodeTypes.every((nodeType)=>unallowedNodes.has(nodeType) || nodeType.isInline);
            if (config.className !== undefined && config.className === (0, $cOvkw.InlineSuggestionToolbar).INLINE_SUGGESTION_FLOATING_TOOLBAR_CLASS || isTableConfig && config.items.length === 0 || configNodeTypes.some((nodeType)=>unallowedNodes.has(nodeType) || nodeType.isInline) && !hasMBENodeType && !hasExpandNodeType) return;
            // When all node types are denied/inline and the only reason we didn't
            // skip is because the config includes MBE or an expand, we need to gate the Remix
            // button on the actual node: an allowed MBE variant, or an expand with the
            // experiment enabled.
            const requiresNodeCheck = allDeniedOrInline && (hasMBENodeType || hasExpandNodeType);
            const toolbarItems = config.items;
            if (Array.isArray(toolbarItems)) {
                const remixButton = {
                    id: 'editor.malleable-ui.remix',
                    type: 'button',
                    title: intl.formatMessage((0, $lhZdS.messages).remixToolbarLabel),
                    tooltipContent: isRemixing ? intl.formatMessage((0, $lhZdS.messages).remixInProgressTooltip) : intl.formatMessage((0, $lhZdS.messages).remixToolbarTooltip),
                    showTitle: true,
                    hideTooltipOnClick: false,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($1pCE4))),
                    onClick: ()=>false,
                    disabled: isRemixing || areAiEntryPointsDisabled,
                    testId: (0, $444f275c146ea05d$export$dad9e20bd9ca4fef)
                };
                const remixToolbarItems = [
                    remixButton,
                    {
                        type: 'separator',
                        fullHeight: true
                    }
                ];
                config.items = (node)=>{
                    // When the config was only kept because it contains MBE or an expand, check
                    // whether the actual selected node is remixable — an allowed MBE variant
                    // (e.g. native tabs), or a non-empty expand with the experiment on. If not,
                    // return the original items without the Remix button.
                    if (requiresNodeCheck && !(0, $444f275c146ea05d$export$ff7e5ebac3487125)({
                        node: node
                    })) return toolbarItems;
                    const isRemixButtonDisabled = isRemixing || areAiEntryPointsDisabled || (0, $444f275c146ea05d$export$ebd59c3751cfcc95)(node);
                    if ((0, $444f275c146ea05d$export$2c2cd6cb969bd93a)()) return [
                        {
                            type: 'custom',
                            fallback: [],
                            render: (view)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f2f7ec9e8a84769b$var$RemixFloatingToolbarButton, {
                                    api: api,
                                    intl: intl,
                                    isDisabled: isRemixButtonDisabled,
                                    node: node,
                                    remixHiddenOptionsResolver: options?.remixHiddenOptionsResolver,
                                    view: view
                                })
                        },
                        {
                            type: 'separator',
                            fullHeight: true
                        },
                        ...toolbarItems
                    ];
                    remixButton.onClick = (editorState)=>{
                        if (isRemixing) return false;
                        (0, $cha5E.expVal)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'control');
                        (0, $cha5E.expVal)('cc-ce-maui-remix-menu-multivariant-aa', 'variant', 'control');
                        const $pos = editorState.selection.$from;
                        let nodePos;
                        for(let depth = $pos.depth; depth > 0; depth--)if ($pos.node(depth) === node) {
                            nodePos = $pos.before(depth);
                            break;
                        }
                        api.analytics?.actions.fireAnalyticsEvent($f2f7ec9e8a84769b$var$remixFloatingToolbarClickAnalyticsPayload);
                        api.core.actions.execute(api.malleableUi.commands.openRemixModal({
                            nodePos: nodePos,
                            nodeType: node.type.name,
                            metadata: {
                                interactionSource: 'remixModalFromFloatingToolbar'
                            },
                            source: 'floatingToolbar'
                        }));
                        return true;
                    };
                    remixButton.disabled = isRemixButtonDisabled;
                    return [
                        ...remixToolbarItems,
                        ...toolbarItems
                    ];
                };
            }
        });
        const mediaNodesForAskRovo = $f2f7ec9e8a84769b$export$81aefa0141c75da9(state.schema);
        const isViewMode = api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
        const showAskRovoForMedia = (0, $iDrrr.fg)('cc-maui-phase-2') || isViewMode && (0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true);
        if (!mediaNodesForAskRovo.size || !showAskRovoForMedia && isViewMode) return;
        const askRovoButton = showAskRovoForMedia ? api?.aiExperience?.actions?.getAskRovoFloatingToolbarButton?.({
            intl: intl,
            disabled: api?.malleableUi?.actions?.shouldDisableRemix?.() && (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar'),
            target: isViewMode ? 'default' : 'image'
        }) : undefined;
        const shouldShowAskRovoForMediaNode = (node)=>mediaNodesForAskRovo.has(node.type) && !node.type.isInline && $f2f7ec9e8a84769b$var$isImageMediaNodeForAskRovo(node);
        const buildTypeSwitcherItemsForMediaNode = (node)=>{
            return (0, $d723c49ce3553147$export$8997b1d407b19449)({
                node: node,
                schema: state.schema,
                state: state,
                intl: intl,
                disabled: Boolean(isRemixing || areAiEntryPointsDisabled),
                api: api
            });
        };
        // Build a per-node wrapped Ask Rovo button whose onClick stages the
        // selected media's target id (localId, falling back to file id) as the
        // inline-Rovo streaming target.
        const buildAskRovoItemsForMediaNode = (node)=>{
            if (!askRovoButton) return [];
            const wrappedAskRovoButton = {
                ...askRovoButton,
                ...isViewMode ? {
                    supportsViewMode: true
                } : {},
                onClick: (innerState, dispatch, view)=>{
                    if ((0, $iDrrr.fg)('cc-maui-phase-2')) {
                        const targetId = (0, $d723c49ce3553147$export$812e6631895ae78a)(node);
                        if (targetId) api?.aiExperience?.actions?.stageInlineRovoStreaming?.(targetId);
                    }
                    return askRovoButton.onClick ? askRovoButton.onClick(innerState, dispatch, view) : false;
                }
            };
            return [
                wrappedAskRovoButton,
                {
                    type: 'separator',
                    fullHeight: true,
                    ...isViewMode ? {
                        supportsViewMode: true
                    } : {}
                }
            ];
        };
        const buildRemoveBackgroundItemsForMediaNode = (node)=>{
            const mediaFileId = $f2f7ec9e8a84769b$var$getMediaFileId(node);
            if (isViewMode || !mediaFileId || isRemixing || areAiEntryPointsDisabled) return [];
            if (!(0, $cha5E.expVal)('cc_image_remove_background', 'isEnabled', false)) return [];
            const label = intl.formatMessage((0, $lhZdS.messages).removeBackgroundToolbarLabel);
            return [
                {
                    id: 'editor.malleable-ui.remove-background',
                    type: 'button',
                    title: label,
                    tooltipContent: label,
                    showTitle: true,
                    hideTooltipOnClick: false,
                    icon: $f2f7ec9e8a84769b$var$RemoveBackgroundIcon,
                    disabled: false,
                    testId: (0, $444f275c146ea05d$export$287305cbde0809e),
                    onClick: ()=>false
                },
                {
                    type: 'separator',
                    fullHeight: true
                }
            ];
        };
        activeConfigs.forEach((config)=>{
            const nodeTypes = [].concat(config.nodeType);
            const isMediaConfig = nodeTypes.some((nodeType)=>mediaNodesForAskRovo.has(nodeType) && !nodeType.isInline);
            if (!isMediaConfig) return;
            const items = config.items;
            if (Array.isArray(items)) config.items = (node)=>{
                if (!shouldShowAskRovoForMediaNode(node)) return items;
                const withAskRovo = [
                    ...buildAskRovoItemsForMediaNode(node),
                    ...buildRemoveBackgroundItemsForMediaNode(node),
                    ...items
                ];
                if ((0, $iDrrr.fg)('platform_editor_ai_remix_toolbar')) {
                    const typeSwitcher = buildTypeSwitcherItemsForMediaNode(node);
                    if (typeSwitcher) withAskRovo.splice(1, 0, typeSwitcher);
                }
                return withAskRovo;
            };
            else if (typeof items === 'function') config.items = (node)=>{
                const baseItems = items(node);
                if (!shouldShowAskRovoForMediaNode(node)) return baseItems;
                const withAskRovo = [
                    ...buildAskRovoItemsForMediaNode(node),
                    ...buildRemoveBackgroundItemsForMediaNode(node),
                    ...baseItems
                ];
                if ((0, $iDrrr.fg)('platform_editor_ai_remix_toolbar')) {
                    const typeSwitcher = buildTypeSwitcherItemsForMediaNode(node);
                    if (typeSwitcher) withAskRovo.splice(1, 0, typeSwitcher);
                }
                return withAskRovo;
            };
        });
    };
}








var $hVLmg = parcelRequire("hVLmg");























var $erHVE = parcelRequire("erHVE");












































const $b38b8034b2cc03ff$var$testId = 'editor-toolbar__remix-button';
const $b38b8034b2cc03ff$export$53a35bc3b2402206 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(49);
    const { api: api, isDisabled: isDisabled, isRemixHidden: isRemixHidden, remixDisabledReason: remixDisabledReason, remixHiddenOptionsResolver: t1 } = t0;
    const RemixHiddenOptionsResolver = t1 === undefined ? (0, $1e53a3d0eb9e77e8$export$6c1a73717c6bf793) : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = [
            "malleableUi",
            "aiExperience",
            "contextIdentifier"
        ];
        $[0] = t2;
    } else t2 = $[0];
    const { isLegacyRemixing: isLegacyRemixing, isAnyRemixing: isAnyRemixing, isUpdate: isUpdate, aiEditInProgress: aiEditInProgress, areAiEntryPointsDisabled: areAiEntryPointsDisabled, contentId: contentId } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, t2, $b38b8034b2cc03ff$var$_temp);
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $444f275c146ea05d$export$2c2cd6cb969bd93a)();
        $[1] = t3;
    } else t3 = $[1];
    const isInlineDropdownVariant = t3;
    const [, refreshMachinePresentation] = (0, $cozmU.useState)(0);
    let t4;
    if ($[2] !== api || $[3] !== refreshMachinePresentation) {
        t4 = ()=>(0, $dc44c0de1ed07c1a$export$ca9605d624b3c2db)(api, ()=>refreshMachinePresentation($b38b8034b2cc03ff$var$_temp2));
        $[2] = api;
        $[3] = refreshMachinePresentation;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== api) {
        t5 = [
            api
        ];
        $[5] = api;
        $[6] = t5;
    } else t5 = $[6];
    (0, $cozmU.useLayoutEffect)(t4, t5);
    let t6;
    if ($[7] !== api) {
        t6 = (0, $dc44c0de1ed07c1a$export$58aeb614b6d856f7)(api);
        $[7] = api;
        $[8] = t6;
    } else t6 = $[8];
    const machinePresentation = t6;
    const isOwnRemixing = isLegacyRemixing || machinePresentation.phase === "inserting";
    const isRemixing = isOwnRemixing || isAnyRemixing;
    const isMachineOwnedEditInProgress = machinePresentation.authority === "active" && isUpdate && isOwnRemixing;
    let t7;
    if ($[9] !== aiEditInProgress || $[10] !== areAiEntryPointsDisabled || $[11] !== isDisabled) {
        t7 = isDisabled || areAiEntryPointsDisabled || aiEditInProgress && (0, $4o0zT.isExperimentEnabled)("cc_maui_polish_changes_batch_5");
        $[9] = aiEditInProgress;
        $[10] = areAiEntryPointsDisabled;
        $[11] = isDisabled;
        $[12] = t7;
    } else t7 = $[12];
    const effectiveDisabled = t7;
    const [isDropdownOpen, setIsDropdownOpen] = (0, $cozmU.useState)(false);
    let t8;
    if ($[13] !== api?.core || $[14] !== api?.malleableUi.commands || $[15] !== experienceTracker) {
        t8 = (preselection)=>{
            const openModal = api?.malleableUi.commands.openRemixModal({
                metadata: {
                    interactionSource: "remixModalFromToolbar",
                    ...preselection && {
                        preselectedType: preselection.type,
                        preselectedSubType: preselection.subType,
                        ...preselection.userPrompt && {
                            preselectedUserPrompt: preselection.userPrompt
                        }
                    }
                },
                source: "selectionToolbar"
            });
            if (!openModal) return;
            const featureArea = (0, $iBsvI.getRemixFeatureArea)({});
            experienceTracker.start({
                name: (0, $irnO2.ExperienceName).REMIX_START,
                id: (0, $irnO2.ExperienceName).REMIX_START,
                attributes: {
                    entryPoint: "editor",
                    remixSource: "selectionToolbar",
                    product: "confluence",
                    ...featureArea !== undefined && {
                        featureArea: featureArea
                    }
                }
            });
            (0, $kDDrf.startRemixCreateExperience)({
                experienceTracker: experienceTracker,
                attributes: {
                    entryPoint: "editor",
                    remixSource: "selectionToolbar",
                    product: "confluence"
                }
            });
            api?.core.actions.execute((t9)=>{
                const { tr: tr } = t9;
                openModal({
                    tr: tr
                });
                tr.setMeta((0, $erHVE.editorToolbarPluginKey), {
                    shouldShowToolbar: false
                });
                return tr;
            });
        };
        $[13] = api?.core;
        $[14] = api?.malleableUi.commands;
        $[15] = experienceTracker;
        $[16] = t8;
    } else t8 = $[16];
    const openRemix = t8;
    let t9;
    if ($[17] !== createAnalyticsEvent || $[18] !== effectiveDisabled || $[19] !== isRemixing || $[20] !== openRemix) {
        t9 = ()=>{
            if (effectiveDisabled || isRemixing) return;
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: "remixModalFromToolbar",
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "remix",
                    attributes: {
                        entryPoint: "editor"
                    }
                }
            }).fire();
            (0, $cha5E.expVal)("cc-ce-maui-remix-menu-multivariant", "cohort", "control");
            (0, $cha5E.expVal)("cc-ce-maui-remix-menu-multivariant-aa", "variant", "control");
            if (isInlineDropdownVariant) {
                setIsDropdownOpen($b38b8034b2cc03ff$var$_temp3);
                return;
            }
            openRemix();
        };
        $[17] = createAnalyticsEvent;
        $[18] = effectiveDisabled;
        $[19] = isRemixing;
        $[20] = openRemix;
        $[21] = t9;
    } else t9 = $[21];
    const handleClick = t9;
    let t10;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = ()=>setIsDropdownOpen(false);
        $[22] = t10;
    } else t10 = $[22];
    const closeDropdown = t10;
    let t11;
    if ($[23] !== openRemix) {
        t11 = (selection)=>{
            closeDropdown();
            openRemix(selection);
        };
        $[23] = openRemix;
        $[24] = t11;
    } else t11 = $[24];
    const handleOptionSelect = t11;
    if (isRemixHidden || !(0, $ieeJu.expValEquals)("cc-maui-experiment", "isEnabled", true)) return null;
    let tooltipContent;
    if ($[25] !== aiEditInProgress || $[26] !== effectiveDisabled || $[27] !== formatMessage || $[28] !== isMachineOwnedEditInProgress || $[29] !== isRemixing || $[30] !== remixDisabledReason) {
        if (isMachineOwnedEditInProgress || aiEditInProgress && (0, $4o0zT.isExperimentEnabled)("cc_maui_polish_changes_batch_5")) tooltipContent = formatMessage((0, $lhZdS.messages).editInProgressTooltip);
        else if (isRemixing) tooltipContent = formatMessage((0, $lhZdS.messages).remixInProgressTooltip);
        else {
            if (effectiveDisabled) tooltipContent = (0, $185ff2366808da00$export$5626baa73ed0afeb)(formatMessage, remixDisabledReason);
            else if ((0, $iDrrr.fg)("cc_maui_updated_remix_tooltip_text")) tooltipContent = formatMessage((0, $lhZdS.messages).remixToolbarTooltipUpdated);
            else tooltipContent = formatMessage((0, $lhZdS.messages).remixToolbarTooltip);
        }
        $[25] = aiEditInProgress;
        $[26] = effectiveDisabled;
        $[27] = formatMessage;
        $[28] = isMachineOwnedEditInProgress;
        $[29] = isRemixing;
        $[30] = remixDisabledReason;
        $[31] = tooltipContent;
    } else tooltipContent = $[31];
    let t12;
    if ($[32] !== effectiveDisabled || $[33] !== formatMessage || $[34] !== handleClick || $[35] !== isDropdownOpen || $[36] !== isRemixing || $[37] !== tooltipContent) {
        t12 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lslMH.ToolbarTooltip), {
                content: tooltipContent
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6t3CY.ToolbarButton), {
                ...triggerProps,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1pCE4))), {
                    label: "",
                    size: "small"
                }),
                testId: $b38b8034b2cc03ff$var$testId,
                onClick: handleClick,
                isSelected: isInlineDropdownVariant ? isDropdownOpen : undefined,
                isDisabled: effectiveDisabled || isRemixing
            }, formatMessage((0, $lhZdS.messages).remixToolbarLabel)));
        $[32] = effectiveDisabled;
        $[33] = formatMessage;
        $[34] = handleClick;
        $[35] = isDropdownOpen;
        $[36] = isRemixing;
        $[37] = tooltipContent;
        $[38] = t12;
    } else t12 = $[38];
    const renderButton = t12;
    if (!isInlineDropdownVariant) {
        let t13;
        if ($[39] !== renderButton) {
            t13 = renderButton();
            $[39] = renderButton;
            $[40] = t13;
        } else t13 = $[40];
        return t13;
    }
    let t13;
    if ($[41] !== handleOptionSelect || $[42] !== isDropdownOpen || $[43] !== renderButton) {
        t13 = (hiddenOptions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8GyO5.RemixContainer), {
                hiddenOptions: hiddenOptions,
                presentation: "popup",
                trigger: renderButton,
                popupPlacement: "bottom-start",
                popupOffset: (0, $444f275c146ea05d$export$20c713d08b4969ef),
                isPopupOpen: isDropdownOpen,
                isThinking: false,
                onClose: closeDropdown,
                onOptionSelect: handleOptionSelect
            });
        $[41] = handleOptionSelect;
        $[42] = isDropdownOpen;
        $[43] = renderButton;
        $[44] = t13;
    } else t13 = $[44];
    let t14;
    if ($[45] !== RemixHiddenOptionsResolver || $[46] !== contentId || $[47] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(RemixHiddenOptionsResolver, {
            enabled: true,
            contentId: contentId
        }, t13);
        $[45] = RemixHiddenOptionsResolver;
        $[46] = contentId;
        $[47] = t13;
        $[48] = t14;
    } else t14 = $[48];
    return t14;
} : ({ api: api, isDisabled: isDisabled, isRemixHidden: isRemixHidden, remixDisabledReason: remixDisabledReason, remixHiddenOptionsResolver: RemixHiddenOptionsResolver = (0, $1e53a3d0eb9e77e8$export$6c1a73717c6bf793) })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { isLegacyRemixing: isLegacyRemixing, isAnyRemixing: isAnyRemixing, isUpdate: isUpdate, aiEditInProgress: aiEditInProgress, areAiEntryPointsDisabled: areAiEntryPointsDisabled, contentId: contentId } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'malleableUi',
        'aiExperience',
        'contextIdentifier'
    ], (states)=>({
            isLegacyRemixing: states.malleableUiState?.isRemixModalOpen || false || states.malleableUiState?.isThinking || false,
            // Only the editor treatment projects this, from the shared Remix registry.
            isAnyRemixing: states.malleableUiState?.isAnyRemixing ?? false,
            isUpdate: states.malleableUiState?.isUpdate ?? false,
            areAiEntryPointsDisabled: states.aiExperienceState?.areAiEntryPointsDisabled ?? false,
            aiEditInProgress: (0, $d1c28dddb88abfdb$export$44c2dcb159008a4b)(states.aiExperienceState),
            contentId: states.contextIdentifierState?.contextIdentifierProvider?.objectId
        }));
    const isInlineDropdownVariant = (0, $444f275c146ea05d$export$2c2cd6cb969bd93a)();
    // Ownership lives in a synchronous registry rather than plugin state, so subscribe to keep the
    // button's disabled state and tooltip in step with the flow starting and ending.
    const [, refreshMachinePresentation] = (0, $cozmU.useState)(0);
    (0, $cozmU.useLayoutEffect)(()=>(0, $dc44c0de1ed07c1a$export$ca9605d624b3c2db)(api, ()=>refreshMachinePresentation((value)=>value + 1)), [
        api
    ]);
    // A machine-owned flow is a Remix in progress even though the projection reports `!isThinking`
    // once the early streaming whiteboard lands. Without this the button reads as disabled with no
    // reason, and the tooltip helper's default renders the archived copy on an ordinary page.
    // Only `inserting` extends "in progress". Ownership stays active after the flow completes, so
    // keying off it would leave this button disabled for the rest of the editor session.
    const machinePresentation = (0, $dc44c0de1ed07c1a$export$58aeb614b6d856f7)(api);
    const isOwnRemixing = isLegacyRemixing || machinePresentation.phase === 'inserting';
    // A Remix from another surface (e.g. the Object Sidebar, including one still generating in
    // Rovo Chat after its handoff) is also in progress, and the machine would refuse a new start.
    const isRemixing = isOwnRemixing || isAnyRemixing;
    // Active lifecycle authority is the treatment-owned gate, so the toolbar need not re-evaluate
    // the editor experiment while preserving legacy and Batch 5 classification paths.
    const isMachineOwnedEditInProgress = machinePresentation.authority === 'active' && isUpdate && isOwnRemixing;
    const effectiveDisabled = isDisabled || areAiEntryPointsDisabled || aiEditInProgress && (0, $4o0zT.isExperimentEnabled)('cc_maui_polish_changes_batch_5');
    // Only the inline-dropdown cohort renders the anchored picker; every other assignment
    // keeps the central modal experience.
    const [isDropdownOpen, setIsDropdownOpen] = (0, $cozmU.useState)(false);
    const openRemix = (0, $cozmU.useCallback)((preselection)=>{
        const openModal = api?.malleableUi.commands.openRemixModal({
            metadata: {
                interactionSource: 'remixModalFromToolbar',
                ...preselection && {
                    preselectedType: preselection.type,
                    preselectedSubType: preselection.subType,
                    ...preselection.userPrompt && {
                        preselectedUserPrompt: preselection.userPrompt
                    }
                }
            },
            source: 'selectionToolbar'
        });
        if (!openModal) return;
        const featureArea = (0, $iBsvI.getRemixFeatureArea)({});
        experienceTracker.start({
            name: (0, $irnO2.ExperienceName).REMIX_START,
            id: (0, $irnO2.ExperienceName).REMIX_START,
            attributes: {
                entryPoint: 'editor',
                remixSource: 'selectionToolbar',
                product: 'confluence',
                ...featureArea !== undefined && {
                    featureArea: featureArea
                }
            }
        });
        (0, $kDDrf.startRemixCreateExperience)({
            experienceTracker: experienceTracker,
            attributes: {
                entryPoint: 'editor',
                remixSource: 'selectionToolbar',
                product: 'confluence'
            }
        });
        api?.core.actions.execute(({ tr: tr })=>{
            openModal({
                tr: tr
            });
            tr.setMeta((0, $erHVE.editorToolbarPluginKey), {
                shouldShowToolbar: false
            });
            return tr;
        });
    }, [
        api,
        experienceTracker
    ]);
    const handleClick = (0, $cozmU.useCallback)(()=>{
        if (effectiveDisabled || isRemixing) return;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'remixModalFromToolbar',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'remix',
                attributes: {
                    entryPoint: 'editor'
                }
            }
        }).fire();
        (0, $cha5E.expVal)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'control');
        (0, $cha5E.expVal)('cc-ce-maui-remix-menu-multivariant-aa', 'variant', 'control');
        if (isInlineDropdownVariant) {
            setIsDropdownOpen((open)=>!open);
            return;
        }
        openRemix();
    }, [
        createAnalyticsEvent,
        effectiveDisabled,
        isInlineDropdownVariant,
        isRemixing,
        openRemix
    ]);
    const closeDropdown = (0, $cozmU.useCallback)(()=>setIsDropdownOpen(false), []);
    const handleOptionSelect = (0, $cozmU.useCallback)((selection)=>{
        closeDropdown();
        openRemix(selection);
    }, [
        closeDropdown,
        openRemix
    ]);
    if (isRemixHidden || !(0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true)) return null;
    let tooltipContent;
    if (isMachineOwnedEditInProgress || aiEditInProgress && (0, $4o0zT.isExperimentEnabled)('cc_maui_polish_changes_batch_5')) tooltipContent = formatMessage((0, $lhZdS.messages).editInProgressTooltip);
    else if (isRemixing) tooltipContent = formatMessage((0, $lhZdS.messages).remixInProgressTooltip);
    else if (effectiveDisabled) tooltipContent = (0, $185ff2366808da00$export$5626baa73ed0afeb)(formatMessage, remixDisabledReason);
    else if ((0, $iDrrr.fg)('cc_maui_updated_remix_tooltip_text')) tooltipContent = formatMessage((0, $lhZdS.messages).remixToolbarTooltipUpdated);
    else tooltipContent = formatMessage((0, $lhZdS.messages).remixToolbarTooltip);
    const renderButton = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lslMH.ToolbarTooltip), {
            content: tooltipContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6t3CY.ToolbarButton), {
            ...triggerProps,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1pCE4))), {
                label: "",
                size: "small"
            }),
            testId: $b38b8034b2cc03ff$var$testId,
            onClick: handleClick,
            isSelected: isInlineDropdownVariant ? isDropdownOpen : undefined,
            isDisabled: effectiveDisabled || isRemixing
        }, formatMessage((0, $lhZdS.messages).remixToolbarLabel)));
    if (!isInlineDropdownVariant) return renderButton();
    // The button itself is the picker: the anchored dropdown hangs off it and hands the
    // selection to the remix flow, which is mounted separately and driven by plugin state.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(RemixHiddenOptionsResolver, {
        enabled: true,
        contentId: contentId
    }, (hiddenOptions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8GyO5.RemixContainer), {
            hiddenOptions: hiddenOptions,
            presentation: "popup",
            trigger: renderButton,
            popupPlacement: "bottom-start",
            popupOffset: (0, $444f275c146ea05d$export$20c713d08b4969ef),
            isPopupOpen: isDropdownOpen,
            isThinking: false,
            onClose: closeDropdown,
            onOptionSelect: handleOptionSelect
        }));
};
function $b38b8034b2cc03ff$var$_temp(states) {
    return {
        isLegacyRemixing: states.malleableUiState?.isRemixModalOpen || false || states.malleableUiState?.isThinking || false,
        isAnyRemixing: states.malleableUiState?.isAnyRemixing ?? false,
        isUpdate: states.malleableUiState?.isUpdate ?? false,
        areAiEntryPointsDisabled: states.aiExperienceState?.areAiEntryPointsDisabled ?? false,
        aiEditInProgress: (0, $d1c28dddb88abfdb$export$44c2dcb159008a4b)(states.aiExperienceState),
        contentId: states.contextIdentifierState?.contextIdentifierProvider?.objectId
    };
}
function $b38b8034b2cc03ff$var$_temp2(value) {
    return value + 1;
}
function $b38b8034b2cc03ff$var$_temp3(open) {
    return !open;
}











































const $6928b89135447805$export$6764c57cc6522e0a = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RemixCommentPrimaryMenuItem(t0) {
    const $ = (0, $bDgLe.c)(26);
    const { api: api, isDisabled: isDisabled, remixDisabledReason: remixDisabledReason } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            "malleableUi",
            "aiExperience"
        ];
        $[0] = t1;
    } else t1 = $[0];
    const { isRemixing: isRemixing, areAiEntryPointsDisabled: areAiEntryPointsDisabled } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, t1, $6928b89135447805$var$_temp);
    const effectiveDisabled = isDisabled || areAiEntryPointsDisabled;
    let t2;
    if ($[1] !== api?.analytics?.actions || $[2] !== api?.core || $[3] !== api?.malleableUi?.commands || $[4] !== effectiveDisabled || $[5] !== experienceTracker || $[6] !== isRemixing) {
        t2 = (event)=>{
            if (effectiveDisabled || isRemixing) return;
            const anchorRect = (0, $444f275c146ea05d$export$2c2cd6cb969bd93a)() ? event.currentTarget.getBoundingClientRect() : undefined;
            (0, $cha5E.expVal)("cc-ce-maui-remix-menu-multivariant", "cohort", "control");
            (0, $cha5E.expVal)("cc-ce-maui-remix-menu-multivariant-aa", "variant", "control");
            api?.analytics?.actions.fireAnalyticsEvent({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "remix",
                eventType: "ui",
                attributes: {
                    remixSource: "commentPrimaryToolbar"
                }
            });
            const featureArea = (0, $iBsvI.getRemixFeatureArea)({});
            experienceTracker.start({
                name: (0, $irnO2.ExperienceName).REMIX_START,
                id: (0, $irnO2.ExperienceName).REMIX_START,
                attributes: {
                    entryPoint: "editor",
                    remixSource: "commentPrimaryToolbar",
                    ...featureArea !== undefined && {
                        featureArea: featureArea
                    }
                }
            });
            (0, $kDDrf.startRemixCreateExperience)({
                experienceTracker: experienceTracker,
                attributes: {
                    entryPoint: "editor",
                    remixSource: "commentPrimaryToolbar"
                }
            });
            api?.core.actions.execute(api?.malleableUi?.commands.openRemixModal({
                metadata: {
                    interactionSource: "remixModalFromToolbar",
                    anchorRect: anchorRect
                },
                source: "commentPrimaryToolbar"
            }));
        };
        $[1] = api?.analytics?.actions;
        $[2] = api?.core;
        $[3] = api?.malleableUi?.commands;
        $[4] = effectiveDisabled;
        $[5] = experienceTracker;
        $[6] = isRemixing;
        $[7] = t2;
    } else t2 = $[7];
    const handleClick = t2;
    let t3;
    if ($[8] !== formatMessage) {
        t3 = formatMessage((0, $lhZdS.messages).remixToolbarLabel);
        $[8] = formatMessage;
        $[9] = t3;
    } else t3 = $[9];
    const label = t3;
    let t4;
    bb0: {
        if (isRemixing) {
            let t5;
            if ($[10] !== formatMessage) {
                t5 = formatMessage((0, $lhZdS.messages).remixInProgressTooltip);
                $[10] = formatMessage;
                $[11] = t5;
            } else t5 = $[11];
            t4 = t5;
            break bb0;
        }
        if (effectiveDisabled) {
            let t5;
            if ($[12] !== formatMessage || $[13] !== remixDisabledReason) {
                t5 = (0, $185ff2366808da00$export$5626baa73ed0afeb)(formatMessage, remixDisabledReason);
                $[12] = formatMessage;
                $[13] = remixDisabledReason;
                $[14] = t5;
            } else t5 = $[14];
            t4 = t5;
            break bb0;
        }
        let t5;
        if ($[15] !== formatMessage) {
            t5 = formatMessage((0, $lhZdS.messages).remixToolbarTooltip);
            $[15] = formatMessage;
            $[16] = t5;
        } else t5 = $[16];
        t4 = t5;
    }
    const tooltipContent = t4;
    let t5;
    if ($[17] !== label) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1pCE4))), {
            size: "small",
            label: label
        });
        $[17] = label;
        $[18] = t5;
    } else t5 = $[18];
    let t6;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null);
        $[19] = t6;
    } else t6 = $[19];
    const t7 = effectiveDisabled || isRemixing;
    let t8;
    if ($[20] !== handleClick || $[21] !== label || $[22] !== t5 || $[23] !== t7 || $[24] !== tooltipContent) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
            elemBefore: t5,
            elemAfter: t6,
            testId: "dropdown-item__malleable-ui-remix-comment",
            isDisabled: t7,
            title: tooltipContent,
            onClick: handleClick
        }, label);
        $[20] = handleClick;
        $[21] = label;
        $[22] = t5;
        $[23] = t7;
        $[24] = tooltipContent;
        $[25] = t8;
    } else t8 = $[25];
    return t8;
} : function RemixCommentPrimaryMenuItem({ api: api, isDisabled: isDisabled, remixDisabledReason: remixDisabledReason }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    const { isRemixing: isRemixing, areAiEntryPointsDisabled: areAiEntryPointsDisabled } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'malleableUi',
        'aiExperience'
    ], (states)=>({
            isRemixing: states.malleableUiState?.isRemixModalOpen || states.malleableUiState?.isThinking,
            areAiEntryPointsDisabled: states.aiExperienceState?.areAiEntryPointsDisabled ?? false
        }));
    const effectiveDisabled = isDisabled || areAiEntryPointsDisabled;
    const handleClick = (0, $cozmU.useCallback)((event)=>{
        if (effectiveDisabled || isRemixing) return;
        // Captured at click time, before the dropdown item unmounts as the flow starts.
        const anchorRect = (0, $444f275c146ea05d$export$2c2cd6cb969bd93a)() ? event.currentTarget.getBoundingClientRect() : undefined;
        (0, $cha5E.expVal)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'control');
        (0, $cha5E.expVal)('cc-ce-maui-remix-menu-multivariant-aa', 'variant', 'control');
        api?.analytics?.actions.fireAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'remix',
            eventType: 'ui',
            attributes: {
                remixSource: 'commentPrimaryToolbar'
            }
        });
        const featureArea = (0, $iBsvI.getRemixFeatureArea)({});
        experienceTracker.start({
            name: (0, $irnO2.ExperienceName).REMIX_START,
            id: (0, $irnO2.ExperienceName).REMIX_START,
            attributes: {
                entryPoint: 'editor',
                remixSource: 'commentPrimaryToolbar',
                ...featureArea !== undefined && {
                    featureArea: featureArea
                }
            }
        });
        (0, $kDDrf.startRemixCreateExperience)({
            experienceTracker: experienceTracker,
            attributes: {
                entryPoint: 'editor',
                remixSource: 'commentPrimaryToolbar'
            }
        });
        api?.core.actions.execute(api?.malleableUi?.commands.openRemixModal({
            metadata: {
                interactionSource: 'remixModalFromToolbar',
                anchorRect: anchorRect
            },
            source: 'commentPrimaryToolbar'
        }));
    }, [
        api,
        effectiveDisabled,
        isRemixing,
        experienceTracker
    ]);
    const label = formatMessage((0, $lhZdS.messages).remixToolbarLabel);
    const tooltipContent = (0, $cozmU.useMemo)(()=>{
        if (isRemixing) return formatMessage((0, $lhZdS.messages).remixInProgressTooltip);
        if (effectiveDisabled) return (0, $185ff2366808da00$export$5626baa73ed0afeb)(formatMessage, remixDisabledReason);
        return formatMessage((0, $lhZdS.messages).remixToolbarTooltip);
    }, [
        isRemixing,
        effectiveDisabled,
        formatMessage,
        remixDisabledReason
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1pCE4))), {
            size: "small",
            label: label
        }),
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null),
        testId: "dropdown-item__malleable-ui-remix-comment",
        isDisabled: effectiveDisabled || isRemixing,
        title: tooltipContent,
        onClick: handleClick
    }, label);
};
function $6928b89135447805$var$_temp(states) {
    return {
        isRemixing: states.malleableUiState?.isRemixModalOpen || states.malleableUiState?.isThinking,
        areAiEntryPointsDisabled: states.aiExperienceState?.areAiEntryPointsDisabled ?? false
    };
}


const $5219552937bbf3f0$var$MAUI_REMIX_GROUP = {
    type: 'group',
    key: 'malleable-ui-remix-group'
};
const $5219552937bbf3f0$var$MAUI_REMIX_BUTTON = {
    type: 'button',
    key: 'malleable-ui-remix-button'
};
const $5219552937bbf3f0$var$MAUI_REMIX_COMMENT_MENU_ITEM = {
    type: 'menu-item',
    key: 'malleable-ui-remix-comment-menu-item'
};
/**
 * Between {@link ROVO_PROMPT_MENU_SECTION_RANK}[SPELLING_AND_GRAMMAR_MENU_ITEM] (300) and
 * [CHANGE_TONE_NESTED_MENU] (400); see `packages/editor/editor-common/src/toolbar/rank.ts`.
 */ const $5219552937bbf3f0$var$MAUI_REMIX_COMMENT_MENU_ITEM_RANK = 350;
function $5219552937bbf3f0$var$isCommentPrimaryToolbarContext(parents) {
    return parents.some((p)=>p.key === (0, $3nacY.AI_SECTION_COMMENT_PRIMARY_TOOLBAR).key);
}
const $5219552937bbf3f0$export$716af56477a0c29a = (api, options)=>{
    return [
        {
            type: $5219552937bbf3f0$var$MAUI_REMIX_GROUP.type,
            key: $5219552937bbf3f0$var$MAUI_REMIX_GROUP.key,
            parents: [
                {
                    type: (0, $3nacY.AI_SECTION).type,
                    key: (0, $3nacY.AI_SECTION).key,
                    rank: (0, $hVLmg.AI_SECTION_RANK)[(0, $3nacY.HERO_PROMPT_BUTTON_GROUP).key] + 10
                },
                // View mode (Live Page): AI_VIEW_SECTION
                {
                    type: (0, $3nacY.AI_VIEW_SECTION).type,
                    key: (0, $3nacY.AI_VIEW_SECTION).key,
                    rank: (0, $hVLmg.AI_SECTION_RANK)[(0, $3nacY.HERO_PROMPT_BUTTON_GROUP).key] + 10
                }
            ]
        },
        {
            type: $5219552937bbf3f0$var$MAUI_REMIX_BUTTON.type,
            key: $5219552937bbf3f0$var$MAUI_REMIX_BUTTON.key,
            parents: [
                {
                    type: $5219552937bbf3f0$var$MAUI_REMIX_GROUP.type,
                    key: $5219552937bbf3f0$var$MAUI_REMIX_GROUP.key,
                    rank: 100
                }
            ],
            component: ({ parents: parents })=>{
                const onPrimaryToolbar = parents.at(0)?.key === (0, $3nacY.TOOLBARS).PRIMARY_TOOLBAR;
                if (onPrimaryToolbar) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b38b8034b2cc03ff$export$53a35bc3b2402206), {
                    api: api,
                    isDisabled: options?.isDisabled,
                    isRemixHidden: options?.isRemixHidden,
                    remixDisabledReason: options?.remixDisabledReason,
                    remixHiddenOptionsResolver: options?.remixHiddenOptionsResolver
                });
            }
        },
        {
            type: $5219552937bbf3f0$var$MAUI_REMIX_COMMENT_MENU_ITEM.type,
            key: $5219552937bbf3f0$var$MAUI_REMIX_COMMENT_MENU_ITEM.key,
            parents: [
                {
                    type: (0, $3nacY.ROVO_PROMPT_MENU_SECTION).type,
                    key: (0, $3nacY.ROVO_PROMPT_MENU_SECTION).key,
                    rank: $5219552937bbf3f0$var$MAUI_REMIX_COMMENT_MENU_ITEM_RANK
                },
                {
                    type: (0, $3nacY.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).type,
                    key: (0, $3nacY.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).key,
                    rank: $5219552937bbf3f0$var$MAUI_REMIX_COMMENT_MENU_ITEM_RANK
                }
            ],
            component: ({ parents: parents })=>{
                if (!$5219552937bbf3f0$var$isCommentPrimaryToolbarContext(parents) || options?.isRemixHidden || !(0, $iDrrr.fg)('platform_editor_maui_jira_updates')) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6928b89135447805$export$6764c57cc6522e0a), {
                    api: api,
                    isDisabled: options?.isDisabled,
                    remixDisabledReason: options?.remixDisabledReason
                });
            }
        }
    ];
};



const $c5b4fc4a60b668cd$var$REMIX_BUTTON_DECORATION_TYPE = 'REMIX_BUTTON';

const $c5b4fc4a60b668cd$var$MauiEmbedSpacePickerLazyComponent = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("g9wH6")).then((mod)=>({
            default: mod.MauiEmbedSpacePicker
        })));
Object.assign($c5b4fc4a60b668cd$var$MauiEmbedSpacePickerLazyComponent, {
    displayName: 'lazy(MauiEmbedSpacePicker)'
});

const $c5b4fc4a60b668cd$var$MauiEmbedSpacePickerLoadableComponent = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "3lNcb",
    name: "MauiEmbedSpacePickerLoadableComponent",
    loader: ()=>(parcelRequire("g9wH6")).then((mod)=>mod.MauiEmbedSpacePicker),
    loading: ()=>null
});
const $c5b4fc4a60b668cd$var$MauiEmbedSpacePickerWithSuspense = (0, $gtMdU.isReactCompilerActivePlatform)() ? function MauiEmbedSpacePickerWithSuspense(props) {
    const $ = (0, $bDgLe.c)(4);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c5b4fc4a60b668cd$var$MauiEmbedSpacePickerLazyComponent, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, t0);
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : function MauiEmbedSpacePickerWithSuspense(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c5b4fc4a60b668cd$var$MauiEmbedSpacePickerLazyComponent, props));
};
const $c5b4fc4a60b668cd$var$LoadableMauiEmbedSpacePicker = (props)=>(0, $iDrrr.fg)('nike_r19_react_loadable') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c5b4fc4a60b668cd$var$MauiEmbedSpacePickerWithSuspense, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c5b4fc4a60b668cd$var$MauiEmbedSpacePickerLoadableComponent, props);
const $c5b4fc4a60b668cd$export$90e174b945ae40c7 = ({ api: api, config: config })=>{
    const isRovoLLMEnabled = config?.__isRovoLLMEnabled ?? false;
    const isRemixEnabled = isRovoLLMEnabled && (0, $anBbz.expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true);
    const isRightSideEnabled = isRemixEnabled && (0, $iDrrr.fg)('confluence_remix_button_right_side_block_fg');
    const remixDisabledReason = config?.__remixDisabledReason;
    const isRemixDisabled = !!remixDisabledReason;
    const isRemixHidden = config?.__isRemixHidden;
    const isRemixAvailable = isRemixEnabled && !isRemixHidden && !isRemixDisabled;
    const remixContentCreatorResult = isRemixAvailable && api !== undefined && typeof config?.createRemixContentComponent === 'function' ? config.createRemixContentComponent() : undefined;
    const remixContentComponent = typeof remixContentCreatorResult === 'function' ? remixContentCreatorResult : remixContentCreatorResult?.Component;
    const editorRemixLifecycleAdapterHost = typeof remixContentCreatorResult === 'function' ? undefined : remixContentCreatorResult?.LifecycleHost;
    const hasEditorRemixLifecycleAdapter = typeof remixContentCreatorResult !== 'function' && remixContentCreatorResult?.capabilities.editorRemixLifecycleAdapter === true;
    // The editor owning surface is the single rollout boundary: unavailable and adapter-less hosts
    // (including hosts that cannot render Remix content) short-circuit before this regular evaluation
    // records control or treatment exposure.
    const isEditorRemixStateRearchitectureTreatment = isRemixAvailable && hasEditorRemixLifecycleAdapter && editorRemixLifecycleAdapterHost !== undefined && remixContentComponent !== undefined && api !== undefined && (0, $iDrrr.fg)('remix_state_rearchitecture_enabled') && (0, $4o0zT.isExperimentEnabled)('remix_state_rearchitecture_editor');
    const editorInlineRovoEditLifecycleAdapterHost = isEditorRemixStateRearchitectureTreatment ? editorRemixLifecycleAdapterHost : undefined;
    // Seeding `init()` from the shared registry only matters for flows the Object Sidebar hands to
    // Rovo Chat, and the effect host (editor treatment) is what later clears a seeded `true`. Read
    // without exposure: Confluence records this experiment's exposure at Object Sidebar admission.
    const shouldSeedIsAnyRemixingFromRegistry = isEditorRemixStateRearchitectureTreatment && (0, $2pQiO.UNSAFE_expValNoExposure)('remix_state_rearchitecture_object_sidebar', 'isEnabled', false) === true;
    const RemixHiddenOptionsResolver = config?.remixHiddenOptionsResolver ?? (({ children: children })=>children(config?.hiddenOptions ?? []));
    const remixToolbarOptions = {
        remixDisabledReason: remixDisabledReason,
        isDisabled: isRemixDisabled,
        isRemixHidden: isRemixHidden,
        remixHiddenOptionsResolver: RemixHiddenOptionsResolver
    };
    // Mutable reference to the editor view, set by a PM plugin on init.
    // Used by the Remix block-menu isHidden callback to compute text length.
    let editorView;
    if (api && !isRemixHidden && isRemixEnabled) {
        api.toolbar?.actions.registerComponents((0, $5219552937bbf3f0$export$716af56477a0c29a)(api, remixToolbarOptions));
        // Register Remix in the block menu when the experiment is enabled and
        // Remix is not disabled (e.g. restricted-content contexts).
        // Use NoExposure here since this runs on every editor load — exposure is
        // recorded when the block menu item is actually rendered.
        if (!isRemixDisabled && (0, $anBbz.expValEqualsNoExposure)('platform_editor_remix_in_block_menu', 'isEnabled', true)) api.blockMenu?.actions.registerBlockMenuComponents((0, $b924ab10b3fb73fd$export$96499eef52eb1886)({
            api: api,
            getEditorView: ()=>editorView,
            remixHiddenOptionsResolver: RemixHiddenOptionsResolver
        }));
        if (!isRemixDisabled && [
            'hasSpellingAndGrammar',
            'hasAltAiActions'
        ].includes((0, $mW7G5.expValNoExposure)('platform_editor_paste_actions_menu_v2', 'variant', 'control'))) api.uiControlRegistry?.actions.register((0, $48fd160920f56916$export$e79e54e0ad32496e)({
            api: api
        }));
    }
    if (api?.blockControls && !config?.__isRemixHidden && isRightSideEnabled) {
        const livePage = config?.__livePage;
        // EDITOR-8771: prefer the right surface via the UI Control Registry API once block controls
        // are migrated, falling back to `registerNodeDecoration` on the legacy path.
        if ((0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration')) {
            const remixRightSurfaceButton = {
                component: ({ surfaceContext: surfaceContext })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3a2adec84b86170$export$9097235bf2b51422), {
                        surfaceContext: surfaceContext,
                        api: api,
                        isDisabled: isRemixDisabled,
                        isRovoLLMEnabled: isRovoLLMEnabled,
                        livePage: livePage,
                        remixDisabledReason: remixDisabledReason,
                        remixHiddenOptionsResolver: RemixHiddenOptionsResolver
                    }),
                isHidden: ({ surfaceContext: surfaceContext } = {})=>{
                    const context = surfaceContext?.get((0, $jbxiN.BLOCK_CONTROL_UI_CONTEXT));
                    if (!context) return true;
                    // Remix is a root-node-only control
                    if (context.targetNode.pos !== context.rootNode.pos || context.targetNode.pos !== (context.activeNode?.rootPos ?? context.activeNode?.pos)) return true;
                    return !(0, $444f275c146ea05d$export$ff7e5ebac3487125)({
                        node: context.rootNode.node
                    });
                },
                key: 'remix-right-surface-button',
                parents: [
                    {
                        ...(0, $eRJEr.BLOCK_CONTROLS_RIGHT_GROUP),
                        rank: 100
                    }
                ],
                type: 'button'
            };
            api.uiControlRegistry?.actions.register([
                remixRightSurfaceButton
            ]);
        } else api.blockControls.actions.registerNodeDecoration({
            type: $c5b4fc4a60b668cd$var$REMIX_BUTTON_DECORATION_TYPE,
            create: (params)=>(0, $2986bbc07141fc36$export$d411c8f539cb0edd)({
                    ...params,
                    api: api,
                    livePage: livePage,
                    remixDisabledReason: remixDisabledReason,
                    isDisabled: isRemixDisabled,
                    isRovoLLMEnabled: isRovoLLMEnabled,
                    remixHiddenOptionsResolver: RemixHiddenOptionsResolver
                }),
            showInViewMode: true,
            shouldCreate: (params)=>{
                const { editorState: editorState, rootPos: rootPos } = params;
                if (rootPos === undefined) return false;
                const node = editorState.doc.nodeAt(rootPos);
                return (0, $444f275c146ea05d$export$ff7e5ebac3487125)({
                    node: node ?? undefined
                });
            }
        });
    }
    return {
        name: 'malleableUi',
        pmPlugins () {
            const plugins = [
                {
                    name: 'malleableUi',
                    plugin: ({ dispatch: dispatch })=>(0, $bpOXf.createMalleableUiPmPlugin)(dispatch, {
                            // Only the treatment projects the shared registry into plugin state, so only it
                            // seeds `init()` from that registry across editor state recreation (CCCEMAU-3764).
                            getInitialIsAnyRemixing: shouldSeedIsAnyRemixingFromRegistry ? (0, $gRoSG.isAnyRemixingNow) : undefined
                        })
                },
                {
                    name: 'malleableUiEditorViewCapture',
                    plugin: ()=>(0, $0714cd2e74fa9587$export$c2f4e91d1c0a0502)((view)=>{
                            editorView = view;
                        }, ()=>{
                            editorView = undefined;
                        })
                },
                {
                    name: 'malleableUiToolbarSuppression',
                    plugin: ()=>(0, $bpOXf.createToolbarSuppressionPlugin)()
                },
                {
                    name: 'remixThinking',
                    plugin: ({ dispatch: dispatch, getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>(0, $5ea92dab24394af7$export$1c17a47e3daa5065)({
                            api: api,
                            config: config,
                            dispatch: dispatch,
                            getIntl: getIntl,
                            nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                        })
                },
                ...(0, $iDrrr.fg)('cc-maui-phase-3') ? [
                    {
                        name: 'remixHoverHighlight',
                        plugin: ()=>(0, $3397a9320ab7f32b$export$1c5a63402318eb67)()
                    }
                ] : [],
                ...(0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') ? [
                    {
                        name: 'remixHistory',
                        plugin: ({ dispatch: dispatch })=>(0, $93f21268088062df$export$275a1873be81202e)({
                                api: api,
                                dispatch: dispatch
                            })
                    }
                ] : []
            ];
            if (config?.diagramPaste) {
                const diagramPasteConfig = {
                    ...config.diagramPaste,
                    fireAnalyticsEvent: (payload)=>{
                        api?.analytics?.actions.fireAnalyticsEvent(payload);
                    }
                };
                plugins.push({
                    name: 'mauiDiagramPaste',
                    plugin: ({ dispatch: dispatch, getIntl: getIntl })=>(0, $3kyUj.createMauiDiagramPastePmPlugin)(dispatch, diagramPasteConfig, getIntl)
                });
            }
            return plugins;
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const malleableUiState = (0, $bpOXf.malleableUiPluginKey).getState(editorState);
            const remixThinkingState = (0, $5ea92dab24394af7$export$38c8fc373d691b1d).getState(editorState);
            if (!malleableUiState || !remixThinkingState) return undefined;
            return {
                aiEditReplacementLocalIds: malleableUiState.aiEditReplacementLocalIds,
                inFlightVariantUpdates: malleableUiState.inFlightVariantUpdates,
                isUpdate: remixThinkingState.isUpdate ?? false,
                historyEntryForUpdate: remixThinkingState.historyEntryForUpdate,
                dynamicUiSubtypeForUpdate: remixThinkingState.dynamicUiSubtypeForUpdate,
                isComplete: remixThinkingState.isComplete ?? false,
                isAnyRemixing: malleableUiState.isAnyRemixing,
                isRemixModalOpen: malleableUiState.isRemixModalOpen,
                remixModalMetadata: malleableUiState.remixModalMetadata,
                remixAttemptId: remixThinkingState.remixAttemptId,
                isThinking: remixThinkingState.isThinking,
                isWaitingForInput: remixThinkingState.isWaitingForInput ?? false,
                remixSource: malleableUiState.remixSource,
                remixDiagramContentId: malleableUiState.remixDiagramContentId,
                remixUpdateScrollTargetUrl: malleableUiState.remixUpdateScrollTargetUrl,
                remixImageMediaId: malleableUiState.remixImageMediaId,
                showLocationPicker: malleableUiState.showLocationPicker,
                showSubtypeAdjustedFlag: malleableUiState.showSubtypeAdjustedFlag,
                diagramPaste: (0, $3kyUj.mauiDiagramPastePluginKey).getState(editorState),
                savedSelection: remixThinkingState.savedSelection
            };
        },
        actions: {
            beginInlineRovoEdit: (targetId)=>(0, $d41f3058f4db498d$export$b9869b87d1be6011)(api, targetId),
            claimInlineRovoEdit: (targetId)=>(0, $d41f3058f4db498d$export$804d6981ddbce4fe)(api, targetId),
            duplicateAndReplaceMauiApp: (0, $9ea85748e8d18b6b$export$4f422ec95246a715)({
                api: api,
                config: config
            }),
            finalizeMauiEmbedFromIndicator: (0, $157df83f4da5e36c$export$68002784dcd3d97)({
                config: config
            }),
            getRemixDynamicUiSubtype: (fieldId)=>editorView ? (0, $2bef14e94508caba$export$c976fd9e927eb20d)({
                    state: editorView.state,
                    fieldId: fieldId
                })?.dynamicUiSubtype : undefined,
            getRemixFloatingToolbarButton: (0, $9ca8eb041284f342$export$f5e01f6a1e2eeb41)({
                api: api,
                options: remixToolbarOptions
            }),
            getRemixVariantFloatingToolbarButton: (0, $d723c49ce3553147$export$fb69ba203a08f43d)({
                api: api
            }),
            isVariantUpdateInFlight: (id)=>{
                const sharedState = api?.malleableUi?.sharedState?.currentState();
                return sharedState?.inFlightVariantUpdates.has(id) ?? false;
            },
            reportInlineRovoEdit: (attemptId, result)=>(0, $d41f3058f4db498d$export$5b4e6541783f126c)(api, attemptId, result),
            settleUnclaimedInlineRovoEdit: (attemptId)=>(0, $d41f3058f4db498d$export$14ce80a40ed788cd)(api, attemptId),
            shouldDisableRemix: ()=>{
                const malleableUiState = api?.malleableUi?.sharedState.currentState();
                return Boolean(malleableUiState?.isRemixModalOpen || malleableUiState?.isThinking || malleableUiState?.isAnyRemixing || api?.aiExperience?.sharedState.currentState()?.areAiEntryPointsDisabled);
            }
        },
        commands: {
            clearRemixThinkingDecoration: $592515a66bfc26f7$export$65f89d2d4741e4b7,
            setMauiEmbedFinalizeStatus: $39483ef3a0dde328$export$d2cccfcd66c92b90,
            setRemixImageMediaId: $8ef7f637f4ca3dda$export$f36198854f9520d1,
            addBackendRemixHistoryStackEntry: (0, $f4ca8840d77ba1f3$export$b509b1134d7bb5c1),
            openRemixModal: (0, $a41417a475703a7a$export$e01f52b7ef73f07b)(api),
            closeRemixModal: (0, $d02a52a2c9adaa11$export$8818f9db6e7370f7)(api),
            startRemixThinking: (0, $3ed7f22374c9e3fb$export$b0011c604093029)(api),
            // Modal-free remix: anchors to pre-supplied localIds and starts remixing without opening
            // the Remix modal (used by Suggested Remix).
            startRemix: (0, $5708e7965bf3427a$export$e34b9fef80996931)(api),
            stopRemixThinking: $06443500a2493931$export$5569fef6b45e570f,
            replaceMauiApp: $b4d126e73ed52524$export$ff177b3b8713a3ae,
            replaceWhiteboardEmbed: $51bd462f1be2ad42$export$1aa62896db449f52,
            trackVariantUpdateStart: (0, $7725f70f68e88b96$export$b3219bd5df32333),
            trackVariantUpdateComplete: (0, $7725f70f68e88b96$export$242a1c29a4a1fdc3),
            updateRemixImageHistoryFieldId: (0, $51d6f7d12f1d2e45$export$de0bdc3bedba2bdf),
            showSubtypeAdjustedFlag: $756f290e221243c1$export$a5258d8cd6540560,
            dismissSubtypeAdjustedFlag: $756f290e221243c1$export$cc7138497964f45a
        },
        contentComponent: ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fjeDY.EditorRemixLifecycleOwnerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $loghT.EditorRemixRecoveryCoordinatorProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $828d24cf3c31b50c$export$3bccfb6f759a17), null), isEditorRemixStateRearchitectureTreatment ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $adce69c763bccff9$export$1ab134daab5fcbca), {
                api: api
            }) : null, editorInlineRovoEditLifecycleAdapterHost ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b2e4188f0e483040$export$fdca5082072fada0), {
                api: api,
                LifecycleAdapterHost: editorInlineRovoEditLifecycleAdapterHost
            }) : null, isRemixAvailable && api && !editorInlineRovoEditLifecycleAdapterHost ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7e9f8d762d979b80$export$9fd1c9027ae2084e), {
                api: api
            }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $da0e6f79e5c28019$export$9b636cd211668abd), {
                api: api,
                hiddenOptions: config?.hiddenOptions,
                remixContentComponent: remixContentComponent,
                isEditorRemixStateRearchitectureTreatment: isEditorRemixStateRearchitectureTreatment
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7d0e604702ca44aa$export$a91404893a3e2794), {
                api: api,
                productFlags: config?.productFlags
            }), config?.diagramPaste && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cf98493589757f0e$export$bdca710d02013452), {
                api: api,
                productFlags: config?.productFlags
            }), config?.diagramPaste && // eslint-disable-next-line @atlaskit/platform/use-recommended-utils -- dynamic config killswitch, not a standard feature gate
            !(0, $cXtTj.default).getExperimentValue('maui-native-embed-finalize-diagram-anywhere', 'value', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c5b4fc4a60b668cd$var$LoadableMauiEmbedSpacePicker, {
                api: api,
                config: config
            }) : null));
        },
        pluginsOptions: !config?.__isRemixHidden && !config?.__remixDisabledReason && isRemixEnabled ? {
            floatingToolbar: (0, $f2f7ec9e8a84769b$export$5b679e92b69e94fb)(api, {
                shouldHideToolbarWhileRemixing: config?.shouldHideToolbarWhileRemixing ?? false,
                remixHiddenOptionsResolver: RemixHiddenOptionsResolver
            })
        } : {}
    };
};
module.exports["malleableUiPlugin"] = $c5b4fc4a60b668cd$export$90e174b945ae40c7;

});

parcelRegister("loghT", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $fjeDY = parcelRequire("fjeDY");


var $3kyUj = parcelRequire("3kyUj");

const $aa52ec003d696f70$var$EditorRemixRecoveryContext = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $aa52ec003d696f70$export$712696ae13ff1c32 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($aa52ec003d696f70$var$EditorRemixRecoveryContext);
} : ()=>(0, $cozmU.useContext)($aa52ec003d696f70$var$EditorRemixRecoveryContext);
const $aa52ec003d696f70$export$3694853de04accb3 = ({ children: children })=>{
    const owner = (0, $fjeDY.useEditorRemixLifecycleOwner)();
    const activeRef = (0, $cozmU.useRef)(owner?.active);
    const bindingRef = (0, $cozmU.useRef)(undefined);
    activeRef.current = owner?.active;
    const activeToken = owner?.active?.token;
    /** Drops a binding whose flow is no longer the owner's active flow; its observer must not linger. */ const dropStaleBinding = (0, $cozmU.useCallback)(()=>{
        const binding = bindingRef.current;
        if (binding && binding.token !== activeRef.current?.token) {
            bindingRef.current = undefined;
            binding.unobserve();
        }
    }, []);
    (0, $cozmU.useEffect)(()=>{
        dropStaleBinding();
    }, [
        activeToken,
        dropStaleBinding
    ]);
    const consumeExactBinding = (0, $cozmU.useCallback)((contentId)=>{
        const binding_0 = bindingRef.current;
        const active = activeRef.current;
        if (!binding_0 || !active || binding_0.contentId !== contentId || binding_0.token !== active.token) return undefined;
        bindingRef.current = undefined;
        binding_0.unobserve();
        return binding_0;
    }, []);
    const discard = (0, $cozmU.useCallback)((contentId_0)=>{
        const binding_1 = consumeExactBinding(contentId_0);
        if (!binding_1?.lifecycle) return false;
        binding_1.lifecycle.transition({
            type: 'INSERTION_FAILED'
        });
        binding_1.lifecycle.end('error');
        return true;
    }, [
        consumeExactBinding
    ]);
    const defer = (0, $cozmU.useCallback)((contentId_1)=>{
        const lifecycle = activeRef.current;
        if (!lifecycle) return false;
        dropStaleBinding();
        const existing = bindingRef.current;
        if (existing) {
            // One recovery embed per flow. Repeating the same id is idempotent; a different id means
            // the flow's recovery embed moved, so the old observer is released and the id rebound.
            if (existing.contentId === contentId_1) return true;
            bindingRef.current = undefined;
            existing.unobserve();
        }
        // Observe before claiming ownership: if the embed is already gone, the streamed content was
        // not inserted, so settle now rather than retain a handle nothing can release.
        const unobserve = (0, $3kyUj.observeMauiEmbedRemoval)(contentId_1, ()=>discard(contentId_1));
        if (!unobserve) {
            lifecycle.transition({
                type: 'INSERTION_FAILED'
            });
            lifecycle.end('error');
            return false;
        }
        lifecycle.setOwnerDestructionEndReason('error');
        bindingRef.current = {
            contentId: contentId_1,
            lifecycle: lifecycle,
            token: lifecycle.token,
            unobserve: unobserve
        };
        return true;
    }, [
        discard,
        dropStaleBinding
    ]);
    const resolve = (0, $cozmU.useCallback)((contentId_2)=>{
        const binding_2 = consumeExactBinding(contentId_2);
        if (!binding_2?.lifecycle) return false;
        // The owner releases itself only on an accepted `INSERTED`. A rejected transition
        // (a concurrent terminal signal already moved the machine on) must not strand ownership.
        if (!binding_2.lifecycle.transition({
            type: 'INSERTED'
        })) binding_2.lifecycle.rollback();
        return true;
    }, [
        consumeExactBinding
    ]);
    (0, $cozmU.useEffect)(()=>()=>{
            const binding_3 = bindingRef.current;
            if (!binding_3) return;
            bindingRef.current = undefined;
            binding_3.unobserve();
            if (activeRef.current?.token === binding_3.token) {
                binding_3.lifecycle.transition({
                    type: 'INSERTION_FAILED'
                });
                binding_3.lifecycle.end('error');
            }
        }, []);
    const value = (0, $cozmU.useMemo)(()=>({
            defer: defer,
            discard: discard,
            resolve: resolve
        }), [
        defer,
        discard,
        resolve
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($aa52ec003d696f70$var$EditorRemixRecoveryContext.Provider, {
        value: value
    }, children);
};
module.exports["useEditorRemixRecoveryCoordinator"] = $aa52ec003d696f70$export$712696ae13ff1c32;
module.exports["EditorRemixRecoveryCoordinatorProvider"] = $aa52ec003d696f70$export$3694853de04accb3;

});

parcelRegister("g9wH6", function(module, exports) {

let $bc26d8ffb9fced4d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $bc26d8ffb9fced4d$var$load("hhss7"),
    $bc26d8ffb9fced4d$var$load("6clcf")
]).then(()=>parcelRequire('8yELO'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("d4d2J", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $dTEBe = parcelRequire("dTEBe");


var $irnO2 = parcelRequire("irnO2");


var $kDDrf = parcelRequire("kDDrf");


var $bjY3F = parcelRequire("bjY3F");


var $iBsvI = parcelRequire("iBsvI");


var $8akfd = parcelRequire("8akfd");


var $8GyO5 = parcelRequire("8GyO5");


var $aXWtB = parcelRequire("aXWtB");


var $6mKj3 = parcelRequire("6mKj3");


var $jyA9t = parcelRequire("jyA9t");


var $1AJi3 = parcelRequire("1AJi3");





var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");





var $isuYJ = parcelRequire("isuYJ");





var $aYC8J = parcelRequire("aYC8J");














var $6GT8L = parcelRequire("6GT8L");


var $kNXXO = parcelRequire("kNXXO");





var $1Pvvv = parcelRequire("1Pvvv");





var $7akNQ = parcelRequire("7akNQ");


var $4o0zT = parcelRequire("4o0zT");


var $2pQiO = parcelRequire("2pQiO");





var $anBbz = parcelRequire("anBbz");











var $60x4y = parcelRequire("60x4y");













const $bb37f8415315e332$export$48102a280783173d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    editorRemixLifecycleAdapter: undefined,
    entryPoint: undefined,
    smartCreationConfig: undefined,
    smartCreationContext: undefined,
    productConfig: undefined,
    isViewMode: undefined,
    dynamicUiType: undefined,
    setDynamicUiType: (type)=>{},
    dynamicUiSubtype: undefined,
    setDynamicUiSubtype: (subtype)=>{},
    dynamicUiSource: undefined,
    setDynamicUiSource: (source)=>{},
    conversationId: undefined,
    setConversationId: (conversationId)=>{},
    interactionSource: undefined,
    setInteractionSource: (interactionSource)=>{},
    aspectRatio: undefined,
    setAspectRatio: (aspectRatio)=>{},
    finalMessage: undefined,
    setFinalMessage: (message)=>{},
    contentClassification: undefined,
    setContentClassification: (classification)=>{},
    clearThinkingDecoration: ()=>{},
    replaceWhiteboardEmbed: ()=>false,
    setMauiEmbedFinalizeStatus: ()=>{},
    setThinkingComplete: (isComplete)=>{},
    setThinkingWaitingForInput: (isWaitingForInput)=>{},
    finishRemixThinking: ()=>{},
    showLocationPicker: false,
    setShowLocationPicker: (show)=>{},
    addHistoryEntry: (options)=>{},
    addHistoryStackEntry: (options)=>{},
    onVariantUpdateComplete: (id)=>{},
    onRemixInsertSuccess: (payload)=>{},
    onFinalizeSuccess: undefined,
    onFinalizeFailed: undefined,
    scheduleRemixRetentionCheck: undefined,
    isUpdate: undefined,
    historyEntryForUpdate: undefined,
    remixUpdateSentinelRef: {
        current: undefined
    },
    isRemixInsertingRef: {
        current: false
    },
    dynamicUiSubtypeForUpdate: undefined,
    onRemixThinkingCompleteAnimationFinished: ()=>{},
    resetContext: ()=>{}
});
const $bb37f8415315e332$export$4ea2348b19df1d27 = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($bb37f8415315e332$export$48102a280783173d);
};
const $bb37f8415315e332$export$93604a1decc87c40 = ({ editorRemixLifecycleAdapter: editorRemixLifecycleAdapter, isEditorRemixStateRearchitectureTreatment: isEditorRemixStateRearchitectureTreatment, entryPoint: entryPoint, isViewMode: isViewMode, isRemixPreviewVisible: isRemixPreviewVisible = false, clearThinkingDecoration: clearThinkingDecoration, onBeforeEditorRemixResultInsertion: onBeforeEditorRemixResultInsertion, replaceWhiteboardEmbed: replaceWhiteboardEmbed, setMauiEmbedFinalizeStatus: setMauiEmbedFinalizeStatus, setThinkingComplete: setThinkingComplete, setThinkingWaitingForInput: setThinkingWaitingForInput, finishRemixThinking: finishRemixThinking, showLocationPicker: showLocationPicker = false, setShowLocationPicker: setShowLocationPicker = ()=>{}, smartCreationConfig: smartCreationConfig, smartCreationContext: smartCreationContext, productConfig: productConfig, addHistoryEntry: addHistoryEntry, addHistoryStackEntry: addHistoryStackEntry, onVariantUpdateComplete: onVariantUpdateComplete, onSubtypeMismatch: onSubtypeMismatch, onRemixInsertSuccess: onRemixInsertSuccess, onFinalizeSuccess: onFinalizeSuccess, onFinalizeFailed: onFinalizeFailed, scheduleRemixRetentionCheck: scheduleRemixRetentionCheck, isUpdate: isUpdate, historyEntryForUpdate: historyEntryForUpdate, dynamicUiSubtypeForUpdate: dynamicUiSubtypeForUpdate, onRemixThinkingCompleteAnimationFinished: onRemixThinkingCompleteAnimationFinished, children: children })=>{
    const [dynamicUiType, setDynamicUiType] = (0, $cozmU.useState)(undefined);
    const [dynamicUiSubtype, setDynamicUiSubtype] = (0, $cozmU.useState)(undefined);
    const [dynamicUiSource, setDynamicUiSource] = (0, $cozmU.useState)(undefined);
    const [conversationId, setConversationId] = (0, $cozmU.useState)(undefined);
    const [interactionSource, setInteractionSource] = (0, $cozmU.useState)(undefined);
    const [aspectRatio, setAspectRatio] = (0, $cozmU.useState)(undefined);
    const [finalMessage, setFinalMessage] = (0, $cozmU.useState)(undefined);
    const [contentClassification, setContentClassification] = (0, $cozmU.useState)(undefined);
    const remixUpdateSentinelRef = (0, $cozmU.useRef)(undefined);
    const isRemixInsertingRef = (0, $cozmU.useRef)(false);
    const resetContext = (0, $cozmU.useCallback)(()=>{
        setDynamicUiType(undefined);
        setDynamicUiSubtype(undefined);
        setDynamicUiSource(undefined);
        setConversationId(undefined);
        setInteractionSource(undefined);
        setAspectRatio(undefined);
        setFinalMessage(undefined);
        setContentClassification(undefined);
        remixUpdateSentinelRef.current = undefined;
        isRemixInsertingRef.current = false;
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bb37f8415315e332$export$48102a280783173d.Provider, {
        value: {
            editorRemixLifecycleAdapter: editorRemixLifecycleAdapter,
            isEditorRemixStateRearchitectureTreatment: isEditorRemixStateRearchitectureTreatment,
            entryPoint: entryPoint,
            smartCreationConfig: smartCreationConfig,
            smartCreationContext: smartCreationContext,
            productConfig: productConfig,
            isViewMode: isViewMode,
            isRemixPreviewVisible: isRemixPreviewVisible,
            dynamicUiType: dynamicUiType,
            setDynamicUiType: setDynamicUiType,
            dynamicUiSubtype: dynamicUiSubtype,
            setDynamicUiSubtype: setDynamicUiSubtype,
            dynamicUiSource: dynamicUiSource,
            setDynamicUiSource: setDynamicUiSource,
            conversationId: conversationId,
            setConversationId: setConversationId,
            interactionSource: interactionSource,
            setInteractionSource: setInteractionSource,
            aspectRatio: aspectRatio,
            setAspectRatio: setAspectRatio,
            finalMessage: finalMessage,
            setFinalMessage: setFinalMessage,
            contentClassification: contentClassification,
            setContentClassification: setContentClassification,
            clearThinkingDecoration: clearThinkingDecoration,
            onBeforeEditorRemixResultInsertion: onBeforeEditorRemixResultInsertion,
            replaceWhiteboardEmbed: replaceWhiteboardEmbed,
            setMauiEmbedFinalizeStatus: setMauiEmbedFinalizeStatus,
            setThinkingComplete: setThinkingComplete,
            setThinkingWaitingForInput: setThinkingWaitingForInput,
            finishRemixThinking: finishRemixThinking,
            showLocationPicker: showLocationPicker,
            setShowLocationPicker: setShowLocationPicker,
            addHistoryEntry: addHistoryEntry,
            addHistoryStackEntry: addHistoryStackEntry,
            onVariantUpdateComplete: onVariantUpdateComplete,
            onSubtypeMismatch: onSubtypeMismatch,
            onRemixInsertSuccess: onRemixInsertSuccess,
            onFinalizeSuccess: onFinalizeSuccess,
            onFinalizeFailed: onFinalizeFailed,
            scheduleRemixRetentionCheck: scheduleRemixRetentionCheck,
            isUpdate: isUpdate,
            historyEntryForUpdate: historyEntryForUpdate,
            remixUpdateSentinelRef: remixUpdateSentinelRef,
            isRemixInsertingRef: isRemixInsertingRef,
            dynamicUiSubtypeForUpdate: dynamicUiSubtypeForUpdate,
            onRemixThinkingCompleteAnimationFinished: onRemixThinkingCompleteAnimationFinished,
            resetContext: resetContext
        }
    }, children);
};



var $gZHXx = parcelRequire("gZHXx");


var $fjeDY = parcelRequire("fjeDY");

/* LocationPickerPopup.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");





var $fngNp = parcelRequire("fngNp");


var $4n1IT = parcelRequire("4n1IT");


var $x00VQ = parcelRequire("x00VQ");









var $bxkJA = parcelRequire("bxkJA");


var $iF7Yl = parcelRequire("iF7Yl");


var $lSM29 = parcelRequire("lSM29");


var $5OXoi = parcelRequire("5OXoi");


var $6isLN = parcelRequire("6isLN");


var $5Tn11 = parcelRequire("5Tn11");


var $iL3p7 = parcelRequire("iL3p7");


var $d5NOj = parcelRequire("d5NOj");


var $4nKqn = parcelRequire("4nKqn");


var $85mU8 = parcelRequire("85mU8");


var $c7So7 = parcelRequire("c7So7");

const $d296c14a5ba7d8bb$export$1b93a9a573fc03d0 = (chatMessages)=>{
    const latestAIFCActionMessage = (0, $c7So7.findLastMessageWithAIFCAction)(chatMessages);
    return (0, $c7So7.getAIFCActionStatus)(latestAIFCActionMessage) === 'complete' && latestAIFCActionMessage?.content?.streamingComplete ? latestAIFCActionMessage : undefined;
};
const $d296c14a5ba7d8bb$export$96c1f076bacee3e3 = (message)=>(0, $bxkJA.isStreamActionClassification)(message);
const $d296c14a5ba7d8bb$export$16999efdbe112ac3 = (message)=>$d296c14a5ba7d8bb$export$96c1f076bacee3e3(message) && message.message.action_key === (0, $aYC8J.CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY);
const $d296c14a5ba7d8bb$export$54efbf7cb26887a3 = (message)=>{
    if ($d296c14a5ba7d8bb$export$16999efdbe112ac3(message)) return {
        type: 'whiteboard',
        actionClassification: message
    };
    return undefined;
};
const $d296c14a5ba7d8bb$export$b5c3d4828f4ee170 = (classification, data)=>{
    if (classification?.type === 'whiteboard' && (0, $aYC8J.isConfluenceAIFCWhiteboardCreateActionData)(data)) return {
        ...classification,
        data: data
    };
    return classification;
};
const $d296c14a5ba7d8bb$export$ce5fc05d35f87c7f = (message)=>{
    const action = message?.content?.message?.message?.actions?.[0];
    if (action?.key === (0, $aYC8J.CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY) && (0, $aYC8J.isConfluenceAIFCWhiteboardCreateActionData)(action.data)) return action.data;
    return undefined;
};
const $d296c14a5ba7d8bb$export$4364bc0cb56ef88f = ({ message: message, actionKey: actionKeyOverride })=>{
    const actionKey = actionKeyOverride || message?.content?.message?.message?.actions?.[0]?.key;
    const actionData = message?.content?.message?.message?.actions?.[0]?.data;
    switch(actionKey){
        case 0, $aYC8J.DYNAMIC_UI_CREATE_KEY:
            return actionData?.id;
        case 0, $aYC8J.CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY:
        case 0, $aYC8J.AIFC_CONFLUENCE_WHITEBOARD_DIAGRAMMING_KEY:
        case 0, $aYC8J.LEGACY_CONFLUENCE_WHITEBOARD_DIAGRAMMING_KEY:
            return actionData?.contentId;
        default:
            return undefined;
    }
};
const $d296c14a5ba7d8bb$export$4c6fb8272867c7c7 = (appId)=>{
    return `${window.location.origin}/remix/ui/${encodeURIComponent(appId)}`;
};
const $d296c14a5ba7d8bb$export$da909f2259e7fc5d = (contentId, spaceId, spaceKey)=>{
    const spaceSegment = spaceKey ?? (spaceId ? `~${spaceId}` : '~');
    return `${window.location.origin}/wiki/spaces/${spaceSegment}/whiteboard/${contentId}?isRemixDiagram=true`;
};
const $d296c14a5ba7d8bb$export$8eb2ca3c9f5828b7 = (contentId)=>{
    const url = new URL(`/wiki/spaces/_/whiteboard/${encodeURIComponent(contentId)}`, window.location.origin);
    url.searchParams.set('isRemixDiagram', 'true');
    url.searchParams.set('parentProduct', 'rovo');
    url.searchParams.set('embed', 'true');
    url.searchParams.set('hideBorder', 'true');
    url.searchParams.set('rovoReceiverId', (0, $6isLN.getConfluenceWhiteboardClientId)(contentId));
    return url.toString();
};
/**
 * Single query-param name for the base64-encoded conversation context blob.
 * `isRemixDiagram` remains a separate unencoded param for fast paste/embed
 * detection without needing to decode.
 */ const $d296c14a5ba7d8bb$var$CONVO_CONTEXT_PARAM = '_rc';
const $d296c14a5ba7d8bb$export$7c1652f26d87311f = (url, context)=>{
    const { conversationId: conversationId, messageId: messageId, invocationId: invocationId } = context;
    if (!conversationId || !messageId || !invocationId) return url;
    try {
        const urlObj = new URL(url, window.location.origin);
        const json = JSON.stringify({
            conversationId: conversationId,
            messageId: messageId,
            invocationId: invocationId
        });
        urlObj.searchParams.set($d296c14a5ba7d8bb$var$CONVO_CONTEXT_PARAM, btoa(json));
        return urlObj.toString();
    } catch  {
        return url;
    }
};
const $d296c14a5ba7d8bb$export$34709c570ec2b0fe = (remixId, actionKey, spaceId, spaceKey)=>{
    if (!remixId) return undefined;
    switch(actionKey){
        case 0, $aYC8J.DYNAMIC_UI_CREATE_KEY:
            return $d296c14a5ba7d8bb$export$4c6fb8272867c7c7(remixId);
        case 0, $aYC8J.CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY:
        case 0, $aYC8J.AIFC_CONFLUENCE_WHITEBOARD_DIAGRAMMING_KEY:
        case 0, $aYC8J.LEGACY_CONFLUENCE_WHITEBOARD_DIAGRAMMING_KEY:
            return $d296c14a5ba7d8bb$export$da909f2259e7fc5d(remixId, spaceId, spaceKey);
        default:
            return undefined;
    }
};
const $d296c14a5ba7d8bb$var$buildEmbedCardContent = (url, localId)=>{
    return [
        {
            type: 'embedCard',
            attrs: {
                url: url,
                layout: 'center',
                ...localId ? {
                    localId: localId
                } : {}
            }
        }
    ];
};
const $d296c14a5ba7d8bb$export$b27145b8437f4229 = 10000;
class $d296c14a5ba7d8bb$export$1aae99a70be32322 extends Error {
    constructor(lateResult){
        super('Editor insertion acknowledgement timed out'), this.lateResult = lateResult;
        this.name = 'EditorInsertionAcknowledgementTimeoutError';
    }
}
const $d296c14a5ba7d8bb$export$58fea9df16941043 = (invocation, { cancelOnTimeout: cancelOnTimeout = false } = {})=>{
    const lateResult = invocation.result();
    return new Promise((resolve, reject)=>{
        const timeoutId = setTimeout(()=>{
            if (cancelOnTimeout) invocation.cancel();
            reject(new $d296c14a5ba7d8bb$export$1aae99a70be32322(lateResult));
        }, $d296c14a5ba7d8bb$export$b27145b8437f4229);
        lateResult.then(resolve, reject).finally(()=>clearTimeout(timeoutId));
    });
};
const $d296c14a5ba7d8bb$export$20a274baad2c5da7 = ({ url: url, insertReceiverId: insertReceiverId, isUpdate: isUpdate, localId: localId, requireAcknowledgement: requireAcknowledgement = false, cancelOnTimeout: cancelOnTimeout = false })=>{
    if (!insertReceiverId) return;
    const insertion = (0, $85mU8.getBrowserBridgeAPI)().send((0, $d5NOj.EditorInsertContentCommand), {
        senderId: (0, $5Tn11.ROVO_CHAT_CLIENT_ID),
        receiverId: (0, $5OXoi.getConfluenceEditorClientId)(insertReceiverId),
        ...requireAcknowledgement ? {
            requireInsertionAcknowledgement: true
        } : {},
        mode: 'insert',
        placement: isUpdate && (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') ? 'replace-selection' : 'after-block',
        useStoredSelection: true,
        data: {
            type: 'text/adf',
            content: $d296c14a5ba7d8bb$var$buildEmbedCardContent(url, localId)
        }
    });
    return requireAcknowledgement ? $d296c14a5ba7d8bb$export$58fea9df16941043(insertion, {
        cancelOnTimeout: cancelOnTimeout
    }) : undefined;
};
const $d296c14a5ba7d8bb$export$46b78d980e0f6822 = ({ data: data, groupId: groupId, singleInstrumentationID: singleInstrumentationID })=>{
    if (!data?.contentId || !groupId) return;
    const receiverId = (0, $6isLN.getConfluenceWhiteboardClientId)(data.contentId);
    const bridgeAPI = (0, $85mU8.getBrowserBridgeAPI)();
    bridgeAPI.send((0, $iL3p7.ConfluenceWhiteboardCreateCommand), {
        senderId: (0, $5Tn11.ROVO_CHAT_CLIENT_ID),
        receiverId: receiverId,
        key: (0, $aYC8J.CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY),
        data: data,
        isStreamComplete: true,
        groupId: groupId,
        singleInstrumentationID: singleInstrumentationID
    });
    bridgeAPI.send((0, $4nKqn.RovoStreamCompletedCommand), {
        senderId: (0, $5Tn11.ROVO_CHAT_CLIENT_ID),
        receiverId: receiverId,
        streamId: groupId,
        contentId: data.contentId
    });
};
const $d296c14a5ba7d8bb$export$aa4d2a25d60fb7d2 = (source)=>{
    if (!source || typeof source !== 'object') return false;
    const s = source;
    return s.startLocalId === '' && s.endLocalId === '';
};
const $d296c14a5ba7d8bb$export$613faa0f449b767 = (actionKey)=>{
    switch(actionKey){
        case 0, $aYC8J.CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY:
        case 0, $aYC8J.AIFC_CONFLUENCE_WHITEBOARD_DIAGRAMMING_KEY:
        case 0, $aYC8J.LEGACY_CONFLUENCE_WHITEBOARD_DIAGRAMMING_KEY:
            return true;
        case 0, $aYC8J.DYNAMIC_UI_CREATE_KEY:
        default:
            return false;
    }
};
const $d296c14a5ba7d8bb$export$c5a9419e25b8541c = (actionKey)=>{
    switch(actionKey){
        case 0, $aYC8J.CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY:
        case 0, $aYC8J.AIFC_CONFLUENCE_WHITEBOARD_DIAGRAMMING_KEY:
        case 0, $aYC8J.LEGACY_CONFLUENCE_WHITEBOARD_DIAGRAMMING_KEY:
            return 'whiteboard';
        default:
            return undefined;
    }
};
const $d296c14a5ba7d8bb$export$a4213ba64cef4d03 = new Set([
    ...(0, $aYC8J.PAGE_CREATE_ACTIONS),
    ...(0, $aYC8J.WHITEBOARD_CREATE_ACTIONS),
    ...(0, $aYC8J.DATABASE_CREATE_ACTIONS),
    ...(0, $aYC8J.SLIDES_CREATE_ACTIONS)
]);
async function $d296c14a5ba7d8bb$export$62fb64678f4b5325({ mediaFileId: mediaFileId, clientId: clientId, product: product }) {
    const { token: token, collection: collection } = await (0, $iF7Yl.fetchMauiPersonalReadToken)(product);
    const imageUrl = (0, $aYC8J.buildImageUrl)({
        fileId: mediaFileId,
        token: token.split('Bearer ')[1],
        collection: // TODO: Consider moving into fetchMauiPersonalReadToken
        collection,
        clientId: clientId,
        isStaging: (0, $lSM29.isStaging)()
    });
    return imageUrl;
}
const $d296c14a5ba7d8bb$export$ced9470b70691a2b = (message)=>{
    const actionData = message?.content?.message?.message?.actions?.[0]?.data;
    return (0, $aYC8J.isImageCreateData)(actionData) ? actionData.mediaFileId : undefined;
};


const $70441b6598113e0c$var$triggerStyles = null;
function $70441b6598113e0c$export$378069e28d21ecbf() {
    const { entryPoint: entryPoint, conversationId: conversationId, showLocationPicker: showLocationPicker, setShowLocationPicker: setShowLocationPicker, smartCreationConfig: smartCreationConfig, smartCreationContext: smartCreationContext, finalMessage: finalMessage, resetContext: resetContext } = (0, $bb37f8415315e332$export$4ea2348b19df1d27)();
    const action = finalMessage?.content?.message?.message?.actions?.[0];
    const actionKey = action?.key;
    const spaceId = smartCreationContext?.confluence?.space?.id;
    const remixId = (0, $d296c14a5ba7d8bb$export$4364bc0cb56ef88f)({
        message: finalMessage
    });
    const remixUrl = (0, $d296c14a5ba7d8bb$export$34709c570ec2b0fe)(remixId, actionKey, spaceId);
    const currentPageId = smartCreationContext?.confluence?.content?.id;
    const insertReceiverId = currentPageId ?? smartCreationContext?.editor?.editorId; /**
                                                                                     * Called by the picker after a successful user-driven finalization.
                                                                                     * We discard the popup's baseUrl/path because the user is already in the
                                                                                     * editor — we just need to insert the embed and dismiss the modal.
                                                                                     */ 
    const handlePopupFinalizeSuccess = (0, $cozmU.useCallback)((_params)=>{
        if (remixUrl) (0, $d296c14a5ba7d8bb$export$20a274baad2c5da7)({
            url: remixUrl,
            insertReceiverId: insertReceiverId,
            isUpdate: false
        });
        resetContext();
        setShowLocationPicker(false);
    }, [
        remixUrl,
        insertReceiverId,
        setShowLocationPicker,
        resetContext
    ]);
    if (!entryPoint || !smartCreationConfig || !smartCreationContext || !finalMessage || !remixId || !remixUrl || !conversationId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
        shouldRenderToParent: true,
        isOpen: showLocationPicker,
        onClose: ()=>{
            // Picker dismissed without finalizing — close the modal, don't insert the embed.
            resetContext();
            setShowLocationPicker(false);
        },
        placement: "bottom-end",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $x00VQ.LazyConfluenceObjectFinalizePopup), {
                config: smartCreationConfig,
                contentId: remixId ?? '',
                closeModal: handlePopupFinalizeSuccess,
                closePopup: ()=>{
                    resetContext();
                    setShowLocationPicker(false);
                },
                conversationId: conversationId,
                entryPoint: entryPoint,
                context: smartCreationContext,
                selectedPreviewMessage: finalMessage
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                "data-testid": "remix-location-picker-popup-trigger",
                ...triggerProps,
                className: (0, $hekY6.default)([
                    "_1mT5xdy1CL _2IhTonxav9 _3OE6xY715P"
                ])
            }, (0, $fngNp.ZERO_WIDTH_SPACE))
    });
}



var $iCjKh = parcelRequire("iCjKh");





var $cXtTj = parcelRequire("cXtTj");











var $6IQoR = parcelRequire("6IQoR");





var $Ou0Zz = parcelRequire("Ou0Zz");











var $3TxKn = parcelRequire("3TxKn");


var $kc9aB = parcelRequire("kc9aB");

var $fC0nb = parcelRequire("fC0nb");














var $hq73c = parcelRequire("hq73c");









var $1qYXT = parcelRequire("1qYXT");

const $0aab913f0ec52dbb$export$c2603f72338ce63d = (dynamicUiSource, isNodeUnsupportedForRemix = (node)=>(0, $1qYXT.isRemixRestrictedNodeType)(node.type))=>{
    if (!dynamicUiSource) return undefined;
    const unsupportedNodeTypes = (0, $fC0nb.getTopLevelNodeTypes)(dynamicUiSource.fullAdf, dynamicUiSource.startLocalId, dynamicUiSource.endLocalId, {
        includeNode: isNodeUnsupportedForRemix
    });
    return unsupportedNodeTypes.length > 0 ? unsupportedNodeTypes : undefined;
};






var $b8Mxh = parcelRequire("b8Mxh");

const $183e1c3f08896433$export$2f469114f24ff104 = async (currentPageId)=>{
    if (!currentPageId) return undefined;
    const isFinalizeDiagramSiblingDraftKillswitchOn = // eslint-disable-next-line @atlaskit/platform/use-recommended-utils -- dynamic config killswitch, not a standard feature gate
    (0, $cXtTj.default).getExperimentValue('confluence_maui_finalize_diagram_sibling_draft', 'value', false);
    if (isFinalizeDiagramSiblingDraftKillswitchOn) return currentPageId;
    const draftSiblingParentId = await (0, $b8Mxh.resolveConfluenceDraftSiblingParent)(currentPageId, {
        distinguishRootDraft: true
    });
    return draftSiblingParentId === null ? undefined : draftSiblingParentId ?? currentPageId;
};




var $dOW9b = parcelRequire("dOW9b");

const $2edfa7d301f1bfd9$var$isFinalizePermissionError = (error)=>error.errorAttributes?.statusCode === 403;
const $2edfa7d301f1bfd9$var$isAcknowledgementTimeout = (error)=>error instanceof (0, $d296c14a5ba7d8bb$export$1aae99a70be32322);
function $2edfa7d301f1bfd9$export$d70fe66889862a96() {
    const retainedLifecycle = (0, $fjeDY.useEditorRemixLifecycleOwner)()?.active;
    const { hasMachineAuthority: hasMachineAuthority } = (0, $fjeDY.useEditorRemixLifecycle)();
    const { isViewMode: isViewMode, isUpdate: isUpdate, historyEntryForUpdate: historyEntryForUpdate, dynamicUiSubtypeForUpdate: dynamicUiSubtypeForUpdate, dynamicUiType: dynamicUiType, dynamicUiSubtype: dynamicUiSubtypeFromContext, dynamicUiSource: dynamicUiSource, productConfig: productConfig, conversationId: conversationId, interactionSource: interactionSource, aspectRatio: aspectRatio, finalMessage: finalMessage, contentClassification: contentClassification, clearThinkingDecoration: clearThinkingDecoration, onBeforeEditorRemixResultInsertion: onBeforeEditorRemixResultInsertion, replaceWhiteboardEmbed: replaceWhiteboardEmbed, setMauiEmbedFinalizeStatus: setMauiEmbedFinalizeStatus, setThinkingComplete: setThinkingComplete, finishRemixThinking: finishRemixThinking, addHistoryEntry: addHistoryEntry, addHistoryStackEntry: addHistoryStackEntry, onRemixInsertSuccess: onRemixInsertSuccess, onFinalizeSuccess: onFinalizeSuccess, onFinalizeFailed: onFinalizeFailed, scheduleRemixRetentionCheck: scheduleRemixRetentionCheck, onVariantUpdateComplete: onVariantUpdateComplete, onSubtypeMismatch: onSubtypeMismatch, smartCreationConfig: smartCreationConfig = {
        siteId: '',
        product: '',
        userId: ''
    }, smartCreationContext: smartCreationContext, resetContext: resetContext, editorRemixLifecycleAdapter: editorRemixLifecycleAdapter, isRemixInsertingRef: isRemixInsertingRef } = (0, $bb37f8415315e332$export$4ea2348b19df1d27)();
    const featureArea = (0, $iBsvI.getRemixFeatureArea)({
        remixType: dynamicUiType
    });
    const featureAreaAttributes = (0, $cozmU.useMemo)(()=>({
            ...featureArea !== undefined && {
                featureArea: featureArea
            }
        }), [
        featureArea
    ]);
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    const { sendAnalyticsEvent: sendAnalyticsEvent, trackAIMAUEvent: trackAIMAUEvent } = (0, $Ou0Zz.useAnalytics)();
    // Shadow lifecycle diagnostics carry no identifiers and must never interrupt insertion.
    const logLifecycleTelemetryBestEffort = (0, $cozmU.useCallback)((attributes)=>{
        try {
            sendAnalyticsEvent({
                eventType: 'operational',
                actionSubject: 'editorRemixLifecycleTransition',
                action: 'failed',
                actionSubjectId: attributes.operation,
                attributes: attributes
            });
        } catch  {
        // Telemetry must never interrupt insertion.
        }
    }, [
        sendAnalyticsEvent
    ]);
    const { resolveConversationAction: resolveConversationAction } = (0, $3TxKn.useChatStoreActions)();
    const { userId: clientId, siteId: siteId } = smartCreationConfig;
    const action = finalMessage?.content?.message?.message?.actions?.[0];
    const actionData = action?.data;
    const actionKey = action?.key;
    const remixId = (0, $d296c14a5ba7d8bb$export$4364bc0cb56ef88f)({
        message: finalMessage
    });
    const agentMessageId = finalMessage?.content?.message?.message?.id;
    const mediaFileId = (0, $aYC8J.isImageCreateData)(actionData) ? actionData.mediaFileId : undefined;
    const backendDynamicUiSubtype = actionData?.dynamicUiSubtype;
    const isDiagramUpdate = isUpdate && (0, $d296c14a5ba7d8bb$export$613faa0f449b767)(actionKey);
    const succeedDiagramRegenerate = (0, $cozmU.useCallback)(()=>{
        if (!isDiagramUpdate) return;
        experienceTracker.succeed({
            name: (0, $irnO2.ExperienceName).REMIX_REGENERATE,
            attributes: featureAreaAttributes
        });
    }, [
        experienceTracker,
        featureAreaAttributes,
        isDiagramUpdate
    ]);
    const failDiagramRegenerate = (0, $cozmU.useCallback)((error)=>{
        if (!isDiagramUpdate) return;
        experienceTracker.fail({
            name: (0, $irnO2.ExperienceName).REMIX_REGENERATE,
            error: error,
            attributes: featureAreaAttributes
        });
    }, [
        experienceTracker,
        featureAreaAttributes,
        isDiagramUpdate
    ]);
    // Flag a true override only: both subtypes present and different. Excludes the
    // "Pick for me" case (no user selection).
    const isSubtypeMismatch = !!dynamicUiSubtypeFromContext && !!backendDynamicUiSubtype && dynamicUiSubtypeFromContext !== backendDynamicUiSubtype;
    const isLiveDoc = smartCreationContext?.confluence?.content?.subType === 'live';
    const contentType = smartCreationContext?.confluence?.content?.type;
    const currentPageId = smartCreationContext?.confluence?.content?.id;
    const spaceId = smartCreationContext?.confluence?.space?.id;
    const spaceKey = smartCreationContext?.confluence?.space?.key;
    const remixUrl = (0, $d296c14a5ba7d8bb$export$34709c570ec2b0fe)(remixId, actionKey, spaceId, spaceKey);
    const finalWhiteboardCreateActionData = (0, $d296c14a5ba7d8bb$export$ce5fc05d35f87c7f)(finalMessage);
    // For non-Confluence products, `context.editor` provides a pre-formed containerAri
    // for the duplicate remix API call and an editorId for routing the insert command
    // to the correct editor instance.
    const smartCreationEditorContext = smartCreationContext?.editor;
    const { selectedContentAnatomy: selectedContentAnatomy, selectedContentWordCount: selectedContentWordCount, unsupportedRemixNodeTypes: unsupportedRemixNodeTypes } = (0, $cozmU.useMemo)(()=>{
        if (!dynamicUiSource) return {
            selectedContentAnatomy: undefined,
            selectedContentWordCount: undefined,
            unsupportedRemixNodeTypes: undefined
        };
        return {
            selectedContentAnatomy: (0, $fC0nb.getTopLevelNodeTypes)(dynamicUiSource.fullAdf, dynamicUiSource.startLocalId, dynamicUiSource.endLocalId),
            selectedContentWordCount: (0, $kc9aB.countFragmentWords)(dynamicUiSource.fragmentAdf ?? []),
            unsupportedRemixNodeTypes: (0, $0aab913f0ec52dbb$export$c2603f72338ce63d)(dynamicUiSource, productConfig?.isNodeUnsupportedForRemix)
        };
    }, [
        dynamicUiSource,
        productConfig?.isNodeUnsupportedForRemix
    ]);
    // The page/editor ID used to route EditorInsertContentCommand via the rovo content bridge.
    // Prefers the Confluence content ID; falls back to the editor UUID for non-Confluence products.
    const insertReceiverId = currentPageId ?? smartCreationEditorContext?.editorId;
    const shouldIncludeCwrAnalyticsUpdates = (0, $iDrrr.fg)('cwr_ai_result_analytics_updates');
    const createRemixAdoptedEvent = (0, $cozmU.useCallback)((objectId, objectType)=>{
        if (!actionKey || !objectId) return;
        return {
            type: 'adopted',
            actionKey: actionKey,
            actionResult: 'contentFinalized',
            invokedFrom: 'remix',
            messageActions: [
                actionKey
            ],
            proactive: false,
            rovoModifiedObjects: [
                {
                    objectType: objectType,
                    objectId: objectId
                }
            ],
            singleInstrumentationID: agentMessageId
        };
    }, [
        actionKey,
        agentMessageId
    ]);
    const mauiEmbedActionedEvent = (0, $cozmU.useMemo)(()=>({
            type: 'actioned',
            actionResult: 'contentFinalized',
            source: 'AIMate',
            invokedFrom: 'remix',
            proactive: false,
            userGenerated: true,
            ...shouldIncludeCwrAnalyticsUpdates && actionKey ? {
                messageActions: [
                    actionKey
                ]
            } : {},
            singleInstrumentationID: agentMessageId,
            pageContext: 'confluence-page-edit',
            attributes: {
                createdContentProduct: 'confluence',
                createdContentType: (0, $d296c14a5ba7d8bb$export$c5a9419e25b8541c)(actionKey),
                createdContentMetadata: {
                    remixId: remixId,
                    contentId: currentPageId,
                    spaceId: spaceId,
                    isLiveDoc: isLiveDoc
                },
                actionKey: actionKey,
                dynamicUiType: dynamicUiType,
                dynamicUiSubtype: dynamicUiSubtypeFromContext ?? backendDynamicUiSubtype,
                userAction: 'insert',
                ...shouldIncludeCwrAnalyticsUpdates && actionKey ? {
                    userConfirmedActions: [
                        {
                            actionKey: actionKey,
                            objectId: remixId
                        }
                    ]
                } : {}
            }
        }), [
        actionKey,
        agentMessageId,
        backendDynamicUiSubtype,
        currentPageId,
        dynamicUiSubtypeFromContext,
        dynamicUiType,
        isLiveDoc,
        remixId,
        shouldIncludeCwrAnalyticsUpdates,
        spaceId
    ]);
    const trackMauiEmbedActioned = (0, $cozmU.useCallback)(()=>{
        trackAIMAUEvent(mauiEmbedActionedEvent);
    }, [
        mauiEmbedActionedEvent,
        trackAIMAUEvent
    ]);
    const infographicActionedEvent = (0, $cozmU.useMemo)(()=>({
            type: 'actioned',
            actionResult: 'contentFinalized',
            source: 'AIMate',
            invokedFrom: 'remix',
            proactive: false,
            userGenerated: true,
            ...shouldIncludeCwrAnalyticsUpdates && actionKey ? {
                messageActions: [
                    actionKey
                ]
            } : {},
            singleInstrumentationID: agentMessageId,
            pageContext: 'confluence-page-edit',
            attributes: {
                createdContentProduct: 'confluence',
                createdContentType: 'image',
                createdContentMetadata: {
                    mediaFileId: mediaFileId,
                    isLiveDoc: isLiveDoc
                },
                actionKey: actionKey,
                dynamicUiType: dynamicUiType,
                dynamicUiSubtype: dynamicUiSubtypeFromContext ?? backendDynamicUiSubtype,
                userAction: 'insert',
                ...shouldIncludeCwrAnalyticsUpdates && actionKey ? {
                    userConfirmedActions: [
                        {
                            actionKey: actionKey,
                            objectId: mediaFileId
                        }
                    ]
                } : {}
            }
        }), [
        actionKey,
        agentMessageId,
        backendDynamicUiSubtype,
        dynamicUiSubtypeFromContext,
        dynamicUiType,
        isLiveDoc,
        mediaFileId,
        shouldIncludeCwrAnalyticsUpdates
    ]);
    const trackInfographicActioned = (0, $cozmU.useCallback)(()=>{
        trackAIMAUEvent(infographicActionedEvent);
    }, [
        infographicActionedEvent,
        trackAIMAUEvent
    ]);
    const completeRemixGeneratePreview = (0, $cozmU.useCallback)(()=>{
        if (isUpdate) return;
        (0, $irnO2.remixGeneratePreviewExperience).mark((0, $irnO2.REMIX_GENERATE_PREVIEW_MARKS).PREVIEW_VISIBLE);
        (0, $irnO2.remixGeneratePreviewExperience).success();
    }, [
        isUpdate
    ]);
    const failRemixGeneratePreview = (0, $cozmU.useCallback)((error)=>{
        if (isUpdate) return;
        (0, $irnO2.remixGeneratePreviewExperience).failure({
            metadata: {
                reason: error.message
            }
        });
    }, [
        isUpdate
    ]);
    /**
   * Calls the convo-ai action endpoint when `aifc_finalize_convo_ai` is on.
   * `onError` re-throws so callers can detect failure — without it, the chat
   * store's safe-action wrapper would silently swallow the error.
   */ const finalizeAction = (0, $cozmU.useCallback)(async ({ contentId: contentId, parentId: parentId, resolvedSpaceId: resolvedSpaceId })=>{
        if (!conversationId) return;
        // Only finalize via convo-ai for Confluence object types (pages, whiteboards,
        // databases). MAUI apps and images don't need this endpoint.
        if (!actionKey || !(0, $d296c14a5ba7d8bb$export$a4213ba64cef4d03).has(actionKey)) return;
        const message = finalMessage?.content?.message?.message;
        const messageAction = message?.actions?.[0];
        if (!message || !messageAction) return;
        const isActionComplete = finalMessage?.content.streamingComplete || messageAction?.status?.toLowerCase() === 'planned' || messageAction?.status?.toLowerCase() === 'finished';
        if (!isActionComplete) return;
        const existingData = messageAction.data ?? {};
        const existingMetadata = existingData.metadata ?? {};
        const payload = {
            context: {
                key: messageAction.key,
                invocationId: messageAction.invocationId,
                actionId: messageAction.actionId,
                displayName: messageAction.displayName,
                status: messageAction.status,
                toolSource: messageAction.toolSource,
                humanMessageId: messageAction.humanMessageId,
                confirmationMessage: messageAction.confirmationMessage,
                executedData: messageAction.executedData,
                messageId: message.id,
                resolution: {
                    type: 'confirm',
                    message: 'finalize'
                },
                data: {
                    ...existingData,
                    metadata: {
                        ...existingMetadata,
                        contentId: contentId,
                        parentId: parentId,
                        spaceId: resolvedSpaceId
                    }
                }
            }
        };
        await resolveConversationAction({
            conversationId: conversationId,
            messageId: message.id,
            payload: payload,
            actionContentProcessor: (msg)=>({
                    message: {
                        message_metadata: msg?.message_metadata
                    }
                }),
            onError: ({ error: error })=>{
                throw error;
            }
        });
    }, [
        finalMessage,
        resolveConversationAction,
        conversationId,
        actionKey
    ]);
    const clearThinkingDecorationRef = (0, $cozmU.useRef)(clearThinkingDecoration);
    (0, $cozmU.useEffect)(()=>{
        clearThinkingDecorationRef.current = clearThinkingDecoration;
    }, [
        clearThinkingDecoration
    ]);
    const replaceWhiteboardEmbedRef = (0, $cozmU.useRef)(replaceWhiteboardEmbed);
    (0, $cozmU.useEffect)(()=>{
        replaceWhiteboardEmbedRef.current = replaceWhiteboardEmbed;
    }, [
        replaceWhiteboardEmbed
    ]);
    const setMauiEmbedFinalizeStatusRef = (0, $cozmU.useRef)(setMauiEmbedFinalizeStatus);
    (0, $cozmU.useEffect)(()=>{
        setMauiEmbedFinalizeStatusRef.current = setMauiEmbedFinalizeStatus;
    }, [
        setMauiEmbedFinalizeStatus
    ]);
    // Captures the suppressed contentId so the abandoned-stream backstop can
    // release it when finalMessage (hence remixId) is null and no other id source exists.
    const streamingContentIdRef = (0, $cozmU.useRef)(undefined);
    const setThinkingCompleteRef = (0, $cozmU.useRef)(setThinkingComplete);
    (0, $cozmU.useEffect)(()=>{
        setThinkingCompleteRef.current = setThinkingComplete;
    }, [
        setThinkingComplete
    ]);
    const finishRemixThinkingRef = (0, $cozmU.useRef)(finishRemixThinking);
    (0, $cozmU.useEffect)(()=>{
        finishRemixThinkingRef.current = finishRemixThinking;
    }, [
        finishRemixThinking
    ]);
    const hasInsertedRef = (0, $cozmU.useRef)(false);
    const shouldSettleRetainedLifecycleRef = (0, $cozmU.useRef)(true);
    const hasEarlyInsertedWhiteboardRef = (0, $cozmU.useRef)(false);
    const earlyWhiteboardInsertionAcknowledgementRef = (0, $cozmU.useRef)(undefined);
    const hasDeferredWhiteboardRecoveryRef = (0, $cozmU.useRef)(false);
    const earlyInsertedWhiteboardAtRef = (0, $cozmU.useRef)(undefined);
    const earlyInsertedWhiteboardLocalIdRef = (0, $cozmU.useRef)(undefined);
    const earlyInsertedWhiteboardUrlRef = (0, $cozmU.useRef)(undefined);
    const insertEarlyStreamingWhiteboard = (0, $cozmU.useCallback)((contentId)=>{
        const earlyRemixUrl = (0, $d296c14a5ba7d8bb$export$8eb2ca3c9f5828b7)(contentId);
        const localId = crypto.randomUUID();
        hasEarlyInsertedWhiteboardRef.current = true;
        earlyInsertedWhiteboardAtRef.current = Date.now();
        earlyInsertedWhiteboardLocalIdRef.current = localId;
        earlyInsertedWhiteboardUrlRef.current = earlyRemixUrl;
        streamingContentIdRef.current = contentId;
        // Suppress before insert so the banner mounts with a known status instead of warning mid-stream.
        setMauiEmbedFinalizeStatusRef.current?.({
            contentId: contentId,
            status: 'suppressed'
        });
        const acknowledgement = (0, $d296c14a5ba7d8bb$export$20a274baad2c5da7)({
            url: earlyRemixUrl,
            insertReceiverId: insertReceiverId,
            isUpdate: isUpdate,
            localId: localId,
            ...retainedLifecycle ? {
                requireAcknowledgement: true,
                cancelOnTimeout: true
            } : {}
        });
        if (retainedLifecycle) {
            retainedLifecycle.transition({
                type: 'DIRECT_INSERTION_STARTED'
            });
            earlyWhiteboardInsertionAcknowledgementRef.current = acknowledgement ? acknowledgement.then((result)=>result?.inserted === true).catch(()=>false) : Promise.resolve(false);
        }
        // The whiteboard iframe is now the streaming surface. Hide only the editor-owned
        // generating decoration; keep the Remix flow mounted so finalMessage can still
        // trigger finalize/reparent and history recording.
        clearThinkingDecorationRef.current?.();
    }, [
        insertReceiverId,
        isUpdate,
        retainedLifecycle
    ]);
    const replaceEarlyStreamingWhiteboard = (0, $cozmU.useCallback)((contentId, finalizedUrl)=>{
        return replaceWhiteboardEmbedRef.current?.({
            contentId: contentId,
            finalizedUrl: finalizedUrl,
            localId: earlyInsertedWhiteboardLocalIdRef.current
        }) === true;
    }, []);
    const handleInsertMauiEmbedIntoPage = (0, $cozmU.useCallback)(async ()=>{
        let url = '';
        let acknowledgementTimedOut = false;
        if (!conversationId || !remixId || !remixUrl) return;
        if (retainedLifecycle && hasEarlyInsertedWhiteboardRef.current && !await earlyWhiteboardInsertionAcknowledgementRef.current) {
            streamingContentIdRef.current = undefined;
            retainedLifecycle.transition({
                type: 'INSERTION_FAILED'
            });
            return;
        }
        const shouldDelayActionedEvent = (0, $4o0zT.isExperimentEnabled)('platform_editor_maui_delay_actioned_event');
        const insertionLocalId = earlyInsertedWhiteboardLocalIdRef.current ?? crypto.randomUUID();
        let insertedContentLocalId = hasEarlyInsertedWhiteboardRef.current ? earlyInsertedWhiteboardLocalIdRef.current : undefined;
        let adoptedEvent;
        const insertRemixEmbed = async (embedUrl)=>{
            let result;
            try {
                result = await (0, $d296c14a5ba7d8bb$export$20a274baad2c5da7)({
                    url: embedUrl,
                    insertReceiverId: insertReceiverId,
                    isUpdate: isUpdate,
                    localId: insertionLocalId,
                    ...retainedLifecycle ? {
                        requireAcknowledgement: true
                    } : {}
                });
            } catch (error) {
                if (!retainedLifecycle || !$2edfa7d301f1bfd9$var$isAcknowledgementTimeout(error)) throw error;
                acknowledgementTimedOut = true;
                shouldSettleRetainedLifecycleRef.current = false;
                retainedLifecycle.end('abandoned');
                sendAnalyticsEvent({
                    eventType: 'operational',
                    actionSubject: 'editorInsertionAcknowledgement',
                    action: 'failed',
                    actionSubjectId: 'timeout',
                    attributes: {
                        contentType: 'embed',
                        reason: 'acknowledgement-timeout'
                    }
                });
                error.lateResult.then((result)=>sendAnalyticsEvent({
                        eventType: 'operational',
                        actionSubject: 'editorInsertionAcknowledgement',
                        action: 'settled',
                        attributes: {
                            contentType: 'embed',
                            outcome: result?.inserted === true ? 'insertedLate' : 'notInserted'
                        }
                    })).catch(()=>undefined);
            }
            if (retainedLifecycle && !acknowledgementTimedOut && result?.inserted !== true) throw new Error('Editor insertion was not acknowledged');
            insertedContentLocalId = insertionLocalId;
        };
        experienceTracker.start({
            name: (0, $irnO2.ExperienceName).REMIX_INSERT,
            id: (0, $irnO2.ExperienceName).REMIX_INSERT,
            attributes: {
                ...featureAreaAttributes,
                actionKey: actionKey,
                dynamicUiType: dynamicUiType,
                contentType: (0, $d296c14a5ba7d8bb$export$c5a9419e25b8541c)(actionKey),
                conversationChannelId: conversationId,
                remixCreateId: (0, $kDDrf.getActiveRemixCreateId)()
            }
        });
        if (!shouldDelayActionedEvent) trackMauiEmbedActioned();
        try {
            // For MAUI apps, duplicate the app first, then insert the duplicated URL.
            // When context.editor is set (gated by platform_editor_maui_jira_updates), use its
            // pre-formed containerAri. Otherwise build a Confluence ARI from the page ID.
            if (actionKey === (0, $aYC8J.DYNAMIC_UI_CREATE_KEY) && (currentPageId || smartCreationEditorContext)) {
                const duplicateExperienceAttributes = {
                    ...featureAreaAttributes,
                    appId: remixId,
                    currentPageId: currentPageId,
                    source: 'mauiEmbedFinalizeButtons'
                };
                experienceTracker.start({
                    name: (0, $irnO2.ExperienceName).REMIX_DUPLICATE_APP,
                    id: (0, $irnO2.ExperienceName).REMIX_DUPLICATE_APP,
                    attributes: duplicateExperienceAttributes
                });
                let duplicatedAppId;
                try {
                    const { id: newAppId } = await (0, $6IQoR.duplicateMauiApp)(remixId, smartCreationEditorContext ? {
                        containerAri: smartCreationEditorContext.containerAri
                    } : {
                        containerContentId: currentPageId ?? '',
                        cloudId: smartCreationConfig.siteId,
                        contentType: contentType
                    });
                    duplicatedAppId = newAppId;
                } catch (error) {
                    sendAnalyticsEvent({
                        eventType: 'operational',
                        actionSubject: 'mauiAppDuplicate',
                        action: 'failed',
                        actionSubjectId: 'mauiEmbedInsertIntoPage',
                        attributes: {
                            originalId: remixId
                        }
                    });
                    const duplicateError = error instanceof Error ? error : new Error('Failed to duplicate MAUI app');
                    experienceTracker.fail({
                        name: (0, $irnO2.ExperienceName).REMIX_DUPLICATE_APP,
                        error: duplicateError,
                        attributes: duplicateExperienceAttributes
                    });
                    experienceTracker.fail({
                        name: (0, $irnO2.ExperienceName).REMIX_INSERT,
                        error: duplicateError,
                        attributes: {
                            ...duplicateExperienceAttributes,
                            failedDueTo: (0, $irnO2.ExperienceName).REMIX_DUPLICATE_APP
                        }
                    });
                    // Duplication failed — insert the original URL as a fallback
                    // so the user isn't left with nothing.
                    await insertRemixEmbed(remixUrl);
                    url = remixUrl;
                    completeRemixGeneratePreview();
                }
                if (duplicatedAppId) {
                    const newAppId = duplicatedAppId;
                    sendAnalyticsEvent({
                        eventType: 'operational',
                        actionSubject: 'mauiAppDuplicate',
                        action: 'succeeded',
                        actionSubjectId: 'mauiEmbedInsertIntoPage',
                        attributes: {
                            originalId: remixId,
                            newId: newAppId
                        }
                    });
                    experienceTracker.succeed({
                        name: (0, $irnO2.ExperienceName).REMIX_DUPLICATE_APP,
                        attributes: {
                            ...duplicateExperienceAttributes,
                            newAppId: newAppId,
                            remixCreateId: (0, $kDDrf.getActiveRemixCreateId)()
                        }
                    });
                    const duplicatedUrl = (0, $d296c14a5ba7d8bb$export$4c6fb8272867c7c7)(duplicatedAppId);
                    await insertRemixEmbed(duplicatedUrl);
                    url = duplicatedUrl;
                    experienceTracker.succeed({
                        name: (0, $irnO2.ExperienceName).REMIX_INSERT,
                        attributes: {
                            ...featureAreaAttributes,
                            remixCreateId: (0, $kDDrf.getActiveRemixCreateId)()
                        }
                    });
                    completeRemixGeneratePreview();
                    adoptedEvent = shouldIncludeCwrAnalyticsUpdates ? createRemixAdoptedEvent(duplicatedAppId, 'maui-app') : undefined;
                }
                return {
                    acknowledgementTimedOut: acknowledgementTimedOut,
                    fieldId: undefined,
                    url: url
                };
            }
            if (!(0, $d296c14a5ba7d8bb$export$613faa0f449b767)(actionKey)) {
                // Fallback for MAUI apps reached without a currentPageId (the
                // duplicate flow above requires one). Insert the original URL
                // as-is.
                await insertRemixEmbed(remixUrl);
                url = remixUrl;
                try {
                    await finalizeAction({
                        contentId: remixId,
                        parentId: currentPageId,
                        resolvedSpaceId: spaceId
                    });
                } catch (error) {
                    const finalizeError = error instanceof Error ? error : new Error('finalizeAction failed');
                    experienceTracker.fail({
                        name: (0, $irnO2.ExperienceName).REMIX_INSERT,
                        error: finalizeError,
                        attributes: {
                            ...featureAreaAttributes,
                            remixCreateId: (0, $kDDrf.getActiveRemixCreateId)()
                        }
                    });
                    failRemixGeneratePreview(finalizeError);
                    return;
                }
                experienceTracker.succeed({
                    name: (0, $irnO2.ExperienceName).REMIX_INSERT,
                    attributes: {
                        ...featureAreaAttributes,
                        remixCreateId: (0, $kDDrf.getActiveRemixCreateId)()
                    }
                });
                adoptedEvent = shouldIncludeCwrAnalyticsUpdates ? createRemixAdoptedEvent(remixId, 'maui-app') : undefined;
                completeRemixGeneratePreview();
                return {
                    acknowledgementTimedOut: acknowledgementTimedOut,
                    fieldId: undefined,
                    url: url
                };
            }
            // Whiteboards must be durable before the page keeps a final embed URL. If we
            // inserted a temporary streaming URL on the first chunk, finalization still runs
            // here and then swaps that exact node to the canonical finalized URL by localId.
            //
            // Append `_rc` so the Confluence in-embed recovery picker can
            // finalize a stuck embed via the convo-ai endpoint if inline
            // finalize fails (e.g. permission error on current space).
            // Only when the killswitch is OFF; falls back to plain remixUrl.
            const finalizeAnywhereKillswitchOn = // eslint-disable-next-line @atlaskit/platform/use-recommended-utils -- dynamic config killswitch, not a standard feature gate
            (0, $cXtTj.default).getExperimentValue('maui-native-embed-finalize-diagram-anywhere', 'value', false);
            // Recovery URL used only when finalize fails. The board was NOT moved
            // server-side (it still lives in the placeholder Rovo space), so the
            // embed must point at a placeholder-space URL — NOT `remixUrl`, which
            // embeds the current space key and would make the unfinalized diagram
            // look as if it had been moved. We deliberately omit `spaceKey` here so
            // `getWhiteboardUrl` falls back to the `~{spaceId}`/`~` placeholder, and
            // append `_rc` so the in-embed recovery picker can finalize it later.
            // Only when the killswitch is OFF; otherwise the embed is left as-is.
            const placeholderWhiteboardUrl = (0, $d296c14a5ba7d8bb$export$da909f2259e7fc5d)(remixId, spaceId);
            const whiteboardUrlWithRc = !finalizeAnywhereKillswitchOn ? (0, $d296c14a5ba7d8bb$export$7c1652f26d87311f)(placeholderWhiteboardUrl, {
                conversationId: conversationId,
                messageId: agentMessageId,
                invocationId: action?.invocationId
            }) : placeholderWhiteboardUrl;
            let finalizeError;
            try {
                const parentIdForFinalize = await (0, $183e1c3f08896433$export$2f469114f24ff104)(currentPageId);
                await finalizeAction({
                    contentId: remixId,
                    parentId: parentIdForFinalize,
                    resolvedSpaceId: spaceId
                });
                onFinalizeSuccess?.({
                    contentId: remixId,
                    parentId: parentIdForFinalize
                });
            } catch (error) {
                finalizeError = error instanceof Error ? error : new Error('Failed to finalize whiteboard');
            }
            if (!finalizeError) {
                // Finalize succeeded — insert/replace with plain URL (no `_rc` needed).
                if (hasEarlyInsertedWhiteboardRef.current) {
                    // Success rewrites the URL → FINALIZED, keeping the banner hidden. Only a retained
                    // lifecycle requires the replacement to be positively acknowledged.
                    const replaced = replaceEarlyStreamingWhiteboard(remixId, remixUrl);
                    if (retainedLifecycle && !replaced) throw new Error('Finalized whiteboard replacement was not acknowledged');
                    streamingContentIdRef.current = undefined;
                } else await insertRemixEmbed(remixUrl);
                url = remixUrl;
                experienceTracker.succeed({
                    name: (0, $irnO2.ExperienceName).REMIX_INSERT,
                    attributes: {
                        remixCreateId: (0, $kDDrf.getActiveRemixCreateId)()
                    }
                });
                const reparentedContentType = (0, $d296c14a5ba7d8bb$export$c5a9419e25b8541c)(actionKey);
                if (shouldIncludeCwrAnalyticsUpdates && reparentedContentType) adoptedEvent = createRemixAdoptedEvent(remixId, reparentedContentType);
                completeRemixGeneratePreview();
                succeedDiagramRegenerate();
                return {
                    acknowledgementTimedOut: acknowledgementTimedOut,
                    fieldId: undefined,
                    url: url
                };
            }
            failDiagramRegenerate(finalizeError);
            if (hasEarlyInsertedWhiteboardRef.current) {
                // Finalize failed — swap streaming URL for the placeholder `_rc`
                // URL so the in-embed recovery picker can finalize into a writable
                // space, regardless of error type (permission or otherwise).
                // When the killswitch is ON we skip the swap and leave the stuck
                // streaming embed in place (no `_rc` recovery flow).
                if (!finalizeAnywhereKillswitchOn) {
                    const replacementAcknowledged = replaceEarlyStreamingWhiteboard(remixId, whiteboardUrlWithRc);
                    if (retainedLifecycle && !replacementAcknowledged) throw new Error('Recoverable whiteboard replacement was not acknowledged');
                    earlyInsertedWhiteboardUrlRef.current = whiteboardUrlWithRc;
                }
                if ($2edfa7d301f1bfd9$var$isFinalizePermissionError(finalizeError)) {
                    experienceTracker.succeed({
                        name: (0, $irnO2.ExperienceName).REMIX_INSERT,
                        attributes: {
                            isFinalizePermissionError: true
                        }
                    });
                    completeRemixGeneratePreview();
                } else {
                    experienceTracker.fail({
                        name: (0, $irnO2.ExperienceName).REMIX_INSERT,
                        error: finalizeError,
                        attributes: {
                            remixCreateId: (0, $kDDrf.getActiveRemixCreateId)()
                        }
                    });
                    failRemixGeneratePreview(finalizeError);
                }
            } else {
                experienceTracker.fail({
                    name: (0, $irnO2.ExperienceName).REMIX_INSERT,
                    error: finalizeError,
                    attributes: {
                        remixCreateId: (0, $kDDrf.getActiveRemixCreateId)()
                    }
                });
                failRemixGeneratePreview(finalizeError);
            }
            if (hasEarlyInsertedWhiteboardRef.current) {
                // The diagram remains inserted on the page. Hand the failure to the
                // product integration so it can open its recovery UX. For Confluence
                // this opens the shared MAUI embed space picker (the same UI used by
                // the paste / 2-minute needs-finalize banner flow), giving the user a
                // way to choose a space they can write to and finalize there.
                if (onFinalizeFailed) {
                    // Hand the picker the URL that is actually on the embed node: the
                    // placeholder-space URL carrying `_rc` (set above via
                    // replaceEarlyStreamingWhiteboard). This lets the picker (1) parse
                    // `_rc` and finalize via the convo-ai `/action` endpoint, and (2)
                    // match the node in updateUrlInDoc so the success rewrite strips
                    // `_rc` and swaps the space key. Passing `remixUrl` here would lack
                    // `_rc` (forcing the monolith `/finalize` path) and would not match
                    // the embed node.
                    const recoveryWasDeferred = onFinalizeFailed({
                        contentId: remixId,
                        originalUrl: whiteboardUrlWithRc
                    });
                    if (recoveryWasDeferred) {
                        hasDeferredWhiteboardRecoveryRef.current = true;
                        // The picker drives recovery from here; clear the streaming
                        // suppression bookkeeping so the embed's banner state isn't left
                        // stuck in a suppressed state.
                        streamingContentIdRef.current = undefined;
                    } else if (streamingContentIdRef.current) {
                        setMauiEmbedFinalizeStatusRef.current?.({
                            contentId: streamingContentIdRef.current,
                            status: 'needs-finalize'
                        });
                        streamingContentIdRef.current = undefined;
                        hasDeferredWhiteboardRecoveryRef.current = true;
                    }
                } else if (streamingContentIdRef.current) {
                    // No product recovery UX wired — fall back to the needs-finalize
                    // banner (embed is still in a Rovo system space).
                    setMauiEmbedFinalizeStatusRef.current?.({
                        contentId: streamingContentIdRef.current,
                        status: 'needs-finalize'
                    });
                    streamingContentIdRef.current = undefined;
                    hasDeferredWhiteboardRecoveryRef.current = true;
                }
                return {
                    acknowledgementTimedOut: acknowledgementTimedOut,
                    fieldId: undefined,
                    url: earlyInsertedWhiteboardUrlRef.current
                };
            }
        } catch (error) {
            const insertError = error instanceof Error ? error : new Error('Failed to insert into page');
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).REMIX_INSERT,
                error: insertError,
                attributes: featureAreaAttributes
            });
            failRemixGeneratePreview(insertError);
        } finally{
            if (!shouldDelayActionedEvent && adoptedEvent) trackAIMAUEvent(adoptedEvent);
            if (shouldDelayActionedEvent && insertedContentLocalId && insertReceiverId && scheduleRemixRetentionCheck) scheduleRemixRetentionCheck({
                adoptedAnalyticsEvent: adoptedEvent,
                analyticsEvent: mauiEmbedActionedEvent,
                identity: {
                    attribute: 'localId',
                    value: insertedContentLocalId
                },
                insertedAt: earlyInsertedWhiteboardAtRef.current,
                interactionSource: interactionSource,
                receiverId: insertReceiverId
            });
        }
    }, [
        action,
        conversationId,
        contentType,
        remixUrl,
        remixId,
        actionKey,
        onFinalizeSuccess,
        onFinalizeFailed,
        spaceId,
        agentMessageId,
        smartCreationEditorContext,
        currentPageId,
        dynamicUiType,
        featureAreaAttributes,
        insertReceiverId,
        finalizeAction,
        completeRemixGeneratePreview,
        failRemixGeneratePreview,
        failDiagramRegenerate,
        succeedDiagramRegenerate,
        experienceTracker,
        trackMauiEmbedActioned,
        mauiEmbedActionedEvent,
        createRemixAdoptedEvent,
        shouldIncludeCwrAnalyticsUpdates,
        scheduleRemixRetentionCheck,
        interactionSource,
        sendAnalyticsEvent,
        trackAIMAUEvent,
        smartCreationConfig.siteId,
        isUpdate,
        replaceEarlyStreamingWhiteboard,
        retainedLifecycle
    ]);
    const handleInsertInfographicIntoPage = (0, $cozmU.useCallback)(async ()=>{
        if (!mediaFileId || !clientId || !insertReceiverId || !siteId) return;
        const shouldDelayActionedEvent = (0, $4o0zT.isExperimentEnabled)('platform_editor_maui_delay_actioned_event');
        const adoptedEvent = shouldIncludeCwrAnalyticsUpdates ? createRemixAdoptedEvent(mediaFileId, 'image') : undefined;
        experienceTracker.start({
            name: (0, $irnO2.ExperienceName).REMIX_INSERT,
            id: (0, $irnO2.ExperienceName).REMIX_INSERT,
            attributes: {
                ...featureAreaAttributes,
                actionKey: actionKey,
                dynamicUiType: dynamicUiType,
                contentType: 'image',
                conversationChannelId: conversationId,
                remixCreateId: (0, $kDDrf.getActiveRemixCreateId)()
            }
        });
        if (!shouldDelayActionedEvent) trackInfographicActioned();
        try {
            const mediaUrl = await (0, $d296c14a5ba7d8bb$export$62fb64678f4b5325)({
                mediaFileId: mediaFileId,
                clientId: clientId,
                product: 'confluence'
            });
            const insertion = (0, $85mU8.getBrowserBridgeAPI)().send((0, $d5NOj.EditorInsertContentCommand), {
                senderId: (0, $5Tn11.ROVO_CHAT_CLIENT_ID),
                receiverId: (0, $5OXoi.getConfluenceEditorClientId)(insertReceiverId),
                ...retainedLifecycle ? {
                    requireInsertionAcknowledgement: true
                } : {},
                mode: 'upload-and-insert-media',
                placement: (0, $d296c14a5ba7d8bb$export$aa4d2a25d60fb7d2)(dynamicUiSource) ? 'end-of-doc' : isUpdate && (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') ? 'replace-selection' : 'after-block',
                useStoredSelection: true,
                conversationChannelId: conversationId,
                interactionSource: interactionSource,
                aspectRatio: aspectRatio,
                // The insert command records the subtype the backend actually produced,
                // falling back to the user's pick only if the backend returned none.
                remixSubtype: backendDynamicUiSubtype ?? dynamicUiSubtypeFromContext,
                data: {
                    type: 'image',
                    url: mediaUrl,
                    presentation: undefined
                }
            });
            let insertionResult;
            let acknowledgementTimedOut = false;
            try {
                insertionResult = retainedLifecycle ? await (0, $d296c14a5ba7d8bb$export$58fea9df16941043)(insertion) : undefined;
            } catch (error) {
                if (!retainedLifecycle || !$2edfa7d301f1bfd9$var$isAcknowledgementTimeout(error)) throw error;
                acknowledgementTimedOut = true;
                shouldSettleRetainedLifecycleRef.current = false;
                retainedLifecycle.end('abandoned');
                sendAnalyticsEvent({
                    eventType: 'operational',
                    actionSubject: 'editorInsertionAcknowledgement',
                    action: 'failed',
                    actionSubjectId: 'timeout',
                    attributes: {
                        contentType: 'image',
                        reason: 'acknowledgement-timeout'
                    }
                });
                error.lateResult.then((result)=>sendAnalyticsEvent({
                        eventType: 'operational',
                        actionSubject: 'editorInsertionAcknowledgement',
                        action: 'settled',
                        attributes: {
                            contentType: 'image',
                            outcome: result?.inserted === true ? 'insertedLate' : 'notInserted'
                        }
                    })).catch(()=>undefined);
            }
            if (retainedLifecycle && !acknowledgementTimedOut && (insertionResult?.inserted !== true || !insertionResult.mediaFileId)) throw new Error('Editor media insertion was not acknowledged');
            if (shouldDelayActionedEvent) {
                const delayedResult = insertionResult ? Promise.resolve(insertionResult) : insertion.result();
                delayedResult.then((result)=>{
                    if (result?.mediaFileId && scheduleRemixRetentionCheck) scheduleRemixRetentionCheck({
                        adoptedAnalyticsEvent: adoptedEvent,
                        analyticsEvent: infographicActionedEvent,
                        identity: {
                            attribute: 'id',
                            value: result.mediaFileId
                        },
                        interactionSource: interactionSource,
                        receiverId: insertReceiverId
                    });
                }).catch(()=>undefined);
            }
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).REMIX_INSERT,
                attributes: {
                    ...featureAreaAttributes,
                    remixCreateId: (0, $kDDrf.getActiveRemixCreateId)()
                }
            });
            if (!shouldDelayActionedEvent && adoptedEvent) trackAIMAUEvent(adoptedEvent);
            completeRemixGeneratePreview();
            return {
                acknowledgementTimedOut: acknowledgementTimedOut,
                fieldId: insertionResult?.mediaFileId ?? 'fieldId-placeholder',
                url: undefined
            };
        } catch (error) {
            const insertError = error instanceof Error ? error : new Error('Failed to insert infographic into page');
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).REMIX_INSERT,
                error: insertError,
                attributes: {
                    ...featureAreaAttributes,
                    remixCreateId: (0, $kDDrf.getActiveRemixCreateId)()
                }
            });
            failRemixGeneratePreview(insertError);
            return;
        }
    }, [
        mediaFileId,
        clientId,
        siteId,
        dynamicUiType,
        featureAreaAttributes,
        actionKey,
        experienceTracker,
        conversationId,
        dynamicUiSource,
        trackInfographicActioned,
        infographicActionedEvent,
        createRemixAdoptedEvent,
        shouldIncludeCwrAnalyticsUpdates,
        scheduleRemixRetentionCheck,
        insertReceiverId,
        dynamicUiSubtypeFromContext,
        backendDynamicUiSubtype,
        isUpdate,
        interactionSource,
        aspectRatio,
        completeRemixGeneratePreview,
        failRemixGeneratePreview,
        retainedLifecycle,
        sendAnalyticsEvent,
        trackAIMAUEvent
    ]);
    const handleInsertMauiEmbedIntoPageRef = (0, $cozmU.useRef)(handleInsertMauiEmbedIntoPage);
    (0, $cozmU.useEffect)(()=>{
        handleInsertMauiEmbedIntoPageRef.current = handleInsertMauiEmbedIntoPage;
    }, [
        handleInsertMauiEmbedIntoPage
    ]);
    const handleInsertInfographicIntoPageRef = (0, $cozmU.useRef)(handleInsertInfographicIntoPage);
    (0, $cozmU.useEffect)(()=>{
        handleInsertInfographicIntoPageRef.current = handleInsertInfographicIntoPage;
    }, [
        handleInsertInfographicIntoPage
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading')) return;
        if (isViewMode) return;
        if (hasEarlyInsertedWhiteboardRef.current) return;
        if (contentClassification?.type !== 'whiteboard' || !contentClassification.data?.contentId) return;
        if (hasMachineAuthority && !retainedLifecycle) return;
        // Insert the temporary whiteboard shell when the first real ACTION_PART arrives.
        // This avoids showing an empty whiteboard during long gaps between classification
        // and the first streamed diagram content. The same localId is later used to replace
        // this temporary URL with the finalized canonical URL, even if native-embeds has
        // transformed the Smart Link into a native whiteboard extension in the meantime.
        if (retainedLifecycle) onBeforeEditorRemixResultInsertion?.();
        insertEarlyStreamingWhiteboard(contentClassification.data.contentId);
    }, [
        contentClassification,
        insertEarlyStreamingWhiteboard,
        isViewMode,
        onBeforeEditorRemixResultInsertion,
        retainedLifecycle,
        hasMachineAuthority
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isViewMode) return;
        if (actionKey && finalMessage && !hasInsertedRef.current && (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading')) {
            if (hasMachineAuthority && !retainedLifecycle) return;
            hasInsertedRef.current = true;
            // Insertion has no reactive signal and the preview has already closed by now, so the
            // lifecycle-phase projection reported for shadow parity cannot observe it. Record it on
            // the shared ref and report it here, at the single point insertion begins.
            isRemixInsertingRef.current = true;
            editorRemixLifecycleAdapter?.observeLegacyPhase?.('inserting');
            shouldSettleRetainedLifecycleRef.current = true;
            const settleSuccessfulInsertion = ()=>{
                if (!retainedLifecycle || !shouldSettleRetainedLifecycleRef.current) return;
                if (hasEarlyInsertedWhiteboardRef.current && hasDeferredWhiteboardRecoveryRef.current) // The inserted early whiteboard remains recoverable. Keep the retained handle in
                // `inserting`; the token-bound recovery coordinator settles retry or discard.
                return;
                if (!retainedLifecycle.transition({
                    type: 'INSERTED'
                })) retainedLifecycle.rollback();
            };
            const insertContent = async ()=>{
                if (isUpdate && actionKey === (0, $aYC8J.CONFLUENCE_AIFC_WHITEBOARD_UPDATE_KEY)) {
                    // A whiteboard update streams into the already-selected board. Its completed
                    // action is the acknowledgement for that existing artifact: record the new
                    // invocation baseline without inserting, duplicating, or finalizing a board.
                    if (!historyEntryForUpdate || !historyEntryForUpdate.url && !historyEntryForUpdate.fieldId) return;
                    return {
                        acknowledgementTimedOut: false,
                        fieldId: historyEntryForUpdate.fieldId,
                        url: historyEntryForUpdate.url
                    };
                }
                if (actionKey === (0, $aYC8J.IMAGE_CREATE_KEY)) return handleInsertInfographicIntoPageRef.current();
                else {
                    const result = await handleInsertMauiEmbedIntoPageRef.current();
                    if (!result) return;
                    if (hasEarlyInsertedWhiteboardRef.current) // The ephemeral preview sends a final whiteboard bridge command with
                    // `isStreamComplete: true`; the whiteboard client uses that final signal
                    // for end-of-stream behaviours such as zoom-to-fit. Since the editor flow
                    // inserts the whiteboard outside the preview, mirror that signal here once
                    // streaming has completed, even when finalization fails and the inserted
                    // diagram remains unfinalized.
                    (0, $d296c14a5ba7d8bb$export$46b78d980e0f6822)({
                        data: finalWhiteboardCreateActionData,
                        groupId: conversationId,
                        singleInstrumentationID: agentMessageId
                    });
                    return result;
                }
            };
            if (retainedLifecycle && !hasEarlyInsertedWhiteboardRef.current) {
                onBeforeEditorRemixResultInsertion?.();
                const insertionStartAccepted = retainedLifecycle.transition({
                    type: retainedLifecycle.hasAcceptedPreview() ? 'ACCEPTED' : 'DIRECT_INSERTION_STARTED'
                });
                if (!insertionStartAccepted) {
                    shouldSettleRetainedLifecycleRef.current = false;
                    retainedLifecycle.rollback();
                    logLifecycleTelemetryBestEffort({
                        operation: 'insertionStart',
                        outcome: 'rejected',
                        contentType: actionKey === (0, $aYC8J.IMAGE_CREATE_KEY) ? 'image' : 'embed'
                    });
                }
            }
            // `INSERTED` destroys the machine session, and with it the write-authority lease that the
            // completion callback's captured sink is bound to. Completion therefore has to run before
            // the settle, or the sink declines and nothing releases the AI entry points. Deferred with
            // a flag rather than moved into the `.then` below, because `.finally` also runs after a
            // failed insertion, where settling would send `INSERTED` on top of an errored flow.
            let hasInsertionSucceeded = false;
            insertContent().then((result)=>{
                if (!result) {
                    retainedLifecycle?.transition({
                        type: 'INSERTION_FAILED'
                    });
                    return;
                }
                const isRemixToolbarEnabled = (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar');
                if (result.acknowledgementTimedOut) {
                    // The editor may have received this update, but its acknowledgement was
                    // lost. Do not record a new displayed-artifact baseline or settle the
                    // successful machine path; do release the original toolbar update so
                    // bridge processors are not suppressed indefinitely.
                    if (isUpdate && isRemixToolbarEnabled) {
                        const completionId = historyEntryForUpdate?.fieldId ?? (0, $dOW9b.getMauiIdFromUrl)(historyEntryForUpdate?.url);
                        if (completionId) onVariantUpdateComplete?.(completionId);
                    }
                    return;
                }
                // The next update suppresses the acknowledged displayed artifact, never an
                // inherited history final message. Failed and cancelled attempts do not reach
                // this point, so they cannot replace the displayed artifact baseline.
                const admissionBaselineInvocationId = (0, $hq73c.getRemixResultPayload)([
                    finalMessage
                ])?.invocationId;
                const { fieldId: fieldId, url: url } = result;
                if (!isUpdate) {
                    const requestId = finalMessage.content.metadata?.request_id;
                    onRemixInsertSuccess?.({
                        currentConversationId: conversationId,
                        requestId: requestId,
                        remixMetadata: (0, $aYC8J.getRemixMetadata)({
                            action: action,
                            selectedRemixMetadata: {
                                selectedDynamicUiType: dynamicUiType,
                                selectedDynamicUiSubtype: dynamicUiSubtypeFromContext ?? backendDynamicUiSubtype,
                                isObjectLevelRemix: !dynamicUiSource ? undefined : (0, $d296c14a5ba7d8bb$export$aa4d2a25d60fb7d2)(dynamicUiSource),
                                selectedContentAnatomy: selectedContentAnatomy,
                                selectedContentWordCount: selectedContentWordCount,
                                unsupportedRemixNodeTypes: unsupportedRemixNodeTypes,
                                interactionSource: interactionSource
                            }
                        })
                    });
                }
                if (!isRemixToolbarEnabled) {
                    hasInsertionSucceeded = true;
                    return;
                }
                if (hasEarlyInsertedWhiteboardRef.current && url) finishRemixThinkingRef.current?.();
                if (isUpdate) {
                    if (conversationId && historyEntryForUpdate?.dynamicUiType) addHistoryStackEntry?.({
                        admissionBaselineInvocationId: admissionBaselineInvocationId,
                        conversationId: conversationId,
                        dynamicUiType: historyEntryForUpdate.dynamicUiType,
                        // Preserve the backend-confirmed subtype for type-changing edits.
                        dynamicUiSubtype: backendDynamicUiSubtype ?? dynamicUiSubtypeForUpdate,
                        finalMessage: finalMessage,
                        previousFieldId: historyEntryForUpdate.fieldId,
                        previousUrl: historyEntryForUpdate.url,
                        url: url,
                        fieldId: fieldId
                    });
                    // Release the in-flight mark so the bridge processors resume
                    // handling BE pushes for this id. Must match the toolbar's
                    // tracking key: image fieldId, or MAUI app id from the
                    // *pre-update* stack-entry URL.
                    const completionId = historyEntryForUpdate?.fieldId ?? (0, $dOW9b.getMauiIdFromUrl)(historyEntryForUpdate?.url);
                    if (completionId) onVariantUpdateComplete?.(completionId);
                } else {
                    if (conversationId && dynamicUiSource && dynamicUiType) addHistoryEntry?.({
                        admissionBaselineInvocationId: admissionBaselineInvocationId,
                        conversationId: conversationId,
                        dynamicUiSource: dynamicUiSource,
                        // History and the variant picker must reflect the subtype the
                        // backend produced, falling back to the user's pick if it returned none.
                        dynamicUiSubtype: backendDynamicUiSubtype ?? dynamicUiSubtypeFromContext,
                        dynamicUiType: dynamicUiType,
                        finalMessage: finalMessage,
                        contentClassification: contentClassification?.type === 'whiteboard' ? {
                            ...contentClassification,
                            data: finalWhiteboardCreateActionData
                        } : contentClassification,
                        url: url,
                        fieldId: fieldId
                    });
                    // Via the host so the flag renders on a durable surface outliving this flow.
                    if (isSubtypeMismatch) onSubtypeMismatch?.();
                }
                hasInsertionSucceeded = true;
            }).catch((error)=>{
                retainedLifecycle?.transition({
                    type: 'INSERTION_FAILED'
                });
                if (!retainedLifecycle) throw error;
            }).finally(()=>{
                resetContext();
                // Before the settle below: see `hasInsertionSucceeded`.
                setThinkingCompleteRef.current?.(true);
                if (hasInsertionSucceeded) settleSuccessfulInsertion();
            });
        }
    }, [
        isViewMode,
        action,
        actionKey,
        finalMessage,
        resetContext,
        conversationId,
        dynamicUiType,
        dynamicUiSource,
        selectedContentAnatomy,
        selectedContentWordCount,
        unsupportedRemixNodeTypes,
        interactionSource,
        dynamicUiSubtypeFromContext,
        backendDynamicUiSubtype,
        isSubtypeMismatch,
        onSubtypeMismatch,
        contentClassification,
        finalWhiteboardCreateActionData,
        agentMessageId,
        addHistoryEntry,
        addHistoryStackEntry,
        onRemixInsertSuccess,
        onVariantUpdateComplete,
        isUpdate,
        historyEntryForUpdate?.dynamicUiType,
        dynamicUiSubtypeForUpdate,
        historyEntryForUpdate,
        retainedLifecycle,
        logLifecycleTelemetryBestEffort,
        editorRemixLifecycleAdapter,
        isRemixInsertingRef,
        onBeforeEditorRemixResultInsertion,
        hasMachineAuthority
    ]);
    // reset the hasInsertedRef when the final message is cleared
    (0, $cozmU.useEffect)(()=>{
        if (!finalMessage && (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading')) {
            hasInsertedRef.current = false;
            isRemixInsertingRef.current = false;
            shouldSettleRetainedLifecycleRef.current = true;
            hasEarlyInsertedWhiteboardRef.current = false;
            earlyWhiteboardInsertionAcknowledgementRef.current = undefined;
            hasDeferredWhiteboardRecoveryRef.current = false;
            earlyInsertedWhiteboardAtRef.current = undefined;
            earlyInsertedWhiteboardLocalIdRef.current = undefined;
            earlyInsertedWhiteboardUrlRef.current = undefined;
            // Backstop for abandoned streams: finalMessage (hence remixId) is null here,
            // so the ref is the only id source. No-op if success/failure already settled.
            if (streamingContentIdRef.current) {
                setMauiEmbedFinalizeStatusRef.current?.({
                    contentId: streamingContentIdRef.current,
                    status: 'needs-finalize'
                });
                streamingContentIdRef.current = undefined;
            }
        }
    }, [
        finalMessage,
        isRemixInsertingRef
    ]);
}












var $ieeJu = parcelRequire("ieeJu");











var $iW40i = parcelRequire("iW40i");


var $lTU4O = parcelRequire("lTU4O");


var $c5wKe = parcelRequire("c5wKe");


var $g3v8V = parcelRequire("g3v8V");















const $b16d8c0008439ca2$export$322153c0a4e9d5f = [
    {
        value: 'corporate-modern',
        label: (0, $g3v8V.default).remixVariantModernStyle,
        updateChatMessage: (0, $g3v8V.default).chatUpdateModernStyle
    },
    {
        value: 'corporate-doodle',
        label: (0, $g3v8V.default).remixVariantSketchStyle,
        updateChatMessage: (0, $g3v8V.default).chatUpdateSketchStyle
    }
];
const $b16d8c0008439ca2$export$535f851b59dd2234 = [
    {
        value: 'charlie',
        label: (0, $g3v8V.default).remixVariantBoldStyle,
        updateChatMessage: (0, $g3v8V.default).chatUpdateBoldStyle
    },
    {
        value: 'minimalist',
        label: (0, $g3v8V.default).remixVariantMinimalistStyle,
        updateChatMessage: (0, $g3v8V.default).chatUpdateMinimalistStyle
    },
    {
        value: 'corporate-doodle',
        label: (0, $g3v8V.default).remixVariantSketchStyle,
        updateChatMessage: (0, $g3v8V.default).chatUpdateSketchStyle
    }
];
function $b16d8c0008439ca2$export$8f231a371a5707c7({ useNewStyles: useNewStyles }) {
    return useNewStyles ? $b16d8c0008439ca2$export$535f851b59dd2234 : $b16d8c0008439ca2$export$322153c0a4e9d5f;
}
const $b16d8c0008439ca2$export$51da310b481fda77 = [
    {
        value: 'flip-card',
        label: (0, $g3v8V.default).remixVariantFlipCard,
        updateChatMessage: (0, $g3v8V.default).chatUpdateFlipCard
    },
    {
        value: 'quadrant',
        label: (0, $g3v8V.default).remixVariantQuadrant,
        updateChatMessage: (0, $g3v8V.default).chatUpdateQuadrant
    },
    {
        value: 'tree-map',
        label: (0, $g3v8V.default).remixVariantTreeMap,
        updateChatMessage: (0, $g3v8V.default).chatUpdateTreeMap
    },
    {
        value: 'horizontal-timeline',
        label: (0, $g3v8V.default).remixVariantTimeline,
        updateChatMessage: (0, $g3v8V.default).chatUpdateTimeline
    },
    {
        value: 'map',
        label: (0, $g3v8V.default).remixVariantGeographicalMap,
        updateChatMessage: (0, $g3v8V.default).chatUpdateGeographicalMap
    },
    {
        value: 'org-chart',
        label: (0, $g3v8V.default).remixVariantOrgChart,
        updateChatMessage: (0, $g3v8V.default).chatUpdateOrgChart
    },
    {
        value: 'gantt-chart',
        label: (0, $g3v8V.default).remixVariantGanttChart,
        updateChatMessage: (0, $g3v8V.default).chatUpdateGanttChart
    }
];
const $b16d8c0008439ca2$var$imageVariant = {
    value: 'image',
    label: (0, $g3v8V.default).remixVariantImage,
    updateChatMessage: (0, $g3v8V.default).chatUpdateImage,
    emitType: 'image'
};
function $b16d8c0008439ca2$export$2387703d47fba168({ enableImage: enableImage }) {
    return enableImage ? [
        ...$b16d8c0008439ca2$export$51da310b481fda77,
        $b16d8c0008439ca2$var$imageVariant
    ] : $b16d8c0008439ca2$export$51da310b481fda77;
}


const $41033c121bd9554e$var$staticVariantsByRemixType = {
    chart: [
        {
            value: 'line-chart',
            label: (0, $g3v8V.default).remixVariantLineChart,
            updateChatMessage: (0, $g3v8V.default).chatUpdateLineChart
        },
        {
            value: 'area-chart',
            label: (0, $g3v8V.default).remixVariantAreaChart,
            updateChatMessage: (0, $g3v8V.default).chatUpdateAreaChart
        },
        {
            value: 'bar-chart',
            label: (0, $g3v8V.default).remixVariantBarChart,
            updateChatMessage: (0, $g3v8V.default).chatUpdateBarChart
        },
        {
            value: 'funnel-chart',
            label: (0, $g3v8V.default).remixVariantFunnelChart,
            updateChatMessage: (0, $g3v8V.default).chatUpdateFunnelChart
        },
        {
            value: 'pie-chart',
            label: (0, $g3v8V.default).remixVariantPieChart,
            updateChatMessage: (0, $g3v8V.default).chatUpdatePieChart
        },
        {
            value: 'gantt-chart',
            label: (0, $g3v8V.default).remixVariantGanttChart,
            updateChatMessage: (0, $g3v8V.default).chatUpdateGanttChart
        }
    ],
    diagram: [
        {
            value: 'mindmap',
            label: (0, $g3v8V.default).remixVariantMindMap,
            updateChatMessage: (0, $g3v8V.default).chatUpdateMindMap
        },
        {
            value: 'flowchart',
            label: (0, $g3v8V.default).remixVariantFlowChart,
            updateChatMessage: (0, $g3v8V.default).chatUpdateFlowChart
        }
    ]
};
/**
 * Build a subtype-to-backend-type map.  Prefers `emitType` when set so
 * that the backend receives the correct type even when a subtype is displayed
 * under a different UI category.
 */ function $41033c121bd9554e$var$buildEmitTypeBySubtype(variantMap) {
    return Object.entries(variantMap).reduce((acc, [remixType, variants])=>{
        for (const variant of variants)acc[variant.value] = variant.emitType ?? remixType;
        return acc;
    }, {});
}
/**
 * Reverse mapping from subtype to remix type.
 * Each subtype is unique to one remix type, so we can infer the type from the subtype.
 */ function $41033c121bd9554e$var$buildRemixTypeBySubtype(variantMap) {
    return Object.entries(variantMap).reduce((acc, [remixType, variants])=>{
        for (const variant of variants)acc[variant.value] = remixType;
        return acc;
    }, {});
}
const $41033c121bd9554e$var$isThenable = (value)=>typeof value?.then === 'function';
const $41033c121bd9554e$var$resolveLifecycleContextResolution = (targetNodeId, updateSentinel)=>{
    if (!targetNodeId) return updateSentinel ? 'missingTargetNodeId' : 'missingTargetNodeIdAndUpdateSentinel';
    return updateSentinel ? 'ready' : 'missingUpdateSentinel';
};
function $41033c121bd9554e$export$a1c201a4bfffda2a() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const lifecycleOwner = (0, $fjeDY.useEditorRemixLifecycleOwner)();
    const { sendMessage: sendMessage } = (0, $c5wKe.useSmartCreationChatStoreApi)();
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    const { preferences: preferences } = (0, $lTU4O.useUserPreferences)();
    const { isUpdate: isUpdate, dynamicUiSubtypeForUpdate: dynamicUiSubtypeForUpdate, historyEntryForUpdate: historyEntryForUpdate, setFinalMessage: setFinalMessage, setConversationId: setConversationId, setContentClassification: setContentClassification, remixUpdateSentinelRef: remixUpdateSentinelRef, isViewMode: isViewMode, editorRemixLifecycleAdapter: editorRemixLifecycleAdapter } = (0, $bb37f8415315e332$export$4ea2348b19df1d27)();
    const { getMessages: getMessages } = (0, $iW40i.useChatMessagesActions)();
    const variantsByRemixType = (0, $cozmU.useMemo)(()=>({
            ...$41033c121bd9554e$var$staticVariantsByRemixType,
            infographic: (0, $b16d8c0008439ca2$export$8f231a371a5707c7)({
                useNewStyles: true
            }),
            'visual-aid': (0, $b16d8c0008439ca2$export$2387703d47fba168)({
                enableImage: true
            })
        }), []);
    const remixTypeBySubtype = (0, $cozmU.useMemo)(()=>$41033c121bd9554e$var$buildRemixTypeBySubtype(variantsByRemixType), [
        variantsByRemixType
    ]);
    const emitTypeBySubtype = (0, $cozmU.useMemo)(()=>$41033c121bd9554e$var$buildEmitTypeBySubtype(variantsByRemixType), [
        variantsByRemixType
    ]);
    const updateRemix = (0, $cozmU.useCallback)(()=>{
        if (!(0, $iDrrr.fg)('platform_editor_ai_remix_toolbar')) return;
        if (isViewMode || !isUpdate || !historyEntryForUpdate || !dynamicUiSubtypeForUpdate) return;
        const { conversationId: conversationId, dynamicUiSource: dynamicUiSource, dynamicUiSubtype: dynamicUiSubtype, dynamicUiType: dynamicUiType, finalMessage: finalMessage } = historyEntryForUpdate;
        // Read the conversation once at the update boundary. The UI dedup sentinel is the final
        // message id currently displayed, while lifecycle admission must compare the result action's
        // invocation id (whiteboard updates intentionally reuse the same contentId).
        const messages = getMessages(conversationId);
        const uiFinalMessageSentinel = (0, $dOW9b.getFinalMessageId)((0, $d296c14a5ba7d8bb$export$1b93a9a573fc03d0)(messages));
        // The live lookup is bounded by the latest HUMAN turn. After a cancelled
        // update that turn has no result, fall back only to the baseline stored for
        // the selected displayed artifact.
        const liveLifecycleInvocationSentinel = (0, $hq73c.getRemixResultPayload)(messages)?.invocationId;
        const lifecycleInvocationSentinel = liveLifecycleInvocationSentinel ?? historyEntryForUpdate.admissionBaselineInvocationId;
        const sentinelSource = liveLifecycleInvocationSentinel ? 'live-current-turn' : historyEntryForUpdate.admissionBaselineInvocationId ? 'artifact-history' : 'none';
        const remixType = (dynamicUiSubtype && remixTypeBySubtype[dynamicUiSubtype]) ?? dynamicUiType ?? 'custom';
        const remixVariants = (variantsByRemixType[remixType] ?? []).map((v)=>{
            const formattedLabel = formatMessage(v.label);
            const formattedChatUpdateMessage = formatMessage(v.updateChatMessage);
            return {
                value: v.value,
                label: formattedLabel,
                chatUpdateMessage: formattedChatUpdateMessage
            };
        });
        const selectedVariant = remixVariants.find((v)=>v.value === dynamicUiSubtypeForUpdate) ?? remixVariants[0];
        // Only extract whiteboardContentId for whiteboard actions — chart actions
        // include contentId that would otherwise wrongly trigger shouldOverrideContentId.
        const currentDisplayActionKey = finalMessage?.content?.message?.message?.actions?.[0]?.key;
        const isWhiteboardAction = currentDisplayActionKey === (0, $aYC8J.CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY) || currentDisplayActionKey === (0, $aYC8J.CONFLUENCE_AIFC_WHITEBOARD_UPDATE_KEY);
        // Start remixRegenerate experience — succeed/fail are settled by the staging-area preview components.
        const currentMediaFileId = (0, $d296c14a5ba7d8bb$export$ced9470b70691a2b)(finalMessage);
        const contentMauiId = (0, $dOW9b.getMauiIdFromUrl)(historyEntryForUpdate.url) ?? (0, $d296c14a5ba7d8bb$export$4364bc0cb56ef88f)({
            message: finalMessage,
            actionKey: (0, $aYC8J.DYNAMIC_UI_CREATE_KEY)
        });
        // CONFLUENCE_AIFC_WHITEBOARD_UPDATE_KEY has no case in getRemixIdFromPreview, use CREATE key for both.
        const whiteboardContentId = isWhiteboardAction ? (0, $d296c14a5ba7d8bb$export$4364bc0cb56ef88f)({
            message: finalMessage,
            actionKey: (0, $aYC8J.CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY)
        }) : undefined;
        const targetNodeId = contentMauiId ?? whiteboardContentId ?? currentMediaFileId;
        const artifactType = isWhiteboardAction ? 'whiteboard' : currentMediaFileId || dynamicUiType === 'image' ? 'image' : 'maui';
        const lifecycleContextResolution = $41033c121bd9554e$var$resolveLifecycleContextResolution(targetNodeId, lifecycleInvocationSentinel);
        let retainedLifecycle;
        let resolvedConversationId = conversationId;
        if (!editorRemixLifecycleAdapter || !targetNodeId) {
            if (editorRemixLifecycleAdapter) {
                const missingContextReason = lifecycleInvocationSentinel ? 'missing-target' : 'missing-target-and-sentinel';
                try {
                    editorRemixLifecycleAdapter.observeLifecycle?.({
                        actionSubjectId: 'admission',
                        producer: 'variant-update',
                        artifactType: artifactType,
                        sentinelSource: sentinelSource,
                        outcome: lifecycleOwner?.active ? 'rejected' : 'legacy',
                        reason: lifecycleOwner?.active ? 'active-flow' : missingContextReason
                    });
                } catch  {
                // Ownership observations must never affect legacy update behavior.
                }
            }
            if (lifecycleOwner?.active) // Fail closed the same way admission would have. Missing context is not a licence to run
            // a second flow: the live one still owns its terminal effects, so proceeding would both
            // run two flows at once and unfence the legacy effects the live flow owns. No request
            // goes out, so the caller has to take its thinking UI back down.
            return 'active-flow-rejected';
            // This update runs as a legacy flow, so a previous flow's machine authority must not outlive
            // it. `admitAndRetainEditorRemixLifecycle` is the only other place that clears the latch, and
            // it is skipped here, which would otherwise leave this update's legacy terminal effects fenced
            // for an owner that is not running them.
            lifecycleOwner?.forgetMachineAuthority();
        } else {
            const lifecycleRetention = (0, $fjeDY.admitAndRetainEditorRemixLifecycle)({
                adapter: editorRemixLifecycleAdapter,
                owner: lifecycleOwner,
                request: {
                    kind: 'update',
                    conversationId: conversationId,
                    targetNodeId: targetNodeId,
                    // A missing sentinel only means the latest turn has no result to suppress. Invocation ids
                    // never equal node ids, so the target suppresses nothing, as inline edits already do.
                    updateSentinel: lifecycleInvocationSentinel ?? targetNodeId,
                    messageCountBeforeSend: messages?.length ?? 0,
                    observation: {
                        producer: 'variant-update',
                        artifactType: artifactType,
                        sentinelSource: sentinelSource
                    }
                }
            });
            if (lifecycleRetention.status === 'active-flow-rejected') // No request goes out, so the caller has to take its thinking UI back down.
            return 'active-flow-rejected';
            if (lifecycleRetention.status === 'retained') {
                retainedLifecycle = lifecycleRetention.lifecycle;
                resolvedConversationId = retainedLifecycle.conversationId;
            }
        }
        remixUpdateSentinelRef.current = uiFinalMessageSentinel;
        setFinalMessage(undefined);
        setConversationId(resolvedConversationId);
        if ((0, $iDrrr.fg)('platform_maui_stream_on_subtype_change')) setContentClassification(undefined);
        const editExperienceId = targetNodeId ?? 'unknown';
        experienceTracker.start({
            name: (0, $irnO2.ExperienceName).REMIX_REGENERATE,
            id: editExperienceId,
            attributes: {
                appId: contentMauiId,
                contentMauiId: contentMauiId,
                mediaFileId: currentMediaFileId,
                whiteboardContentId: whiteboardContentId,
                remixType: dynamicUiType,
                remixSubtype: dynamicUiSubtypeForUpdate ?? dynamicUiSubtype,
                hasSubtypeChange: dynamicUiSubtype !== (dynamicUiSubtypeForUpdate ?? dynamicUiSubtype),
                conversationChannelId: resolvedConversationId,
                editSource: 'typeSwitcher',
                ...editorRemixLifecycleAdapter ? {
                    lifecycleContextResolution: lifecycleContextResolution
                } : {}
            }
        });
        // if there's a whiteboard contentId, we need to override the contentId to be
        // the existing whiteboard contentId to be able to update it.
        // we don't do this though if the subtype is set because for changing subtypes, we
        // want a new whiteboard creation instead of updating existing board
        const shouldOverrideContentId = whiteboardContentId && !dynamicUiSubtypeForUpdate;
        // Omit mediaFileId for infographic style updates (marked by subtype being defined)
        const mediaFileId = dynamicUiSubtypeForUpdate === undefined ? (0, $d296c14a5ba7d8bb$export$ced9470b70691a2b)(finalMessage) : undefined;
        const resolvedUiType = shouldOverrideContentId ? undefined : dynamicUiSubtypeForUpdate ? emitTypeBySubtype[dynamicUiSubtypeForUpdate] : dynamicUiType;
        const isCustom = resolvedUiType === 'custom';
        const experience = resolvedUiType ? isCustom ? 'remix_custom' : 'remix_edit' : undefined;
        const isRemixExperienceContextEnabled = (0, $ieeJu.expValEquals)('rovo_remix_experience_context', 'isEnabled', true);
        const prompt = {
            type: 'doc',
            version: 1,
            content: [
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'text',
                            text: selectedVariant?.chatUpdateMessage
                        }
                    ]
                }
            ]
        };
        const additionalAnalyticAttributes = dynamicUiSubtype ? {
            remixVariantBefore: dynamicUiSubtype,
            remixVariantAfter: dynamicUiSubtypeForUpdate ?? dynamicUiSubtype,
            remixVariantChanged: dynamicUiSubtype !== (dynamicUiSubtypeForUpdate ?? dynamicUiSubtype)
        } : undefined;
        const rollbackLifecycle = ()=>{
            retainedLifecycle?.rollback();
        };
        const acceptsRetainedStreamCallback = ()=>!retainedLifecycle || (retainedLifecycle.isCurrent?.() ?? true);
        try {
            const sendResult = sendMessage({
                prompt: prompt,
                storeUserMessages: preferences.storeUserMessages,
                conversationId: resolvedConversationId,
                messageSources: {
                    interactionSource: 'editor',
                    // Use the same source for follow-ups: Remix doesn't have a separate follow-up entry point, but the "viewed" AIMAU analytics event uses `followUpSource`.
                    followUpSource: 'editor'
                },
                additionalAnalyticAttributes: additionalAnalyticAttributes,
                productKey: 'confluence',
                contentContext: 'global',
                minionAlias: 'remix-content',
                skipEditorContext: true,
                promptStreamHook: (0, $iDrrr.fg)('platform_maui_stream_on_subtype_change') ? {
                    onActionClassification: async (actionClassification)=>{
                        if (!acceptsRetainedStreamCallback()) return;
                        setContentClassification((0, $d296c14a5ba7d8bb$export$54efbf7cb26887a3)(actionClassification));
                    },
                    onActionPart: async (actionPart)=>{
                        if (!acceptsRetainedStreamCallback()) return;
                        if (actionPart.type === 'ACTION_PART' && actionPart.message.key === (0, $aYC8J.CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY)) setContentClassification((classification)=>(0, $d296c14a5ba7d8bb$export$b5c3d4828f4ee170)(classification, actionPart.message.data));
                    }
                } : undefined,
                creationContextParams: {
                    source: 'remix',
                    ...isRemixExperienceContextEnabled && experience ? {
                        experience: experience
                    } : {},
                    ...isRemixExperienceContextEnabled && !isCustom && resolvedUiType ? {
                        blocks: [
                            resolvedUiType
                        ]
                    } : {},
                    contentMauiId: contentMauiId,
                    dynamicUiType: resolvedUiType,
                    dynamicUiSubtype: dynamicUiSubtypeForUpdate ?? dynamicUiSubtype,
                    dynamicUiSource: dynamicUiSource,
                    mediaFileId: // TODO check if this is correct
                    mediaFileId,
                    ...shouldOverrideContentId ? {
                        isViewMode: false
                    } : isViewMode ? {
                        isViewMode: true
                    } : {}
                },
                contentId: shouldOverrideContentId ? whiteboardContentId : undefined
            });
            if (retainedLifecycle && $41033c121bd9554e$var$isThenable(sendResult)) Promise.resolve(sendResult).catch(rollbackLifecycle);
        } catch (error) {
            rollbackLifecycle();
            throw error;
        }
        return retainedLifecycle ? {
            status: 'retained',
            lifecycle: {
                remixId: retainedLifecycle.remixId,
                token: retainedLifecycle.token
            }
        } : undefined;
    }, [
        setConversationId,
        setContentClassification,
        variantsByRemixType,
        isViewMode,
        formatMessage,
        emitTypeBySubtype,
        sendMessage,
        preferences.storeUserMessages,
        remixTypeBySubtype,
        experienceTracker,
        setFinalMessage,
        isUpdate,
        historyEntryForUpdate,
        dynamicUiSubtypeForUpdate,
        getMessages,
        remixUpdateSentinelRef,
        editorRemixLifecycleAdapter,
        lifecycleOwner
    ]);
    return {
        updateRemix: updateRemix
    };
}






var $jTt8P = parcelRequire("jTt8P");


var $4Aqqh = parcelRequire("4Aqqh");











var $hdBxM = parcelRequire("hdBxM");





var $i7OAD = parcelRequire("i7OAD");

















var $gzMZq = parcelRequire("gzMZq");


var $igOtY = parcelRequire("igOtY");











var $kuGC4 = parcelRequire("kuGC4");




var $042Lk = parcelRequire("042Lk");








var $loej8 = parcelRequire("loej8");



var $6viot = parcelRequire("6viot");






/**
 * Filters an ADF fragment (array of JSONNode) by recursively removing nodes
 * whose type is in the Remix deny list at every level of the tree.
 * Returns null when given null.
 *
 * Uses the adf-utils `traverse` helper which drops nodes when a visitor
 * returns `false` and automatically rebuilds content arrays.
 */ /**
 * Extracts frame titles from a multiBodiedExtension's parameters.
 *
 * Searches for any array property in `parameters` whose length matches the
 * frame count and whose items have a `title` field. This avoids hard-coding
 * macro-specific parameter names (e.g. `tabs`) so it scales to any MBE
 * variant that stores per-frame titles in its parameters.
 */ const $084a36b9faaabd0a$var$extractFrameTitles = (node, frameCount)=>{
    const attrs = node.attrs;
    const parameters = attrs?.parameters;
    if (!parameters) return undefined;
    for (const value of Object.values(parameters)){
        if (Array.isArray(value) && value.length === frameCount && value.some((item)=>typeof item === 'object' && item !== null && 'title' in item)) return value.map((item)=>item.title);
    }
    return undefined;
};
/**
 * Unwraps a multiBodiedExtension node, extracting inner content from each
 * extensionFrame so the AI receives clean ADF (paragraphs, lists, etc.)
 * instead of extension wrapper types it cannot process.
 *
 * When frame titles are available in the node's parameters, a heading is
 * injected before each frame's content so the AI preserves the logical
 * grouping rather than treating everything as one flat list.
 */ const $084a36b9faaabd0a$var$unwrapMultiBodiedExtension = (node, result, isNodeUnsupported)=>{
    const frames = (node.content ?? []).filter((frame)=>frame?.type === 'extensionFrame' && Array.isArray(frame?.content));
    const frameTitles = $084a36b9faaabd0a$var$extractFrameTitles(node, frames.length);
    frames.forEach((frame, index)=>{
        const title = frameTitles?.[index];
        if (title) result.push({
            type: 'heading',
            attrs: {
                level: 2
            },
            content: [
                {
                    type: 'text',
                    text: title
                }
            ]
        });
        for (const child of frame.content){
            const filtered = (0, $jTt8P.traverse)(child, {
                any: (adfNode)=>{
                    if (isNodeUnsupported(adfNode)) return false;
                }
            });
            if (filtered !== false) result.push(filtered);
        }
    });
};
const $084a36b9faaabd0a$var$defaultIsNodeUnsupportedForRemix = (node)=>(0, $1qYXT.isRemixRestrictedNodeType)(node.type);
const $084a36b9faaabd0a$export$cee0b7c2921c06e1 = (nodes, isNodeUnsupported = $084a36b9faaabd0a$var$defaultIsNodeUnsupportedForRemix)=>{
    if (nodes === null) return null;
    const result = [];
    for (const node of nodes){
        if (node.type === 'multiBodiedExtension' && Array.isArray(node.content)) {
            $084a36b9faaabd0a$var$unwrapMultiBodiedExtension(node, result, isNodeUnsupported);
            continue;
        }
        const filtered = (0, $jTt8P.traverse)(node, {
            any: (adfNode)=>{
                if (isNodeUnsupported(adfNode)) return false;
            }
        });
        if (filtered !== false) result.push(filtered);
    }
    return result;
};
const $084a36b9faaabd0a$export$d6cdcf2c2885fa31 = (nodes, isNodeUnsupported)=>{
    if ((0, $4o0zT.isExperimentEnabled)('cc_maui_polish_changes_batch_6')) {
        if (nodes === null) return null;
        const sanitizedNodes = nodes.flatMap((node)=>{
            // The sanitizer can remove an invalid root node at runtime even though its legacy return
            // type only exposes JSONNode.
            const sanitizedNode = (0, $4Aqqh.sanitizeNode)(node, {
                keepNestedTables: true
            });
            return sanitizedNode === false ? [] : [
                sanitizedNode
            ];
        });
        return $084a36b9faaabd0a$export$cee0b7c2921c06e1(sanitizedNodes, isNodeUnsupported);
    }
    return $084a36b9faaabd0a$export$cee0b7c2921c06e1(nodes, isNodeUnsupported);
};
const $084a36b9faaabd0a$var$isActionComplete = (chatMessages, isEditorRemixStateRearchitectureTreatment)=>{
    // Scan backwards to find completion signals in the latest turn.
    // If we encounter a HUMAN message first, that marks a turn boundary —
    // any completion signal before it belongs to a previous turn.
    let hasActionCompleteStep = false;
    let hasPlannedAIFCAction = false;
    for(let i = chatMessages.length - 1; i >= 0; i--){
        const message = chatMessages[i];
        if (message.type === 'ACTION_COMPLETE') {
            hasActionCompleteStep = true;
            break;
        }
        if (isEditorRemixStateRearchitectureTreatment && (0, $igOtY.isStoreAssistant)(message)) {
            const actions = message.content?.message?.message?.actions ?? [];
            if (actions.some((action)=>(0, $i7OAD.isAIFCAction)(action) && action.status === 'planned')) {
                hasPlannedAIFCAction = true;
                break;
            }
        }
        if ((0, $igOtY.isStoreHuman)(message)) break;
    }
    if (!isEditorRemixStateRearchitectureTreatment) {
        const lastPlannedAIFCAction = (0, $kNXXO.findLastAssistantAction)(chatMessages, (action)=>(0, $i7OAD.isAIFCAction)(action) && action.status === 'planned');
        return hasActionCompleteStep || lastPlannedAIFCAction !== undefined;
    }
    return hasActionCompleteStep || hasPlannedAIFCAction;
};
const $084a36b9faaabd0a$var$isWhiteboardCreateOrUpdateKey = (key)=>key === (0, $aYC8J.CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY) || key === (0, $aYC8J.CONFLUENCE_AIFC_WHITEBOARD_UPDATE_KEY);
const $084a36b9faaabd0a$var$shouldUseEphemeralPreviewForAction = (action)=>(0, $aYC8J.isRemixGeneratedFlow)(action);
// When free-text remix produces a whiteboard (isRemixGenerated=true, no dynamicUiSubtype),
// open the full AIFC staging modal rather than inserting a URL into the page.
const $084a36b9faaabd0a$var$shouldUseAifcStagingAreaForAction = (action)=>{
    if (!(0, $aYC8J.isRemixGeneratedFlow)(action)) return false;
    return $084a36b9faaabd0a$var$isWhiteboardCreateOrUpdateKey(action.key) && !action.data?.dynamicUiSubtype;
};
const $084a36b9faaabd0a$var$defaultShouldUseEphemeralPreview = (chatMessages)=>{
    for(let i = chatMessages.length - 1; i >= 0; i--){
        const message = chatMessages[i];
        if (message.type === 'ACTION_PREPARE') return message.action ? $084a36b9faaabd0a$var$shouldUseEphemeralPreviewForAction(message.action) : false;
    }
    return false;
};
const $084a36b9faaabd0a$export$cca9e2432f59b3f8 = ({ config: config, onActionReady: onActionReady, productIntegration: productIntegration, onStagingAIFCFlowStarted: onStagingAIFCFlowStarted, onStagingPreviewOpened: onStagingPreviewOpened })=>{
    const { isUpdate: isUpdate, conversationId: conversationId, isEditorRemixStateRearchitectureTreatment: isEditorRemixStateRearchitectureTreatment, setConversationId: setConversationId, setFinalMessage: setFinalMessage, setContentClassification: setContentClassification, remixUpdateSentinelRef: remixUpdateSentinelRef, dynamicUiType: dynamicUiType, smartCreationContext: smartCreationContext } = (0, $bb37f8415315e332$export$4ea2348b19df1d27)();
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    const { sendMessage: sendMessage, createConversationOptimistically: createConversationOptimistically, abortRequests: abortRequests, activeConversation: activeConversation, setSelectedConversation: setSelectedConversation } = (0, $c5wKe.useSmartCreationChatStoreApi)();
    const { setPrompt: setPrompt, setDynamicUiContext: setDynamicUiContext, setUserSelectedDynamicUiSubtype: setUserSelectedDynamicUiSubtype, setForceSkipAutoConversationSelection: setForceSkipAutoConversationSelection } = (0, $8akfd.useStagingAreaActions)();
    const { preferences: preferences } = (0, $lTU4O.useUserPreferences)();
    const [editorContext] = (0, $gzMZq.useChatContextEditorContext)();
    const editorContextRef = (0, $cozmU.useRef)(editorContext);
    editorContextRef.current = editorContext;
    const hasEditablePageContext = editorContext !== undefined && editorContext.isViewMode !== true;
    // remove local state when cleanup platform_editor_ai_remix_in_editor_loading
    const [remixConversationId, setRemixConversationId] = (0, $cozmU.useState)(undefined);
    const activeRemixConversation = activeConversation?.id && activeConversation.id === remixConversationId ? activeConversation : null;
    const remixConversationById = (0, $kuGC4.useConversationById)({
        conversationId: conversationId ?? ''
    });
    const remixConversation = (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') ? remixConversationById : activeRemixConversation;
    const remixConversationIdToRead = (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') ? conversationId : activeRemixConversation?.id;
    const [chatMessages] = (0, $iW40i.useChatMessages)({
        conversationId: remixConversationIdToRead ?? ''
    });
    const isDisambiguationEnabled = (0, $iDrrr.fg)('platform_editor_ai_remix_disambiguation');
    const [confirmedAskQuestion, setConfirmedAskQuestion] = (0, $cozmU.useState)();
    (0, $hdBxM.useSubscribe)({
        topic: 'ai-mate-chat-input-overlay'
    }, (payload)=>{
        if (!isDisambiguationEnabled || payload.type !== 'task-ask-question-confirmed') return;
        const { conversationId: confirmedConversationId, invocationId: invocationId } = payload.data;
        if (confirmedConversationId === remixConversationIdToRead) setConfirmedAskQuestion({
            conversationId: confirmedConversationId,
            invocationId: invocationId
        });
    });
    const isCustomOnlyPromptRef = (0, $cozmU.useRef)(false);
    let finalMessage = (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') ? (0, $d296c14a5ba7d8bb$export$1b93a9a573fc03d0)(chatMessages) : undefined;
    // If it's an update, suppress the previously-displayed result until the new
    // variant response arrives. The sentinel is the id of the final message that
    // was on the page when the update was initiated, captured live in
    // useUpdateRemix — stored remix-history ids can be stale (e.g. a BE-driven Ask
    // Rovo edit inherits the prior entry's id rather than its own message id).
    const currentFinalMessageId = (0, $dOW9b.getFinalMessageId)(finalMessage);
    const previousFinalMessageId = remixUpdateSentinelRef.current;
    if (isUpdate && previousFinalMessageId && previousFinalMessageId === currentFinalMessageId && (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar')) finalMessage = undefined;
    const remixStoreError = chatMessages.find((message)=>(0, $igOtY.isStoreError)(message)) ?? null;
    const isRemixError = remixConversation?.status === (0, $igOtY.CHAT_STORE_STATUS).deactivatedAgentError || remixStoreError !== null;
    const hasAssistantResponse = chatMessages.some((0, $igOtY.isStoreAssistant));
    const isCustomOnlyRovoChatEnabled = (0, $4o0zT.isExperimentEnabled)('cc_maui_polish_changes_batch_5');
    const isCustomOnlyPromptComplete = isCustomOnlyRovoChatEnabled && isCustomOnlyPromptRef.current && remixConversation?.status === (0, $igOtY.CHAT_STORE_STATUS).idle && hasAssistantResponse;
    const hasAskQuestionAction = isDisambiguationEnabled && (0, $042Lk.lastAssistantHasAskQuestionAction)(chatMessages);
    const askQuestionAction = hasAskQuestionAction ? (0, $kNXXO.findLastAssistantAction)(chatMessages, (action)=>action.key === 'ask_question') : undefined;
    const hasPendingAskQuestionAction = askQuestionAction !== undefined && askQuestionAction.status !== 'finished' && askQuestionAction.status !== 'cancelled' && askQuestionAction.status !== 'errored';
    const hasConfirmedCurrentQuestion = confirmedAskQuestion?.conversationId === remixConversationIdToRead && confirmedAskQuestion?.invocationId === askQuestionAction?.invocationId;
    const isWaitingForInput = hasPendingAskQuestionAction && !hasConfirmedCurrentQuestion;
    const isLatestTurnActionComplete = $084a36b9faaabd0a$var$isActionComplete(chatMessages, isEditorRemixStateRearchitectureTreatment);
    const isRemixAborted = !isRemixError && !isCustomOnlyPromptComplete && !hasPendingAskQuestionAction && remixConversation?.status === (0, $igOtY.CHAT_STORE_STATUS).idle && !isLatestTurnActionComplete && hasAssistantResponse;
    // Set on a (non-fatal) safety/AUP violation. It looks like a completed
    // action here, so isRemixError/isRemixAborted miss it — this flag lets the component
    // dismiss the thinking bar and open the Rovo side chat.
    const [isRemixSafetyViolation, setIsRemixSafetyViolation] = (0, $cozmU.useState)(false);
    const actionReadyFired = (0, $cozmU.useRef)(false);
    const hasOpenedFullStagingModalRef = (0, $cozmU.useRef)(false);
    const recordedFinalMessageId = (0, $cozmU.useRef)(undefined);
    const recordedFinalMessage = (0, $cozmU.useRef)(undefined);
    const previousConversationId = (0, $cozmU.useRef)(remixConversationIdToRead);
    (0, $cozmU.useEffect)(()=>{
        if (previousConversationId.current !== remixConversationIdToRead) {
            actionReadyFired.current = false;
            hasOpenedFullStagingModalRef.current = false;
            recordedFinalMessageId.current = undefined;
            recordedFinalMessage.current = undefined;
            previousConversationId.current = remixConversationIdToRead;
            setIsRemixSafetyViolation(false);
            if ((0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading')) setFinalMessage(undefined);
        }
    }, [
        remixConversationIdToRead,
        setFinalMessage
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (actionReadyFired.current || !onActionReady) return;
        const isConfiguredActionReady = config.isActionReady?.(chatMessages);
        const effectiveActionReady = isConfiguredActionReady ?? isLatestTurnActionComplete;
        const shouldOpenRovoChat = isCustomOnlyPromptComplete && !effectiveActionReady;
        const isActionReady = shouldOpenRovoChat || effectiveActionReady;
        if (isActionReady) {
            actionReadyFired.current = true;
            onActionReady({
                shouldOpenRovoChat: shouldOpenRovoChat
            });
        }
    }, [
        config,
        chatMessages,
        isCustomOnlyPromptComplete,
        isLatestTurnActionComplete,
        onActionReady,
        remixConversation?.status,
        remixConversationIdToRead
    ]);
    (0, $cozmU.useEffect)(()=>{
        const finalMessageId = (0, $dOW9b.getFinalMessageId)(finalMessage);
        const hasRecordedFinalMessage = finalMessageId !== undefined ? recordedFinalMessageId.current === finalMessageId : recordedFinalMessage.current === finalMessage;
        if (finalMessage && !hasRecordedFinalMessage && !hasOpenedFullStagingModalRef.current && (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading')) {
            recordedFinalMessageId.current = finalMessageId;
            recordedFinalMessage.current = finalMessage;
            setFinalMessage(finalMessage);
            const featureArea = (0, $iBsvI.getRemixFeatureArea)({
                remixType: dynamicUiType
            });
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).REMIX_START,
                attributes: {
                    ...featureArea !== undefined && {
                        featureArea: featureArea
                    }
                }
            });
        }
    }, [
        finalMessage,
        setFinalMessage,
        experienceTracker,
        dynamicUiType
    ]);
    const stopRemixing = (0, $cozmU.useCallback)(()=>{
        abortRequests?.({
            conversationId: remixConversationIdToRead
        });
    }, [
        abortRequests,
        remixConversationIdToRead
    ]);
    // Despite the name, this opens the appropriate AIFC surface for the generated output:
    // remix-generated outputs use the floating ephemeral preview, while non-remix AIFC
    // object outputs (page, database, whiteboard, slides, etc.) use the full staging modal.
    const openRemixPreview = (0, $cozmU.useCallback)((options)=>{
        setForceSkipAutoConversationSelection(true);
        let shouldUseEphemeralPreview;
        if (options?.action) shouldUseEphemeralPreview = !$084a36b9faaabd0a$var$shouldUseAifcStagingAreaForAction(options.action) && $084a36b9faaabd0a$var$shouldUseEphemeralPreviewForAction(options.action);
        else shouldUseEphemeralPreview = config.shouldUseEphemeralPreview?.(chatMessages) ?? $084a36b9faaabd0a$var$defaultShouldUseEphemeralPreview(chatMessages);
        productIntegration.openRemixPreview({
            isFloating: shouldUseEphemeralPreview,
            remixConversationId: options?.remixConversationId ?? remixConversationIdToRead,
            ...options?.onOpen ? {
                onOpen: options.onOpen
            } : {},
            ...options?.onSubmit ? {
                onSubmit: options.onSubmit
            } : {},
            // Forward the capability object untouched so a future member cannot be dropped here.
            ...options?.editorInsertionAcknowledgement ? {
                editorInsertionAcknowledgement: options.editorInsertionAcknowledgement
            } : {},
            ...options?.onDismiss ? {
                onDismiss: options.onDismiss
            } : {}
        });
    }, [
        config,
        chatMessages,
        productIntegration,
        remixConversationIdToRead,
        setForceSkipAutoConversationSelection
    ]);
    const sendAIFCPrompt = (0, $cozmU.useCallback)(async ({ userPrompt: userPrompt, promptText: promptTextOverride, dynamicUiSubtype: dynamicUiSubtype, dynamicUiType: dynamicUiType, dynamicUiSource: dynamicUiSource, interactionSource: interactionSource, aspectRatio: aspectRatio, aiFeatureName: aiFeatureName, isMediaInsertFlow: isMediaInsertFlow, conversationId: reuseConversationId, lifecycleConversationId: lifecycleConversationId })=>{
        isCustomOnlyPromptRef.current = isCustomOnlyRovoChatEnabled && dynamicUiType === 'custom' && !dynamicUiSubtype && !!userPrompt?.trim();
        const defaultPromptText = 'Remix the selected content';
        const selectedDisplayName = dynamicUiSubtype ? (0, $loej8.getSubTypeDisplayName)(dynamicUiSubtype) : (0, $loej8.getTypeDisplayName)(dynamicUiType);
        const autoText = `Remix the selected content as a ${selectedDisplayName}`;
        const promptText = promptTextOverride ? promptTextOverride : dynamicUiType === 'custom' || dynamicUiType === 'image' && userPrompt && isMediaInsertFlow ? userPrompt ?? defaultPromptText : userPrompt ? `${autoText}. ${userPrompt}` : autoText;
        const prompt = {
            type: 'doc',
            version: 1,
            content: [
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'text',
                            text: promptText
                        }
                    ]
                }
            ]
        };
        const newConversationId = reuseConversationId ?? lifecycleConversationId ?? crypto.randomUUID();
        setRemixConversationId(newConversationId);
        if ((0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading')) {
            setConversationId(newConversationId);
            setFinalMessage(undefined);
            setContentClassification(undefined);
        }
        actionReadyFired.current = false;
        if (!reuseConversationId) await createConversationOptimistically({
            id: newConversationId
        });
        else if ((0, $2pQiO.UNSAFE_expValNoExposure)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'control') === 'variant2') setSelectedConversation({
            conversationId: reuseConversationId
        });
        (0, $kDDrf.trackRemixCreateOptionSelected)({
            experienceTracker: experienceTracker,
            conversationId: newConversationId,
            remixType: dynamicUiType,
            remixSubtype: dynamicUiSubtype,
            includesFreegenPrompt: !!userPrompt
        });
        // 'custom' is a free-form prompt with no block type. Eligible editor page
        // selections map to REMIX_CUSTOM_EDIT; remaining custom requests map to
        // REMIX_CUSTOM. Everything else (chart/diagram/visual-aid/infographic/etc.) is
        // REMIX with the block type as `blocks`. The backend ConfluenceExperienceValidator
        // rejects REMIX without `blocks`, and rejects custom Remix experiences with `blocks`.
        const isCustom = dynamicUiType === 'custom';
        const sourceContentId = smartCreationContext?.confluence?.content?.id;
        const { dynamicUiSource: dynamicUiSourceToSend, editorContextFallback: editorContextFallback, experienceParams: customPageEditExperienceParams } = (0, $6viot.getCustomPageEditRequestParams)({
            dynamicUiSource: dynamicUiSource,
            dynamicUiType: dynamicUiType,
            editorContext: editorContextRef.current,
            hasEditablePageContext: hasEditablePageContext,
            sourceContentId: sourceContentId
        });
        const isRemixExperienceContextEnabled = (0, $ieeJu.expValEquals)('rovo_remix_experience_context', 'isEnabled', true);
        const creationContextParamsToSend = {
            dynamicUiType: dynamicUiType,
            dynamicUiSubtype: dynamicUiSubtype,
            dynamicUiSource: dynamicUiSourceToSend,
            source: 'remix',
            ...customPageEditExperienceParams ? customPageEditExperienceParams : isRemixExperienceContextEnabled && (isCustom || dynamicUiType) ? {
                experience: isCustom ? 'remix_custom' : 'remix'
            } : {},
            ...isRemixExperienceContextEnabled && !isCustom && dynamicUiType ? {
                blocks: [
                    dynamicUiType
                ]
            } : {},
            ...aspectRatio ? {
                additionalContext: {
                    aspectRatio: aspectRatio
                }
            } : {},
            ...!isCustom && userPrompt ? {
                hasUserInstruction: true
            } : {},
            // The object this remix was initiated from, so the agent session can be anchored to it.
            ...(0, $iDrrr.fg)('confluence_remix_session_source_content') && productIntegration.sourceContent?.contentId ? {
                sourceContent: productIntegration.sourceContent
            } : {}
        };
        const unsupportedRemixNodeTypes = (0, $0aab913f0ec52dbb$export$c2603f72338ce63d)(dynamicUiSource, config.isNodeUnsupportedForRemix);
        sendMessage({
            prompt: prompt,
            storeUserMessages: preferences.storeUserMessages,
            conversationId: newConversationId,
            messageSources: {
                interactionSource: interactionSource,
                followUpSource: interactionSource,
                aiFeatureName: aiFeatureName
            },
            promptStreamHook: (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') ? {
                // Flag the (non-fatal) safety/AUP violation so the component
                // can dismiss the thinking bar and open the Rovo side chat.
                onSafetyViolation: ()=>{
                    setIsRemixSafetyViolation(true);
                },
                onActionClassification: async (actionClassification)=>{
                    setContentClassification((0, $d296c14a5ba7d8bb$export$54efbf7cb26887a3)(actionClassification));
                },
                onActionPart: async (actionPart)=>{
                    if (actionPart.type === 'ACTION_PREPARE' && !hasOpenedFullStagingModalRef.current) {
                        const useAifcStagingArea = $084a36b9faaabd0a$var$shouldUseAifcStagingAreaForAction(actionPart.message);
                        const useEphemeralPreview = !useAifcStagingArea && $084a36b9faaabd0a$var$shouldUseEphemeralPreviewForAction(actionPart.message);
                        if (!useEphemeralPreview) {
                            hasOpenedFullStagingModalRef.current = true;
                            openRemixPreview({
                                action: actionPart.message,
                                remixConversationId: newConversationId,
                                onOpen: onStagingPreviewOpened
                            });
                            // Legacy cleanup keeps its original timing for every integration.
                            onStagingAIFCFlowStarted?.();
                        }
                    }
                    // ACTION_CLASSIFICATION is the semantic source of truth for the stream's
                    // content type. ACTION_PREPARE may carry a contentId, but it does not yet
                    // represent visible whiteboard output. Wait for the first real ACTION_PART
                    // before inserting the whiteboard so users do not see an empty embed.
                    if (actionPart.type === 'ACTION_PART' && actionPart.message.key === (0, $aYC8J.CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY) && !hasOpenedFullStagingModalRef.current) setContentClassification((classification)=>(0, $d296c14a5ba7d8bb$export$b5c3d4828f4ee170)(classification, actionPart.message.data));
                }
            } : undefined,
            productKey: config.productKey,
            contentContext: 'staging-area',
            unsupportedRemixNodeTypes: unsupportedRemixNodeTypes,
            creationContextParams: creationContextParamsToSend,
            editorContextFallback: editorContextFallback
        });
        setPrompt('Remix');
        setDynamicUiContext(dynamicUiType, dynamicUiSubtype, dynamicUiSourceToSend);
        // Preserve the user's original choice separately so EditWithRovoBar can
        // detect when the backend overrides it (setDynamicUiContext above is later
        // overwritten with the backend-produced subtype on response).
        setUserSelectedDynamicUiSubtype(dynamicUiSubtype);
        return newConversationId;
    }, [
        setConversationId,
        config.productKey,
        createConversationOptimistically,
        setSelectedConversation,
        sendMessage,
        setPrompt,
        setDynamicUiContext,
        setUserSelectedDynamicUiSubtype,
        preferences.storeUserMessages,
        setFinalMessage,
        setContentClassification,
        openRemixPreview,
        onStagingAIFCFlowStarted,
        onStagingPreviewOpened,
        config.isNodeUnsupportedForRemix,
        experienceTracker,
        isCustomOnlyRovoChatEnabled,
        hasEditablePageContext,
        smartCreationContext?.confluence?.content?.id,
        productIntegration.sourceContent
    ]);
    return {
        sendAIFCPrompt: sendAIFCPrompt,
        stopRemixing: stopRemixing,
        isRemixError: isRemixError,
        isRemixAborted: isRemixAborted,
        isRemixSafetyViolation: isRemixSafetyViolation,
        isWaitingForInput: isWaitingForInput,
        remixStoreError: remixStoreError,
        openRemixPreview: openRemixPreview,
        closeRemixPreview: productIntegration.closeRemixPreview
    };
};


function $437afbad13638573$var$OnCompleteSync() {
    (0, $2edfa7d301f1bfd9$export$d70fe66889862a96)();
    return null;
}
/**
 * Bounds the wait for a preview or staging surface to acknowledge opening (`onOpen`). Distinct from
 * the insertion acknowledgement timeout: expiry only releases shadow ownership as `abandoned`.
 */ const $437afbad13638573$var$PREVIEW_HANDOFF_ACKNOWLEDGEMENT_TIMEOUT_MS = 10000;
/** The experience-tracker reason for a locally cancelled flow. */ const $437afbad13638573$var$CANCELLATION_ABORT_REASON = 'User cancelled remix thinking';
/**
 * Exactly one outcome wins: the acknowledgement or the timeout's `abandoned` settlement. The timer
 * deliberately outlives the component that armed it (legacy staging cleanup unmounts it
 * synchronously), so both paths act only on the token-bound handle. An unacknowledged handoff is
 * not a cancellation: no machine terminal event is sent. `onTimedOut` is diagnostics only and runs
 * only when the timeout actually released ownership; a flow already settled by another terminal
 * path is not reported as a handoff abandonment.
 */ const $437afbad13638573$var$armPreviewAcknowledgement = (lifecycle, onAcknowledged, onTimedOut)=>{
    let settled = false;
    const timer = setTimeout(()=>{
        if (settled) return;
        settled = true;
        if (lifecycle.end('abandoned')) onTimedOut();
    }, $437afbad13638573$var$PREVIEW_HANDOFF_ACKNOWLEDGEMENT_TIMEOUT_MS);
    return ()=>{
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        onAcknowledged();
    };
};
const $437afbad13638573$export$f07319916703112a = (historyEntryForUpdate, dynamicUiSubtypeForUpdate, submittedUpdateKey)=>{
    if (!historyEntryForUpdate || !dynamicUiSubtypeForUpdate) return {
        shouldSubmit: false
    };
    const updateKey = [
        historyEntryForUpdate.conversationId,
        historyEntryForUpdate.url ?? historyEntryForUpdate.fieldId ?? '',
        dynamicUiSubtypeForUpdate
    ].join(':');
    return {
        shouldSubmit: submittedUpdateKey !== updateKey,
        updateKey: updateKey
    };
};
/**
 * editor has two modes, editing / viewing
 * - for editing mode, the thinking bar is rendered by the editor plugin
 * - for viewing mode, the thinking bar is rendered by the malleable-ui components
 * so the flow is different in two modes, specifically the onCompleteAnimationFinished callback
 */ const $437afbad13638573$var$RemixContentComponentInner = ({ handleModalClose: handleModalClose, selectedContext: selectedContext, editorApi: editorApi, isComplete: pluginIsComplete, isThinking: isThinking, isEditorRemixStateRearchitectureTreatment: isEditorRemixStateRearchitectureTreatment, remixAttemptId: remixAttemptId, onStartThinking: onStartThinking, onDismissThinkingUi: onDismissThinkingUi, onStopThinking: onStopThinking, onRegisterAbortRequest: onRegisterAbortRequest, onRegisterEditorRemixUxHandles: onRegisterEditorRemixUxHandles, onRegisterEditorRemixMutationCancellationSink: onRegisterEditorRemixMutationCancellationSink, onBeforeEditorRemixResultInsertion: onBeforeEditorRemixResultInsertion, finishRemixThinking: finishRemixThinking, remixModalMetadata: remixModalMetadata, remixSource: remixSource, productIntegration: productIntegration, productConfig: productConfig, hiddenOptions: hiddenOptions, isUiVisible: isUiVisible = true })=>{
    const { getRemixGeneratePreviewMetadata: getRemixGeneratePreviewMetadata } = productConfig;
    const lifecycleOwner = (0, $fjeDY.useEditorRemixLifecycleOwner)();
    const retainedLifecycle = lifecycleOwner?.active;
    /**
   * Whether a machine session owns this flow's terminal effects.
   *
   * Owned by `EditorRemixLifecycleOwnerProvider`, which latches it inside `retain` and clears it per
   * flow start, rather than being re-derived here: it has to outlive both the machine ownership the
   * observer releases before dispatching terminal commands *and* the read session that the terminal
   * command's own cleanup dismisses.
   */ const { hasMachineAuthority: isMachineAuthoritative } = (0, $fjeDY.useEditorRemixLifecycle)();
    const { closeConversationAssistant: closeConversationAssistant } = productIntegration;
    const { editorRemixLifecycleAdapter: editorRemixLifecycleAdapter, isViewMode: isViewMode, setDynamicUiType: setDynamicUiType, setDynamicUiSubtype: setDynamicUiSubtype, setDynamicUiSource: setDynamicUiSource, setInteractionSource: setInteractionSource, setAspectRatio: setAspectRatio, showLocationPicker: showLocationPicker, setThinkingComplete: setThinkingComplete, setThinkingWaitingForInput: setThinkingWaitingForInput, clearThinkingDecoration: clearThinkingDecoration, isUpdate: isUpdate, historyEntryForUpdate: historyEntryForUpdate, dynamicUiSubtypeForUpdate: dynamicUiSubtypeForUpdate, isRemixInsertingRef: isRemixInsertingRef, onRemixThinkingCompleteAnimationFinished: onRemixThinkingCompleteAnimationFinished, resetContext: resetContext } = (0, $bb37f8415315e332$export$4ea2348b19df1d27)();
    const isRemixCancelled = (0, $cozmU.useRef)(false);
    const hasCommittedRemixCreateTerminal = (0, $cozmU.useRef)(false);
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    // Records why a bounded handoff released the shadow lifecycle. Diagnostics only: it must never
    // throw into the lifecycle path, and the payload carries no identifiers.
    const logHandoffOutcomeBestEffort = (0, $cozmU.useCallback)((surface, result)=>{
        try {
            createAnalyticsEvent({
                eventType: 'operational',
                action: 'failed',
                actionSubject: 'editorRemixHandoff',
                actionSubjectId: surface,
                source: 'editorRemix',
                attributes: {
                    operation: 'handoffAcknowledgement',
                    surface: surface,
                    outcome: result.outcome,
                    ...result.outcome === 'abandoned' ? {
                        reason: result.reason
                    } : {}
                }
            }).fire();
        } catch  {
        // Telemetry must never affect lifecycle behavior.
        }
    }, [
        createAnalyticsEvent
    ]);
    // Records a classified non-acknowledgement of an external preview's editor insertion. Diagnostics
    // only: no machine event, no ownership change, and it must never throw into the lifecycle path.
    const logExternalPreviewInsertionNotAcknowledgedBestEffort = (0, $cozmU.useCallback)((result)=>{
        try {
            createAnalyticsEvent({
                eventType: 'operational',
                action: 'failed',
                actionSubject: 'editorInsertionAcknowledgement',
                actionSubjectId: 'externalPreview',
                source: 'editorRemix',
                attributes: {
                    operation: 'externalPreviewInsertion',
                    insertionKind: result.insertionKind,
                    outcome: result.outcome
                }
            }).fire();
        } catch  {
        // Telemetry must never affect lifecycle behavior.
        }
    }, [
        createAnalyticsEvent
    ]);
    const openRemixPreviewRef = (0, $cozmU.useRef)(()=>{});
    const selectedSubTypeRef = (0, $cozmU.useRef)(undefined);
    const conversationIdRef = (0, $cozmU.useRef)(undefined);
    const shouldOpenRovoChatOnCompleteRef = (0, $cozmU.useRef)(false);
    const hasAutoSubmittedRef = (0, $cozmU.useRef)(false);
    const remixModalMetadataRef = (0, $cozmU.useRef)(remixModalMetadata);
    remixModalMetadataRef.current = remixModalMetadata;
    const isThinkingRef = (0, $cozmU.useRef)(isThinking);
    isThinkingRef.current = isThinking;
    const isUpdateRef = (0, $cozmU.useRef)(isUpdate);
    isUpdateRef.current = isUpdate;
    const retainedLifecycleRef = (0, $cozmU.useRef)(retainedLifecycle);
    retainedLifecycleRef.current = retainedLifecycle;
    const isMachineAuthoritativeRef = (0, $cozmU.useRef)(isMachineAuthoritative);
    isMachineAuthoritativeRef.current = isMachineAuthoritative;
    const editorRemixLifecycleAdapterRef = (0, $cozmU.useRef)(editorRemixLifecycleAdapter);
    editorRemixLifecycleAdapterRef.current = editorRemixLifecycleAdapter;
    const updateRemixRef = (0, $cozmU.useRef)(undefined);
    const { dynamicUiType: dynamicUiType } = (0, $8akfd.useStagingAreaState)();
    const featureArea = (0, $iBsvI.getRemixFeatureArea)({
        remixType: dynamicUiType
    });
    const remixStartAttributes = (0, $cozmU.useMemo)(()=>({
            ...featureArea !== undefined && {
                featureArea: featureArea
            }
        }), [
        featureArea
    ]);
    const remixStartAttributesRef = (0, $cozmU.useRef)(remixStartAttributes);
    remixStartAttributesRef.current = remixStartAttributes;
    /**
   * This flow's own cancellation intent, recorded before `CANCELLED` is sent to the machine.
   *
   * `RemixAborted` is origin-blind by design: `CANCELLED` transitions the machine to `aborted`, so a
   * local cancel and a Rovo-side abort arrive as the same command. Recording the intent here is the
   * documented way for a caller to tell them apart inside the abort handler.
   *
   * Scoped to the flow it was recorded for, and dropped when the machine refuses the transition.
   * Without both, a later abort could be reported as a local cancel: by `remixId` when the next flow
   * is an update (the update producer never announces a flow start this component can reset on), and
   * by the refusal check when the same flow is aborted from elsewhere after its cancel was rejected.
   */ const abortOriginRef = (0, $cozmU.useRef)(undefined);
    /**
   * The flow that completed into a Rovo Chat handoff, which is a success even though the machine
   * reads it as an abort: the conversation goes idle with an assistant response and no remix action,
   * which is exactly `looksAborted` in `deriveRemixPhase.utils.ts`. Legacy excludes the same state
   * through `isCustomOnlyPromptComplete`, so `isRemixAborted` never fires for it and the handoff
   * settles its own experiences and thinking UI.
   *
   * Recorded so the machine-owned abort effects stand down for that flow instead of reporting an
   * abort over the handoff's success and tearing its thinking UI down underneath it. Keyed by
   * `remixId` for the same reason as {@link abortOriginRef}: a later flow's genuine abort must still
   * settle.
   */ const handedOffRemixIdRef = (0, $cozmU.useRef)(undefined);
    /**
   * Settles the cancellation experiences. Owned by `onRemixFlowActiveChange` for a legacy flow, and
   * by `RemixAborted` / `RemixFlowEnded('cancelled')` for an authoritative machine session.
   */ const settleCancellationExperience = (0, $cozmU.useCallback)(()=>{
        experienceTracker.abort({
            name: (0, $irnO2.ExperienceName).REMIX_START,
            reason: $437afbad13638573$var$CANCELLATION_ABORT_REASON,
            attributes: {
                ...remixStartAttributesRef.current,
                reason: $437afbad13638573$var$CANCELLATION_ABORT_REASON
            }
        });
        if (!isUpdateRef.current) (0, $kDDrf.abortRemixCreateExperience)(experienceTracker, $437afbad13638573$var$CANCELLATION_ABORT_REASON);
        (0, $irnO2.remixGeneratePreviewExperience).abort({
            metadata: {
                reason: $437afbad13638573$var$CANCELLATION_ABORT_REASON
            }
        });
    }, [
        experienceTracker
    ]);
    // remove legacy local state when cleanup platform_editor_ai_remix_in_editor_loading
    const [isComplete, setIsComplete] = (0, $cozmU.useState)(false);
    const resetCompletion = (0, $cozmU.useCallback)(()=>{
        setIsComplete(false);
    }, []);
    const openPreviewAndTrack = (0, $cozmU.useCallback)(()=>{
        experienceTracker.succeed({
            name: (0, $irnO2.ExperienceName).REMIX_START,
            ...Object.keys(remixStartAttributes).length > 0 ? {
                attributes: remixStartAttributes
            } : {}
        });
        hasCommittedRemixCreateTerminal.current = true;
        if (shouldOpenRovoChatOnCompleteRef.current) {
            shouldOpenRovoChatOnCompleteRef.current = false;
            (0, $irnO2.remixGeneratePreviewExperience).success();
            if (retainedLifecycle) // No machine event is emitted for this handoff and ownership is kept below, so the
            // completion write is fenced off. End the presentation directly instead.
            onDismissThinkingUi?.({
                endsFlow: true,
                reopenModal: false
            });
            else if (setThinkingComplete) setThinkingComplete(true);
            else {
                onRemixThinkingCompleteAnimationFinished?.();
                finishRemixThinking?.();
                clearThinkingDecoration?.();
            }
            handleModalClose();
            const conversationId = conversationIdRef.current;
            // The acknowledged handoff exists only to settle a retained shadow lifecycle. Without one
            // (control, master gate off, adapter absent) take the legacy path unchanged.
            if (retainedLifecycle && productIntegration.requestConversationAssistantOpen) productIntegration.requestConversationAssistantOpen('sidebar', conversationId).then((result)=>{
                if (result.outcome === 'acknowledged') {
                    retainedLifecycle.end('handed-off');
                    return;
                }
                // No proof of handoff: release shadow ownership as an unacknowledged handoff so it
                // cannot block the next Remix, and record the bounded outcome only when this path
                // actually released it. Not a cancellation and not a product failure: no machine
                // terminal event, no producer abort, no cancellation UX.
                if (retainedLifecycle.end('abandoned')) logHandoffOutcomeBestEffort('rovo-chat', result);
            }).catch(()=>{
                if (retainedLifecycle.end('abandoned')) logHandoffOutcomeBestEffort('rovo-chat', {
                    outcome: 'rejected'
                });
            });
            else // Legacy integrations can request the sidebar, but cannot prove that the requested
            // conversation opened. Keep lifecycle ownership until a real acknowledgement exists.
            productIntegration.openConversationAssistant?.('sidebar', conversationId);
            return;
        }
        experienceTracker.start({
            name: (0, $irnO2.ExperienceName).REMIX_RENDERS_IN_MODAL,
            id: (0, $irnO2.ExperienceName).REMIX_RENDERS_IN_MODAL,
            attributes: {
                product: productConfig.analyticsProductName ?? productConfig.productKey,
                remixType: dynamicUiType,
                remixSubtype: selectedSubTypeRef.current,
                entryPoint: 'editor'
            }
        });
        let isExternalPreviewLifecycleActive = Boolean(isViewMode && retainedLifecycle);
        let hasAcceptedExternalPreview = false;
        openRemixPreviewRef.current({
            onOpen: retainedLifecycle ? ()=>{
                const accepted = retainedLifecycle.transition({
                    type: 'PREVIEW_OPENED'
                });
                if (isViewMode && !accepted) {
                    isExternalPreviewLifecycleActive = false;
                    retainedLifecycle.rollback();
                }
            } : undefined,
            ...isViewMode && retainedLifecycle ? {
                onSubmit: ()=>{
                    if (!isExternalPreviewLifecycleActive) return;
                    hasAcceptedExternalPreview = retainedLifecycle.transition({
                        type: 'ACCEPTED'
                    });
                    if (!hasAcceptedExternalPreview) {
                        isExternalPreviewLifecycleActive = false;
                        retainedLifecycle.rollback();
                    }
                },
                editorInsertionAcknowledgement: {
                    onAcknowledged: ()=>{
                        if (!isExternalPreviewLifecycleActive) return;
                        // The acknowledgement can arrive before or after the submit observer depending on the
                        // finalize surface, so accept here when submit has not already done it.
                        isExternalPreviewLifecycleActive = false;
                        if (!hasAcceptedExternalPreview) hasAcceptedExternalPreview = retainedLifecycle.transition({
                            type: 'ACCEPTED'
                        });
                        if (!hasAcceptedExternalPreview || !retainedLifecycle.transition({
                            type: 'INSERTED'
                        })) retainedLifecycle.rollback();
                    },
                    onNotAcknowledged: (result)=>{
                        if (!isExternalPreviewLifecycleActive) return;
                        logExternalPreviewInsertionNotAcknowledgedBestEffort(result);
                        if (result.outcome !== 'timed-out-in-flight') return; // recovery UI is still open; the flow stays active
                        // Delivered but unacknowledged: outcome unknown, so release rather than hold a possible duplicate.
                        isExternalPreviewLifecycleActive = false;
                        retainedLifecycle.end('abandoned');
                    }
                },
                onDismiss: ()=>{
                    if (!isExternalPreviewLifecycleActive) return;
                    isExternalPreviewLifecycleActive = false;
                    retainedLifecycle.transition({
                        type: 'CANCELLED'
                    });
                    retainedLifecycle.settleTerminal();
                    retainedLifecycle.end('cancelled');
                }
            } : {}
        });
        // stop thinking when showing the preview modal, otherwise,
        // the thinking bar will flash when the preview modal close
        if ((0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading')) {
            if (isViewMode && !(0, $iDrrr.fg)('cc-maui-fix-live-doc-previews')) onDismissThinkingUi?.({
                reopenModal: false
            });
            else // `preserveRequest` suppresses only the request abort; the host still dismisses the legacy
            // thinking UI. Only an admitted lifecycle flow asks for it: a view-mode preview may still be
            // streaming into the external surface. Without admission the legacy path is unchanged.
            onStopThinking({
                reopenModal: false,
                preserveRequest: isViewMode && retainedLifecycle !== undefined
            });
        }
    }, [
        clearThinkingDecoration,
        dynamicUiType,
        experienceTracker,
        finishRemixThinking,
        handleModalClose,
        isViewMode,
        logExternalPreviewInsertionNotAcknowledgedBestEffort,
        logHandoffOutcomeBestEffort,
        onDismissThinkingUi,
        onRemixThinkingCompleteAnimationFinished,
        onStopThinking,
        productConfig.analyticsProductName,
        productConfig.productKey,
        productIntegration,
        retainedLifecycle,
        setThinkingComplete,
        remixStartAttributes
    ]);
    // when updating in editing mode, will call this callback when the thinking bar is complete
    // when in viewing mode, we need to open the preview modal when the thinking bar is complete
    const onCompleteAnimationFinished = (0, $cozmU.useCallback)(()=>{
        if (!isViewMode && (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar')) onRemixThinkingCompleteAnimationFinished?.();
        else openPreviewAndTrack();
    }, [
        openPreviewAndTrack,
        onRemixThinkingCompleteAnimationFinished,
        isViewMode
    ]);
    /**
   * The completion path `RemixReady` owns for an authoritative session.
   *
   * Byte-for-byte the branch it replaces in `onActionReady`, so each cohort's gate behavior is
   * unchanged. It writes no ProseMirror lifecycle: in treatment `setThinkingComplete(true)` no
   * longer dispatches one, because the lifecycle mirror already projects `isComplete` from the
   * machine's `ready` phase and holds `isThinking` until the completion animation finishes.
   */ const markReady = (0, $cozmU.useCallback)(()=>{
        if (isRemixCancelled.current) return;
        if ((0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') ? isViewMode : true) {
            // When we use the "showProgressBar"
            if ((0, $iDrrr.fg)('platform_editor_maui_jira_updates')) {
                // Defer opening the preview until the progress bar fills to 100%.
                if ((0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading')) setThinkingComplete?.(true);
                else setIsComplete(true);
            } else openPreviewAndTrack();
        }
    }, [
        isViewMode,
        openPreviewAndTrack,
        setThinkingComplete
    ]);
    const onActionReady = (0, $cozmU.useCallback)((options)=>{
        if (!isRemixCancelled.current) {
            if (!isUpdate) (0, $irnO2.remixGeneratePreviewExperience).mark((0, $irnO2.REMIX_GENERATE_PREVIEW_MARKS).ACTION_COMPLETE_RECEIVED);
            if (!options?.shouldOpenRovoChat) shouldOpenRovoChatOnCompleteRef.current = false;
            if (options?.shouldOpenRovoChat && shouldOpenRovoChatOnCompleteRef.current) {
                // Not a machine `ready`: a custom prompt that completed without a remix action has no
                // result to preview, so `isPreviewReady` is false and no `RemixReady` is emitted for it.
                // This handoff stays legacy-driven in every cohort, and the command carries no
                // `shouldOpenRovoChat` to express it.
                //
                // The machine reads the same conversation state as an abort, so record the handoff
                // first: it is the success this flow committed, and the abort effects have to yield to
                // it. Recorded from the retained handle rather than the read session, which the owner
                // has not necessarily published yet at completion. See {@link handedOffRemixIdRef}.
                handedOffRemixIdRef.current = retainedLifecycle?.remixId;
                openPreviewAndTrack();
                return;
            }
            // `RemixReady` owns completion for an authoritative session, through `markReady`.
            if (isMachineAuthoritative) return;
            if ((0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') ? isViewMode : true) {
                // When we use the "showProgressBar"
                if ((0, $iDrrr.fg)('platform_editor_maui_jira_updates')) {
                    // Defer opening the preview until the progress bar fills to 100%.
                    if ((0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading')) setThinkingComplete?.(true);
                    else setIsComplete(true);
                } else openPreviewAndTrack();
            }
        }
    }, [
        isMachineAuthoritative,
        isUpdate,
        openPreviewAndTrack,
        retainedLifecycle,
        setThinkingComplete,
        isViewMode
    ]);
    // Invariant: legacy UX/telemetry only, for every integration. Must not settle machine ownership.
    const onStagingAIFCFlowStarted = (0, $cozmU.useCallback)(()=>{
        experienceTracker.succeed({
            name: (0, $irnO2.ExperienceName).REMIX_START
        });
        (0, $kDDrf.succeedRemixCreateExperienceAtHandoff)(experienceTracker);
        (0, $irnO2.remixGeneratePreviewExperience).success();
        isRemixCancelled.current = true;
        clearThinkingDecoration?.();
        finishRemixThinking?.();
        handleModalClose();
    }, [
        clearThinkingDecoration,
        experienceTracker,
        finishRemixThinking,
        handleModalClose
    ]);
    // Positive acknowledgement from the integration that the full staging surface opened.
    const onStagingPreviewOpened = (0, $cozmU.useCallback)(()=>{
        retainedLifecycle?.end('handed-off');
    }, [
        retainedLifecycle
    ]);
    // Bounds every `onOpen` for a retained flow. Ephemeral previews share the staging contract on
    // purpose: an unopened preview leaves the machine in `ready` and would strand the owner too.
    const lifecycleAwareProductIntegration = (0, $cozmU.useMemo)(()=>retainedLifecycle ? {
            ...productIntegration,
            openRemixPreview: (options)=>productIntegration.openRemixPreview({
                    ...options,
                    ...options.onOpen ? {
                        onOpen: $437afbad13638573$var$armPreviewAcknowledgement(retainedLifecycle, options.onOpen, ()=>logHandoffOutcomeBestEffort(options.isFloating ? 'preview' : 'staging', {
                                outcome: 'timed-out'
                            }))
                    } : {}
                })
        } : productIntegration, [
        logHandoffOutcomeBestEffort,
        productIntegration,
        retainedLifecycle
    ]);
    const { sendAIFCPrompt: sendAIFCPrompt, stopRemixing: stopRemixing, isRemixError: isRemixError, isRemixAborted: isRemixAborted, isRemixSafetyViolation: isRemixSafetyViolation, isWaitingForInput: isWaitingForInput, remixStoreError: remixStoreError, openRemixPreview: openRemixPreview, closeRemixPreview: closeRemixPreview } = (0, $084a36b9faaabd0a$export$cca9e2432f59b3f8)({
        config: productConfig,
        onActionReady: onActionReady,
        productIntegration: lifecycleAwareProductIntegration,
        onStagingAIFCFlowStarted: onStagingAIFCFlowStarted,
        onStagingPreviewOpened: retainedLifecycle ? onStagingPreviewOpened : undefined
    });
    openRemixPreviewRef.current = openRemixPreview;
    (0, $cozmU.useEffect)(()=>{
        setThinkingWaitingForInput?.(isWaitingForInput);
    }, [
        isWaitingForInput,
        setThinkingWaitingForInput
    ]);
    // Keep unmount cleanup separate so waiting-state changes do not run cleanup between updates.
    // `isWaitingForInput` is intentionally excluded from this effect's dependencies.
    (0, $cozmU.useEffect)(()=>()=>{
            setThinkingWaitingForInput?.(false);
        }, [
        setThinkingWaitingForInput
    ]);
    /**
   * Settles the failure experiences. Owned by the legacy error effect for a legacy flow, and by
   * `RemixErrored` for an authoritative machine session.
   */ const settleFailureExperience = (0, $cozmU.useCallback)((commandError)=>{
        // The Rovo store's own message wins, so treatment reports exactly what legacy reported. A
        // command's error is only the fallback for a failure the store never described.
        const failure = remixStoreError?.content ? new Error(remixStoreError.content) : commandError ?? new Error((0, $iCjKh.DEFAULT_REMIX_ERROR_MESSAGE));
        experienceTracker.fail({
            name: (0, $irnO2.ExperienceName).REMIX_START,
            error: failure,
            attributes: {
                ...remixStartAttributesRef.current,
                errorType: remixStoreError?.errorType,
                traceId: remixStoreError?.traceId
            }
        });
        (0, $irnO2.remixGeneratePreviewExperience).failure({
            metadata: {
                errorType: remixStoreError?.errorType,
                traceId: remixStoreError?.traceId
            }
        });
    }, [
        experienceTracker,
        remixStoreError
    ]);
    /** The error path's preview close, with the visibility and view-mode conditions it always had. */ const closeRemixPreviewForError = (0, $cozmU.useCallback)(()=>{
        if (productIntegration.isRemixPreviewVisible && ((0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') ? isViewMode : true)) closeRemixPreview();
    }, [
        closeRemixPreview,
        isViewMode,
        productIntegration
    ]);
    /**
   * The editor UX that command handlers drive. They are mounted on a host above this component
   * — which terminal cleanup unmounts — so they reach these closures through the registry rather
   * than through props.
   */ const editorRemixUxHandles = (0, $cozmU.useMemo)(()=>({
            closeModal: handleModalClose,
            closeTerminalPreview: closeRemixPreviewForError,
            markReady: markReady,
            openPreview: openPreviewAndTrack,
            openSidebar: ()=>productIntegration.toggleConversationAssistant?.('sidebar'),
            settleCancellation: settleCancellationExperience,
            settleExperience: (outcome)=>{
                if (outcome.kind === 'failed') {
                    settleFailureExperience(outcome.error);
                    return 'settled';
                }
                // A flow that handed off to Rovo Chat already succeeded and tore its own thinking UI
                // down. The machine reads that same state as an abort, so this abort is not a real one
                // and neither is the teardown the caller would run after it.
                if (handedOffRemixIdRef.current === outcome.remixId) return 'ignored';
                // `RemixAborted` cannot tell a local cancel from a Rovo-side abort, so this flow's own
                // recorded intent wins over the command's neutral reason. Matched against the command's
                // own flow rather than the read session, which a flow that already ended has released.
                const recorded = abortOriginRef.current;
                const reason = recorded !== undefined && recorded.remixId === outcome.remixId ? recorded.reason : outcome.reason;
                experienceTracker.abort({
                    name: (0, $irnO2.ExperienceName).REMIX_START,
                    reason: reason,
                    attributes: {
                        ...remixStartAttributesRef.current,
                        reason: reason
                    }
                });
                if (!isUpdateRef.current) (0, $kDDrf.abortRemixCreateExperience)(experienceTracker, reason);
                (0, $irnO2.remixGeneratePreviewExperience).abort({
                    metadata: {
                        reason: reason
                    }
                });
                return 'settled';
            },
            stopThinking: onStopThinking
        }), [
        closeRemixPreviewForError,
        experienceTracker,
        handleModalClose,
        markReady,
        onStopThinking,
        openPreviewAndTrack,
        productIntegration,
        settleCancellationExperience,
        settleFailureExperience
    ]);
    (0, $cozmU.useEffect)(()=>onRegisterEditorRemixUxHandles?.(editorRemixUxHandles), [
        editorRemixUxHandles,
        onRegisterEditorRemixUxHandles
    ]);
    // Register stopRemixing so that cancelRemixThinking (called from the decoration or
    // RemixContent.tsx's onStopThinking for the toolbar ON path) can abort the in-flight
    // AI request and trigger the paired aiInteraction initiated + dismissed analytics.
    (0, $cozmU.useEffect)(()=>{
        return onRegisterAbortRequest?.(stopRemixing);
    }, [
        onRegisterAbortRequest,
        stopRemixing
    ]);
    const { updateRemix: updateRemix } = (0, $41033c121bd9554e$export$a1c201a4bfffda2a)();
    updateRemixRef.current = updateRemix;
    const experienceTrackerRef = (0, $cozmU.useRef)(experienceTracker);
    experienceTrackerRef.current = experienceTracker;
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (isRemixCancelled.current) return;
            experienceTrackerRef.current.abort({
                name: (0, $irnO2.ExperienceName).REMIX_START,
                reason: 'User closed remix overlay',
                attributes: {
                    ...remixStartAttributesRef.current,
                    reason: 'User closed remix overlay'
                }
            });
            if (!isUpdateRef.current && !hasCommittedRemixCreateTerminal.current) (0, $kDDrf.abortRemixCreateExperience)(experienceTrackerRef.current, 'User closed remix overlay');
        };
    }, []);
    const onRemixFlowActiveChange = (0, $cozmU.useCallback)((active)=>{
        if ((0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading')) // when start/cancel, reset the context
        resetContext();
        if (active) {
            isRemixCancelled.current = false;
            shouldOpenRovoChatOnCompleteRef.current = false;
            conversationIdRef.current = undefined;
            // A new flow has not been cancelled, so it must not inherit the previous flow's intent:
            // its own abort would otherwise be settled as a local cancellation.
            abortOriginRef.current = undefined;
            // Clear stale completion state from any previous flow.
            if (!(0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading')) resetCompletion();
            // When isThinking is already true (e.g. pre-supplied userPrompt flow from
            // startRemixThinking), skip calling onStartThinking again — it would wipe
            // remixModalMetadata from plugin state by dispatching a new startRemixThinking
            // without the metadata. Use ref to avoid stale closure.
            if (!isThinkingRef.current) onStartThinking((0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') ? {
                contentType: productIntegration.contentType
            } : undefined);
            return;
        }
        isRemixCancelled.current = true;
        shouldOpenRovoChatOnCompleteRef.current = false;
        conversationIdRef.current = undefined;
        if (retainedLifecycle) {
            // `RemixAborted` is origin-blind, so record this cancellation's reason before driving the
            // machine: `CANCELLED` reaches `aborted`, and the command that settles the experience has
            // no way to tell a local cancel from a Rovo-side abort.
            abortOriginRef.current = {
                reason: $437afbad13638573$var$CANCELLATION_ABORT_REASON,
                remixId: retainedLifecycle.remixId
            };
            // Abort the request, publish the typed intent, run the unchanged legacy cohort UX below,
            // then each exit settles the handle last.
            stopRemixing();
            if (!retainedLifecycle.transition({
                type: 'CANCELLED'
            })) // The machine refused this cancellation, so it emits no `RemixAborted` for it. Any abort
            // that does arrive for this flow came from somewhere else and must not be reported as a
            // local cancel.
            abortOriginRef.current = undefined;
        }
        // Experience settlement is the one part of this path a command now owns: `RemixAborted`
        // settles it through `settleExperience`, and a `cancelled` teardown that no terminal command
        // settled falls through to `settleCancellation`. The teardown below stays here because it is
        // user-initiated, not machine-derived.
        if (!isMachineAuthoritative) settleCancellationExperience();
        if ((0, $anBbz.expValEqualsNoExposure)('cc_page_experiences_editor_image_generation', 'isEnabled', true)) {
            const userPrompt = remixModalMetadataRef.current?.userPrompt;
            const onCancel = remixModalMetadataRef.current?.onCancel;
            if (onCancel && userPrompt) {
                // Abort the AI request so send-message-action.ts fires the paired
                // aiInteraction initiated + dismissed events automatically via AbortError.
                if (!retainedLifecycle) stopRemixing();
                onStopThinking({
                    reopenModal: false
                });
                onCancel();
                retainedLifecycle?.settleTerminal();
                retainedLifecycle?.end('cancelled');
                return;
            }
        }
        if (!retainedLifecycle) stopRemixing();
        if ((0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') ? isViewMode : true) onStopThinking({
            reopenModal: false
        });
        retainedLifecycle?.settleTerminal();
        retainedLifecycle?.end('cancelled');
    }, [
        isViewMode,
        isMachineAuthoritative,
        onStartThinking,
        onStopThinking,
        productIntegration.contentType,
        resetCompletion,
        settleCancellationExperience,
        stopRemixing,
        resetContext,
        retainedLifecycle
    ]);
    const onRemixFlowActiveChangeRef = (0, $cozmU.useRef)(onRemixFlowActiveChange);
    (0, $cozmU.useEffect)(()=>{
        onRemixFlowActiveChangeRef.current = onRemixFlowActiveChange;
    }, [
        onRemixFlowActiveChange
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!retainedLifecycle) return;
        // The product registry fences this callback to the retained session.
        return onRegisterEditorRemixMutationCancellationSink?.(()=>{
            onRemixFlowActiveChangeRef.current(false);
            return true;
        });
    }, [
        onRegisterEditorRemixMutationCancellationSink,
        retainedLifecycle
    ]);
    // When thinking stops without completing, treat it as cancellation.
    const previousIsThinking = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        const isImageGenFlow = (0, $anBbz.expValEqualsNoExposure)('cc_page_experiences_editor_image_generation', 'isEnabled', true) && !!remixModalMetadataRef.current?.userPrompt;
        const shouldFire = !isImageGenFlow && (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') || isImageGenFlow && (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar');
        if (!isViewMode && previousIsThinking.current && !isThinking && pluginIsComplete !== true && showLocationPicker !== true && !isRemixCancelled.current && shouldFire) {
            // The authority latch outlives the session, so this also catches a flow already released,
            // e.g. handed off to Rovo Chat before thinking fell.
            if (retainedLifecycleRef.current || isMachineAuthoritativeRef.current) try {
                editorRemixLifecycleAdapterRef.current?.observeLifecycle?.({
                    actionSubjectId: 'cancellationSignal',
                    producer: isUpdateRef.current ? 'variant-update' : 'create',
                    artifactType: 'unknown',
                    outcome: 'thinking-fell',
                    reason: retainedLifecycleRef.current ? 'retained-flow' : 'released-authoritative-flow'
                });
            } catch  {
            // Observability must never affect cancellation behavior.
            }
            onRemixFlowActiveChangeRef.current(false);
        }
        previousIsThinking.current = isThinking;
    }, [
        isThinking,
        pluginIsComplete,
        showLocationPicker,
        isViewMode
    ]);
    // Dismiss the thinking bar when the user stops the remix from the Rovo side chat.
    // `RemixAborted` owns abort settlement and thinking cleanup for an authoritative session; the
    // bookkeeping above it is untouched so both cohorts read the same internal state.
    (0, $cozmU.useEffect)(()=>{
        if (isMachineAuthoritative) return;
        if (isRemixAborted && !isRemixCancelled.current) {
            experienceTracker.abort({
                name: (0, $irnO2.ExperienceName).REMIX_START,
                reason: (0, $iCjKh.REMIX_REMOTE_ABORT_REASON),
                attributes: remixStartAttributes
            });
            if (!isUpdate) (0, $kDDrf.abortRemixCreateExperience)(experienceTracker, (0, $iCjKh.REMIX_REMOTE_ABORT_REASON));
            (0, $irnO2.remixGeneratePreviewExperience).abort({
                metadata: {
                    reason: (0, $iCjKh.REMIX_REMOTE_ABORT_REASON)
                }
            });
            onStopThinking({
                reopenModal: false
            });
        }
    }, [
        experienceTracker,
        isMachineAuthoritative,
        isRemixAborted,
        isUpdate,
        onStopThinking,
        remixStartAttributes
    ]);
    // Fail experience and clean up thinking UI when Rovo encounters an error.
    // `RemixErrored` owns failure settlement and error cleanup for an authoritative session. The
    // `previousIsRemixError` edge tracking below stays unfenced so both cohorts keep the same
    // internal state.
    const previousIsRemixError = (0, $cozmU.useRef)(isRemixError);
    (0, $cozmU.useEffect)(()=>{
        if (!isMachineAuthoritative && !previousIsRemixError.current && isRemixError && !isRemixCancelled.current) {
            settleFailureExperience();
            onStopThinking({
                reopenModal: true
            });
        }
        previousIsRemixError.current = isRemixError;
    }, [
        isMachineAuthoritative,
        isRemixError,
        onStopThinking,
        settleFailureExperience
    ]);
    // When an error occurs, close the ephemeral preview if open, dismiss the
    // remix UI entirely, and open the sidebar so the user can see the error.
    // Fenced as one unit with the effect above: `RemixErrored` closes the preview, opens the sidebar
    // and closes the modal in the same handler, before it dismisses the latched terminal session.
    (0, $cozmU.useEffect)(()=>{
        if (!isMachineAuthoritative && !isRemixCancelled.current && isRemixError) {
            closeRemixPreviewForError();
            // Use handleModalClose (not onStopThinking) to fully unmount the component
            // and clear isModalOpen. The first error effect already sets reopenModal:true
            // via onStopThinking; using it here alone would leave the progress bar visible.
            handleModalClose();
            productIntegration.toggleConversationAssistant?.('sidebar');
        }
    }, [
        closeRemixPreviewForError,
        handleModalClose,
        isMachineAuthoritative,
        isRemixError,
        productIntegration
    ]);
    // [MAUI-1070] Safety/AUP violation handled non-fatally: the friendly response is
    // still streaming into the conversation, but in this flow the violation looks like
    // a completed action — so the thinking bar would hang ("Almost done.") and the
    // response would stay unseen. Dismiss the thinking bar, close any preview, and open
    // the Rovo side chat so the user sees the response as it arrives.
    //
    // IMPORTANT: use `onDismissThinkingUi` (UI-only) rather than `onStopThinking` here —
    // `onStopThinking` aborts the in-flight AI request (getAbortRequest), which would
    // cut off the friendly response before it streams in and leave an empty message.
    const previousIsRemixSafetyViolation = (0, $cozmU.useRef)(isRemixSafetyViolation);
    (0, $cozmU.useEffect)(()=>{
        if (!previousIsRemixSafetyViolation.current && isRemixSafetyViolation && !isRemixCancelled.current) {
            // Settle the expected refusal before dismissing UI. Dismissal can synchronously unmount
            // this component, whose cleanup otherwise wins with "User closed remix overlay".
            isRemixCancelled.current = true;
            hasCommittedRemixCreateTerminal.current = true;
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).REMIX_START,
                attributes: {
                    ...remixStartAttributesRef.current,
                    outcome: (0, $60x4y.REMIX_IMAGE_GENERATION_SAFETY_REFUSAL_OUTCOME)
                }
            });
            if (!isUpdateRef.current) (0, $kDDrf.succeedRemixCreateExperienceForSafetyRefusal)(experienceTracker);
            if (productIntegration.isRemixPreviewVisible) closeRemixPreview();
            onDismissThinkingUi?.({
                reopenModal: false
            });
            productIntegration.toggleConversationAssistant?.('sidebar');
        }
        previousIsRemixSafetyViolation.current = isRemixSafetyViolation;
    }, [
        closeRemixPreview,
        experienceTracker,
        isRemixSafetyViolation,
        onDismissThinkingUi,
        productIntegration
    ]);
    const handleRemixOverlayClose = (0, $cozmU.useCallback)(()=>{
        if (retainedLifecycle) {
            stopRemixing();
            retainedLifecycle.transition({
                type: 'CANCELLED'
            });
            handleModalClose();
            retainedLifecycle.settleTerminal();
            retainedLifecycle.end('cancelled');
            return;
        }
        handleModalClose();
    }, [
        handleModalClose,
        retainedLifecycle,
        stopRemixing
    ]);
    // Report the editor's own lifecycle phase for migration shadow parity. Strictly observational:
    // it projects signals computed above and never feeds back into the flow. `observeLegacyPhase` is
    // absent for products that do not observe parity, so this costs those products nothing.
    //
    // Insertion is reported by `useOnComplete` at the moment it starts, because the preview closes
    // before insertion in the editor path and no reactive signal marks it. The shared ref keeps both
    // report sites agreeing on precedence rather than racing to overwrite each other.
    const lastReportedLegacyPhaseRef = (0, $cozmU.useRef)(undefined);
    (0, $cozmU.useEffect)(()=>{
        const observeLegacyPhase = editorRemixLifecycleAdapter?.observeLegacyPhase;
        if (!observeLegacyPhase) return;
        const legacyPhase = (0, $gZHXx.deriveLegacyEditorRemixPhase)({
            isThinking: isThinking,
            isReady: (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') ? !!pluginIsComplete : isComplete,
            isPreviewVisible: productIntegration.isRemixPreviewVisible,
            isInserting: isRemixInsertingRef.current,
            // A safety/AUP violation is an error outcome for the flow even though it arrives as a
            // completed action, so it is not a separate phase.
            isError: isRemixError || isRemixSafetyViolation,
            isAborted: isRemixAborted,
            isCancelled: isRemixCancelled.current
        });
        if (lastReportedLegacyPhaseRef.current === legacyPhase) return;
        lastReportedLegacyPhaseRef.current = legacyPhase;
        observeLegacyPhase(legacyPhase);
    }, [
        editorRemixLifecycleAdapter,
        isComplete,
        isRemixAborted,
        isRemixError,
        isRemixInsertingRef,
        isRemixSafetyViolation,
        isThinking,
        pluginIsComplete,
        productIntegration.isRemixPreviewVisible
    ]);
    const constructDynamicUiSource = (0, $cozmU.useCallback)(async ()=>{
        const localIds = selectedContext?.localIds ?? [];
        const startLocalId = localIds[0] ?? '';
        const endLocalId = localIds[localIds.length - 1] ?? '';
        const fragmentAdf = (0, $084a36b9faaabd0a$export$d6cdcf2c2885fa31)(selectedContext?.selectionFragment ?? null, productConfig.isNodeUnsupportedForRemix);
        let fullAdf = {
            type: 'doc',
            version: 1,
            content: []
        };
        if (editorApi) fullAdf = await new Promise((resolve)=>{
            try {
                editorApi.core?.actions?.requestDocument?.((doc)=>{
                    resolve(doc ?? {
                        type: 'doc',
                        version: 1,
                        content: []
                    });
                }, {
                    alwaysFire: true
                });
            } catch  {
                resolve({
                    type: 'doc',
                    version: 1,
                    content: []
                });
            }
        });
        // When the entire page is selected (e.g. cmd+a), selectionFragment is null
        // because ProseMirror's AllSelection does not produce a fragment. Fall back
        // to the full document content so Remix still receives the source it needs.
        const resolvedFragmentAdf = fragmentAdf ?? fullAdf.content;
        return {
            contentType: productIntegration.contentType,
            startLocalId: startLocalId,
            endLocalId: endLocalId,
            startIndex: selectedContext?.startIndex ?? 0,
            endIndex: selectedContext?.endIndex ?? -1,
            fragmentAdf: resolvedFragmentAdf,
            fullAdf: fullAdf
        };
    }, [
        editorApi,
        productIntegration.contentType,
        selectedContext,
        productConfig.isNodeUnsupportedForRemix
    ]);
    /**
   * Entry points start REMIX_START (and, for creates, the create collect) before either producer
   * runs, so a refused flow has to settle them or they stay open until unmount and get reported as
   * a user action. `isRemixCancelled` stops the unmount and thinking-stopped effects doing that.
   */ const settleRefusedAdmission = (0, $cozmU.useCallback)(()=>{
        isRemixCancelled.current = true;
        hasCommittedRemixCreateTerminal.current = true;
        experienceTracker.abort({
            name: (0, $irnO2.ExperienceName).REMIX_START,
            reason: 'active-flow-rejected',
            attributes: {
                ...remixStartAttributes,
                reason: 'active-flow-rejected'
            }
        });
        if (!isUpdate) (0, $kDDrf.abortRemixCreateExperience)(experienceTracker, 'active-flow-rejected');
    }, [
        experienceTracker,
        isUpdate,
        remixStartAttributes
    ]);
    const onOptionSelect = (0, $cozmU.useCallback)(async ({ type: type, subType: subType, userPrompt: userPrompt })=>{
        const isRovoChatSubmission = remixSource === 'rovoChat' && remixModalMetadata?.preselectedConversationId !== undefined;
        const isCustomOnlyPrompt = type === 'custom' && !subType && !!userPrompt?.trim();
        // Toolbar / Rovo selections are submitted by `RemixContainer`'s own auto-submit, and it
        // renders no picker for them, so reopening would show an empty surface.
        const isPreselectedSubmission = remixModalMetadata?.preselectedType !== undefined;
        // Built before admission so nothing is awaited between the machine write and the send.
        let dynamicUiSource = await constructDynamicUiSource();
        // When the AI Image Generation media-insert tab is the entry point there is
        // no editor selection - the user's typed prompt IS the "highlighted text".
        // Mirror the shape the existing "click Image in Visual aid accordion" flow
        // produces (a doc-ADF with the source content) so the backend image-generation
        // path receives the prompt via dynamicUiSource.fragmentAdf / fullAdf the same
        // way it normally receives selected text.
        // remixModalMetadataRef.current?.userPrompt is only set by the media-insert
        // image-generation flow (not the Remix modal). It distinguishes "prompt
        // pre-supplied by media-insert tab" from "prompt typed in the Remix overlay."
        if (type === 'image' && userPrompt && remixModalMetadataRef.current?.userPrompt) {
            const promptDoc = {
                type: 'doc',
                version: 1,
                content: [
                    {
                        type: 'paragraph',
                        content: [
                            {
                                type: 'text',
                                text: userPrompt
                            }
                        ]
                    }
                ]
            };
            dynamicUiSource = {
                contentType: dynamicUiSource?.contentType ?? productIntegration.contentType,
                startLocalId: dynamicUiSource?.startLocalId ?? '',
                endLocalId: dynamicUiSource?.endLocalId ?? '',
                startIndex: dynamicUiSource?.startIndex ?? 0,
                endIndex: dynamicUiSource?.endIndex ?? -1,
                fragmentAdf: promptDoc.content,
                fullAdf: promptDoc
            };
        }
        // Every create entrypoint converges here: one lifecycle write, no per-entrypoint gate policy.
        // Admission is asked for before any editor state or telemetry side effect, so a refused flow
        // leaves nothing started behind it.
        const lifecycleRetention = (0, $fjeDY.admitAndRetainEditorRemixLifecycle)({
            adapter: editorRemixLifecycleAdapter,
            owner: lifecycleOwner,
            request: {
                kind: 'create',
                observation: {
                    producer: 'create',
                    artifactType: type === 'image' ? 'image' : type === 'diagram' ? 'whiteboard' : 'maui'
                },
                // Omitted for a brand-new create so the machine allocates the authoritative
                // conversation identity; supplied when this flow continues a Rovo Chat conversation.
                ...remixModalMetadata?.preselectedConversationId !== undefined && {
                    conversationId: remixModalMetadata.preselectedConversationId
                }
            }
        });
        // Fail closed for product policy only; every other outcome falls through to the legacy request.
        if (lifecycleRetention.status === 'active-flow-rejected') {
            // Thinking is already on when this runs, so settle the open experiences and dismiss it
            // (UI-only, so no request is aborted). Re-arm the guard so a refused prompt can retry.
            settleRefusedAdmission();
            hasAutoSubmittedRef.current = false;
            onDismissThinkingUi?.({
                reopenModal: !isPreselectedSubmission
            });
            return;
        }
        // Possession of the handle IS the treatment decision for this flow. Nothing below may
        // re-evaluate rollout controls for it.
        const admittedLifecycle = lifecycleRetention.status === 'retained' ? lifecycleRetention.lifecycle : undefined;
        // Everything from here to the send is synchronous, so a throw would leave the admitted
        // machine active with no request for the watcher to settle, blocking later creates.
        let sendResult;
        try {
            if (!isViewMode && (0, $2pQiO.UNSAFE_expValNoExposure)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'control') === 'variant2') closeConversationAssistant?.();
            if ((0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading')) {
                setDynamicUiType(type);
                setDynamicUiSubtype(subType);
                setInteractionSource(remixModalMetadata?.interactionSource);
                setAspectRatio(remixModalMetadata?.aspectRatio);
            }
            selectedSubTypeRef.current = subType;
            conversationIdRef.current = undefined;
            shouldOpenRovoChatOnCompleteRef.current = !isRovoChatSubmission && isCustomOnlyPrompt && (0, $4o0zT.isExperimentEnabled)('cc_maui_polish_changes_batch_5');
            const featureArea = (0, $iBsvI.getRemixFeatureArea)({
                remixType: type
            });
            experienceTracker.updateAttributes({
                name: (0, $irnO2.ExperienceName).REMIX_START,
                attributes: {
                    remixType: type,
                    remixSubtype: subType,
                    includesFreegenPrompt: !!userPrompt,
                    ...featureArea !== undefined && {
                        featureArea: featureArea
                    }
                }
            });
            (0, $irnO2.remixGeneratePreviewExperience).start();
            (0, $irnO2.remixGeneratePreviewExperience).mark((0, $irnO2.REMIX_GENERATE_PREVIEW_MARKS).SUBMIT);
            (0, $irnO2.remixGeneratePreviewExperience).addMetadata({
                product: productConfig.analyticsProductName ?? productConfig.productKey,
                interactionSource: remixModalMetadata?.interactionSource,
                remixType: type,
                remixSubtype: subType,
                entryPoint: isViewMode ? 'renderer' : 'editor',
                contentType: productIntegration.contentType,
                includesFreegenPrompt: !!userPrompt,
                ...getRemixGeneratePreviewMetadata?.({
                    type: type,
                    subType: subType,
                    userPrompt: userPrompt
                })
            });
            if ((0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading')) setDynamicUiSource(dynamicUiSource);
            sendResult = sendAIFCPrompt({
                userPrompt: isRovoChatSubmission ? undefined : userPrompt,
                promptText: isRovoChatSubmission ? userPrompt : undefined,
                dynamicUiType: type,
                dynamicUiSubtype: subType,
                dynamicUiSource: dynamicUiSource,
                interactionSource: remixModalMetadata?.interactionSource,
                aspectRatio: remixModalMetadata?.aspectRatio,
                aiFeatureName: remixModalMetadata?.aiFeatureName,
                conversationId: remixModalMetadata?.preselectedConversationId,
                lifecycleConversationId: admittedLifecycle?.conversationId,
                // See comment above — metadata userPrompt is the media-insert flow signal
                isMediaInsertFlow: !!remixModalMetadataRef.current?.userPrompt
            }).then((conversationId)=>{
                conversationIdRef.current = conversationId;
            });
        } catch (error) {
            admittedLifecycle?.rollback();
            throw error;
        }
        // Release the machine on a rejected send, or the single-active policy blocks the next create.
        if (admittedLifecycle) sendResult.catch(()=>{
            admittedLifecycle.rollback();
        });
    }, [
        editorRemixLifecycleAdapter,
        lifecycleOwner,
        onDismissThinkingUi,
        settleRefusedAdmission,
        setDynamicUiType,
        setDynamicUiSubtype,
        setInteractionSource,
        setAspectRatio,
        constructDynamicUiSource,
        closeConversationAssistant,
        experienceTracker,
        isViewMode,
        getRemixGeneratePreviewMetadata,
        productConfig.analyticsProductName,
        productConfig.productKey,
        productIntegration.contentType,
        remixModalMetadata,
        remixSource,
        sendAIFCPrompt,
        setDynamicUiSource
    ]);
    // When a userPrompt is pre-supplied in remixModalMetadata (e.g. from the AI Image Generation
    // submit flow), skip the option-picker modal UI and go straight to processing.
    // The ref guard prevents double-firing if the component re-renders.
    // Must be placed before any early returns to satisfy React hooks rules.
    (0, $cozmU.useEffect)(()=>{
        const isSuggestedRemix = remixSource === 'suggestedRemix' && (0, $2pQiO.UNSAFE_expValNoExposure)('platform_editor_ai_content_suggested_edits', 'isEnabled', false);
        if (!isSuggestedRemix && !(0, $anBbz.expValEqualsNoExposure)('cc_page_experiences_editor_image_generation', 'isEnabled', true)) return;
        if (hasAutoSubmittedRef.current) return;
        const userPrompt = remixModalMetadata?.userPrompt;
        if (!userPrompt) return;
        hasAutoSubmittedRef.current = true;
        onRemixFlowActiveChange(true);
        const autoSubmitType = remixModalMetadata?.dynamicUiType ?? 'custom';
        // Suggested Remix drives the subtype via `dynamicUiSubtype`; other flows (media-insert image
        // generation) use `imageStyle`. Falls back to "image" so the backend always gets a subtype.
        const suggestedSubtype = isSuggestedRemix ? remixModalMetadata?.dynamicUiSubtype : undefined;
        const autoSubmitSubType = suggestedSubtype ?? remixModalMetadata?.imageStyle ?? 'image';
        onOptionSelect({
            type: autoSubmitType,
            subType: autoSubmitSubType,
            userPrompt: userPrompt
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        remixModalMetadata?.userPrompt
    ]);
    // When the editor toolbar "Remix" dropdown is the picker, it opens the chooser
    // with a preselected option in metadata. The RemixContainer suppresses its own
    // picker UI and starts the flow immediately for this selection (see the
    // `autoSubmitSelection` prop passed below).
    const autoSubmitSelection = !isUpdate && remixModalMetadata?.preselectedType ? {
        type: remixModalMetadata.preselectedType,
        subType: remixModalMetadata.preselectedSubType,
        ...remixModalMetadata.preselectedUserPrompt && {
            userPrompt: remixModalMetadata.preselectedUserPrompt
        }
    } : undefined;
    const submittedUpdateKeyRef = (0, $cozmU.useRef)(undefined);
    // Bound ownership to the lifecycle attempt this effect admitted. A preset key is only a request
    // description: it changes when the user picks another subtype, while the retained lifecycle is the
    // authority that decides whether that request belongs to this effect or an inline Rovo flow.
    const locallyOwnedUpdateProvenanceRef = (0, $cozmU.useRef)(undefined);
    // The stale preset remains consumed for this update epoch even if the inline lifecycle releases
    // before the host clears `isThinking`. Bug 2 can use this state for presentation arbitration
    // without having to infer ownership a second time.
    const externallyOwnedPresetUpdateKeyRef = (0, $cozmU.useRef)(undefined);
    const [externallyOwnedPresetUpdateKey, setExternallyOwnedPresetUpdateKey] = (0, $cozmU.useState)(undefined);
    (0, $cozmU.useEffect)(()=>{
        if (!isViewMode && (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar')) {
            const isOwnershipArbitrationEnabled = isEditorRemixStateRearchitectureTreatment === true;
            if (!isOwnershipArbitrationEnabled) {
                // Control retains the pre-migration submission path. Do not let an earlier treatment
                // epoch leak ownership into a later treatment render, but preserve submitted-key behavior.
                locallyOwnedUpdateProvenanceRef.current = undefined;
                if (externallyOwnedPresetUpdateKeyRef.current !== undefined) {
                    externallyOwnedPresetUpdateKeyRef.current = undefined;
                    setExternallyOwnedPresetUpdateKey(undefined);
                }
            }
            const localProvenance = locallyOwnedUpdateProvenanceRef.current;
            if (isOwnershipArbitrationEnabled && localProvenance && retainedLifecycle?.token !== localProvenance.lifecycleToken) // The lifecycle that made this effect local is gone or has been replaced. Do not retain
            // ownership through a transient thinking state: a later lifecycle must prove itself again.
            locallyOwnedUpdateProvenanceRef.current = undefined;
            if (!isThinking || !isUpdate) {
                submittedUpdateKeyRef.current = undefined;
                if (isOwnershipArbitrationEnabled && externallyOwnedPresetUpdateKeyRef.current !== undefined) {
                    externallyOwnedPresetUpdateKeyRef.current = undefined;
                    setExternallyOwnedPresetUpdateKey(undefined);
                }
                return;
            }
            if (isOwnershipArbitrationEnabled && externallyOwnedPresetUpdateKeyRef.current !== undefined) // This thinking epoch was already identified as an inline-owned stale preset. A subtype
            // change is still stale state, not permission to replay an update after that lifecycle
            // releases before the host clears its projection.
            return;
            const { shouldSubmit: shouldSubmit, updateKey: updateKey } = $437afbad13638573$export$f07319916703112a(historyEntryForUpdate, dynamicUiSubtypeForUpdate, submittedUpdateKeyRef.current);
            if (shouldSubmit && updateKey) {
                if (isOwnershipArbitrationEnabled && retainedLifecycle) {
                    if (retainedLifecycle.token !== locallyOwnedUpdateProvenanceRef.current?.lifecycleToken) {
                        // A stale preset can remain after inline Rovo has retained a lifecycle. Do not send
                        // or run refusal cleanup against that different attempt. Consume this update key so
                        // a release before the host clears thinking cannot replay the stale request.
                        submittedUpdateKeyRef.current = updateKey;
                        if (externallyOwnedPresetUpdateKeyRef.current !== updateKey) {
                            externallyOwnedPresetUpdateKeyRef.current = updateKey;
                            setExternallyOwnedPresetUpdateKey(updateKey);
                        }
                        return;
                    }
                    // A new subtype is a new request, but the previous locally-admitted request still
                    // owns the single-flow slot. Leave the key unclaimed so this effect retries after its
                    // own lifecycle settles, rather than misclassifying it as external or refusing it.
                    return;
                }
                submittedUpdateKeyRef.current = updateKey;
                const updateOutcome = updateRemixRef.current?.();
                if (isOwnershipArbitrationEnabled && updateOutcome && typeof updateOutcome !== 'string') locallyOwnedUpdateProvenanceRef.current = {
                    updateKey: updateKey,
                    lifecycleToken: updateOutcome.lifecycle.token,
                    remixId: updateOutcome.lifecycle.remixId
                };
                if (updateOutcome === 'active-flow-rejected') {
                    // Leave `submittedUpdateKeyRef` set or this re-attempts every render; the `!isThinking`
                    // branch above clears it once the dismissal lands, which is what allows a retry.
                    settleRefusedAdmission();
                    onDismissThinkingUi?.({
                        reopenModal: false
                    });
                }
            }
        }
    }, [
        isThinking,
        isUpdate,
        isEditorRemixStateRearchitectureTreatment,
        historyEntryForUpdate,
        dynamicUiSubtypeForUpdate,
        isViewMode,
        onDismissThinkingUi,
        retainedLifecycle,
        settleRefusedAdmission
    ]);
    // Render nothing while no remix UI belongs on screen, but stay mounted. Every hook above keeps
    // running, which is the point: this subtree owns the conversation read that produces
    // `finalMessage`. Placed after the last hook so the early return cannot change hook order.
    if (!isUiVisible) return null;
    if (!isViewMode && showLocationPicker && (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $70441b6598113e0c$export$378069e28d21ecbf), null);
    // Create flows own their editor thinking presentation. For updates, only the stale preset that
    // Bug 1 identified as externally owned yields its fixed bar to the legitimate inline Rovo owner.
    const hideThinkingBar = !isViewMode && isThinking && (!isUpdate || isEditorRemixStateRearchitectureTreatment === true && externallyOwnedPresetUpdateKey !== undefined);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8GyO5.RemixContainer), {
        isWaitingForInput: isWaitingForInput,
        remixAttemptId: remixAttemptId,
        hideThinkingBar: (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') ? hideThinkingBar : undefined,
        showProgressBar: (0, $iDrrr.fg)('platform_editor_maui_jira_updates') && (!(0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') || isViewMode),
        isComplete: (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') ? pluginIsComplete : isComplete,
        isThinking: (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') ? isThinking : undefined,
        onCompleteAnimationFinished: (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') ? !hideThinkingBar ? onCompleteAnimationFinished : undefined : onCompleteAnimationFinished,
        onClose: handleRemixOverlayClose,
        onOptionSelect: onOptionSelect,
        onRemixFlowActiveChange: onRemixFlowActiveChange,
        isEphemeralViewVisible: productIntegration.isRemixPreviewVisible,
        hiddenOptions: hiddenOptions,
        contentType: productIntegration.contentType,
        autoSubmitUserPrompt: remixModalMetadata?.userPrompt ?? undefined,
        autoSubmitSelection: autoSubmitSelection,
        onStopThinking: onStopThinking,
        anchorRect: remixModalMetadata?.anchorRect,
        popupPlacement: remixModalMetadata?.popupPlacement ?? 'bottom-start',
        isRemixEntrance: (0, $anBbz.expValEqualsNoExposure)('cc_page_experiences_editor_image_generation', 'isEnabled', true) ? !remixModalMetadata?.userPrompt : true
    }));
};
const $437afbad13638573$export$9d4c73ad3f5edcd5 = (props)=>{
    // `startRemixThinking` closes the options modal (`isRemixModalOpen` false) while remix
    // is still active. We must keep rendering `RemixContainer` (thinking bar / ephemeral)
    // whenever the editor reports `isThinking`, not only when the modal is open.
    // Whether any remix UI belongs on screen. `startRemixThinking` closes the options modal
    // (`isRemixModalOpen` false) while remix is still active, so `isThinking` has to keep the
    // container rendered too, not only an open modal.
    const isRemixUiVisible = props.isModalOpen || props.isThinking || props.showLocationPicker && (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading');
    // `hasLiveMachineFlow` covers a window neither flag can see: the machine projection turns
    // `isThinking` off when the early streaming whiteboard is placed, while generation continues.
    // The subtree below owns the conversation read that produces `finalMessage`, so it has to stay
    // mounted across that window or the final message lands with nothing listening and the insert
    // is never finalized. It renders `null` there rather than unmounting, which keeps the option
    // picker off screen without dropping the subscription.
    if (!isRemixUiVisible && !props.hasLiveMachineFlow) return null;
    const inner = (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7akNQ.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bb37f8415315e332$export$93604a1decc87c40), {
        editorRemixLifecycleAdapter: props.editorRemixLifecycleAdapter,
        isEditorRemixStateRearchitectureTreatment: props.isEditorRemixStateRearchitectureTreatment,
        isViewMode: props.isViewMode,
        isRemixPreviewVisible: props.productIntegration.isRemixPreviewVisible,
        clearThinkingDecoration: props.clearThinkingDecoration,
        onBeforeEditorRemixResultInsertion: props.onBeforeEditorRemixResultInsertion,
        replaceWhiteboardEmbed: props.replaceWhiteboardEmbed,
        setMauiEmbedFinalizeStatus: props.setMauiEmbedFinalizeStatus,
        entryPoint: props.entryPoint,
        smartCreationConfig: props.smartCreationConfig,
        smartCreationContext: props.smartCreationContext,
        productConfig: props.productConfig,
        setThinkingComplete: props.setThinkingComplete,
        setThinkingWaitingForInput: props.setThinkingWaitingForInput,
        finishRemixThinking: props.finishRemixThinking,
        onRemixThinkingCompleteAnimationFinished: props.onRemixThinkingCompleteAnimationFinished,
        showLocationPicker: props.showLocationPicker,
        setShowLocationPicker: props.setShowLocationPicker,
        addHistoryEntry: props.addHistoryEntry,
        addHistoryStackEntry: props.addHistoryStackEntry,
        onVariantUpdateComplete: props.onVariantUpdateComplete,
        onSubtypeMismatch: props.onSubtypeMismatch,
        onRemixInsertSuccess: props.productIntegration.onRemixInsertSuccess,
        onFinalizeSuccess: props.productIntegration.onFinalizeSuccess,
        onFinalizeFailed: props.productIntegration.onFinalizeFailed,
        scheduleRemixRetentionCheck: props.scheduleRemixRetentionCheck,
        isUpdate: props.isUpdate,
        historyEntryForUpdate: props.historyEntryForUpdate,
        dynamicUiSubtypeForUpdate: props.dynamicUiSubtypeForUpdate
    }, (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($437afbad13638573$var$OnCompleteSync, null) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($437afbad13638573$var$RemixContentComponentInner, {
        isUiVisible: isRemixUiVisible,
        clearThinkingDecoration: props.clearThinkingDecoration,
        replaceWhiteboardEmbed: props.replaceWhiteboardEmbed,
        handleModalClose: props.handleModalClose,
        isModalOpen: props.isModalOpen,
        isComplete: props.isComplete,
        selectedContext: props.selectedContext,
        editorApi: props.editorApi,
        setThinkingComplete: props.setThinkingComplete,
        finishRemixThinking: props.finishRemixThinking,
        onStartThinking: props.onStartThinking,
        onDismissThinkingUi: props.onDismissThinkingUi,
        onStopThinking: props.onStopThinking,
        onRegisterAbortRequest: props.onRegisterAbortRequest,
        onRegisterEditorRemixUxHandles: props.onRegisterEditorRemixUxHandles,
        onRegisterEditorRemixMutationCancellationSink: props.onRegisterEditorRemixMutationCancellationSink,
        remixModalMetadata: props.remixModalMetadata,
        remixSource: props.remixSource,
        isThinking: props.isThinking,
        isEditorRemixStateRearchitectureTreatment: props.isEditorRemixStateRearchitectureTreatment,
        productIntegration: props.productIntegration,
        productConfig: props.productConfig,
        hiddenOptions: props.hiddenOptions
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($437afbad13638573$var$RemixContentComponentInner, {
        isUiVisible: isRemixUiVisible,
        clearThinkingDecoration: props.clearThinkingDecoration,
        replaceWhiteboardEmbed: props.replaceWhiteboardEmbed,
        handleModalClose: props.handleModalClose,
        isModalOpen: props.isModalOpen,
        isComplete: props.isComplete,
        selectedContext: props.selectedContext,
        editorApi: props.editorApi,
        setThinkingComplete: props.setThinkingComplete,
        finishRemixThinking: props.finishRemixThinking,
        onStartThinking: props.onStartThinking,
        onDismissThinkingUi: props.onDismissThinkingUi,
        onStopThinking: props.onStopThinking,
        onRegisterAbortRequest: props.onRegisterAbortRequest,
        onRegisterEditorRemixUxHandles: props.onRegisterEditorRemixUxHandles,
        onRegisterEditorRemixMutationCancellationSink: props.onRegisterEditorRemixMutationCancellationSink,
        remixModalMetadata: props.remixModalMetadata,
        remixSource: props.remixSource,
        isThinking: props.isThinking,
        isEditorRemixStateRearchitectureTreatment: props.isEditorRemixStateRearchitectureTreatment,
        productIntegration: props.productIntegration,
        productConfig: props.productConfig,
        hiddenOptions: props.hiddenOptions
    });
    if (props.remixModalMetadata?.aiFeatureName) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1Pvvv.AIMateAnalyticsContext), {
        data: {
            attributes: {
                aiFeatureName: props.remixModalMetadata.aiFeatureName
            }
        }
    }, inner);
    return inner;
};






var $bWlOZ = parcelRequire("bWlOZ");

var $2Pvub = parcelRequire("2Pvub");








var $8aF6s = parcelRequire("8aF6s");


var $7aRa9 = parcelRequire("7aRa9");








var $ep3mz = parcelRequire("ep3mz");


var $3jwuS = parcelRequire("3jwuS");





var $ficwO = parcelRequire("ficwO");


var $bQm3c = parcelRequire("bQm3c");


var $zCcSI = parcelRequire("zCcSI");


var $cJeDc = parcelRequire("cJeDc");


var $9cZ1w = parcelRequire("9cZ1w");


var $kqIWy = parcelRequire("kqIWy");


var $aSsfA = parcelRequire("aSsfA");


var $gc4HO = parcelRequire("gc4HO");

const $95b2dd072c7020e7$var$TAGS = [
    'remix',
    'stateRearchitecture'
];
const $95b2dd072c7020e7$export$e6c8b098f47bc21 = (createAnalyticsEvent, observation)=>{
    try {
        const { actionSubjectId: actionSubjectId, producer: producer, artifactType: artifactType, sentinelSource: sentinelSource, outcome: outcome, reason: reason } = observation;
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'observed',
                actionSubject: 'editorRemixLifecycleOwnership',
                actionSubjectId: actionSubjectId,
                source: 'editorRemix',
                tags: $95b2dd072c7020e7$var$TAGS,
                attributes: {
                    migrationPhase: 'ownership-soak',
                    producer: producer,
                    artifactType: artifactType,
                    ...sentinelSource ? {
                        sentinelSource: sentinelSource
                    } : {},
                    outcome: outcome,
                    reason: reason,
                    ...'phaseAtSettlement' in observation && observation.phaseAtSettlement ? {
                        phaseAtSettlement: observation.phaseAtSettlement
                    } : {},
                    ...'settlementTrigger' in observation && observation.settlementTrigger ? {
                        settlementTrigger: observation.settlementTrigger
                    } : {},
                    ...'blockingAttempt' in observation && observation.blockingAttempt ? {
                        blockingAttempt: observation.blockingAttempt
                    } : {}
                }
            }
        }).fire();
    } catch  {
    // Observability must never affect Remix behavior.
    }
};



var $iMLPM = parcelRequire("iMLPM");

/**
 * Reports when the editor's legacy lifecycle and the Remix state machine settle on different
 * phases. This is a read-only observer: it derives nothing the editor does not already compute for
 * itself, and it never participates in editor behavior.
 *
 * Classification lives in `editorRemixParity.ts`; this hook owns only scoping, settle timing and
 * deduplication. The editor reports its own phase through the lifecycle adapter, and the machine
 * phase is read imperatively from the registry rather than through `useMachinePhase`, so machine
 * transitions add no renders to the editor subtree.
 */ 













/**
 * Builds and fires the bounded operational event for an editor Remix parity divergence.
 *
 * Every attribute is drawn from a closed union, so the payload carries no flow identifier, no
 * content reference, and no user content. `remixId` scopes deduplication inside
 * `useEditorRemixParityDiagnostics` and deliberately never reaches this dispatcher.
 *
 * `treatmentPhase` records the migration phase the event was observed in. The editor runs in M2
 * shadow, where legacy state stays authoritative, so the only value today is `shadow`. It exists to
 * keep these events distinguishable once the editor read cutover (CCCEMAU-3488) lands. The renderer
 * equivalent reports `machine-read` because its cutover has already happened.
 *
 * EVENT IDENTITY: a distinct subject from the renderer's `rendererRemixStateParity`, rather than
 * emitting under that subject and discriminating on `entryPoint`. This mirrors the per-surface
 * pairing the renderer already established, so each surface owns both of its operational events:
 *
 *   renderer: `rendererRemixStateParity` + `rendererRemixLifecycleOperation`, source `rendererRemix`
 *   editor:   `editorRemixStateParity`   + `editorRemixLifecycleOperation`,   source `editorRemix`
 *
 * Because this is a new subject rather than a reuse, it needs its own Data Portal registration
 * before `remix_state_rearchitecture_editor` ramps — otherwise the dashboard stays empty, which is
 * indistinguishable from clean parity.
 */ const $2d19728253dfbda3$var$ACTION = 'diverged';
const $2d19728253dfbda3$var$ACTION_SUBJECT = 'editorRemixStateParity';
const $2d19728253dfbda3$var$SOURCE = 'editorRemix';
const $2d19728253dfbda3$var$ENTRY_POINT = 'editor';
const $2d19728253dfbda3$var$TREATMENT_PHASE = 'shadow';
/** Shared with the renderer parity event so both surfaces can be queried by tag. */ const $2d19728253dfbda3$var$TAGS = [
    'remix',
    'stateRearchitecture'
];
const $2d19728253dfbda3$export$faea11873c201815 = ({ producerKind: producerKind, legacyPhase: legacyPhase, machinePhase: machinePhase, comparisonPoint: comparisonPoint, divergenceReason: divergenceReason })=>`${producerKind}|${legacyPhase}|${machinePhase}|${comparisonPoint}|${divergenceReason}`;
const $2d19728253dfbda3$export$fbed7643d7aab933 = (createAnalyticsEvent, { producerKind: producerKind, legacyPhase: legacyPhase, machinePhase: machinePhase, comparisonPoint: comparisonPoint, divergenceReason: divergenceReason })=>{
    try {
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: $2d19728253dfbda3$var$ACTION,
                actionSubject: $2d19728253dfbda3$var$ACTION_SUBJECT,
                source: $2d19728253dfbda3$var$SOURCE,
                tags: $2d19728253dfbda3$var$TAGS,
                attributes: {
                    entryPoint: $2d19728253dfbda3$var$ENTRY_POINT,
                    severity: 'critical',
                    outcome: divergenceReason === 'terminal-outcome-mismatch' ? 'terminal-mismatch' : 'released-unresolved',
                    reason: divergenceReason,
                    producerKind: producerKind,
                    legacyPhase: legacyPhase,
                    machinePhase: machinePhase,
                    comparisonPoint: comparisonPoint,
                    divergenceReason: divergenceReason,
                    treatmentPhase: $2d19728253dfbda3$var$TREATMENT_PHASE
                }
            }
        }).fire();
    } catch  {
    // Diagnostics must never affect the editor flow.
    }
};
const $2d19728253dfbda3$export$c104e903814d46ff = (createAnalyticsEvent, { producerKind: producerKind, legacyPhase: legacyPhase, machinePhase: machinePhase, comparisonPoint: comparisonPoint, action: action, outcome: outcome, reason: reason, durationBucket: durationBucket })=>{
    try {
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: action,
                actionSubject: 'editorRemixParityMechanic',
                source: $2d19728253dfbda3$var$SOURCE,
                tags: $2d19728253dfbda3$var$TAGS,
                attributes: {
                    entryPoint: $2d19728253dfbda3$var$ENTRY_POINT,
                    severity: 'info',
                    outcome: outcome,
                    reason: reason,
                    producerKind: producerKind,
                    legacyPhase: legacyPhase,
                    machinePhase: machinePhase,
                    comparisonPoint: comparisonPoint,
                    durationBucket: durationBucket,
                    treatmentPhase: $2d19728253dfbda3$var$TREATMENT_PHASE
                }
            }
        }).fire();
    } catch  {
    // Diagnostics must never affect the editor flow.
    }
};


/**
 * Pure comparison of the editor's legacy lifecycle against the Remix state machine.
 *
 * Both sides are expressed in the shared editor's own `EditorRemixLifecyclePhase` vocabulary, so
 * diagnostics introduce no second normalization of editor state. Nothing here reads or mutates
 * runtime state: callers pass two phases plus whether the pair has settled, and get back a
 * classification. Timing and scoping are the caller's concern.
 *
 * Both projections into that vocabulary live in the shared editor package, next to each other; this
 * module owns only the classification of a pair.
 *
 * The renderer equivalent lives in `rendererRemixParity.ts`. The two are deliberately separate
 * rather than generalized: the phase vocabularies differ (the renderer projects the machine's
 * `inserting` as `submitting`; the editor does not) and each surface classifies its own skew.
 */ 


const $3a933293b1eefe6e$var$COMPARISON_POINT_BY_LEGACY_PHASE = {
    inactive: 'released',
    thinking: 'flow-started',
    ready: 'result-ready',
    previewing: 'preview-opened',
    inserting: 'inserting',
    error: 'error',
    aborted: 'aborted'
};
const $3a933293b1eefe6e$export$b2aaa5bc54318fb1 = (legacyPhase)=>$3a933293b1eefe6e$var$COMPARISON_POINT_BY_LEGACY_PHASE[legacyPhase];
const $3a933293b1eefe6e$export$d239298095fe15f0 = (legacyPhase, machinePhase)=>{
    // The machine is running a flow the editor no longer considers active.
    if (legacyPhase === 'inactive') return 'legacy-not-tracking';
    if ((0, $gZHXx.isTerminalEditorRemixPhase)(legacyPhase) || (0, $gZHXx.isTerminalEditorRemixPhase)(machinePhase)) return 'terminal-outcome-mismatch';
    return 'unexpected-phase-pair';
};
const $3a933293b1eefe6e$export$b8437f017644102f = ({ producerKind: producerKind, legacyPhase: legacyPhase, machinePhase: machinePhase, isStable: isStable })=>{
    // `inactive` covers both admission skew and a released machine flow, and the editor releases on
    // a successful insertion while its own state settles afterwards. Comparing here would report
    // normal teardown as a divergence, so terminal pairs must be captured before release. The
    // lifecycle owner instruments its own release paths separately.
    if (machinePhase === 'inactive') return {
        outcome: 'pending',
        reason: 'machine-not-tracking'
    };
    if (legacyPhase === machinePhase) return {
        outcome: 'match'
    };
    if (!isStable) return {
        outcome: 'pending',
        reason: 'awaiting-stable-phases'
    };
    return {
        outcome: 'divergence',
        divergence: {
            producerKind: producerKind,
            legacyPhase: legacyPhase,
            machinePhase: machinePhase,
            comparisonPoint: $3a933293b1eefe6e$export$b2aaa5bc54318fb1(legacyPhase),
            divergenceReason: $3a933293b1eefe6e$export$d239298095fe15f0(legacyPhase, machinePhase)
        }
    };
};



var $nkPkg = parcelRequire("nkPkg");

/**
 * How long a non-terminal phase pair must hold before it counts as settled.
 *
 * The editor's own state and the machine's watcher-driven phase land on different ticks, so a
 * healthy flow briefly reports two different phases at every transition. Reporting only what
 * survives this delay keeps that ordinary skew out of the signal.
 *
 * Matches the renderer's window so both surfaces are equally sensitive.
 */ const $29c93ce36895d779$var$PARITY_SETTLE_MS = 250;
/**
 * Runs an observation step, swallowing anything it throws.
 *
 * Every entry point is wrapped in this. Diagnostics are called from inside the admission and
 * settlement paths, so an observer that threw would turn a healthy flow into a failed one — the one
 * thing this must never do. There is no product behavior to fall back to, so a failed observation
 * is simply not reported.
 */ const $29c93ce36895d779$var$safely = (observation)=>{
    try {
        observation();
    } catch  {
    // Diagnostics must never affect the editor flow.
    }
};
const $29c93ce36895d779$export$b20741ce45749fa9 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const observedRef = (0, $cozmU.useRef)(undefined);
    /**
   * The editor's most recent phase, tracked whether or not a flow is being observed.
   *
   * Both producers turn thinking on before they ask for admission, so the editor is already at
   * `thinking` by the time a flow arrives here. Seeding a new flow at `inactive` instead would
   * strand it there — the reporter dedupes on its side and will not resend a phase it has already
   * sent — producing a false `legacy-not-tracking` divergence on an ordinary flow.
   */ const latestLegacyPhaseRef = (0, $cozmU.useRef)('inactive');
    const clearSettleTimeout = (0, $cozmU.useCallback)((flow)=>{
        if (flow.settleTimeout !== undefined) {
            clearTimeout(flow.settleTimeout);
            flow.settleTimeout = undefined;
        }
    }, []);
    const stopObserving = (0, $cozmU.useCallback)((flow)=>{
        clearSettleTimeout(flow);
        flow.unsubscribe();
        if (observedRef.current === flow) observedRef.current = undefined;
    }, [
        clearSettleTimeout
    ]);
    const reportDivergence = (0, $cozmU.useCallback)((flow, machinePhase, reasonOverride)=>{
        const settled = (0, $3a933293b1eefe6e$export$b8437f017644102f)({
            producerKind: flow.producerKind,
            legacyPhase: flow.legacyPhase,
            machinePhase: machinePhase,
            isStable: true
        });
        if (settled.outcome !== 'divergence') return;
        const divergenceReason = reasonOverride ?? settled.divergence.divergenceReason;
        if (divergenceReason === 'unexpected-phase-pair') return;
        const severeDivergence = {
            ...settled.divergence,
            divergenceReason: divergenceReason
        };
        // A definitive severe disposition closes every mechanic retained for this flow. None of
        // them converged, so discard them without emitting misleading resolved events.
        flow.mechanicObservations.clear();
        // Each admitted flow reports a given divergence once, so a divergence that persists
        // across many transitions does not become a flood of identical events.
        const signature = (0, $2d19728253dfbda3$export$faea11873c201815)(severeDivergence);
        if (flow.reportedSignatures.has(signature)) return;
        flow.reportedSignatures.add(signature);
        (0, $2d19728253dfbda3$export$fbed7643d7aab933)(createAnalyticsEvent, severeDivergence);
    }, [
        createAnalyticsEvent
    ]);
    const reportMechanicObserved = (0, $cozmU.useCallback)((flow, machinePhase)=>{
        const result = (0, $3a933293b1eefe6e$export$b8437f017644102f)({
            producerKind: flow.producerKind,
            legacyPhase: flow.legacyPhase,
            machinePhase: machinePhase,
            isStable: true
        });
        if (result.outcome !== 'divergence' || result.divergence.divergenceReason !== 'unexpected-phase-pair' && !((0, $gZHXx.isTerminalEditorRemixPhase)(flow.legacyPhase) && !(0, $gZHXx.isTerminalEditorRemixPhase)(machinePhase))) return;
        const signature = (0, $2d19728253dfbda3$export$faea11873c201815)(result.divergence);
        if (flow.reportedMechanicSignatures.has(signature)) return;
        flow.reportedMechanicSignatures.add(signature);
        flow.mechanicObservations.set(signature, {
            legacyPhase: flow.legacyPhase,
            machinePhase: machinePhase,
            comparisonPoint: result.divergence.comparisonPoint,
            startedAt: Date.now() - $29c93ce36895d779$var$PARITY_SETTLE_MS
        });
        (0, $2d19728253dfbda3$export$c104e903814d46ff)(createAnalyticsEvent, {
            producerKind: flow.producerKind,
            legacyPhase: flow.legacyPhase,
            machinePhase: machinePhase,
            comparisonPoint: result.divergence.comparisonPoint,
            action: 'observed',
            outcome: 'timing-skew',
            reason: 'awaiting-convergence',
            durationBucket: (0, $nkPkg.durationBucketForMs)($29c93ce36895d779$var$PARITY_SETTLE_MS)
        });
    }, [
        createAnalyticsEvent
    ]);
    const resolveMechanics = (0, $cozmU.useCallback)((flow)=>{
        if (flow.mechanicObservations.size === 0) return;
        const observations = Array.from(flow.mechanicObservations.values());
        flow.mechanicObservations.clear();
        for (const pending of observations)(0, $2d19728253dfbda3$export$c104e903814d46ff)(createAnalyticsEvent, {
            producerKind: flow.producerKind,
            legacyPhase: pending.legacyPhase,
            machinePhase: pending.machinePhase,
            comparisonPoint: pending.comparisonPoint,
            action: 'resolved',
            outcome: 'converged',
            reason: 'phase-converged',
            durationBucket: (0, $nkPkg.durationBucketForMs)(Date.now() - pending.startedAt)
        });
    }, [
        createAnalyticsEvent
    ]);
    /**
   * Classifies a pair still pending when observation ends.
   *
   * Convergence is the normal case: in shadow the machine drives nothing, so teardown only follows
   * the editor reaching its own terminal phase, which the machine then matches. The one case worth
   * keeping is the pair that never converged and is now out of time — the machine settled on one
   * terminal outcome while the editor settled on the other.
   *
   * Both sides must be terminal to report. A terminal machine against a non-terminal editor is the
   * same skew the settle window exists for: the machine subscriber runs synchronously on the
   * watcher's transition while the editor's own terminal state needs a React commit, and an
   * ordinary error tears the Remix UI down inside that window. Reporting on the machine side alone
   * would fire on every one of those.
   *
   * Read the pending flag before `stopObserving`, which clears it.
   */ const classifyUnsettledPairAtTeardown = (0, $cozmU.useCallback)((flow)=>{
        const machinePhase = (0, $gZHXx.deriveMachineEditorRemixPhase)((0, $bWlOZ.getRemixMachine)(flow.remixId)?.state());
        if (flow.mechanicObservations.size > 0 && (0, $gZHXx.isTerminalEditorRemixPhase)(flow.legacyPhase) && !(0, $gZHXx.isTerminalEditorRemixPhase)(machinePhase)) {
            reportDivergence(flow, machinePhase, 'released-unresolved');
            return;
        }
        if (flow.settleTimeout === undefined) return;
        if ((0, $gZHXx.isTerminalEditorRemixPhase)(machinePhase) && (0, $gZHXx.isTerminalEditorRemixPhase)(flow.legacyPhase)) reportDivergence(flow, machinePhase);
    }, [
        reportDivergence
    ]);
    /**
   * Classifies the flow's current pair, deferring anything that has not settled.
   *
   * Every differing pair waits out the settle window, including a terminal machine phase. The
   * machine subscriber fires synchronously on the watcher's transition while the editor's own
   * error and abort state needs a React commit, so reporting a terminal machine phase on sight
   * would fire a `terminal-outcome-mismatch` on every ordinary error. A pair that is genuinely
   * stuck is caught by `classifyUnsettledPairAtTeardown` instead. Non-terminal pairs are reported as
   * low-severity mechanics; only terminal evidence reaches the severe dispatcher.
   */ const evaluate = (0, $cozmU.useCallback)((flow)=>{
        clearSettleTimeout(flow);
        const machinePhase = (0, $gZHXx.deriveMachineEditorRemixPhase)((0, $bWlOZ.getRemixMachine)(flow.remixId)?.state());
        const result = (0, $3a933293b1eefe6e$export$b8437f017644102f)({
            producerKind: flow.producerKind,
            legacyPhase: flow.legacyPhase,
            machinePhase: machinePhase,
            isStable: false
        });
        if (result.outcome === 'match' || result.outcome === 'pending') {
            if (result.outcome === 'match') resolveMechanics(flow);
            if (result.outcome === 'pending' && result.reason === 'awaiting-stable-phases') flow.settleTimeout = setTimeout(()=>{
                flow.settleTimeout = undefined;
                // Re-read both sides: the pair that settles is the one worth reporting, and either
                // side may have moved while the window was open.
                const settledMachinePhase = (0, $gZHXx.deriveMachineEditorRemixPhase)((0, $bWlOZ.getRemixMachine)(flow.remixId)?.state());
                const settled = (0, $3a933293b1eefe6e$export$b8437f017644102f)({
                    producerKind: flow.producerKind,
                    legacyPhase: flow.legacyPhase,
                    machinePhase: settledMachinePhase,
                    isStable: true
                });
                if (settled.outcome === 'match') {
                    resolveMechanics(flow);
                    return;
                }
                if (settled.outcome !== 'divergence') return;
                if ((0, $gZHXx.isTerminalEditorRemixPhase)(settledMachinePhase)) reportDivergence(flow, settledMachinePhase);
                else reportMechanicObserved(flow, settledMachinePhase);
            }, $29c93ce36895d779$var$PARITY_SETTLE_MS);
            return;
        }
        reportDivergence(flow, machinePhase);
    }, [
        clearSettleTimeout,
        reportDivergence,
        reportMechanicObserved,
        resolveMechanics
    ]);
    const observeFlow = (0, $cozmU.useCallback)((remixId, producerKind)=>{
        $29c93ce36895d779$var$safely(()=>{
            const previous = observedRef.current;
            if (previous) // A newly admitted flow supersedes the previous one. Ending observation is not proof
            // of divergence, so the retained pair is discarded without classification.
            stopObserving(previous);
            const flow = {
                remixId: remixId,
                producerKind: producerKind,
                // Seeded from the editor's current phase, not from `inactive`: thinking is already on
                // by the time admission happens.
                legacyPhase: latestLegacyPhaseRef.current,
                reportedSignatures: new Set(),
                unsubscribe: ()=>{},
                settleTimeout: undefined,
                mechanicObservations: new Map(),
                reportedMechanicSignatures: new Set()
            };
            flow.unsubscribe = (0, $2Pvub.subscribeToMachine)(remixId, ()=>{
                $29c93ce36895d779$var$safely(()=>{
                    if (observedRef.current === flow) evaluate(flow);
                });
            });
            observedRef.current = flow;
            // Admission is itself a comparison point. Waiting for the next machine transition would
            // miss a pair that is already mismatched the moment the flow is admitted.
            evaluate(flow);
        });
    }, [
        evaluate,
        stopObserving
    ]);
    const releaseFlow = (0, $cozmU.useCallback)((remixId)=>{
        $29c93ce36895d779$var$safely(()=>{
            const flow = observedRef.current;
            if (flow?.remixId !== remixId) return;
            classifyUnsettledPairAtTeardown(flow);
            stopObserving(flow);
        });
    }, [
        classifyUnsettledPairAtTeardown,
        stopObserving
    ]);
    const recordLegacyPhase = (0, $cozmU.useCallback)((legacyPhase)=>{
        $29c93ce36895d779$var$safely(()=>{
            // Recorded unconditionally so the next admitted flow can be seeded from it, even when
            // this phase arrives before any flow exists.
            latestLegacyPhaseRef.current = legacyPhase;
            const flow = observedRef.current;
            if (!flow || flow.legacyPhase === legacyPhase) return;
            flow.legacyPhase = legacyPhase;
            evaluate(flow);
        });
    }, [
        evaluate
    ]);
    (0, $cozmU.useEffect)(()=>()=>{
            $29c93ce36895d779$var$safely(()=>{
                const flow = observedRef.current;
                if (flow) {
                    classifyUnsettledPairAtTeardown(flow);
                    stopObserving(flow);
                }
            });
        }, [
        classifyUnsettledPairAtTeardown,
        stopObserving
    ]);
    return (0, $cozmU.useMemo)(()=>({
            observeFlow: observeFlow,
            releaseFlow: releaseFlow,
            recordLegacyPhase: recordLegacyPhase
        }), [
        observeFlow,
        recordLegacyPhase,
        releaseFlow
    ]);
};



var $hxqA6 = parcelRequire("hxqA6");

/**
 * Bounds the wait for the Rovo sidebar to show the requested conversation. Distinct from the
 * insertion acknowledgement timeout: expiry means "no proof of handoff", not an insertion outcome.
 */ const $cb26a2afd8038e71$var$ROVO_CHAT_HANDOFF_ACKNOWLEDGEMENT_TIMEOUT_MS = 10000;
const $cb26a2afd8038e71$var$REMIX_MBE_ALLOW_LIST = [
    'native-tabs'
];
const $cb26a2afd8038e71$var$REMIX_NO_EMPTY_CHECK_EXTENSION_ALLOW_LIST = new Set([
    'native-embed:page'
]);
/** Only invoked for expand node types, so other selections never read the experiment. */ const $cb26a2afd8038e71$var$areRemixExpandsEnabled = ()=>(0, $6mKj3.isExperimentEnabled)((0, $1qYXT.REMIX_EXPANDS_EXPERIMENT));
const $cb26a2afd8038e71$export$6b53e18ae81f1dc6 = (node)=>{
    if (node.type === 'multiBodiedExtension') return !(0, $1qYXT.isAllowedMBEExtensionForRemix)(node.attrs?.extensionKey, $cb26a2afd8038e71$var$REMIX_MBE_ALLOW_LIST);
    if (node.type === 'extension' && typeof node.attrs?.extensionKey === 'string' && $cb26a2afd8038e71$var$REMIX_NO_EMPTY_CHECK_EXTENSION_ALLOW_LIST.has(node.attrs.extensionKey) && (0, $iDrrr.fg)('maui_remixable_page_native_embeds')) return false;
    return (0, $1qYXT.isRemixRestrictedNodeTypeWithExpands)(node.type, $cb26a2afd8038e71$var$areRemixExpandsEnabled);
};
const $cb26a2afd8038e71$var$confluenceProductConfig = {
    productKey: 'confluence',
    analyticsProductName: 'confluence',
    getRemixGeneratePreviewMetadata: ({ type: type })=>type === 'infographic' ? {
            isConfluenceInfographicsTwoStageEnabled: (0, $iDrrr.fg)('confluence-infographics-two-stage')
        } : {},
    isNodeUnsupportedForRemix: $cb26a2afd8038e71$export$6b53e18ae81f1dc6,
    shouldUseEphemeralPreview: (chatMessages)=>{
        for(let i = chatMessages.length - 1; i >= 0; i--){
            const message = chatMessages[i];
            if (message.type === 'ACTION_PREPARE') return message.action ? (0, $aYC8J.isRemixGeneratedFlow)(message.action) : false;
        }
        return false;
    },
    isActionReady: (chatMessages)=>{
        const hasWhiteboard = (0, $kNXXO.findLastAssistantAction)(chatMessages, (action)=>action.key === (0, $aYC8J.CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY) || action.key === (0, $aYC8J.CONFLUENCE_AIFC_WHITEBOARD_UPDATE_KEY)) !== undefined;
        if (hasWhiteboard) return true;
        for(let i = chatMessages.length - 1; i >= 0; i--){
            const message = chatMessages[i];
            if (message.type === 'ACTION_COMPLETE') return true;
            if (message.type === 'HUMAN') return false;
        }
        return false;
    }
};
const $cb26a2afd8038e71$var$useEditorRemixLifecycleAdapter = (onRegisterEditorRemixMachineLifecycleOwnership, isEditorRemixStateRearchitectureTreatment)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const observeLifecycle = (0, $cozmU.useCallback)((observation)=>(0, $95b2dd072c7020e7$export$e6c8b098f47bc21)(createAnalyticsEvent, observation), [
        createAnalyticsEvent
    ]);
    const { releaseFlow: releaseFlow, recordLegacyPhase: recordLegacyPhase } = (0, $29c93ce36895d779$export$b20741ce45749fa9)();
    const logLifecycleOperationError = (0, $cozmU.useCallback)((operation, error)=>{
        try {
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'failed',
                    actionSubject: 'editorRemixLifecycleOperation',
                    source: 'editorRemix',
                    attributes: {
                        operation: operation,
                        errorName: error instanceof Error ? error.name : typeof error
                    }
                }
            }).fire();
        } catch  {
        // Diagnostics must never affect lifecycle behavior.
        }
    }, [
        createAnalyticsEvent
    ]);
    const createHandle = (0, $cozmU.useCallback)(({ conversationId: conversationId, remixId: remixId, observation: observation })=>{
        let hasSettled = false;
        let hasObservedSettlement = false;
        let hasBeenRetained = false;
        // The owner destroys the machine on a terminal transition, so the phase a flow settled from
        // has to be recorded while it is live. This records only live phases, so a notification after
        // the owner destroys the machine is ignored.
        let lastLivePhase = 'unknown';
        const recordLivePhase = ()=>{
            const phase = (0, $gZHXx.deriveMachineEditorRemixPhase)((0, $bWlOZ.getRemixMachine)(remixId)?.state());
            if (phase !== 'inactive' && !(0, $gZHXx.isTerminalEditorRemixPhase)(phase)) lastLivePhase = phase;
        };
        let unsubscribePhase = ()=>{};
        try {
            recordLivePhase();
            unsubscribePhase = (0, $2Pvub.subscribeToMachine)(remixId, recordLivePhase);
        } catch  {
        // Diagnostics must never affect lifecycle behavior.
        }
        let inFlightEvent;
        let isRollingBack = false;
        const observeSettlement = (outcome, reason)=>{
            if (!hasBeenRetained || hasObservedSettlement) return;
            hasObservedSettlement = true;
            observeLifecycle({
                actionSubjectId: 'settlement',
                producer: observation?.producer ?? 'create',
                artifactType: observation?.artifactType ?? 'unknown',
                ...observation?.sentinelSource ? {
                    sentinelSource: observation.sentinelSource
                } : {},
                outcome: outcome,
                reason: reason,
                phaseAtSettlement: lastLivePhase,
                settlementTrigger: isRollingBack ? 'rollback' : inFlightEvent === 'CANCELLED' ? 'cancel-transition' : inFlightEvent ? 'producer-transition' : outcome === 'aborted' || outcome === 'error' ? 'machine-inferred' : 'direct-end'
            });
        };
        const end = (reason)=>{
            if (hasSettled) return;
            hasSettled = true;
            observeSettlement(reason, 'lifecycle-ended');
            unsubscribePhase();
            // Stop observing before the machine goes away: a released flow has no phase to compare
            // against, and settlement is not evidence of divergence.
            releaseFlow(remixId);
            try {
                (0, $bWlOZ.endRemix)(remixId, reason);
            } catch (error) {
                logLifecycleOperationError('endRemix', error);
            }
        };
        const transition = (event)=>{
            if (hasSettled) return false;
            try {
                const phaseBefore = (0, $bWlOZ.getRemixMachine)(remixId)?.state();
                inFlightEvent = event.type;
                (0, $bWlOZ.sendRemixEvent)(remixId, event);
                const accepted = phaseBefore !== (0, $bWlOZ.getRemixMachine)(remixId)?.state();
                if (accepted) {
                    const terminalOutcome = event.type === 'INSERTED' ? 'inserted' : event.type === 'INSERTION_FAILED' ? 'insertion-failed' : event.type === 'GENERATION_ERROR' ? 'error' : event.type === 'GENERATION_ABORTED' ? 'aborted' : event.type === 'CANCELLED' ? 'cancelled' : undefined;
                    if (terminalOutcome) observeSettlement(terminalOutcome, 'terminal-transition-accepted');
                }
                if (accepted && event.type === 'INSERTED') {
                    hasSettled = true;
                    unsubscribePhase();
                    releaseFlow(remixId);
                }
                return accepted;
            } catch (error) {
                logLifecycleOperationError('sendTransition', error);
                return false;
            } finally{
                inFlightEvent = undefined;
            }
        };
        const rollback = ()=>{
            if (hasSettled) return;
            isRollingBack = true;
            // Mandatory cleanup is structurally independent of the CANCELLED publish and its logging.
            try {
                (0, $bWlOZ.sendRemixEvent)(remixId, {
                    type: 'CANCELLED'
                });
            } catch (error) {
                logLifecycleOperationError('sendCancelled', error);
            } finally{
                end('cancelled');
            }
        };
        return {
            conversationId: conversationId,
            remixId: remixId,
            rollback: rollback,
            transition: transition,
            end: end,
            onRetained: (session)=>{
                if (!onRegisterEditorRemixMachineLifecycleOwnership) throw new Error('Editor Remix lifecycle ownership registration is unavailable');
                const cleanup = onRegisterEditorRemixMachineLifecycleOwnership(session);
                hasBeenRetained = true;
                return cleanup;
            }
        };
    }, [
        logLifecycleOperationError,
        onRegisterEditorRemixMachineLifecycleOwnership,
        observeLifecycle,
        releaseFlow
    ]);
    const startFlow = (0, $cozmU.useCallback)((request)=>{
        if (!isEditorRemixStateRearchitectureTreatment) return {
            status: 'disabled'
        };
        // The background-phase watcher host may not have loaded yet on a fresh page. Start its
        // fetch now so the admitted flow is observed without waiting on the chunk.
        (0, $iMLPM.preloadRemixWatcherHost)();
        try {
            const { observation: observation, ...lifecycleRequest } = request;
            // Neutral metadata is deliberate for this dormant foundation. Producer wiring will define
            // the content attribution carried by the lifecycle machine.
            // `useCommandBus` selects the process-default in-memory dispatcher, the same transport the
            // renderer surface uses. An admitted editor flow's terminal product effects are owned by
            // the command handlers on `EditorRemixEffectHost` from here on.
            const result = (0, $bWlOZ.startRemix)({
                ...lifecycleRequest,
                metadata: {},
                useCommandBus: true
            });
            if (!result) return {
                status: 'active-flow-rejected'
            };
            const handle = createHandle({
                ...result,
                observation: observation
            });
            if (request.conversationId !== undefined && result.conversationId !== request.conversationId) {
                logLifecycleOperationError('validateAdmissionIdentity', new Error('Machine admission returned a different conversation identity'));
                handle.rollback();
                return {
                    status: 'shadow-infrastructure-failure'
                };
            }
            // An admitted flow's ProseMirror lifecycle is machine-derived, so there is no second
            // phase to compare: parity observation is not started for it.
            return {
                status: 'admitted',
                handle: handle
            };
        } catch (error) {
            logLifecycleOperationError('startRemix', error);
            return {
                status: 'shadow-infrastructure-failure'
            };
        }
    }, [
        createHandle,
        isEditorRemixStateRearchitectureTreatment,
        logLifecycleOperationError
    ]);
    return (0, $cozmU.useMemo)(()=>({
            startFlow: startFlow,
            observeLegacyPhase: recordLegacyPhase,
            observeLifecycle: observeLifecycle
        }), [
        observeLifecycle,
        recordLegacyPhase,
        startFlow
    ]);
};
const $cb26a2afd8038e71$export$adea0596c0c4a3d3 = ({ isEditorRemixStateRearchitectureTreatment: isEditorRemixStateRearchitectureTreatment, onRegisterEditorInlineRovoEditLifecycleAdapter: onRegisterEditorInlineRovoEditLifecycleAdapter, onRegisterEditorRemixMachineLifecycleOwnership: onRegisterEditorRemixMachineLifecycleOwnership })=>{
    const editorRemixLifecycleAdapter = $cb26a2afd8038e71$var$useEditorRemixLifecycleAdapter(onRegisterEditorRemixMachineLifecycleOwnership, isEditorRemixStateRearchitectureTreatment);
    (0, $cozmU.useEffect)(()=>onRegisterEditorInlineRovoEditLifecycleAdapter(editorRemixLifecycleAdapter), [
        editorRemixLifecycleAdapter,
        onRegisterEditorInlineRovoEditLifecycleAdapter
    ]);
    return null;
};
const $cb26a2afd8038e71$var$useConfluenceProductIntegration = ({ dismissSubtypeAdjustedFlag: dismissSubtypeAdjustedFlag, flags: flags, onFinalizeFailed: onFinalizeFailed, rootPageTreeParentId: rootPageTreeParentId })=>{
    const { showSmartCreationModal: showSmartCreationModal } = (0, $jyA9t.useSmartCreationModalState)();
    const { openModal: openModal, closeModal: closeModal } = (0, $jyA9t.useSmartCreationModalActions)();
    const { isConversationAssistantSidebarActive: isConversationAssistantSidebarActive, openConversationAssistant: openAssistant, toggleConversationAssistant: toggleAssistant } = (0, $1AJi3.useToggleConversationAssistant)();
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    const { dynamicUiType: dynamicUiType, dynamicUiSubtype: dynamicUiSubtype } = (0, $8akfd.useStagingAreaState)();
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const showCreateWithRovoModalCloseFeedbackFlag = (0, $9cZ1w.useLazyShowFeedbackFlag)(flags, intl, showModal, createAnalyticsEvent);
    // Global chat store (`ChatStoreContainer isGlobal`): the conversation the sidebar is showing.
    const currentConversationId = (0, $6GT8L.useCurrentConversationId)();
    const pendingConversationOpenRef = (0, $cozmU.useRef)(undefined);
    const settlePendingConversationOpen = (0, $cozmU.useCallback)((result)=>{
        const pending = pendingConversationOpenRef.current;
        if (!pending) return;
        pendingConversationOpenRef.current = undefined;
        clearTimeout(pending.timer);
        pending.resolve(result);
    }, []);
    const isRequestedConversationOpen = (0, $cozmU.useCallback)((requestedConversationId)=>isConversationAssistantSidebarActive && requestedConversationId === currentConversationId, [
        currentConversationId,
        isConversationAssistantSidebarActive
    ]);
    (0, $cozmU.useEffect)(()=>{
        const pending = pendingConversationOpenRef.current;
        if (pending && isRequestedConversationOpen(pending.conversationId)) settlePendingConversationOpen({
            outcome: 'acknowledged'
        });
    }, [
        isRequestedConversationOpen,
        settlePendingConversationOpen
    ]);
    (0, $cozmU.useEffect)(()=>()=>settlePendingConversationOpen({
                outcome: 'abandoned',
                reason: 'unmounted'
            }), [
        settlePendingConversationOpen
    ]);
    const requestConversationAssistantOpen = (0, $cozmU.useCallback)((location, conversationId)=>new Promise((resolve)=>{
            settlePendingConversationOpen({
                outcome: 'abandoned',
                reason: 'superseded'
            });
            if (conversationId) (0, $dTEBe.updatePageRovoParams)({
                pathway: 'chat',
                conversationId: conversationId
            });
            openAssistant(location);
            if (!conversationId) {
                // Positive acknowledgement needs a conversation to observe; opening alone proves nothing.
                resolve({
                    outcome: 'rejected'
                });
                return;
            }
            if (isRequestedConversationOpen(conversationId)) {
                // Already showing the requested conversation; no store change will follow.
                resolve({
                    outcome: 'acknowledged'
                });
                return;
            }
            // Sidebar visibility alone is not acceptance; wait for the store, bounded.
            const timer = setTimeout(()=>{
                if (pendingConversationOpenRef.current?.resolve === resolve) settlePendingConversationOpen({
                    outcome: 'timed-out'
                });
            }, $cb26a2afd8038e71$var$ROVO_CHAT_HANDOFF_ACKNOWLEDGEMENT_TIMEOUT_MS);
            pendingConversationOpenRef.current = {
                conversationId: conversationId,
                resolve: resolve,
                timer: timer
            };
        }), [
        isRequestedConversationOpen,
        openAssistant,
        settlePendingConversationOpen
    ]);
    const onRemixInsertSuccess = (0, $cozmU.useCallback)(({ currentConversationId: currentConversationId, remixMetadata: remixMetadata, requestId: requestId })=>{
        dismissSubtypeAdjustedFlag?.();
        showCreateWithRovoModalCloseFeedbackFlag({
            feedbackVariant: (0, $cJeDc.FeedbackVariant).AFTER_REMIX_INSERT,
            contentType: contentType,
            contentMode: contentType === 'page' ? pageMode : undefined,
            cloudId: cloudId,
            currentConversationId: currentConversationId,
            remixMetadata: remixMetadata,
            requestId: requestId
        });
    }, [
        cloudId,
        contentType,
        dismissSubtypeAdjustedFlag,
        pageMode,
        showCreateWithRovoModalCloseFeedbackFlag
    ]);
    const publishPageTreeRefresh = (0, $cozmU.useCallback)((parentId)=>{
        const pageTreeParentId = parentId ?? rootPageTreeParentId;
        if (!pageTreeParentId) return;
        (0, $ficwO.publishMessage)((0, $ficwO.Message).PageTreeRefreshRequested, {
            parentId: pageTreeParentId
        });
    }, [
        rootPageTreeParentId
    ]);
    const onFinalizeSuccess = (0, $cozmU.useCallback)(({ parentId: parentId })=>{
        publishPageTreeRefresh(parentId);
    }, [
        publishPageTreeRefresh
    ]);
    return (0, $cozmU.useMemo)(()=>({
            closeConversationAssistant: ()=>{
                if (isConversationAssistantSidebarActive) toggleAssistant('sidebar');
            },
            contentType: contentType ?? 'page',
            sourceContent: contentId ? {
                contentId: contentId,
                contentType: contentType
            } : undefined,
            isRemixPreviewVisible: showSmartCreationModal,
            onRemixInsertSuccess: onRemixInsertSuccess,
            onFinalizeSuccess: onFinalizeSuccess,
            onFinalizeFailed: onFinalizeFailed,
            requestConversationAssistantOpen: requestConversationAssistantOpen,
            openRemixPreview: ({ isFloating: isFloating, remixConversationId: remixConversationId, onOpen: onOpen, onSubmit: onSubmit, editorInsertionAcknowledgement: editorInsertionAcknowledgement, onDismiss: onDismiss })=>{
                const remixAifcHandoffAttributes = {
                    featureArea: (0, $iBsvI.getRemixFeatureArea)({
                        remixType: dynamicUiType,
                        existingFeatureArea: 'remix'
                    }) ?? 'remix',
                    entryPoint: 'editor',
                    ...remixConversationId && {
                        conversationChannelId: remixConversationId
                    },
                    ...dynamicUiType && {
                        remixType: dynamicUiType
                    },
                    ...dynamicUiSubtype && {
                        remixSubtype: dynamicUiSubtype
                    }
                };
                experienceTracker.start({
                    name: (0, $irnO2.ExperienceName).REMIX_AIFC_HANDOFF,
                    id: (0, $irnO2.ExperienceName).REMIX_AIFC_HANDOFF,
                    attributes: remixAifcHandoffAttributes
                });
                openModal({
                    entryPoint: 'dynamicUi',
                    spaceKey: spaceKey ?? undefined,
                    stagingAreaActive: true,
                    isFloating: isFloating,
                    shouldShowBackButton: false,
                    onOpenCallback: ()=>{
                        experienceTracker.succeed({
                            name: (0, $irnO2.ExperienceName).REMIX_AIFC_HANDOFF,
                            attributes: remixAifcHandoffAttributes
                        });
                        onOpen?.();
                    },
                    ...onSubmit ? {
                        onSubmitCallback: onSubmit
                    } : {},
                    // Both floating and full-modal previews report insertion through the modal
                    // callback, so the retained lifecycle settles from the insert path itself.
                    ...editorInsertionAcknowledgement ? {
                        editorInsertionAcknowledgement: editorInsertionAcknowledgement
                    } : {},
                    ...onDismiss ? {
                        onCloseCallback: ()=>{
                            // Smart Creation invokes this callback immediately before its synchronous
                            // close action. Defer lifecycle settlement until that legacy UI close lands.
                            // The observer must never surface into the close path, so swallow a throw
                            // instead of leaving an unhandled rejection.
                            Promise.resolve().then(onDismiss).catch(()=>{});
                        }
                    } : {},
                    ...remixConversationId && (0, $6mKj3.expValEquals)('cc-maui-experiment', 'isEnabled', true) ? {
                        remixConversationId: remixConversationId
                    } : {},
                    content: contentId ? {
                        id: contentId,
                        type: contentType ?? 'page',
                        subType: isLivePage ? 'live' : null
                    } : undefined,
                    // Pass submitCallback only for ephemeral (floating) previews so the full
                    // modal flow (isFloating: false) still falls through to
                    // handleSubmitSmartCreate and redirects to the newly created content.
                    // Mirrors useRemixToAIFC.
                    ...isFloating ? {
                        submitCallback: async ()=>{
                            if (contentId && (0, $6mKj3.expVal)('cc-maui-refresh-page-tree-with-diagram', 'isEnabled', false)) publishPageTreeRefresh(contentId);
                        }
                    } : {}
                });
            },
            closeRemixPreview: closeModal,
            openConversationAssistant: (location, conversationId)=>{
                if (conversationId) (0, $dTEBe.updatePageRovoParams)({
                    pathway: 'chat',
                    conversationId: conversationId
                });
                openAssistant(location);
            },
            toggleConversationAssistant: (location)=>{
                toggleAssistant(location);
            }
        }), [
        isConversationAssistantSidebarActive,
        showSmartCreationModal,
        openModal,
        closeModal,
        openAssistant,
        toggleAssistant,
        spaceKey,
        contentId,
        contentType,
        isLivePage,
        onRemixInsertSuccess,
        onFinalizeSuccess,
        onFinalizeFailed,
        requestConversationAssistantOpen,
        publishPageTreeRefresh,
        dynamicUiType,
        dynamicUiSubtype,
        experienceTracker
    ]);
};
const $cb26a2afd8038e71$var$useConfig = ()=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    return (0, $zCcSI.useConversationAssistantConfig)({
        assistanceServiceConfigHeaders: {
            'X-Cloudid': cloudId
        },
        preventAbortRequestsOnStagingModalClose: true
    });
};
// remove this when cleanup platform_editor_ai_remix_in_editor_loading
function $cb26a2afd8038e71$var$useConfigOld() {
    return undefined;
}
const $cb26a2afd8038e71$var$useConfigSafe = (0, $isuYJ.conditionalHooksFactory)(()=>(0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading'), $cb26a2afd8038e71$var$useConfig, $cb26a2afd8038e71$var$useConfigOld);
const $cb26a2afd8038e71$var$useSmartCreationContext = ()=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { data: spaceDetail } = (0, $kqIWy.useSpaceDetail)(spaceKey, {
        includeSpaceTypeSettings: true
    });
    const context = {
        confluence: {
            space: spaceDetail ? {
                id: spaceDetail.spaceId,
                name: spaceDetail.name,
                // `key` is needed to construct correct whiteboard URLs
                // (`/wiki/spaces/{spaceKey}/whiteboard/...`). Without it,
                // `useOnComplete` falls back to `~{numericSpaceId}`, which
                // the page-level URL routing treats as a personal-space key
                // and resolves to the wrong space.
                key: spaceKey ?? undefined,
                iconPath: spaceDetail.iconPath,
                typeSettings: spaceDetail.typeSettings
            } : undefined,
            parentContent: spaceDetail ? {
                id: spaceDetail.homepage?.id ?? '',
                title: spaceDetail.homepage?.title ?? '',
                contentType: spaceDetail.homepage?.type ?? ''
            } : undefined,
            content: contentId ? {
                id: contentId,
                type: contentType ?? 'page',
                subType: isLivePage ? 'live' : null
            } : undefined
        }
    };
    return context;
};
// remove this when cleanup platform_editor_ai_remix_in_editor_loading
function $cb26a2afd8038e71$var$useSmartCreationContextOld() {
    return undefined;
}
const $cb26a2afd8038e71$var$useSmartCreationContextSafe = (0, $isuYJ.conditionalHooksFactory)(()=>(0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading'), $cb26a2afd8038e71$var$useSmartCreationContext, $cb26a2afd8038e71$var$useSmartCreationContextOld);
const $cb26a2afd8038e71$var$PlatformComponentInner = ({ flags: flags, ...props })=>{
    const smartCreationConfig = $cb26a2afd8038e71$var$useConfigSafe();
    const smartCreationContext = $cb26a2afd8038e71$var$useSmartCreationContextSafe();
    const dismissSubtypeAdjustedFlag = (0, $cozmU.useCallback)(()=>{
        const editorApi = props.editorApi;
        const command = editorApi?.malleableUi?.commands.dismissSubtypeAdjustedFlag?.();
        if (command) editorApi?.core.actions.execute(command);
    }, [
        props.editorApi
    ]);
    const productIntegration = $cb26a2afd8038e71$var$useConfluenceProductIntegration({
        dismissSubtypeAdjustedFlag: dismissSubtypeAdjustedFlag,
        flags: flags,
        onFinalizeFailed: props.onFinalizeFailed,
        rootPageTreeParentId: smartCreationContext?.confluence?.parentContent?.id
    });
    const editorRemixLifecycleAdapter = $cb26a2afd8038e71$var$useEditorRemixLifecycleAdapter(props.onRegisterEditorRemixMachineLifecycleOwnership, props.isEditorRemixStateRearchitectureTreatment);
    const unavailableSpaceOptions = (0, $hxqA6.useShouldHideDiagramRemixOption)();
    const hiddenOptions = unavailableSpaceOptions.length > 0 ? [
        ...props.hiddenOptions ?? [],
        ...unavailableSpaceOptions
    ] : props.hiddenOptions;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $437afbad13638573$export$9d4c73ad3f5edcd5), {
        ...props,
        editorRemixLifecycleAdapter: editorRemixLifecycleAdapter,
        entryPoint: (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') ? 'dynamicUi' : undefined,
        smartCreationConfig: (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') ? smartCreationConfig : undefined,
        smartCreationContext: (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') ? smartCreationContext : undefined,
        hiddenOptions: hiddenOptions,
        productConfig: $cb26a2afd8038e71$var$confluenceProductConfig,
        productIntegration: productIntegration
    });
};
const $cb26a2afd8038e71$var$PlatformComponent = (0, $7aRa9.withFlags)($cb26a2afd8038e71$var$PlatformComponentInner);
const $cb26a2afd8038e71$export$d5658636dc6cb88 = ()=>{
    const Wrapper = (props)=>{
        const { onStopThinking: onStopThinking, isThinking: isThinking, isModalOpen: isModalOpen } = props;
        const { showSmartCreationModal: showSmartCreationModal } = (0, $jyA9t.useSmartCreationModalState)();
        const isSmartCreationModalOpen = (0, $cozmU.useRef)(false);
        const { didPrefetch: didPrefetch, hiddenOptions: unavailableOptions } = (0, $hxqA6.useAttachmentRemixOptionsPrefetch)();
        const isObjectRemix = props.remixType === 'object';
        const { didPrefetch: didPrefetchSpaceOptions, hiddenOptions: unavailableSpaceOptions } = (0, $hxqA6.useSpaceRemixOptionsPrefetch)({
            enabled: isObjectRemix && // The attachment prefetch records the permissions exposure; do not record it twice.
            // eslint-disable-next-line confluence-feature-gating/no-exposure-recommendation
            (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc_maui_remix_attachment_permissions', 'isEnabled', true)
        });
        const hiddenOptions = unavailableOptions.length > 0 || unavailableSpaceOptions.length > 0 ? [
            ...props.hiddenOptions ?? [],
            ...unavailableOptions,
            ...unavailableSpaceOptions
        ] : props.hiddenOptions;
        (0, $cozmU.useLayoutEffect)(()=>{
            if ((0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading')) return;
            if (isSmartCreationModalOpen.current && !showSmartCreationModal && isThinking && (!isObjectRemix || !(0, $iDrrr.fg)('maui_remixable_page_native_embeds'))) onStopThinking();
            isSmartCreationModalOpen.current = showSmartCreationModal;
        }, [
            showSmartCreationModal,
            isThinking,
            onStopThinking,
            isObjectRemix
        ]);
        let remixContent;
        if (isObjectRemix) {
            const { remixType: remixType, adfDocument: adfDocument, ...restProps } = props;
            remixContent = (0, $iDrrr.fg)('maui_remixable_page_native_embeds') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gc4HO.EditorPageRemixModal), {
                ...restProps,
                remixType: remixType,
                adfDocument: adfDocument,
                prefetchedAttachmentHiddenOptions: didPrefetch ? unavailableOptions : undefined,
                prefetchedSpaceHiddenOptions: didPrefetchSpaceOptions ? unavailableSpaceOptions : undefined
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cb26a2afd8038e71$var$PlatformComponent, {
                ...restProps,
                hiddenOptions: hiddenOptions,
                remixType: "block"
            });
        } else remixContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cb26a2afd8038e71$var$PlatformComponent, {
            ...props,
            hiddenOptions: hiddenOptions
        });
        if ((0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aXWtB.ConfluenceConversationAssistant), null, remixContent);
        if (!(isModalOpen || isThinking)) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aXWtB.ConfluenceConversationAssistant), null, remixContent);
    };
    return Wrapper;
};



var $3rRes = parcelRequire("3rRes");





var $koSDQ = parcelRequire("koSDQ");


var $7eOZ4 = parcelRequire("7eOZ4");




const $3c7fc3da09b0bf1b$var$getEditorRemixAifcHandoffExperienceAttributes = ({ type: type, subType: subType })=>{
    if (type !== 'custom') return undefined;
    return {
        featureArea: (0, $iBsvI.getRemixFeatureArea)({
            remixType: type,
            existingFeatureArea: 'remix'
        }) ?? 'remix',
        entryPoint: 'editor',
        remixType: type,
        ...subType && {
            remixSubtype: subType
        }
    };
};
const $3c7fc3da09b0bf1b$export$b0964dba0fad52a4 = ()=>{
    if ((0, $iDrrr.fg)('confluence_malleable_ui_platform_remix')) return {
        Component: (0, $cb26a2afd8038e71$export$d5658636dc6cb88)(),
        LifecycleHost: (0, $cb26a2afd8038e71$export$adea0596c0c4a3d3),
        capabilities: {
            editorRemixLifecycleAdapter: true
        }
    };
    const BlockRemixComponent = ({ handleModalClose: handleModalClose, selectedContext: selectedContext, editorApi: editorApi, onStartThinking: onStartThinking, onStopThinking: onStopThinking, isUpdate: isUpdate, remixModalMetadata: remixModalMetadata, remixSource: remixSource, hiddenOptions: prefetchedHiddenOptions })=>{
        const isRemixCancelled = (0, $cozmU.useRef)(false);
        const hasCommittedRemixCreateTerminal = (0, $cozmU.useRef)(false);
        const isUpdateRef = (0, $cozmU.useRef)(isUpdate);
        isUpdateRef.current = isUpdate;
        const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
        const openAIFCStagingModalRef = (0, $cozmU.useRef)(()=>{});
        const selectedSubTypeRef = (0, $cozmU.useRef)(undefined);
        const conversationIdRef = (0, $cozmU.useRef)(undefined);
        const shouldOpenRovoChatOnCompleteRef = (0, $cozmU.useRef)(false);
        const remixAifcHandoffExperienceAttributesRef = (0, $cozmU.useRef)(undefined);
        const { dynamicUiType: dynamicUiType } = (0, $8akfd.useStagingAreaState)();
        const { showSmartCreationModal: showSmartCreationModal } = (0, $jyA9t.useSmartCreationModalState)();
        const { openConversationAssistant: openConversationAssistant } = (0, $1AJi3.useToggleConversationAssistant)();
        const unavailableSpaceOptions = (0, $hxqA6.useShouldHideDiagramRemixOption)({
            // The parent attachment hook records the exposure; this read keeps diagram behavior aligned.
            // eslint-disable-next-line confluence-feature-gating/no-exposure-recommendation
            enabled: (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc_maui_remix_attachment_permissions', 'isEnabled', true)
        });
        // The parent attachment hook records the exposure; this read gates its prefetched result.
        // eslint-disable-next-line confluence-feature-gating/no-exposure-recommendation
        const hiddenOptions = (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc_maui_remix_attachment_permissions', 'isEnabled', true) ? unavailableSpaceOptions.length > 0 ? [
            ...prefetchedHiddenOptions ?? [],
            ...unavailableSpaceOptions
        ] : prefetchedHiddenOptions : undefined;
        const { showProgressBar: showProgressBar, isComplete: isComplete, onCompleteAnimationFinished: onCompleteAnimationFinished, onActionReady: onActionReady, resetCompletion: resetCompletion } = (0, $koSDQ.useRemixPreviewFlow)({
            entryPoint: 'editor',
            experienceTracker: experienceTracker,
            dynamicUiType: dynamicUiType,
            selectedSubTypeRef: selectedSubTypeRef,
            openAIFCStagingModalRef: openAIFCStagingModalRef,
            isRemixCancelledRef: isRemixCancelled,
            conversationIdRef: conversationIdRef,
            shouldOpenPreview: ()=>{
                if (!shouldOpenRovoChatOnCompleteRef.current) return true;
                shouldOpenRovoChatOnCompleteRef.current = false;
                hasCommittedRemixCreateTerminal.current = true;
                experienceTracker.succeed({
                    name: (0, $irnO2.ExperienceName).REMIX_START
                });
                (0, $irnO2.remixGeneratePreviewExperience).success();
                handleModalClose();
                if (conversationIdRef.current) (0, $dTEBe.updatePageRovoParams)({
                    pathway: 'chat',
                    conversationId: conversationIdRef.current
                });
                openConversationAssistant('sidebar');
                return false;
            }
        });
        const { sendAIFCPrompt: sendAIFCPrompt, stopRemixing: stopRemixing, isRemixError: isRemixError, isRemixAborted: isRemixAborted, remixStoreError: remixStoreError, openAIFCStagingModal: openAIFCStagingModal, closeAIFCStagingModal: closeAIFCStagingModal, resetRemixConversationId: resetRemixConversationId } = (0, $7eOZ4.useRemixToAIFC)({
            onActionReady: onActionReady
        });
        openAIFCStagingModalRef.current = openAIFCStagingModal;
        const abortRemixAifcHandoffExperience = (0, $cozmU.useCallback)((reason)=>{
            const attributes = remixAifcHandoffExperienceAttributesRef.current;
            if (!attributes) return;
            experienceTracker.abort({
                name: (0, $irnO2.ExperienceName).REMIX_AIFC_HANDOFF,
                reason: reason,
                attributes: {
                    ...attributes,
                    reason: reason
                }
            });
            remixAifcHandoffExperienceAttributesRef.current = undefined;
        }, [
            experienceTracker
        ]);
        // Abort experience on unmount (overlay closed without selecting an option).
        // Uses a ref so the cleanup always calls the latest tracker reference.
        const experienceTrackerRef = (0, $cozmU.useRef)(experienceTracker);
        experienceTrackerRef.current = experienceTracker;
        (0, $cozmU.useEffect)(()=>{
            return ()=>{
                experienceTrackerRef.current.abort({
                    name: (0, $irnO2.ExperienceName).REMIX_START,
                    reason: 'User closed remix overlay',
                    attributes: {
                        reason: 'User closed remix overlay'
                    }
                });
                if (!isUpdateRef.current) (0, $kDDrf.abortRemixCreateExperienceIfNotCommitted)(experienceTrackerRef.current, hasCommittedRemixCreateTerminal.current);
                const attributes = remixAifcHandoffExperienceAttributesRef.current;
                if (attributes) {
                    experienceTrackerRef.current.abort({
                        name: (0, $irnO2.ExperienceName).REMIX_AIFC_HANDOFF,
                        reason: 'User closed remix overlay',
                        attributes: {
                            ...attributes,
                            reason: 'User closed remix overlay'
                        }
                    });
                    remixAifcHandoffExperienceAttributesRef.current = undefined;
                }
            };
        }, []);
        const onRemixFlowActiveChange = (0, $cozmU.useCallback)((active)=>{
            if (active) {
                isRemixCancelled.current = false;
                shouldOpenRovoChatOnCompleteRef.current = false;
                // Clear stale completion state from any previous flow.
                resetCompletion();
                onStartThinking();
            } else {
                isRemixCancelled.current = true;
                shouldOpenRovoChatOnCompleteRef.current = false;
                // Abort the current experience before stopping
                experienceTracker.abort({
                    name: (0, $irnO2.ExperienceName).REMIX_START,
                    reason: 'User cancelled remix thinking',
                    attributes: {
                        reason: 'User cancelled remix thinking'
                    }
                });
                if (!isUpdate) (0, $kDDrf.abortRemixCreateExperience)(experienceTracker, 'User cancelled remix thinking');
                abortRemixAifcHandoffExperience('User cancelled remix thinking');
                (0, $irnO2.remixGeneratePreviewExperience).abort({
                    metadata: {
                        reason: 'User cancelled remix thinking'
                    }
                });
                stopRemixing();
                onStopThinking({
                    reopenModal: false
                });
            }
        }, [
            onStartThinking,
            stopRemixing,
            onStopThinking,
            experienceTracker,
            isUpdate,
            resetCompletion,
            abortRemixAifcHandoffExperience
        ]);
        // Fail experience and clean up thinking UI when Rovo encounters an error
        const prevIsRemixError = (0, $cozmU.useRef)(isRemixError);
        (0, $cozmU.useEffect)(()=>{
            if (!prevIsRemixError.current && isRemixError && !isRemixCancelled.current) {
                const errorMessage = remixStoreError?.content ?? 'Rovo agent error during remix';
                experienceTracker.fail({
                    name: (0, $irnO2.ExperienceName).REMIX_START,
                    error: new Error(errorMessage),
                    attributes: {
                        errorType: remixStoreError?.errorType,
                        traceId: remixStoreError?.traceId,
                        errorStatusCode: remixStoreError?.status_code
                    }
                });
                (0, $irnO2.remixGeneratePreviewExperience).failure({
                    metadata: {
                        errorType: remixStoreError?.errorType,
                        traceId: remixStoreError?.traceId
                    }
                });
                onStopThinking({
                    reopenModal: true
                });
            }
            prevIsRemixError.current = isRemixError;
        }, [
            isRemixError,
            remixStoreError,
            onStopThinking,
            experienceTracker
        ]);
        // Dismiss the thinking bar when the user stops the remix from the Rovo side chat.
        (0, $cozmU.useEffect)(()=>{
            if (isRemixAborted && !isRemixCancelled.current) {
                const reason = 'User stopped from Rovo side chat';
                experienceTracker.abort({
                    name: (0, $irnO2.ExperienceName).REMIX_START,
                    reason: reason
                });
                if (!isUpdate) (0, $kDDrf.abortRemixCreateExperience)(experienceTracker, reason);
                abortRemixAifcHandoffExperience(reason);
                onStopThinking({
                    reopenModal: false
                });
            }
        }, [
            isRemixAborted,
            isUpdate,
            onStopThinking,
            experienceTracker,
            abortRemixAifcHandoffExperience
        ]);
        // When an error occurs during remix, close the thinking bar and ephemeral
        // preview, then open the Rovo chat sidebar so the user can see the error.
        (0, $cozmU.useEffect)(()=>{
            if (!isRemixCancelled.current && isRemixError) {
                // Close the ephemeral preview (staging modal) if it is open
                if (showSmartCreationModal) closeAIFCStagingModal();
                // Close the thinking bar and dismiss the remix UI entirely.
                // This mirrors the renderer's onClose() call which unmounts
                // the component and clears isModalOpen. Using handleModalClose
                // instead of onStopThinking because the first error effect
                // sets isModalOpen=true (via reopenModal), and onStopThinking
                // alone only clears isThinking — leaving the component mounted
                // and the progress bar visible.
                handleModalClose();
                // Open the Rovo chat sidebar to display the error information.
                // `openConversationAssistant` is idempotent (no-op if already
                // open), so it is safe to call on every render where
                // `isRemixError` is true — no infinite toggle loop.
                openConversationAssistant('sidebar');
                resetRemixConversationId();
            }
        }, [
            isRemixError,
            showSmartCreationModal,
            closeAIFCStagingModal,
            handleModalClose,
            openConversationAssistant,
            resetRemixConversationId
        ]);
        const constructDynamicUiSource = (0, $cozmU.useCallback)(async ()=>{
            const localIds = selectedContext?.localIds ?? [];
            const startLocalId = localIds[0] ?? '';
            const endLocalId = localIds[localIds.length - 1] ?? '';
            const fragmentAdf = (0, $3rRes.prepareRemixFragmentNodes)(selectedContext?.selectionFragment ?? null);
            let fullAdf = {
                type: 'doc',
                version: 1,
                content: []
            };
            if (editorApi) fullAdf = await new Promise((resolve)=>{
                try {
                    editorApi.core?.actions?.requestDocument?.((doc)=>{
                        resolve(doc);
                    }, {
                        alwaysFire: true
                    });
                } catch  {
                    resolve({
                        type: 'doc',
                        version: 1,
                        content: []
                    });
                }
            });
            // When the entire page is selected (e.g. cmd+a), selectionFragment is null
            // because ProseMirror's AllSelection does not produce a fragment in the
            // selection context. In that case fall back to the full document content
            // so that Remix still receives the source content it needs.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const resolvedFragmentAdf = fragmentAdf ?? fullAdf.content;
            return {
                contentType: 'page',
                startLocalId: startLocalId,
                endLocalId: endLocalId,
                startIndex: selectedContext?.startIndex ?? 0,
                endIndex: selectedContext?.endIndex ?? -1,
                fragmentAdf: resolvedFragmentAdf,
                fullAdf: fullAdf
            };
        }, [
            editorApi,
            selectedContext
        ]);
        const onOptionSelect = (0, $cozmU.useCallback)(async ({ type: type, subType: subType, userPrompt: userPrompt })=>{
            const isRovoChatSubmission = remixSource === 'rovoChat' && remixModalMetadata?.preselectedConversationId !== undefined;
            const isCustomOnlyPrompt = type === 'custom' && !subType && !!userPrompt?.trim();
            selectedSubTypeRef.current = subType;
            shouldOpenRovoChatOnCompleteRef.current = !isRovoChatSubmission && isCustomOnlyPrompt && (0, $6mKj3.expValEquals)('cc_maui_polish_changes_batch_5', 'isEnabled', true);
            const remixAifcHandoffExperienceAttributes = $3c7fc3da09b0bf1b$var$getEditorRemixAifcHandoffExperienceAttributes({
                type: type,
                subType: subType
            });
            if (remixAifcHandoffExperienceAttributes) {
                remixAifcHandoffExperienceAttributesRef.current = remixAifcHandoffExperienceAttributes;
                experienceTracker.start({
                    name: (0, $irnO2.ExperienceName).REMIX_AIFC_HANDOFF,
                    id: (0, $irnO2.ExperienceName).REMIX_AIFC_HANDOFF,
                    attributes: remixAifcHandoffExperienceAttributes
                });
            }
            experienceTracker.updateAttributes({
                name: (0, $irnO2.ExperienceName).REMIX_START,
                attributes: {
                    featureArea: (0, $iBsvI.getRemixFeatureArea)({
                        remixType: type,
                        existingFeatureArea: 'remix'
                    }) ?? 'remix',
                    remixType: type,
                    remixSubtype: subType,
                    includesFreegenPrompt: !!userPrompt
                }
            });
            (0, $irnO2.remixGeneratePreviewExperience).start();
            (0, $irnO2.remixGeneratePreviewExperience).mark((0, $irnO2.REMIX_GENERATE_PREVIEW_MARKS).SUBMIT);
            (0, $irnO2.remixGeneratePreviewExperience).addMetadata({
                product: 'confluence',
                interactionSource: remixModalMetadata?.interactionSource,
                remixType: type,
                remixSubtype: subType,
                entryPoint: 'editor',
                includesFreegenPrompt: !!userPrompt,
                ...type === 'infographic' ? {
                    isConfluenceInfographicsTwoStageEnabled: (0, $iDrrr.fg)('confluence-infographics-two-stage')
                } : {}
            });
            let conversationChannelId;
            try {
                const dynamicUiSource = await constructDynamicUiSource();
                conversationChannelId = await sendAIFCPrompt({
                    userPrompt: isRovoChatSubmission ? undefined : userPrompt,
                    promptText: isRovoChatSubmission ? userPrompt : undefined,
                    dynamicUiType: type,
                    dynamicUiSubtype: subType,
                    dynamicUiSource: dynamicUiSource,
                    interactionSource: remixModalMetadata?.interactionSource,
                    conversationId: remixModalMetadata?.preselectedConversationId
                });
            } catch (error) {
                if (!remixAifcHandoffExperienceAttributes) throw error;
                experienceTracker.fail({
                    name: (0, $irnO2.ExperienceName).REMIX_AIFC_HANDOFF,
                    error: error instanceof Error ? error : new Error('Failed to complete Remix AIFC handoff'),
                    attributes: remixAifcHandoffExperienceAttributes
                });
                remixAifcHandoffExperienceAttributesRef.current = undefined;
                return;
            }
            // Store the conversationId so `useRemixPreviewFlow` can include it as
            // `conversationChannelId` on the REMIX_RENDERS_IN_MODAL start attributes
            // once `onActionReady` fires.
            conversationIdRef.current = conversationChannelId;
            if (remixAifcHandoffExperienceAttributes) {
                const attributes = {
                    ...remixAifcHandoffExperienceAttributes,
                    conversationChannelId: conversationChannelId
                };
                experienceTracker.succeed({
                    name: (0, $irnO2.ExperienceName).REMIX_AIFC_HANDOFF,
                    attributes: attributes
                });
                (0, $kDDrf.succeedRemixCreateExperienceAtHandoff)(experienceTracker, {
                    conversationId: conversationChannelId
                });
                remixAifcHandoffExperienceAttributesRef.current = undefined;
            }
            experienceTracker.updateAttributes({
                name: (0, $irnO2.ExperienceName).REMIX_START,
                attributes: {
                    conversationChannelId: conversationChannelId
                }
            });
            if (!isUpdate) {
                hasCommittedRemixCreateTerminal.current = true;
                (0, $kDDrf.trackRemixCreateOptionSelected)({
                    experienceTracker: experienceTracker,
                    conversationId: conversationChannelId,
                    remixType: type,
                    remixSubtype: subType,
                    includesFreegenPrompt: !!userPrompt
                });
            }
        }, [
            constructDynamicUiSource,
            sendAIFCPrompt,
            remixModalMetadata,
            experienceTracker,
            isUpdate,
            remixSource
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8GyO5.RemixContainer), {
            onClose: handleModalClose,
            onOptionSelect: onOptionSelect,
            onRemixFlowActiveChange: onRemixFlowActiveChange,
            autoSubmitSelection: remixModalMetadata?.preselectedType ? {
                type: remixModalMetadata.preselectedType,
                subType: remixModalMetadata.preselectedSubType,
                userPrompt: remixModalMetadata.preselectedUserPrompt
            } : undefined,
            isEphemeralViewVisible: showSmartCreationModal,
            showProgressBar: showProgressBar,
            isComplete: isComplete,
            onCompleteAnimationFinished: onCompleteAnimationFinished,
            hiddenOptions: hiddenOptions,
            anchorRect: // The parent attachment hook records the exposure; this only gates sibling UI metadata.
            // eslint-disable-next-line confluence-feature-gating/no-exposure-recommendation
            (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc_maui_remix_attachment_permissions', 'isEnabled', true) ? remixModalMetadata?.anchorRect : undefined,
            popupPlacement: // The parent attachment hook records the exposure; this only gates sibling UI metadata.
            // eslint-disable-next-line confluence-feature-gating/no-exposure-recommendation
            (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc_maui_remix_attachment_permissions', 'isEnabled', true) ? remixModalMetadata?.popupPlacement ?? 'bottom-start' : undefined
        });
    };
    const Wrapper = (props)=>{
        const { onStopThinking: onStopThinking, isThinking: isThinking, isModalOpen: isModalOpen } = props;
        const { showSmartCreationModal: showSmartCreationModal } = (0, $jyA9t.useSmartCreationModalState)();
        const isSmartCreationModalOpen = (0, $cozmU.useRef)(false);
        const { didPrefetch: didPrefetch, hiddenOptions: unavailableOptions } = (0, $hxqA6.useAttachmentRemixOptionsPrefetch)();
        const isObjectRemix = props.remixType === 'object';
        const { didPrefetch: didPrefetchSpaceOptions, hiddenOptions: unavailableSpaceOptions } = (0, $hxqA6.useSpaceRemixOptionsPrefetch)({
            enabled: isObjectRemix && // The attachment prefetch records the permissions exposure; do not record it twice.
            // eslint-disable-next-line confluence-feature-gating/no-exposure-recommendation
            (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc_maui_remix_attachment_permissions', 'isEnabled', true)
        });
        const hiddenOptions = unavailableOptions.length > 0 || unavailableSpaceOptions.length > 0 ? [
            ...props.hiddenOptions ?? [],
            ...unavailableOptions,
            ...unavailableSpaceOptions
        ] : props.hiddenOptions;
        (0, $cozmU.useLayoutEffect)(()=>{
            // Selected content should remain highlighted throughout the entire flow even when ephemeral modal is open
            // We deselect the content when the ephemeral modal is closed
            if (isSmartCreationModalOpen.current && !showSmartCreationModal && isThinking && (!isObjectRemix || !(0, $iDrrr.fg)('maui_remixable_page_native_embeds'))) onStopThinking();
            isSmartCreationModalOpen.current = showSmartCreationModal;
        }, [
            showSmartCreationModal,
            isThinking,
            onStopThinking,
            isObjectRemix
        ]);
        if (!(isModalOpen || isThinking)) return null;
        let remixContent;
        if (isObjectRemix) {
            const { remixType: remixType, adfDocument: adfDocument, ...restProps } = props;
            remixContent = (0, $iDrrr.fg)('maui_remixable_page_native_embeds') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gc4HO.EditorPageRemixModal), {
                ...restProps,
                remixType: remixType,
                adfDocument: adfDocument,
                prefetchedAttachmentHiddenOptions: didPrefetch ? unavailableOptions : undefined,
                prefetchedSpaceHiddenOptions: didPrefetchSpaceOptions ? unavailableSpaceOptions : undefined
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(BlockRemixComponent, {
                ...restProps,
                hiddenOptions: hiddenOptions,
                remixType: "block"
            });
        } else remixContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(BlockRemixComponent, {
            ...props,
            hiddenOptions: hiddenOptions
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aXWtB.ConfluenceConversationAssistant), null, remixContent);
    };
    return {
        Component: Wrapper,
        capabilities: {
            editorRemixLifecycleAdapter: false
        }
    };
};
module.exports["createRemixContentComponent"] = $3c7fc3da09b0bf1b$export$b0964dba0fad52a4;

});

parcelRegister("6ZWlg", function(module, exports) {

var $b8Mxh = parcelRequire("b8Mxh");


var $6mKj3 = parcelRequire("6mKj3");


var $ficwO = parcelRequire("ficwO");

const $f695bc627258d8a1$var$PERMISSION_ERROR_SUBSTRING = 'can not create in space';
class $f695bc627258d8a1$var$PermissionError extends Error {
    constructor(message){
        super(message);
        this.isPermissionError = true;
        this.name = 'PermissionError';
    }
}
async function $f695bc627258d8a1$var$buildErrorFromResponse(message, response) {
    const messageWithStatus = `${message} with status ${response.status}`;
    if (response.status === 400) {
        const rawText = await response.text().catch(()=>'');
        if (rawText.toLowerCase().includes($f695bc627258d8a1$var$PERMISSION_ERROR_SUBSTRING)) return new $f695bc627258d8a1$var$PermissionError(messageWithStatus);
    }
    return new Error(messageWithStatus);
}
function $f695bc627258d8a1$export$d399ddbda75258d9({ contentId: contentId, contentType: contentType, duplicateMauiApp: duplicateMauiApp, siteId: siteId, spaceKey: spaceKey, userId: userId }) {
    return {
        getCurrentPageId: ()=>contentId,
        getCurrentContentType: ()=>contentType,
        duplicateMauiApp: duplicateMauiApp,
        finalizeLocation: {
            currentParentContent: contentId ? {
                contentType: contentType ?? 'page',
                id: contentId,
                title: ''
            } : undefined,
            currentSpace: {
                id: spaceKey,
                key: spaceKey,
                name: spaceKey,
                canCreatePage: false
            },
            siteId: siteId,
            userId: userId
        },
        finalizeAfterMove: async (mauiContentId, parentPageId, conversationContext, targetSpace)=>{
            const resolvedSpaceKey = targetSpace?.key ?? spaceKey;
            const targetSpaceId = targetSpace?.id;
            // Drafts can't have children; reparent as a sibling when possible.
            let resolvedParentId = targetSpace?.parentId ?? parentPageId;
            if (!targetSpace?.parentId) try {
                const ancestorId = await (0, $b8Mxh.resolveConfluenceDraftSiblingParent)(parentPageId);
                if (ancestorId) resolvedParentId = ancestorId;
            } catch  {
            // Swallow — finalize continues with the original parent.
            }
            const monolithBody = {
                id: mauiContentId,
                type: 'whiteboard',
                spaceKey: resolvedSpaceKey,
                parentId: resolvedParentId,
                ...targetSpaceId ? {
                    spaceId: targetSpaceId
                } : {}
            };
            const refreshPageTreeOnFinalize = ()=>{
                if (!(0, $6mKj3.expVal)('cc-maui-refresh-page-tree-with-diagram', 'isEnabled', false)) return;
                (0, $ficwO.publishMessage)((0, $ficwO.Message).PageTreeRefreshRequested, {
                    parentId: resolvedParentId
                });
            };
            // Use the convo-ai path when a conversationContext (_rc) is present.
            // Fall back to monolith when no _rc is available.
            if (conversationContext) {
                // Fetch messages to reconstruct the full action payload; _rc only carries IDs.
                let matchedAction;
                const messagesResponse = await fetch(`/gateway/api/assist/rovo/v1/chat/conversation/${conversationContext.conversationId}/messages`, {
                    method: 'GET',
                    credentials: 'include',
                    headers: {
                        'x-product': 'confluence',
                        'x-experience-id': 'ai-mate'
                    }
                });
                if (messagesResponse.ok) {
                    const messagesPayload = await messagesResponse.json();
                    const messages = Array.isArray(messagesPayload?.items) ? messagesPayload.items : [];
                    for (const message of messages){
                        if (message?.id !== conversationContext.messageId) continue;
                        const actions = Array.isArray(message?.actions) ? message.actions : [];
                        matchedAction = actions.find((action)=>action?.invocationId === conversationContext.invocationId);
                        if (matchedAction) break;
                    }
                }
                if (!matchedAction) {
                    if ((0, $6mKj3.expVal)('maui-native-embed-finalize-diagram-anywhere', 'value', false)) throw new Error('Cannot finalize: conversation action data is unavailable.');
                // Fall through to monolith path below.
                } else {
                    const existingData = matchedAction.data ?? {};
                    const existingMetadata = existingData.metadata ?? {};
                    const actionResponse = await fetch(`/gateway/api/assist/rovo/v1/chat/conversation/${conversationContext.conversationId}/action`, {
                        method: 'POST',
                        credentials: 'include',
                        headers: {
                            'Content-Type': 'application/json;charset=UTF-8',
                            'x-product': 'confluence',
                            'x-experience-id': 'ai-mate'
                        },
                        body: JSON.stringify({
                            context: {
                                ...matchedAction,
                                messageId: conversationContext.messageId,
                                status: 'pending',
                                resolution: {
                                    type: 'confirm',
                                    message: 'finalize'
                                },
                                data: {
                                    ...existingData,
                                    metadata: {
                                        ...existingMetadata,
                                        contentId: mauiContentId,
                                        parentId: resolvedParentId,
                                        spaceKey: resolvedSpaceKey,
                                        ...targetSpaceId ? {
                                            spaceId: targetSpaceId
                                        } : {}
                                    }
                                }
                            }
                        })
                    });
                    if (!actionResponse.ok) // Propagate convo-ai failures (incl. permission errors) so the
                    // space-picker recovery flow can react correctly.
                    throw await $f695bc627258d8a1$var$buildErrorFromResponse('Convo-ai finalize action failed', actionResponse);
                    refreshPageTreeOnFinalize();
                    return;
                }
            } else if ((0, $6mKj3.expVal)('maui-native-embed-finalize-diagram-anywhere', 'value', false)) throw new Error('Cannot finalize: no conversation context found in the embed link.');
            // Monolith fallback — works with contentId alone, no conversation data needed.
            const monolithResponse = await fetch(`/gateway/api/ex/confluence/${siteId}/wiki/rest/internals/latest/smart-create/finalize`, {
                method: 'PUT',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(monolithBody)
            });
            if (!monolithResponse.ok) throw await $f695bc627258d8a1$var$buildErrorFromResponse('Monolith finalize failed', monolithResponse);
            refreshPageTreeOnFinalize();
        },
        isFinalizePermissionError: (error)=>error instanceof $f695bc627258d8a1$var$PermissionError && error.isPermissionError,
        resolveContentSpaceKey: async (mauiContentId)=>{
            try {
                const response = await fetch(`/wiki/rest/api/content/${mauiContentId}?expand=space`, {
                    credentials: 'include'
                });
                if (!response.ok) return null;
                const data = await response.json();
                return data?.space?.key ?? null;
            } catch  {
                return null;
            }
        },
        targetSpaceKey: spaceKey
    };
}
module.exports["createConfluenceMauiDiagramPasteConfig"] = $f695bc627258d8a1$export$d399ddbda75258d9;

});

parcelRegister("52WCt", function(module, exports) {
const $eb8c2fb1adeee18a$export$6248e55c333474d4 = (flags)=>{
    if (!flags) return undefined;
    return {
        showFlag: ({ autoDismissSeconds: autoDismissSeconds, description: description, icon: icon, id: id, onDismissed: onDismissed, title: title, type: type })=>{
            flags.showFlag({
                customIcon: icon,
                description: description,
                id: id,
                onClose: onDismissed,
                title: title,
                type: type,
                ...autoDismissSeconds !== undefined ? {
                    autoDismissSeconds: autoDismissSeconds,
                    close: 'auto'
                } : {}
            });
        },
        hideFlag: (id)=>{
            flags.hideFlag(id);
        }
    };
};
module.exports["createMalleableUiProductFlags"] = $eb8c2fb1adeee18a$export$6248e55c333474d4;

});

parcelRegister("8RXjp", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $11ec5a45260f5479$export$3c59230798c40d1a = (0, $kSwu1.defineMessages)({
    remixReady: {
        id: "malleable-ui-components.remix.remix-ready-toast.remixReady",
        defaultMessage: "Your remix is ready"
    },
    remixReadyUpdated: {
        id: "malleable-ui-components.remix.remix-ready-toast.remixReady.updated",
        defaultMessage: "Your content is ready"
    },
    contentReady: {
        id: "malleable-ui-components.remix.remix-ready-toast.contentReady",
        defaultMessage: "Your content is ready"
    },
    updateReady: {
        id: "malleable-ui-components.remix.remix-ready-toast.updateReady",
        defaultMessage: "Your edits are ready"
    },
    viewButton: {
        id: "malleable-ui-components.remix.remix-ready-toast.viewButton",
        defaultMessage: "View"
    },
    closeButton: {
        id: "malleable-ui-components.remix.remix-ready-toast.closeButton",
        defaultMessage: "Close"
    }
});
module.exports["remixReadyMessages"] = $11ec5a45260f5479$export$3c59230798c40d1a;

});

parcelRegister("iCjKh", function(module, exports) {
const $1c17feb4ff1d747f$export$bf5f4f4fd607a25 = 'User stopped from Rovo side chat';
const $1c17feb4ff1d747f$export$9b4d66054b7f534a = 'Rovo agent error during remix';
function $1c17feb4ff1d747f$export$4509aabcbe267be2(payload) {
    return 'previousMauiId' in payload;
}
module.exports["REMIX_REMOTE_ABORT_REASON"] = $1c17feb4ff1d747f$export$bf5f4f4fd607a25;
module.exports["DEFAULT_REMIX_ERROR_MESSAGE"] = $1c17feb4ff1d747f$export$9b4d66054b7f534a;
module.exports["isAddBackendMauiRemixHistoryStackEntryPayload"] = $1c17feb4ff1d747f$export$4509aabcbe267be2;

});


//# sourceMappingURL=FullPageEditorComponent.e6bf38fe.js.map
